webpackJsonp([0],{

/***/ "+IFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__("hrEl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1d634b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__("LIX2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1d634b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+WJj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MaybeDropzone_vue__ = __webpack_require__("/53q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2b532272_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_MaybeDropzone_vue__ = __webpack_require__("XDUX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MaybeDropzone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2b532272_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_MaybeDropzone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+c4t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SequenceLibrary_vue__ = __webpack_require__("1V01");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd3940a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SequenceLibrary_vue__ = __webpack_require__("zuUg");
function injectStyle (ssrContext) {
  __webpack_require__("3HI+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fd3940a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SequenceLibrary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd3940a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SequenceLibrary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+e6Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{style:(_vm.styles.modalHeader)},[_c('h3',{style:(_vm.styles.modalTitle)},[_vm._v("Add Card To Sequence")]),_vm._v(" "),_c('button',{staticClass:"button__action",on:{"click":_vm.openNewCardModal}},[_vm._v("Create New Action Card")])]),_vm._v(" "),(_vm.checkCardsLoaded && _vm.getCards)?_c('LibraryGrid',{attrs:{"baseStyle":{paddingTop: 0},"fullWidth":""}},_vm._l((_vm.getCards),function(card,index){return _c('section',{key:index,staticClass:"cardWrap",on:{"click":function($event){_vm.addCardToCurrentSequence(card)}}},[_c('div',{style:(_vm.styles.cardContainer)},[_c('p',{style:(_vm.styles.cardName)},[_vm._v(_vm._s(card.legacyName))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(card.displayName))])])])})):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/53q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dropzone__ = __webpack_require__("UNH8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MaybeDropzoneContent__ = __webpack_require__("GME8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Dropzone: __WEBPACK_IMPORTED_MODULE_0__dropzone__["a" /* default */],
    MaybeDropzoneContent: __WEBPACK_IMPORTED_MODULE_1__MaybeDropzoneContent__["a" /* default */]
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    hasVisibleFiles: {
      type: Boolean,
      required: true
    },
    uploader: {
      type: Object,
      required: true
    },
    dropActiveClassName: {
      type: String,
      default: 'vue-fine-uploader-gallery-dropzone-active'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    // TODO: This might be wrong because it might be passed by props and not a string. Might be using slot instead to pass it down
    content: {
      type: String,
      default: ''
    }
  },
  computed: {
    dropzoneDisabled: function dropzoneDisabled() {
      var dzD = this.disabled;
      if (!dzD) {
        dzD = !this.uploader.qq.supportedFeatures.fileDrop;
      }
      return dzD;
    }
  }
});

/***/ }),

/***/ "/CA7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.wrap(_vm.ready)),attrs:{"id":"logged-out-wrap"}},[_c('section',{staticClass:"bg-banner"},[_c('img',{staticClass:"logo-img",attrs:{"src":"http://gigeconomygroup.com/wp-content/uploads/2018/03/gig-economy-incorrect-logo-02.svg"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('span',[_vm._v("v"+_vm._s(_vm.version))])]),_vm._v(" "),_c('section',[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.loading)?_c('div',{staticClass:"loading"}):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[(!_vm.loading)?_c('router-view'):_vm._e()],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Sales Enablement.\n      "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Informed by Human Intelligence.")]),_vm._v(" "),_c('br'),_vm._v("Powered By Machine Learning.\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/JEG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__general_LibraryGrid__ = __webpack_require__("0gt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__general_MediaCard__ = __webpack_require__("lVNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_Services_js__ = __webpack_require__("bdTy");



var _name$components$meth;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = (_name$components$meth = {
  name: 'AddMediaToCard',
  components: {
    LibraryGrid: __WEBPACK_IMPORTED_MODULE_3__general_LibraryGrid__["a" /* default */],
    MediaCard: __WEBPACK_IMPORTED_MODULE_4__general_MediaCard__["a" /* default */]
  },
  methods: {
    newselectActiveMedia: function newselectActiveMedia(media) {
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setActiveMedia', media);
      if (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.getActiveLocalRecord) {
        var activeRecord = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.getActiveLocalRecord);
        activeRecord.mediaId = media;
        __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setActiveLocalRecord', activeRecord);
      }
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('hideModals', true);
    },
    loadMoreMedia: function loadMoreMedia() {
      var _this = this;

      if (this.moreMedia) {
        var count = this.getMedia[this.getMedia.length - 1].position - 1;
        this.last = count;
        __WEBPACK_IMPORTED_MODULE_6__services_Services_js__["a" /* default */].getMediaByMarketForAC(this.marketId, null, null, count, this.moreMedia, function (res) {
          _this.moreMedia = res.more;
        });
      }
    }
  },
  computed: {
    getMedia: function getMedia() {
      return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.getMedia;
    }
  },
  data: function data() {
    return {
      last: null,
      moreMedia: true,
      marketId: null
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var activeLocale = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.getActiveLocale;
    var markets = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.getMarkets;

    console.log('markets', markets);
    var marketId = markets.filter(function (market) {
      return market.locale === activeLocale;
    })[0]._id || null;

    this.marketId = marketId;

    console.log(marketId);

    __WEBPACK_IMPORTED_MODULE_6__services_Services_js__["a" /* default */].getMediaByMarketForAC(marketId, false, false, false, false, function (res) {
      _this2.moreMedia = res.media;
    });
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$meth, 'components', {
  Modal: __WEBPACK_IMPORTED_MODULE_2__general_Modal__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$meth, 'beforeDestroy', function beforeDestroy() {
  __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setMedia', null);
}), _name$components$meth);

/***/ }),

/***/ "/M7p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/NP2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.marketsLoaded)?_c('div',{staticStyle:{},attrs:{"id":"mediaLibraryContainer"}},[_c('nav',{style:(_vm.styles.nav)},[_c('img',{attrs:{"src":_vm.getFlagUrl(_vm.getActiveMarket)}}),_vm._v("\n     \n    "),_c('div',{staticClass:"rule__control-group rule__control-group--select"},[(_vm.marketsLoaded && _vm.markets.length)?_c('select',{ref:"marketDropdown",staticClass:"form__select",style:(_vm.styles.marketSelect),domProps:{"value":_vm.getActiveMarket._id},on:{"change":_vm.changeMarket}},[_vm._v(">\n        "),_vm._l((_vm.markets),function(market,index){return _c('option',{domProps:{"value":market._id}},[_vm._v(_vm._s(market.title))])})],2):_vm._e()]),_vm._v(" "),_c('div',{style:(_vm.styles.navInputWrapper)},[_c('i',{staticClass:"glyphicon glyphicon-search",style:(_vm.styles.navInputIcon)}),_vm._v(" "),_c('input',{style:(_vm.styles.navInput),attrs:{"type":"text","placeholder":"Search"},on:{"focus":_vm.navigateToMediaSearch}})]),_vm._v(" "),_c('button',{staticClass:"button__action",style:(_vm.styles.toggleUploadModalButton),on:{"click":_vm.refreshMedia}},[_c('i',{staticClass:"glyphicon glyphicon-refresh",style:(_vm.styles.uploadIcon)}),_vm._v(" \n      Reload\n    ")]),_vm._v(" "),_c('button',{staticClass:"button__action UppyModalToggle",style:(_vm.styles.toggleUploadModalButton),on:{"click":function($event){_vm.toggleUploadMediaModal(true)}}},[_c('i',{staticClass:"glyphicon glyphicon-plus",style:(_vm.styles.uploadIcon)}),_vm._v(" \n      Upload New\n    ")]),_vm._v(" "),_c('div',{staticClass:"UppyDashboardContainer"})]),_vm._v(" "),_c('div',{style:(_vm.styles.libraryWrapper),attrs:{"id":"libraryWrapper"}},[_c('LibraryGrid',[_c('div',{staticClass:"view-explanation"},[_c('h1',[_vm._v("Media")]),_vm._v(" "),_c('p',{staticClass:"no-bottom-margin"},[_vm._v("The media library is where you can manage media items, the markets they are available in, what product groups they belong in, and configure many more additional settings and properties. Media is available to view in-app within its active market(s).")])]),_vm._v(" "),_c('div',{staticClass:"content-filters-wrapper"},[_c('select',{on:{"change":_vm.handleGroupChange}},[_c('option',{attrs:{"value":"all","selected":""}},[_vm._v("All Products")]),_vm._v(" "),_vm._l((_vm.productGroups),function(group){return (_vm.productGroups && _vm.productGroups.length)?_c('option',{domProps:{"value":group._id}},[_vm._v("\n            "+_vm._s(group.title)+"\n          ")]):_vm._e()})],2)]),_vm._v(" "),(_vm.filteredItems)?_c('vue-tabs',{attrs:{"activeTextColor":"#09a3ed"},on:{"tab-change":_vm.handleTabChange}},[_vm._l((_vm.getMediaTabs),function(tab){return (_vm.getMediaTabs && _vm.getMediaTabs.length)?_c('v-tab',{key:("library-" + (tab._id)),attrs:{"title":tab.title}},[_c('div',{staticClass:"inner-tab"},[_c('draggable',{attrs:{"options":{draggable:'.item'}},on:{"end":_vm.updatePosition},model:{value:(_vm.filteredItems),callback:function ($$v) {_vm.filteredItems=$$v},expression:"filteredItems"}},_vm._l((_vm.filteredItems),function(media,index){return (_vm.mediaLoaded)?_c('MediaRow',{key:index,staticClass:"item",attrs:{"contentType":media.contentType,"title":media.title,"isTop":index === 0,"data-id":media._id,"id":media._id,"onClick":_vm.selectActiveMedia,"media":media,"selectedMlId":_vm.selectedMlId,"selectedPgId":_vm.selectedPgId,"refreshMedia":_vm.refreshMedia,"src":media.thumbnail,"isMediaLibrary":true}}):_vm._e()})),_vm._v(" "),(_vm.mediaLoaded && !_vm.filteredItems.length)?_c('div',[_c('p',{style:(_vm.styles.noMedia)},[_vm._v("No media.")])]):_vm._e()],1)]):_vm._e()}),_vm._v(" "),(_vm.mediaLibraries && _vm.mediaLibraries.length)?_c('v-tab',{key:"library-uncategorized",attrs:{"title":"(Uncategorized)"}},[_c('div',{staticClass:"inner-tab"},[_c('draggable',{attrs:{"options":{draggable:'.item'}},on:{"end":_vm.updatePosition},model:{value:(_vm.filteredItems),callback:function ($$v) {_vm.filteredItems=$$v},expression:"filteredItems"}},_vm._l((_vm.filteredItems),function(media,index){return (_vm.mediaLoaded)?_c('MediaRow',{key:index,staticClass:"item",attrs:{"contentType":media.contentType,"title":media.title,"isTop":index === 0,"data-id":media._id,"id":media._id,"onClick":_vm.selectActiveMedia,"media":media,"selectedMlId":_vm.selectedMlId,"selectedPgId":_vm.selectedPgId,"refreshMedia":_vm.refreshMedia,"src":media.thumbnail,"isMediaLibrary":true}}):_vm._e()})),_vm._v(" "),(_vm.mediaLoaded && !_vm.filteredItems.length)?_c('div',[_c('p',{style:(_vm.styles.noMedia)},[_vm._v("No media.")])]):_vm._e()],1)]):_vm._e()],2):_vm._e()],1)],1),_vm._v(" "),(!_vm.mediaLoaded)?_c('Spinner'):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/VJE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/W+x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('nav',{staticClass:"nav"},[_c('div'),_c('div'),_c('button',{staticClass:"button__action",attrs:{"to":"/products/create"},on:{"click":_vm.toggleCreateProductGroupModal}},[_vm._v("Create New Product Group")])]),_c('LibraryGrid',[_c('div',{staticClass:"view-explanation"},[_c('h1',[_vm._v("Product Groups")])]),(!_vm.getProductGroups.length)?_c('button',{staticClass:"box",on:{"click":_vm.toggleCreateProductGroupModal}},[_vm._v("Create a New Product Group")]):_vm._e(),_vm._l((_vm.getProductGroups),function(productGroup){return (_vm.getProductGroups.length)?_c('router-link',{key:("" + (productGroup._id)),staticClass:"product-group__link",attrs:{"to":("/product-groups/" + (productGroup._id))}},[_c('div',{staticClass:"product box"},[_c('h3',[_vm._v(_vm._s(productGroup.title))])])]):_vm._e()})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/bWl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaUpload_vue__ = __webpack_require__("jDUJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_195104a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MediaUpload_vue__ = __webpack_require__("6u2B");
function injectStyle (ssrContext) {
  __webpack_require__("X7oY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_195104a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MediaUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/mSH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/t0J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "02Ee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{style:(_vm.styles.nav)},[_c('button',{staticClass:"button__action",on:{"click":_vm.goBack}},[_vm._v("\n      ← Back\n    ")]),_vm._v(" "),_c('div',{style:(_vm.styles.navInputWrapper)},[_c('i',{staticClass:"glyphicon glyphicon-search",style:(_vm.styles.navInputIcon)}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],ref:"searchInput",style:(_vm.styles.navInput),attrs:{"type":"text","placeholder":"Search by title, description, filename..."},domProps:{"value":(_vm.searchQuery)},on:{"keyup":_vm.searchMedia,"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])]),_vm._v(" "),_c('div',{style:(_vm.styles.libraryWrapper),attrs:{"id":"mediaLibraryContainer"}},[(_vm.mediaItems.length)?_c('LibraryGrid',_vm._l((_vm.mediaItems),function(media,index){return _c('MediaCard',{key:index,attrs:{"contentType":media.contentType,"title":media.title,"id":media._id,"onClick":_vm.selectActiveMedia,"media":media,"src":media.thumbnail}})})):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "02d3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Delete_vue__ = __webpack_require__("efj3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_06ea22bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Delete_vue__ = __webpack_require__("t9gd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Delete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_06ea22bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Delete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0ByY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('nav',{staticClass:"nav"},[_c('router-link',{staticClass:"button__action",attrs:{"to":"/product-groups/","active-class":"null"}},[_c('i',{staticClass:"glyphicon glyphicon-chevron-left icon"}),_vm._v("Go back")]),_c('div',{staticClass:"submit__container"},[_c('div',{staticClass:"locales"},[(_vm.getActiveProductGroup.localRecords.length > 1)?_c('span',[_vm._v("Switching locales will clear unsaved changes.")]):_vm._e(),_vm._l((_vm.getSortedAvailableLocales),function(localRecord){return _c('button',{staticClass:"button",attrs:{"disabled":localRecord=== _vm.getActiveLocale,"value":"localRecord"},on:{"click":function($event){_vm.changeLocale(localRecord)}}},[_vm._v(_vm._s(localRecord))])})],2),_c('button',{staticClass:"button__submit",attrs:{"type":"button"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")]),_c('button',{staticClass:"button__action",on:{"click":_vm.toggleAddLocale}},[_vm._v("Add Locale")])])],1),_c('div',{staticClass:"editing__container"},[_c('div',{staticClass:"content__container"},[_c('h1',[_vm._v("Edit Product Group")]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Name")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.title),expression:"getActiveLocalRecord.title"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveLocalRecord.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord, "title", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Image URL")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.image),expression:"getActiveLocalRecord.image"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveLocalRecord.image)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord, "image", $event.target.value)}}}),(_vm.getActiveLocalRecord.image)?_c('img',{staticClass:"product-image",attrs:{"src":_vm.getActiveLocalRecord.image}}):_vm._e()])]),_c('div',{staticClass:"meta__container"},[_c('h1',[_vm._v(" ")]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Markets")]),_c('multiselect',{attrs:{"options":_vm.getMarketsByLocale,"placeholder":"Add a Market","multiple":true},model:{value:(_vm.getSortedAvailableLocales),callback:function ($$v) {_vm.getSortedAvailableLocales=$$v},expression:"getSortedAvailableLocales"}})],1),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Postal Codes")]),_c('vue-tags-input',{attrs:{"tags":_vm.tags,"placeholder":"Add Postal Code","validation":_vm.postalValidation,"disableAdd":false},on:{"tags-changed":function (newTags) { return _vm.tags = newTags; }},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0PtA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchMediaLibrary_vue__ = __webpack_require__("ZPAl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44b06b31_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchMediaLibrary_vue__ = __webpack_require__("02Ee");
function injectStyle (ssrContext) {
  __webpack_require__("AGCA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44b06b31"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchMediaLibrary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44b06b31_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchMediaLibrary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0Qp0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'registerUser',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "0W5C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon history-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M13.5,8H12V13L16.28,15.54L17,14.33L13.5,12.25V8M13,3C8.03,3 4,7.03 4,12H1L4.96,16.03L9,12H6C6,8.13 9.13,5 13,5C16.87,5 20,8.13 20,12C20,15.87 16.87,19 13,19C11.07,19 9.32,18.21 8.06,16.94L6.64,18.36C8.27,20 10.5,21 13,21C17.97,21 22,16.97 22,12C22,7.03 17.97,3 13,3"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0XmX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserLibrary_vue__ = __webpack_require__("MfUB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfc14e68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_UserLibrary_vue__ = __webpack_require__("loD8");
function injectStyle (ssrContext) {
  __webpack_require__("qCZX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cfc14e68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserLibrary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfc14e68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_UserLibrary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0gt9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LibraryGrid_vue__ = __webpack_require__("ercg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d65dec02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LibraryGrid_vue__ = __webpack_require__("0zXX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LibraryGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d65dec02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LibraryGrid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0zXX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.base)},[_c('div',{style:(_vm.styles.content)},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "17F8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vue-fine-uploader-status"},[_vm._v(_vm._s(_vm.state.status))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Et1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var isCancelable = function isCancelable(status) {
  return ['delete failed', 'paused', 'queued', 'retrying upload', 'submitted', 'uploading', 'upload failed'].indexOf(status) >= 0;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: Number,
      required: true
    },
    onlyRenderIfCancelable: {
      type: Boolean,
      default: true
    },
    uploader: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      state: {
        cancelable: true
      },
      _unmounted: false
    };
  },
  mounted: function mounted() {
    this.uploader.on('statusChange', this._onStatusChange);
  },
  beforeDestroy: function beforeDestroy() {
    this._unmounted = true;
    this._unregisterStatusChangeHandler();
  },


  methods: {
    _onStatusChange: function _onStatusChange(id, oldStatus, newStatus) {
      if (id === this.id && !this._unmounted) {
        if (!isCancelable(newStatus) && this.state.cancelable) {
          this.$set(this.state, 'cancelable', false);
        } else if (isCancelable(newStatus) && !this.state.cancelable) {
          this.$set(this.state, 'cancelable', true);
        } else if (newStatus === 'deleted' || newStatus === 'canceled') {
          this._unregisterStatusChangeHandler();
        }
      }
    },
    _onClick: function _onClick() {
      if (this.state.cancelable) {
        this.uploader.methods.cancel(this.id);
      }
    },
    _unregisterStatusChangeHandler: function _unregisterStatusChangeHandler() {
      this.uploader.off('statusChange', this._onStatusChange);
    }
  }
});

/***/ }),

/***/ "1JkZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CloseIcon",
  props: {
    title: {
      type: String,
      default: "Close icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "1LgV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageUser_vue__ = __webpack_require__("6DSP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4380396e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ManageUser_vue__ = __webpack_require__("OLIX");
function injectStyle (ssrContext) {
  __webpack_require__("ho1B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4380396e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4380396e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ManageUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1V01":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_LibraryGrid__ = __webpack_require__("0gt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sequenceLibrary",
  components: {
    LibraryGrid: __WEBPACK_IMPORTED_MODULE_0__general_LibraryGrid__["a" /* default */]
  },
  computed: {
    getSequences: function getSequences() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getSequences;
    }
  },
  data: function data() {
    return {
      showDeleted: false,
      query: "",
      styles: {
        wrapper: {
          display: "flex",
          flexFlow: "row nowrap",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          height: "100vh",
          boxSizing: "border-box"
        },
        nav: {
          position: "fixed",
          top: "0",
          left: "200",
          right: "0",
          background: "#fff",
          boxShadow: "0 2px 5px 1px rgba(0,0,0,0.1)",
          height: "60px",
          zIndex: "99",
          padding: "10",
          display: "flex",
          flexFlow: "row nowrap",
          alignItems: "center"
        },
        navInputWrapper: {
          flex: "0 0 auto",
          width: "250px",
          padding: "10",
          background: "#f5f5f5",
          border: "1px solid #eee",
          borderRadius: "5",
          overflow: "hidden",
          display: "flex",
          flexFlow: "row nowrap",
          alignItems: "center"
        },
        navInput: {
          flex: "1",
          padding: "0",
          borderRadius: "0",
          border: "0",
          background: "#f5f5f5"
        },
        navInputIcon: {
          margin: "auto 10px auto 0",
          color: "#888",
          fontSize: "1.25em"
        },
        toggleUploadModalButton: {
          background: "#09a3ed",
          fontSize: "0.9em",
          color: "#fff",
          borderRadius: "5px",
          padding: "5px 10px 5px 5px",
          margin: "auto 0 auto auto",
          border: "0",
          display: "flex",
          flexFlow: "row nowrap",
          alignItems: "center"
        },
        cardWrap: {
          background: "#fff",
          display: "flex",
          border: "1px solid #eee",
          cursor: "pointer",
          padding: "0 10px",
          flexFlow: "row nowrap",
          width: "calc(33.33% - 20px)",
          margin: "10px"
        },
        cardContainer: {
          display: "flex",
          flexFlow: "column nowrap"
        },
        cardPreview: {
          background: "teal",
          position: "relative",
          padding: "20"
        },
        cardName: {
          color: "#aaa",
          fontSize: "0.9em",
          marginBottom: "0"
        },
        cardMetadataSection: {
          display: "flex",
          flexFlow: "column nowrap",
          padding: "40",
          width: "100%"
        },
        cardType: {
          margin: "20px auto 10px 20px",
          color: "#888"
        },
        backIcon: {
          margin: "auto 5px auto auto",
          color: "#aaa"
        },
        actionType: {
          margin: "0 auto 20px 20px",
          fontSize: "1.5em"
        },
        tabWrap: {
          width: "100%",
          minHeight: "200",
          margin: "0",
          display: "flex",
          background: "#e8ffff",
          flexFlow: "column nowrap"
        },
        tabList: {
          listStyle: "none",
          display: "flex",
          flexFlow: "row nowrap",
          margin: "0",
          padding: "0"
        },
        tab: {
          flex: "1",
          padding: "10",
          borderBottom: "5px solid #fff",
          textAlign: "center"
        }
      }
    };
  },

  methods: {
    toggleDeleted: function toggleDeleted() {
      this.showDeleted = !this.showDeleted;
    },
    goToSequence: function goToSequence(id) {
      this.$router.push("/sequences/" + id);
    },
    createNewSequence: function createNewSequence() {
      var newSequence = {
        name: "",
        actionCards: [],
        templates: []
      };

      __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].setActiveSequence(newSequence);
      this.$router.push("/sequences/create");
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getSequences();
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].clearActiveSequence();
  }
});

/***/ }),

/***/ "1alf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{style:(_vm.styles.modalHeader)},[_c('h3',{style:(_vm.styles.modalTitle)},[_vm._v("Add Sequence To Policy")])]),_vm._v(" "),(_vm.checkCardsLoaded && _vm.getSequences)?_c('LibraryGrid',{attrs:{"baseStyle":{paddingTop: 0},"fullWidth":""}},_vm._l((_vm.getSequences),function(sequence){return _c('section',{key:sequence.name,staticClass:"cardWrap",style:(_vm.styles.cardWrap),on:{"click":function($event){_vm.setSelectedSequence(sequence)}}},[_c('div',{style:(_vm.styles.cardContainer)},[_c('p',{style:(_vm.styles.cardName)},[_vm._v("\n              Sequence\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n             "+_vm._s(sequence.name)+"\n            ")])]),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-chevron-right",style:(_vm.styles.backIcon)})])})):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1mLa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state.pausable || _vm.state.resumable || !_vm.onlyRenderIfEnabled)?_c('button',{staticClass:"vue-fine-uploader-pause-resume-button",class:_vm.buttonClassName,attrs:{"aria-label":_vm.buttonLabel,"disabled":!_vm.state.pausable && !_vm.state.resumable},on:{"click":_vm._onClick}},[(_vm.state.resumable)?_vm._t("resume",[_vm._v("Resume")]):_vm._t("state.pause",[_vm._v("Pause")])],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "20Zl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "27h4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'error',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "2VKE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "HistoryIcon",
  props: {
    title: {
      type: String,
      default: "History icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "2ZuK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('p',{staticClass:"slug"},[_vm._v(_vm._s(_vm.slug))]),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.cardTitle))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2hZx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CreateActionCard',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
  },
  computed: {
    getCardTypes: function getCardTypes() {
      if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getCardTypes.length) {
        return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getCardTypes;
      } else {
        __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].getCardTypes();
        return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getCardTypes;
      }
    },
    getMarkets: function getMarkets() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets;
    }
  },
  data: function data() {
    return {
      displayName: '',
      cardType: '',
      market: '',
      showError: false,
      inSequence: this.$route.name === 'sequenceTemplate'
    };
  },

  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      if (!this.displayName || !this.cardType) {
        this.showError = true;
        return false;
      }
      var newCard = {};

      newCard.displayName = this.displayName;

      newCard.cardType = this.cardType;

      newCard.markets = [this.market._id];

      newCard.fallbackLocale = this.market.locale;

      console.log(newCard);

      if (this.inSequence && __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveSequence._id) {
        newCard.sequence = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveSequence._id;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__services_Utils__["c" /* postResource */])('/v1/actioncards/create', false, newCard).then(function (res) {
        console.log('success!', res);
        _this.showSuccessMsg({ message: _this.displayName + ' card created!' });
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('hideModals', true);
        _this.$router.push('/cards/' + res.card._id);
        return res;
      }).catch(function (error) {
        var message = 'An error occurred. Please try again.';
        if (error.message) {
          message = error.message;
        }
        return _this.showErrorMsg({
          message: message
        });
      });
    }
  }
});

/***/ }),

/***/ "2mEl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardTeam_vue__ = __webpack_require__("JBFH");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_187f8aa5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardTeam_vue__ = __webpack_require__("owT0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardTeam_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_187f8aa5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardTeam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "2rtH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v("Create a New Market")]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Title")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],attrs:{"type":"text","placeholder":"Title"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}})]),_c('div',{staticClass:"form__control-group rule__control-group--select"},[_c('label',[_vm._v("Country")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.country),expression:"country"}],staticClass:"form__select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.country=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"disabled","selected":"selected"}},[_vm._v("Select Country")]),_vm._l((_vm.allCountries),function(country,index){return _c('option',{key:country.name,domProps:{"value":country.name}},[_vm._v(_vm._s(country.name))])})],2)]),_c('div',{staticClass:"form__control-group rule__control-group--select"},[_c('label',[_vm._v("Language")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.language),expression:"language"}],staticClass:"form__select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.language=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"disabled","selected":"selected"}},[_vm._v("Select Language")]),_vm._l((_vm.allLanguages),function(language,index){return _c('option',{key:language.name,domProps:{"value":language.code}},[_vm._v(_vm._s(language.name))])})],2)]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Activity Phrases")]),_c('div',{staticClass:"activity-phrases"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.choosePhrase),expression:"choosePhrase"}],attrs:{"type":"radio","value":"new"},domProps:{"checked":_vm._q(_vm.choosePhrase,"new")},on:{"change":function($event){_vm.choosePhrase="new"}}}),_vm._v("Create phrases from scratch")]),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.choosePhrase),expression:"choosePhrase"}],attrs:{"type":"radio","value":"copy"},domProps:{"checked":_vm._q(_vm.choosePhrase,"copy")},on:{"change":function($event){_vm.choosePhrase="copy"}}}),_vm._v("Copy phrases from existing market")]),(_vm.choosePhrase === 'copy')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.targetLocale),expression:"targetLocale"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.targetLocale=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.getMarkets),function(market){return _c('option',{domProps:{"value":market.locale}},[_vm._v(_vm._s(market.title))])})):_vm._e()])]),_c('button',{staticClass:"button__submit",on:{"click":_vm.submit}},[_vm._v("Create")]),(_vm.showError)?_c('p',{staticClass:"validation__error"},[_vm._v("Please enter a Title, Country, and Language")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3HI+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3brE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__rule-group"},[_vm._l((_vm.getRules),function(rule,index){return _c('div',{key:("rule-" + index)},[(index > 0 && _vm.getRules.length > 1)?_c('p',{staticClass:"text__and"},[_vm._v("and")]):_vm._e(),_c('Rule',{attrs:{"groupIndex":_vm.groupIndex,"ruleIndex":index}}),_c('span',{staticClass:"button__remove-group",on:{"click":function($event){_vm.removeRuleGroup(_vm.groupIndex)}}},[_c('DeleteIcon',{staticClass:"icon__close"})],1)],1)}),_c('p',{staticClass:"text__new",on:{"click":_vm.addNewRule}},[_vm._v("Add New Rule")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3by1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4D0O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestoreProduct_vue__ = __webpack_require__("yelj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81d7f77e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_RestoreProduct_vue__ = __webpack_require__("QsxE");
function injectStyle (ssrContext) {
  __webpack_require__("5ga2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-81d7f77e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestoreProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81d7f77e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_RestoreProduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4fE7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddMediaToCard_vue__ = __webpack_require__("/JEG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6138860c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddMediaToCard_vue__ = __webpack_require__("RBIG");
function injectStyle (ssrContext) {
  __webpack_require__("ZEKS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6138860c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddMediaToCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6138860c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddMediaToCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "544f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateProductLocalRecord',
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
    },
    data: function data() {
        return {
            newLocale: ''
        };
    },

    computed: {
        getActiveProductGroup: function getActiveProductGroup() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveProductGroup;
        },
        getAvailableMarkets: function getAvailableMarkets() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets;
        }
    },
    notifications: {
        showSuccessMsg: {
            type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.success,
            title: '',
            icon: '✅'
        },
        showErrorMsg: {
            type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.error,
            title: '',
            icon: '❗️'
        }
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].getMarkets();
    },

    methods: {
        submit: function submit() {
            var _this = this;

            var newRecord = {
                recordId: this.getActiveProductGroup._id,
                recordType: 'ProductGroup',
                locale: this.newLocale
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_Utils_js__["c" /* postResource */])('/v1/productgroups/addLocalRecord', false, newRecord).then(function (res) {
                console.log('success!', res);
                _this.showSuccessMsg({ message: 'New ' + _this.newLocale + ' record added to ' + _this.getActiveProductGroup.title + '!' });
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('hideModals', true);
                __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].setActiveProductGroup(_this.getActiveProductGroup._id, _this.$router.push('/product-groups/' + _this.getActiveProductGroup._id));
                return res;
            }).catch(function (error) {
                var message = 'An error occurred. Please try again.';
                if (error.error) {
                    message = error.error;
                }
                _this.showErrorMsg({
                    message: message
                });
            });
        }
    }
});

/***/ }),

/***/ "5D2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pause_resume_button_vue__ = __webpack_require__("9yI9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3026fbd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_pause_resume_button_vue__ = __webpack_require__("1mLa");
function injectStyle (ssrContext) {
  __webpack_require__("ibfx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pause_resume_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3026fbd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_pause_resume_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Do9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Toc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Uzx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5aEr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5ga2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5n36":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditCardHelp',
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_1__general_Modal__["a" /* default */]
    },
    computed: {
        getActiveLocalRecord: function getActiveLocalRecord() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getActiveLocalRecord;
        }
    },
    data: function data() {
        return {
            helpText: '',
            helpUrl: ''
        };
    },

    methods: {
        storeHelp: function storeHelp() {
            var activeRecord = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getActiveLocalRecord);
            if (!activeRecord.help) {
                activeRecord.help = {};
            }
            activeRecord.help.text = this.helpText;
            activeRecord.help.url = this.helpUrl;

            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveLocalRecord', activeRecord);

            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('hideModals', true);
        }
    },
    mounted: function mounted() {
        this.helpText = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getActiveLocalRecord.help.text || __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getActiveLocalRecord.help.helpText;
        this.helpUrl = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getActiveLocalRecord.help.url || __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getActiveLocalRecord.help.helpUrl;
    }
});

/***/ }),

/***/ "5sGG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PlusCircle_vue__ = __webpack_require__("Tais");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_350b56e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PlusCircle_vue__ = __webpack_require__("yK9K");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PlusCircle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_350b56e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PlusCircle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5tbp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('LibraryGrid',[_c('div',{staticClass:"view-explanation"},[_c('h1',[_vm._v("Interaction Types")]),_vm._l((_vm.interactionTypes),function(interactionType){return _c('div',[_c('h2',[_vm._v(_vm._s(interactionType.name))]),(!interactionType.props || !interactionType.props.length)?_c('p',[_vm._v("No properties.")]):_vm._e(),(interactionType.props.length)?_c('div',{staticClass:"type-container"},_vm._l((interactionType.props),function(prop){return _c('div',[_c('h3',[_vm._v("Property: "+_vm._s(prop.key))]),_c('table',[_c('thead',[_c('tr',[_c('th',[_vm._v("Operators")]),_c('th',[_vm._v("Comparands")])])]),_c('tr',[_c('td',{attrs:{"valign":"top"}},_vm._l((prop.operators),function(operator){return _c('p',[_vm._v(_vm._s(operator))])})),_c('td',{attrs:{"valign":"top"}},[_vm._l((prop.comparands),function(comparand){return (prop.key !== 'Contact Country')?_c('p',[_vm._v(_vm._s(comparand))]):_vm._e()}),(prop.key === 'Contact Country')?_c('p',[_vm._v("(List of countries)")]):_vm._e(),(!prop.comparands || !prop.comparands.length)?_c('p',[_vm._v("(User input)")]):_vm._e()],2)])])])})):_vm._e()])})],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "61q0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage__ = __webpack_require__("+Y1O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Utils__ = __webpack_require__("8u3o");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  methods: {
    handleFormSubmit: function handleFormSubmit() {
      var domain = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getDomain;
      if (!domain) return console.error('No tenant domain found');

      var email = this.email;
      var pswd = this.password;

      this.validateLogin(domain, email, pswd).then(function (res) {
        console.log('validated');
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('GEG__KEY', res.token);
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setUser', res.user);
        return __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'dashboard' });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('GEG__KEY', '');
        return alert(error.error ? error.error : 'Authentication unsuccessful. Please check your credentials and try again.');
      });
    },
    validateLogin: function validateLogin(domain, email, pswd) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // check tenant, email
        // get back new token
        // submit validation with token, password
        // on response, set token and redirect

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_Utils__["c" /* postResource */])('/v1/auth/login', false, { domain: domain, email: email }).then(function (loginRes) {
          var token = loginRes.token;

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_Utils__["c" /* postResource */])('/v1/auth/validate', false, { token: token, value: pswd }).then(function (valRes) {
            return resolve(valRes);
          }).catch(function (err) {
            return reject(err);
          });
        }).catch(function (err) {
          return reject(err);
        });
      });
    }
  },
  computed: {
    getIcon: function getIcon() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getTenant.icon;
    },
    getTenantName: function getTenantName() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getTenant.name;
    }
  },
  data: function data() {
    return {
      email: '',
      password: '',
      styles: {
        base: {
          background: '#f5f5f5',
          boxShadow: '0 0 40px 10px rgba(0,0,0,0.2)',
          width: '60vw',
          height: '100vh',
          display: 'flex',
          flexFlow: 'column nowrap',
          alignItems: 'center',
          justifyContent: 'center'
        },
        form: {
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        formHeader: {
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 40px 0'
        },
        formHeaderTitle: {
          padding: '0 20px',
          fontSize: '1.25em',
          lineHeight: '1.5',
          fontWeight: 400,
          margin: 'auto 0'
        },
        icon: {
          background: '#fff',
          padding: '15px',
          border: '1px solid #aaa',
          borderRadius: '8px',
          height: '90px',
          width: '90px',
          margin: '0px'
        },
        inputContainer: {
          marginBottom: '20px',
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        inputContainerLabel: {
          color: '#888',
          fontSize: '0.8em',
          fontWeight: 700,
          textTransform: 'uppercase',
          margin: '10px 0 10px'
        }
      }
    };
  },
  mounted: function mounted() {
    this.$refs.emailInput.focus();
  }
});

/***/ }),

/***/ "62Jf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":_vm.maxSize,"width":_vm.maxSize,"viewBox":"0 0 251 300","version":"1.1"}},[_c('path',{attrs:{"fill":"#ffffff","d":" M 0.00 0.00 L 5.50 0.00 C 3.57 0.58 1.55 1.87 1.38 4.07 C 1.02 9.12 1.37 14.18 1.25 19.24 C 3.20 19.24 5.16 19.25 7.11 19.25 C 7.40 28.45 9.49 37.52 12.75 46.10 C 18.73 61.86 27.86 76.33 38.93 89.01 C 51.26 103.08 66.33 115.05 83.64 122.38 C 92.38 125.91 101.16 130.29 107.51 137.46 C 111.25 141.69 113.80 147.59 112.27 153.28 C 110.17 161.20 103.40 166.70 96.69 170.79 C 89.30 175.47 80.72 177.72 73.23 182.19 C 49.26 195.79 30.23 217.29 17.84 241.76 C 11.88 253.74 7.50 266.77 7.12 280.25 C 5.17 280.24 3.21 280.25 1.25 280.25 C 1.33 285.16 1.08 290.08 1.33 294.98 C 1.27 297.00 2.89 298.48 4.63 299.18 L 3.28 300.00 L 0.00 300.00 L 0.00 0.00 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#525352","d":" M 5.50 0.00 L 247.37 0.00 C 248.74 1.06 250.50 2.15 250.61 4.09 C 250.98 9.13 250.63 14.20 250.74 19.25 C 248.78 19.25 246.83 19.25 244.88 19.24 C 165.62 19.26 86.37 19.25 7.11 19.25 C 5.16 19.25 3.20 19.24 1.25 19.24 C 1.37 14.18 1.02 9.12 1.38 4.07 C 1.55 1.87 3.57 0.58 5.50 0.00 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 247.37 0.00 L 251.00 0.00 L 251.00 280.03 C 248.96 280.02 246.91 280.00 244.88 280.00 C 244.45 266.87 240.25 254.16 234.50 242.45 C 221.25 215.98 200.24 192.80 173.59 179.46 C 165.71 175.90 157.44 172.91 150.54 167.53 C 144.88 163.36 139.54 157.36 139.33 149.97 C 139.30 143.07 143.94 137.23 149.09 133.12 C 153.86 129.29 159.25 126.29 164.85 123.87 C 192.12 113.26 214.12 91.86 229.08 67.08 C 237.62 52.52 244.37 36.33 244.88 19.24 C 246.83 19.25 248.78 19.25 250.74 19.25 C 250.63 14.20 250.98 9.13 250.61 4.09 C 250.50 2.15 248.74 1.06 247.37 0.00 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 7.11 19.25 C 86.37 19.25 165.62 19.26 244.88 19.24 C 244.37 36.33 237.62 52.52 229.08 67.08 C 214.12 91.86 192.12 113.26 164.85 123.87 C 159.25 126.29 153.86 129.29 149.09 133.12 C 143.94 137.23 139.30 143.07 139.33 149.97 C 139.54 157.36 144.88 163.36 150.54 167.53 C 157.44 172.91 165.71 175.90 173.59 179.46 C 200.24 192.80 221.25 215.98 234.50 242.45 C 240.25 254.16 244.45 266.87 244.88 280.00 C 246.91 280.00 248.96 280.02 251.00 280.03 L 251.00 300.00 L 3.28 300.00 L 4.63 299.18 C 32.74 298.76 60.88 299.12 88.99 299.00 C 141.33 298.98 193.67 299.04 246.01 298.97 C 248.39 299.36 250.34 297.28 250.43 295.00 C 250.84 290.16 250.49 285.30 250.54 280.46 C 235.08 280.04 219.61 280.35 204.14 280.24 C 204.25 271.94 200.83 262.74 192.78 259.18 C 179.36 253.86 164.31 255.95 150.76 251.10 C 146.18 249.52 142.78 245.77 140.47 241.63 C 136.29 234.23 134.05 225.89 132.66 217.56 C 129.77 193.84 127.20 169.41 132.91 145.89 C 135.79 134.35 141.55 122.37 152.34 116.37 C 169.77 109.21 183.92 95.49 193.57 79.51 C 199.34 69.89 203.67 59.09 204.10 47.77 C 151.96 47.74 99.82 47.74 47.69 47.77 C 48.53 64.72 57.24 80.21 67.92 92.97 C 76.39 102.82 86.86 111.13 98.92 116.11 C 109.46 121.51 115.24 132.92 118.35 143.87 C 124.19 165.77 122.50 188.78 119.91 211.03 C 119.06 220.86 116.79 230.67 112.47 239.57 C 109.94 244.79 105.92 249.73 100.15 251.43 C 87.83 255.43 74.51 254.35 62.11 258.03 C 57.61 259.31 53.55 262.18 51.19 266.26 C 48.40 270.33 47.98 275.36 47.70 280.13 C 34.18 280.41 20.65 280.18 7.12 280.25 C 7.50 266.77 11.88 253.74 17.84 241.76 C 30.23 217.29 49.26 195.79 73.23 182.19 C 80.72 177.72 89.30 175.47 96.69 170.79 C 103.40 166.70 110.17 161.20 112.27 153.28 C 113.80 147.59 111.25 141.69 107.51 137.46 C 101.16 130.29 92.38 125.91 83.64 122.38 C 66.33 115.05 51.26 103.08 38.93 89.01 C 27.86 76.33 18.73 61.86 12.75 46.10 C 9.49 37.52 7.40 28.45 7.11 19.25 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#525352","d":" M 47.69 47.77 C 99.82 47.74 151.96 47.74 204.10 47.77 C 203.67 59.09 199.34 69.89 193.57 79.51 C 183.92 95.49 169.77 109.21 152.34 116.37 C 141.55 122.37 135.79 134.35 132.91 145.89 C 127.20 169.41 129.77 193.84 132.66 217.56 C 134.05 225.89 136.29 234.23 140.47 241.63 C 142.78 245.77 146.18 249.52 150.76 251.10 C 164.31 255.95 179.36 253.86 192.78 259.18 C 200.83 262.74 204.25 271.94 204.14 280.24 C 219.61 280.35 235.08 280.04 250.54 280.46 C 250.49 285.30 250.84 290.16 250.43 295.00 C 250.34 297.28 248.39 299.36 246.01 298.97 C 193.67 299.04 141.33 298.98 88.99 299.00 C 60.88 299.12 32.74 298.76 4.63 299.18 C 2.89 298.48 1.27 297.00 1.33 294.98 C 1.08 290.08 1.33 285.16 1.25 280.25 C 3.21 280.25 5.17 280.24 7.12 280.25 C 20.65 280.18 34.18 280.41 47.70 280.13 C 47.98 275.36 48.40 270.33 51.19 266.26 C 53.55 262.18 57.61 259.31 62.11 258.03 C 74.51 254.35 87.83 255.43 100.15 251.43 C 105.92 249.73 109.94 244.79 112.47 239.57 C 116.79 230.67 119.06 220.86 119.91 211.03 C 122.50 188.78 124.19 165.77 118.35 143.87 C 115.24 132.92 109.46 121.51 98.92 116.11 C 86.86 111.13 76.39 102.82 67.92 92.97 C 57.24 80.21 48.53 64.72 47.69 47.77 Z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "64t4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColdDeckReset_vue__ = __webpack_require__("bNK2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b953d2e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColdDeckReset_vue__ = __webpack_require__("cXFH");
function injectStyle (ssrContext) {
  __webpack_require__("LNRi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b953d2e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColdDeckReset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b953d2e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColdDeckReset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "69Bm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6DSP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ManageUser',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
  },
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  props: ['selectedUser', 'close', 'refreshUsers', 'roles'],
  computed: {
    getRoles: function getRoles() {
      return ['admin', 'read', 'write'];
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      var body = {
        primary_email: this.primary_email,
        profile: {
          name: {
            first: this.profile.name.first,
            last: this.profile.name.last
          }
        },
        role: this.role,
        status: this.status
      };

      if (!this.selectedUser) {
        body.domain = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getDomain;
      }
      var action = this.selectedUser ? '/v1/users/update' : '/v1/users/create';
      var query = this.selectedUser ? 'id=' + this.selectedUser._id : false;

      console.log(body);
      console.log(query);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__services_Utils__["c" /* postResource */])(action, query, body).then(function (res) {

        if (_this.selectedUser) {
          _this.showSuccessMsg({
            message: 'User updated!'
          });
        } else {
          _this.showSuccessMsg({
            message: 'User created and sent password link!'
          });
        }
      }).then(function () {
        _this.refreshUsers();
        _this.close('manageUser');
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  data: function data() {
    return {
      profile: {
        name: {
          first: null,
          last: null
        }
      },
      primary_email: '',
      role: '',
      status: '',
      statuses: ['active', 'suspended', 'disabled', 'removed'],
      resetState: false,
      errors: {
        primary_email: false,
        profile: {
          name: {
            first: false,
            last: false
          }
        }
      }
    };
  },
  mounted: function mounted() {
    console.log(this.selectedUser || 'new user');
    if (!this.selectedUser) {
      this.status = 'active';
    } else {
      this.status = this.selectedUser.status;
      this.primary_email = this.selectedUser.primary_email;
      this.role = this.selectedUser.role;
      this.profile = this.selectedUser.profile;
      this.role = this.selectedUser.role;
    }
  }
});

/***/ }),

/***/ "6FaE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v("Create a New Action Card")]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Display Name")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayName),expression:"displayName"}],attrs:{"type":"text","placeholder":"Display Name"},domProps:{"value":(_vm.displayName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.displayName=$event.target.value}}})]),_c('div',{staticClass:"form__control-group rule__control-group--select"},[_c('label',[_vm._v("Card Type")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardType),expression:"cardType"}],staticClass:"form__select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cardType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"disabled","selected":"selected"}},[_vm._v("Select Card Type")]),_vm._l((_vm.getCardTypes),function(type,index){return _c('option',{key:type.name,domProps:{"value":type._id}},[_vm._v(_vm._s(type.name))])})],2)]),_c('div',{staticClass:"form__control-group rule__control-group--select"},[_c('label',[_vm._v("Default Market")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.market),expression:"market"}],staticClass:"form__select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.market=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"disabled","selected":"selected"}},[_vm._v("Select Market")]),_vm._l((_vm.getMarkets),function(market,index){return _c('option',{key:market.name,domProps:{"value":market}},[_vm._v(_vm._s(market.title)+" - "+_vm._s(market.primaryLanguage))])})],2)]),_c('button',{staticClass:"button__submit",on:{"click":_vm.submit}},[_vm._v("Create")]),(_vm.showError)?_c('p',[_vm._v("Please enter a Display Name and select a Card Type.")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6I4N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLibrary_vue__ = __webpack_require__("BUze");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfdec3f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardLibrary_vue__ = __webpack_require__("Gr9/");
function injectStyle (ssrContext) {
  __webpack_require__("zRab")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bfdec3f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLibrary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfdec3f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardLibrary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Jq3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon close-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6VL3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    maxSize: {
      type: Number
    }
  }
});

/***/ }),

/***/ "6XKK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    maxSize: {
      type: Number
    }
  }
});

/***/ }),

/***/ "6u2B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.uploader)?_c('Modal',[_c('Gallery',{attrs:{"uploader":_vm.uploader}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7/ZZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InteractionTypes_vue__ = __webpack_require__("7wuS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7025f992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InteractionTypes_vue__ = __webpack_require__("5tbp");
function injectStyle (ssrContext) {
  __webpack_require__("QlgD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InteractionTypes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7025f992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InteractionTypes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7PuQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7US3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon image-area-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M20,5C21.1,5 22,5.9 22,7V17C22,18.1 21.1,19 20,19H4C2.89,19 2,18.1 2,17V7C2,5.89 2.89,5 4,5H20M5,16H19L14.5,10L11,14.5L8.5,11.5L5,16Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7YgM":
/***/ (function(module, exports) {

module.exports = {"name":"geg-admin-client","version":"1.35.0","description":"GEG Services CMS Front-End","author":"gigeconomygroup","private":true,"scripts":{"dev":"node build/dev-server.js","local":"node build/local-server.js","start":"node build/dev-server.js","build":"node build/build.js","unit":"cross-env BABEL_ENV=test karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit && npm run e2e","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs"},"dependencies":{"@johmun/vue-tags-input":"^2.1.0","@uppy/aws-s3":"^0.29.0","@uppy/core":"^0.29.0","@uppy/dashboard":"^0.29.0","axios":"^0.19.2","babel-helper-vue-jsx-merge-props":"^2.0.3","chart.js":"^2.7.3","fine-uploader-wrappers":"^1.0.1","izitoast":"^1.4.0","jsbarcode":"^3.8.0","local-storage":"^1.4.2","lodash":"^4.17.15","moment":"^2.22.2","popper.js":"^1.14.5","toastr":"^2.1.2","vee-validate":"^2.1.2","vue":"^2.4.2","vue-analytics":"^5.1.1","vue-avatar":"^2.1.6","vue-fineuploader":"^2.0.0-rc.9","vue-material-design-icons":"^2.4.0","vue-multiselect":"^2.1.3","vue-nav-tabs":"^0.5.7","vue-notifications":"^0.9.0","vue-router":"^2.7.0","vue-select":"^2.5.1","vuedraggable":"^2.16.0","vuelidate":"^0.7.4","vuex":"^2.4.1","vuex-persistedstate":"^2.0.0","vuex-router-sync":"^5.0.0"},"devDependencies":{"autoprefixer":"^7.1.2","babel-core":"^6.26.3","babel-eslint":"^7.1.1","babel-loader":"^7.1.1","babel-plugin-istanbul":"^5.1.1","babel-plugin-transform-runtime":"^6.22.0","babel-preset-env":"^1.7.0","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","callback-loader":"^0.2.4","chai":"^3.5.0","chalk":"^2.0.1","chromedriver":"^2.43.1","connect-history-api-fallback":"^1.3.0","copy-webpack-plugin":"^4.6.0","cross-env":"^5.0.1","cross-spawn":"^5.0.1","css-loader":"^0.28.0","cssnano":"^3.10.0","eslint":"^3.19.0","eslint-config-standard":"^6.2.1","eslint-friendly-formatter":"^3.0.0","eslint-loader":"^1.7.1","eslint-plugin-html":"^3.0.0","eslint-plugin-promise":"^3.4.0","eslint-plugin-standard":"^2.3.1","eventsource-polyfill":"^0.9.6","express":"^4.14.1","extract-text-webpack-plugin":"^2.0.0","file-loader":"^0.11.1","friendly-errors-webpack-plugin":"^1.1.3","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.19.0","inject-loader":"^3.0.0","karma":"^4.0.1","karma-coverage":"^1.1.2","karma-mocha":"^1.3.0","karma-phantomjs-launcher":"^1.0.2","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.3.1","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.31","karma-webpack":"^2.0.2","mocha":"^6.0.2","nightwatch":"^1.0.19","node-sass":"^4.13.1","opn":"^5.1.0","optimize-css-assets-webpack-plugin":"^2.0.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.16","pug":"^2.0.3","rimraf":"^2.6.0","sass-loader":"^6.0.6","selenium-server":"^3.141.5","semver":"^5.3.0","shelljs":"^0.7.6","sinon":"^2.1.0","sinon-chai":"^2.8.0","style-loader":"^0.19.0","url-loader":"^1.1.2","vue-loader":"^13.0.4","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^2.6.1","webpack-bundle-analyzer":"^2.2.1","webpack-dev-middleware":"^1.10.0","webpack-hot-middleware":"^2.18.0","webpack-merge":"^4.1.0"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),

/***/ "7aWo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CopyCardLocalRecord_vue__ = __webpack_require__("s13m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b26d885_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CopyCardLocalRecord_vue__ = __webpack_require__("mJol");
function injectStyle (ssrContext) {
  __webpack_require__("nFDS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b26d885"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CopyCardLocalRecord_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b26d885_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CopyCardLocalRecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7kDE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteRecord_vue__ = __webpack_require__("hZML");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b57c5a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteRecord_vue__ = __webpack_require__("ITDl");
function injectStyle (ssrContext) {
  __webpack_require__("/mSH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b57c5a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteRecord_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b57c5a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteRecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7wuS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_LibraryGrid__ = __webpack_require__("0gt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Utils__ = __webpack_require__("8u3o");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'InteractionTypes',
    components: {
        LibraryGrid: __WEBPACK_IMPORTED_MODULE_0__general_LibraryGrid__["a" /* default */]
    },
    data: function data() {
        return {
            interactionTypes: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_Utils__["a" /* getResource */])('/v1/policies/interaction-types').then(function (res) {
            _this.interactionTypes = res.types;
        }).catch(function (error) {
            console.log(error);
        });
    }
});

/***/ }),

/***/ "7zKI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Register Team")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "83Hu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__("uTrW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4f6e194_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__("KLkz");
function injectStyle (ssrContext) {
  __webpack_require__("WVmP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4f6e194"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4f6e194_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8Qc7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v("Are you sure you want to delete this product?")]),_c('div',{staticClass:"button-wrapper"},[_c('button',{staticClass:"button button__submit",on:{"click":function($event){_vm.remove()}}},[_vm._v("Yes")]),_c('button',{staticClass:"button",on:{"click":function($event){_vm.cancel()}}},[_vm._v("Cancel")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8fXO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8u3o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return postResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return postImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_local_storage__ = __webpack_require__("+Y1O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("olkN");






/**
* Global API methods
*/
function getResource(url, query) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('' + __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getApi + url + (query ? '?' + query : ''), {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3_local_storage___default.a.get('GEG__KEY')
            }
        }).then(function (res) {
            if (res.status === 200) return res.json();
            return reject(res);
        }).then(function (res) {
            return resolve(res);
        }).catch(function (error) {
            return reject(error);
        });
    });
}

function postResource(url, query, body) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('' + __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getApi + url + (query ? '?' + query : ''), {
            'method': 'POST',
            'headers': {
                'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3_local_storage___default.a.get('GEG__KEY'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            'body': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body)
        }).then(function (res) {
            return res.json();
        }).then(function (res) {
            if (res.status === 'success') return resolve(res);
            return reject(res);
        }).catch(function (error) {
            return reject(error);
        });
    });
}

function postImage(url, query, body) {
    var formData = new FormData();
    formData.append('file', body);
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('' + __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getApi + url + (query ? '?' + query : ''), {
            'method': 'POST',
            'headers': {
                'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3_local_storage___default.a.get('GEG__KEY')

            },
            'body': formData
        }).then(function (res) {
            return res.json();
        }).then(function (res) {
            if (res.status === 'success') return resolve(res);
            return reject(res);
        }).catch(function (error) {
            return reject(error);
        });
    });
}



/***/ }),

/***/ "9FoL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ContentSave_vue__ = __webpack_require__("N3Ep");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0a56d406_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ContentSave_vue__ = __webpack_require__("JbFR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ContentSave_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0a56d406_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ContentSave_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9P+G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var roles = {
  actionCards: {
    label: 'Action Cards',
    icon: 'edit'
  },
  markets: {
    label: 'Markets',
    icon: 'globe'
  },
  media: {
    label: 'Media',
    icon: 'film'
  },
  mediaLibraries: {
    label: 'Media Libraries',
    icon: 'th'
  },
  policies: {
    label: 'Policies',
    icon: 'bell'
  },
  products: {
    label: 'Products',
    icon: 'tags'
  },
  productGroups: {
    label: 'Product Groups',
    icon: 'inbox'
  },
  roles: {
    label: 'Roles',
    icon: 'briefcase'
  },
  sequences: {
    label: 'Sequences',
    icon: 'tasks'
  },
  users: {
    label: 'Users',
    icon: 'user'
  },
  tenant: {
    label: 'Team',
    icon: 'cog'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ManageRole',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
  },
  props: ['selectedRole', 'close', 'refreshRoles'],
  computed: {
    getMarkets: function getMarkets() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets;
    }
  },
  data: function data() {
    return {
      showError: false,
      title: '',
      privileges: {
        actionCards: 'read',
        markets: 'read',
        media: 'read',
        mediaLibraries: 'read',
        policies: 'read',
        products: 'read',
        productGroups: 'read',
        roles: 'read',
        sequences: 'read',
        users: 'read',
        tenant: 'read'
      },
      roles: roles
    };
  },

  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      var body = {
        title: this.title,
        privileges: this.privileges
      };
      var action = '/v1/tenants/roles/' + (this.selectedRole ? 'update' : 'create');
      var query = this.selectedRole ? 'roleId=' + this.selectedRole._id : false;
      console.log(query);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__services_Utils__["c" /* postResource */])(action, query, body).then(function (res) {
        console.log(res);
        _this.showSuccessMsg({ message: _this.title + ' role ' + (_this.selectedRole ? 'updated' : 'created') + '!' });
        _this.refreshRoles();
        _this.close('manageRole');
      }).catch(function (error) {
        return console.log(error);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      if (_this2.selectedRole) {
        _this2.title = _this2.selectedRole.title;
        _this2.privileges = _this2.selectedRole.privileges;
      }
    });
  }
});

/***/ }),

/***/ "9TV7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      type: Number,
      required: true
    },
    status: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      style: {
        display: 'inline-block',
        maxHeight: this.size,
        maxWidth: this.size
      },
      className: 'vue-fine-uploader-thumbnail-placeholder vue-fine-uploader-thumbnail-' + this.status + ' ' + (this.className || '')
    };
  }
});

/***/ }),

/***/ "9Zwc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getActiveCard)?_c('div',{staticStyle:{"height":"100%"}},[_c('div',{style:(_vm.styles.topBar)},[_c('button',{staticClass:"button__action",on:{"click":_vm.goBack}},[_c('ChevronLeftIcon',{staticClass:"icon"}),_vm._v("Back")],1),_c('div',{staticClass:"submit__container"},[_c('button',{staticClass:"button__action button__delete",on:{"click":function($event){_vm.deleteCard()}}},[_vm._v(_vm._s(_vm.getActiveCard.deleted ? 'Restore Card' : 'Delete Card'))]),_c('div',{staticClass:"alerts"},[(_vm.getActiveCard.localRecords.length > 1)?_c('span',[_vm._v("Switching locales will clear unsaved changes.")]):_vm._e(),(_vm.isDraft)?_c('span',[_vm._v("You are viewing a draft card. Click Publish to make this draft go live.")]):_vm._e()]),_c('div',{staticClass:"locales"},[_c('multiselect',{staticClass:"locale-picker",attrs:{"options":_vm.getSortedAvailableLocales,"searchable":false,"selectLabel":'',"allow-empty":false,"deselectLabel":'',"multiple":false},model:{value:(_vm.getActiveLocale),callback:function ($$v) {_vm.getActiveLocale=$$v},expression:"getActiveLocale"}})],1),_c('button',{staticClass:"button__action",on:{"click":_vm.toggleAddLocale}},[_vm._v("Add Locale")]),_c('button',{staticClass:"button__submit",class:_vm.unsavedChanges ? 'active' : 'disabled',attrs:{"type":"button"},on:{"click":_vm.saveChanges}},[_vm._v("Save Changes")]),_c('button',{staticClass:"button__submit",class:(!_vm.unsavedChanges && _vm.isDraft) ? 'active' : 'disabled',attrs:{"type":"button"},on:{"click":_vm.publishChanges}},[_vm._v("Publish Card")])])]),_c('div'),_c('div',{staticClass:"container"},[_c('div',{staticClass:"editing__container"},[_c('div',{staticClass:"card__title-wrapper"},[_c('div',{staticClass:"card__titles"},[_c('h4',[_vm._v(_vm._s(_vm.getActiveCard.legacyName))]),_c('h1',[_vm._v(_vm._s(_vm.getActiveCard.displayName))]),_c('p',[_vm._v("Last updated:"),_c('span',[_vm._v(" "+_vm._s(_vm.moment(_vm.getActiveCard.updatedAt)))])]),(_vm.getActiveCard.cardType)?_c('p',[_vm._v("Card Type:"),_c('span',[_vm._v(" "+_vm._s(_vm.getActiveCard.cardType.name || ''))])]):_vm._e()]),_c('div',{staticClass:"card-markets"},[_c('h3',[_vm._v("Markets")]),_c('multiselect',{attrs:{"options":_vm.getMarketsByLocale,"placeholder":"Add a Market","multiple":true},model:{value:(_vm.getSortedAvailableLocales),callback:function ($$v) {_vm.getSortedAvailableLocales=$$v},expression:"getSortedAvailableLocales"}})],1),(_vm.getAvailableFields.indexOf('message') > -1)?_c('div',{staticClass:"card-message"},[_c('h3',[_vm._v("Message")]),_c('section',{staticClass:"messages"},[_c('label',{attrs:{"for":"subject"}},[_vm._v("Subject")]),_c('MixedContentInput',{attrs:{"template":_vm.shortId,"isEditing":true,"section":"subject","paramOptions":_vm.getActiveCard.cardType.parameters,"edit":_vm.checkEdits}}),_c('label',{attrs:{"for":"body"}},[_vm._v("Body Message")]),_c('MixedContentInput',{attrs:{"template":_vm.shortId,"isEditing":true,"section":"bodyText","paramOptions":_vm.getActiveCard.cardType.parameters,"edit":_vm.checkEdits}}),(_vm.getActiveLocale !== 'EN-US' && _vm.getEnglishRecords)?_c('div',[_c('h3',[_vm._v("English Reference")]),_c('p',[_c('strong',[_vm._v("Subject:")]),_vm._v("  "+_vm._s(_vm.getEnglishRecords.message ? _vm.getEnglishRecords.message.subject : '(no content)'))]),_c('p',[_c('strong',[_vm._v("Body Text:")]),_vm._v("  "+_vm._s(_vm.getEnglishRecords.message ? _vm.getEnglishRecords.message.bodyText : '(no content)'))])]):_vm._e()],1)]):_vm._e(),(_vm.getAvailableFields.includes('reason'))?_c('div',{staticClass:"card-reason"},[_c('h3',[_vm._v("Reason")]),_c('section',{staticClass:"reason"}),_c('MixedContentInput',{attrs:{"template":_vm.shortId,"isEditing":true,"section":"reason","paramOptions":_vm.getActiveCard.cardType.parameters,"edit":_vm.checkEdits}}),(_vm.getActiveLocale !== 'EN-US' && _vm.getEnglishRecords)?_c('div',[_c('h3',[_vm._v("English Reference")]),_c('p',[_c('strong',[_vm._v("Reason:")]),_vm._v("  "+_vm._s(_vm.getEnglishRecords.reason ? _vm.getEnglishRecords.reason : '(no content)'))])]):_vm._e()],1):_vm._e()]),_c('div',{staticClass:"template__card-wrapper"},[_c('div',{staticClass:"action-card"},[_c('button',{staticClass:"button__action copy-button",on:{"click":_vm.toggleCopyContent}},[_vm._v("Copy Content From Another Market")]),_vm._m(0),(_vm.getAvailableFields.includes('title') || _vm.getAvailableFields.includes('callToAction'))?_c('div',{staticClass:"options"},[_c('label',[_vm._v("Card State:")]),_c('div',{staticClass:"button-group"},_vm._l((_vm.settings),function(setting){return _c('button',{key:("setting-" + setting),staticClass:"button__action",class:setting == _vm.activeSetting ? 'active' : '',on:{"click":function($event){_vm.setActiveSetting(setting)}}},[_vm._v(_vm._s(setting))])}))]):_vm._e(),_c('div',{staticClass:"action-card__container"},[_c('ActionCard',{staticClass:"action-card",attrs:{"activeSetting":_vm.activeSetting,"body":_vm.body,"callToAction":_vm.callToAction,"checkEdits":_vm.checkEdits,"helpText":_vm.helpText,"helpUrl":_vm.helpUrl,"displayName":_vm.displayName,"isEditing":true,"media":_vm.getActiveMedia,"subject":_vm.subject,"title":_vm.title,"params":_vm.getActiveCard.cardType.parameters,"fields":_vm.getAvailableFields}}),(_vm.getActiveLocale !== 'EN-US' && _vm.getEnglishRecords)?_c('div',{staticClass:"action-card-english"},[_c('h3',[_vm._v("English Reference")]),(_vm.getAvailableFields.indexOf('title') > -1)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.getEnglishRecords.title ? _vm.getEnglishRecords.title[_vm.activeSetting] : '(no content)'))]):_vm._e(),(_vm.getAvailableFields.indexOf('callToAction') > -1)?_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.getEnglishRecords.callToAction ? _vm.getEnglishRecords.callToAction[_vm.activeSetting] : '(no content)'))]):_vm._e(),(_vm.fields.includes('buttonText'))?_c('div',{staticClass:"action-button"},[_vm._v(_vm._s(_vm.getEnglishRecords.actionButton ? _vm.getEnglishRecords.actionButton[_vm.activeSetting] : '(no content)'))]):_vm._e(),(_vm.getAvailableFields.indexOf('help') > -1)?_c('div',{staticClass:"help"},[_vm._v(_vm._s(_vm.getEnglishRecords.help ? _vm.getEnglishRecords.help.text : ''))]):_vm._e()]):_vm._e()],1)])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Action Card")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9azx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__general_LibraryActionCard__ = __webpack_require__("JFG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_nav_tabs_themes_paper_css__ = __webpack_require__("CQ+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_nav_tabs_themes_paper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_nav_tabs_themes_paper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__general_MediaCard__ = __webpack_require__("lVNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__general_Spinner__ = __webpack_require__("dSGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MarketEditor',
  components: {
    LibraryActionCard: __WEBPACK_IMPORTED_MODULE_3__general_LibraryActionCard__["a" /* default */],
    MediaCard: __WEBPACK_IMPORTED_MODULE_6__general_MediaCard__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default.a,
    VueTabs: __WEBPACK_IMPORTED_MODULE_4_vue_nav_tabs__["VueTabs"],
    VTab: __WEBPACK_IMPORTED_MODULE_4_vue_nav_tabs__["VTab"]
  },
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_1_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_1_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data: function data() {
    return {
      showCards: false,
      showMarketChoices: false,
      copyFromMarket: '',
      showMedia: false,
      showProductGroups: false,
      showProducts: false,
      getFlagUrl: __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].getFlagUrl,
      marketLoaded: false
    };
  },

  computed: {
    getActiveMarket: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.getActiveMarket;
      },
      set: function set(market) {
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setActiveMarket', market);
      }
    },
    getMarkets: function getMarkets() {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.getMarkets;
    }
  },
  methods: {
    toggleCards: function toggleCards() {
      this.showCards = !this.showCards;
    },
    toggleCopyVolumeLinks: function toggleCopyVolumeLinks() {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('showCopyVolumeLinksModal', true);
    },
    toggleMedia: function toggleMedia() {
      this.showMedia = !this.showMedia;
    },
    toggleProductGroups: function toggleProductGroups() {
      this.showProductGroups = !this.showProductGroups;
    },
    toggleProducts: function toggleProducts() {
      this.showProducts = !this.showProducts;
    },
    createBlankActivityPhrases: function createBlankActivityPhrases() {
      var _this = this;

      var newRecord = {
        locale: this.getActiveMarket.locale.toLowerCase(),
        content: {
          enrollment: '',
          completed_enrollment: '',
          added_contact: '',
          media_followed_up: '',
          low_interest_follow_up: '',
          default_follow_up: '',
          shared_cart: '',
          purchased_cart: '',
          shipped_cart: '',
          scheduled_meeting_with_title: '',
          blank_meeting: '',
          future_meeting: '',
          sent_message: '',
          sent_email: '',
          meeting_invite: '',
          shared_media: '',
          shared_multiple_media: '',
          received_message: '',
          contact_assigned: '',
          contact_updated: '',
          failed_subscriptions: '',
          failed_subscriptions_followup: '',
          product_upsell: '',
          default: '',
          gdprtext: '',
          gdprsmstext: '',
          msgsignature: '',
          thankyou: ''
        }
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__services_Utils__["c" /* postResource */])('/v1/markets/addActivityPhrases', 'id=' + this.getActiveMarket._id, newRecord).then(function () {
        _this.showSuccessMsg({
          message: _this.getActiveMarket.title + ' activity phrases saved!'
        });
      }).then(function () {
        var marketId = _this.$route.params.marketId;

        __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].setActiveMarket(marketId);
      }).catch(function (error) {
        _this.showErrorMsg({
          message: 'There was an error. Please try again.'
        });
      });
    },
    copyActivityPhrases: function copyActivityPhrases() {
      this.showMarketChoices = true;
    },
    createCopiedPhrases: function createCopiedPhrases() {
      var _this2 = this;

      if (this.copyActivityPhrases) {
        var update = {
          locale: this.getActiveMarket.locale,
          targetLocale: this.copyFromMarket
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__services_Utils__["c" /* postResource */])('/v1/markets/copyActivityPhrases', 'id=' + this.getActiveMarket._id, update).then(function () {
          _this2.showSuccessMsg({
            message: _this2.getActiveMarket.title + ' activity phrases copied and saved!'
          });
        }).then(function () {
          var marketId = _this2.$route.params.marketId;

          __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].setActiveMarket(marketId);
        }).catch(function (error) {
          _this2.showErrorMsg({
            message: 'There was an error. Please try again.'
          });
        });
      } else {
        this.showErrorMsg({
          message: 'Please select a market to copy from.'
        });
      }
    },
    save: function save() {
      var _this3 = this;

      var update = {
        title: this.getActiveMarket.title,
        activityPhrases: this.getActiveMarket.activityPhrases,
        volumeLinks: this.getActiveMarket.volumeLinks.content
      };

      console.log('update', update);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__services_Utils__["c" /* postResource */])('/v1/markets/update', 'id=' + this.getActiveMarket._id, update).then(function () {
        _this3.showSuccessMsg({
          message: _this3.getActiveMarket.title + ' market saved!'
        });
      }).catch(function (error) {
        _this3.showSuccessMsg({
          message: 'There was an error. Please try again.'
        });
      });
    }
  },
  mounted: function mounted() {
    var marketId = this.$route.params.marketId;

    if (!marketId) {
      this.showErrorMsg({ message: 'No matching market found' });
      this.$router.push('/markets/');
    }

    __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].setActiveMarket(marketId);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].clearActiveProduct();
    __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].clearActiveMarket();
    __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].clearActiveRecords();
  }
});

/***/ }),

/***/ "9yI9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: Number,
      required: true
    },
    onlyRenderIfEnabled: {
      type: Boolean,
      default: true
    },
    allowPauseOnlyAfterFirstChunk: {
      type: Boolean,
      default: true
    },
    uploader: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      state: {
        pausable: false,
        resumable: false
      },
      _unmounted: false
    };
  },
  mounted: function mounted() {
    this.uploader.on('statusChange', this._onStatusChange);
    this.uploader.on('uploadChunk', this._onUploadChunk);
  },
  beforeDestroy: function beforeDestroy() {
    this._unmounted = true;
    this._unregisterOnStatusChangeHandler();
    this._unregisterOnUploadChunkHandler();
  },


  computed: {
    buttonClassName: function buttonClassName() {
      return this.resumable ? 'vue-fine-uploader-resume-button' : 'vue-fine-uploader-pause-button';
    },
    buttonLabel: function buttonLabel() {
      return this.resumable ? 'resume' : 'pause';
    }
  },

  methods: {
    isPausable: function isPausable(status) {
      return status === 'uploading';
    },
    isResumable: function isResumable(status) {
      return status === 'paused';
    },
    _onStatusChange: function _onStatusChange(id, oldStatus, newStatus) {
      if (id === this.id && !this._unmounted) {
        var pausable = this.isPausable(newStatus);
        var resumable = !pausable && this.isResumable(newStatus);

        this.$set(this.state, 'pausable', pausable);
        this.$set(this.state, 'resumable', resumable);

        if (newStatus === 'deleted' || newStatus === 'canceled' || newStatus === 'upload successful') {
          this._unregisterStatusChangeHandler();
          this._unregisterOnUploadChunkHandler();
        }
      }
    },
    _onClick: function _onClick() {
      if (this.state.pausable) {
        this.uploader.methods.pauseUpload(this.id);
      } else if (this.state.resumable) {
        this.uploader.methods.continueUpload(this.id);
      }
    },
    _onUploadChunk: function _onUploadChunk(id, name, chunkData) {
      if (id === this.id && this.allowPauseOnlyAfterFirstChunk === true && !this._unmounted) {
        if (chunkData.partIndex > 0 && !this.state.pausable) {
          this.$set(this.state, 'pausable', true);
          this.$set(this.state, 'resumable', false);
        } else if (chunkData.partIndex === 0 && this.state.pausable) {
          this.$set(this.state, 'pausable', false);
          this.$set(this.state, 'resumable', false);
        }
      }
    },
    _unregisterOnStatusChangeHandler: function _unregisterOnStatusChangeHandler() {
      this.uploader.off('statusChange', this._onStatusChange);
    },
    _unregisterOnUploadChunkHandler: function _unregisterOnUploadChunkHandler() {
      this.uploader.off('uploadChunk', this._onUploadChunk);
    },
    _unregisterStatusChangeHandler: function _unregisterStatusChangeHandler() {
      this.uploader.off('statusChange', this._onStatusChange);
    }
  }
});

/***/ }),

/***/ "A5tq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'spinner',
  props: {
    styles: {}
  },
  data: function data() {
    return {
      spinnerStyles: {
        wrapper: {
          position: 'absolute',
          top: '0',
          right: '0',
          left: '0',
          bottom: '0',
          margin: 'auto',
          display: 'block',
          height: '65px',
          width: '65px'
        }
      }
    };
  }
});

/***/ }),

/***/ "ADqj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddCardToSequence_vue__ = __webpack_require__("hQ+V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5c590fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCardToSequence_vue__ = __webpack_require__("+e6Z");
function injectStyle (ssrContext) {
  __webpack_require__("el3G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5c590fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddCardToSequence_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5c590fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCardToSequence_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AGCA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ae+d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Rule__ = __webpack_require__("H+iw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_design_icons_Delete__ = __webpack_require__("02d3");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ruleGroup',
  components: {
    DeleteIcon: __WEBPACK_IMPORTED_MODULE_2_vue_material_design_icons_Delete__["a" /* default */],
    Rule: __WEBPACK_IMPORTED_MODULE_1__Rule__["a" /* default */]
  },
  props: {
    groupIndex: Number
  },
  computed: {
    getRules: function getRules() {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.getActivePolicy.rules[this.groupIndex].groupRules;
    }
  },
  methods: {
    addNewRule: function addNewRule() {
      var activePolicy = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.getActivePolicy;
      activePolicy.rules[this.groupIndex].groupRules.push({});
    },
    removeRuleGroup: function removeRuleGroup(index) {
      console.log('clicking');
      var activePolicy = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.getActivePolicy;
      activePolicy.rules.splice(index, 1);
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setActivePolicy', activePolicy);
    }
  }
});

/***/ }),

/***/ "B6Tu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardTemplate_vue__ = __webpack_require__("Zkeb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f67c41_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CardTemplate_vue__ = __webpack_require__("9Zwc");
function injectStyle (ssrContext) {
  __webpack_require__("3by1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71f67c41"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f67c41_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CardTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B7da":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.container)},[_c('h2',[_vm._v("Reset Password")]),_vm._v(" "),(_vm.token)?_c('div',[_c('form',{style:(_vm.styles.form),on:{"submit":function($event){$event.preventDefault();return _vm.submitNewPassword($event)}}},[_c('p',[_vm._v("Please use the form below to create a new password.")]),_vm._v(" "),_c('div',{style:(_vm.styles.inputWrap)},[_c('span',{style:(_vm.styles.inputLabel)},[_vm._v("New Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pswd1),expression:"pswd1"}],staticClass:"input__text",attrs:{"type":"password","placeholder":"your new password","required":""},domProps:{"value":(_vm.pswd1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pswd1=$event.target.value}}})]),_vm._v(" "),_c('div',{style:(_vm.styles.inputWrap)},[_c('span',{style:(_vm.styles.inputLabel)},[_vm._v("New Password Again")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pswd2),expression:"pswd2"}],staticClass:"input__text",attrs:{"type":"password","placeholder":"your new password again","required":""},domProps:{"value":(_vm.pswd2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pswd2=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"button__submit",attrs:{"type":"submit"}},[_vm._v("Reset Password →")])])]):_vm._e(),_vm._v(" "),(!_vm.token)?_c('div',[(!_vm.emailSent && !_vm.formSubmitted)?_c('div',[_c('form',{style:(_vm.styles.form),on:{"submit":function($event){$event.preventDefault();return _vm.submitReset($event)}}},[_c('div',{style:(_vm.styles.inputWrap)},[_c('span',{style:(_vm.styles.inputLabel)},[_vm._v("Email Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"input__text",attrs:{"type":"email","placeholder":"you@somewhere.com","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"button__submit",attrs:{"type":"submit"}},[_vm._v("Send Reset Instructions →")])]),_vm._v(" "),_c('p',[_c('router-link',{staticClass:"password-link",attrs:{"to":"login"}},[_vm._v("← Back to Login")])],1)]):_vm._e(),_vm._v(" "),(!_vm.emailSent && _vm.formSubmitted)?_c('div',{style:(_vm.styles.spinnerContainer)},[_c('Spinner',{attrs:{"styles":_vm.styles.spinner}})],1):_vm._e(),_vm._v(" "),(_vm.emailSent && _vm.formSubmitted)?_c('div',[_c('p',{style:(_vm.styles.submitMessage)},[_vm._v("We have received your request to reset your password. If an account exists that is associated with the email provided, you should receive an email within the next few minutes with instructions on how to proceed. Thank you.")])]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BAag":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_loader_lib_template_compiler_index_id_data_v_52267942_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_upload_icon_vue__ = __webpack_require__("RQ7e");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__vue_loader_lib_template_compiler_index_id_data_v_52267942_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_upload_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BDc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CreateProductGroup',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
  },
  computed: {
    getMarkets: function getMarkets() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets;
    }
  },
  data: function data() {
    return {
      name: '',
      market: '',
      showError: false
    };
  },

  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      if (!this.name || !this.market) {
        this.showError = true;
        return false;
      }
      var newProductGroup = {};

      newProductGroup.title = this.name;
      newProductGroup.markets = this.market._id;

      newProductGroup.fallbackLocale = this.market.locale;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__services_Utils__["c" /* postResource */])('/v1/productgroups/create', false, newProductGroup).then(function (res) {
        console.log('success!', res);
        _this.showSuccessMsg({ message: _this.name + ' product group created!' });
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('hideModals', true);
        _this.$router.push('/product-groups/' + res.productGroup._id);
        return res;
      }).catch(function (error) {
        var message = 'An error occurred. Please try again.';
        if (error.message) {
          message = error.message;
        }
        _this.showErrorMsg({
          message: message
        });
      });
    }
  }
});

/***/ }),

/***/ "BUze":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general_Spinner__ = __webpack_require__("dSGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__general_LibraryGrid__ = __webpack_require__("0gt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__general_LibraryActionCard__ = __webpack_require__("JFG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("olkN");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cardLibrary',
  components: {
    LibraryGrid: __WEBPACK_IMPORTED_MODULE_3__general_LibraryGrid__["a" /* default */],
    LibraryActionCard: __WEBPACK_IMPORTED_MODULE_4__general_LibraryActionCard__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_2__general_Spinner__["a" /* default */]
  },
  computed: {
    checkCardsLoaded: function checkCardsLoaded() {
      return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.checkCardsReady;
    },
    getCards: function getCards() {
      return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.getCards;
    },
    getCardNames: function getCardNames() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.getCards);
    }
  },
  methods: {
    toggleNewCardModal: function toggleNewCardModal() {
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('showCreateCardModal', true);
    },
    toggleDeleted: function toggleDeleted() {
      this.showDeleted = !this.showDeleted;
    }
  },
  data: function data() {
    return {
      loading: true,
      cardQuery: '',
      showDeleted: false,
      styles: {
        wrapper: function wrapper(loaded) {
          return {
            display: 'flex',
            flexFlow: 'row nowrap',
            justifyContent: loaded ? 'flex-start' : 'center',
            alignItems: loaded ? 'flex-start' : 'center',
            height: '100vh',
            width: '100%'
          };
        },
        nav: {
          position: 'fixed',
          top: 0,
          left: '200px',
          right: 0,
          background: '#fff',
          boxShadow: '0 2px 5px 1px rgba(0,0,0,0.1)',
          height: '60px',
          zIndex: '99',
          padding: '10px',
          display: 'flex',
          justifyContent: 'space-between',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        navInputWrapper: {
          flex: '0 0 auto',
          width: '250px',
          padding: '10px',
          background: '#f5f5f5',
          border: '1px solid #eee',
          borderRadius: '5px',
          overflow: 'hidden',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        navInput: {
          flex: '1',
          padding: '0',
          borderRadius: '0',
          border: '0',
          fontSize: '14px',
          background: '#f5f5f5'
        },
        navInputIcon: {
          margin: 'auto 10px auto 0',
          color: '#888'
          // fontSize: '1.25rem'
        },
        toggleUploadModalButton: {
          background: '#09a3ed',
          fontSize: '0.9em',
          color: '#fff',
          borderRadius: '5px',
          padding: '5px 10px 5px 5px',
          margin: 'auto 0 auto auto',
          border: '0',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          ':hover': {
            cursor: 'pointer',
            opacity: '0.9'
          }
        },
        cardContainer: {
          display: 'flex',
          flexFlow: 'column nowrap',
          justifyContent: 'space-around'
        },
        cardPreview: {
          background: 'teal',
          position: 'relative',
          padding: '20px'
        },
        cardName: {
          color: '#aaa',
          fontSize: '13px',
          textTransform: 'capitalize'
          // fontFamily: 'proxima_nova_ltsemibold'
        },
        cardTitle: {
          // fontFamily: 'proxima_nova_ltsemibold',
          // fontSize: '1.2rem'
        },
        cardMetadataSection: {
          display: 'flex',
          flexFlow: 'column nowrap',
          padding: '40',
          width: '100%'
        },
        cardType: {
          margin: '20px auto 10px 20px',
          color: '#888'
        },
        backIcon: {
          margin: 'auto 5px auto auto',
          color: '#aaa'
        },
        actionType: {
          margin: '0 auto 20px 20px',
          fontSize: '1.5em'
        },
        tabWrap: {
          width: '100%',
          minHeight: '200px',
          margin: 0,
          display: 'flex',
          background: '#e8ffff',
          flexFlow: 'column nowrap'
        },
        tabList: {
          listStyle: 'none',
          display: 'flex',
          flexFlow: 'row nowrap',
          margin: 0,
          padding: 0
        },
        tab: {
          flex: '1',
          padding: '10',
          borderBottom: '5px solid #fff',
          textAlign: 'center'
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    console.log('lib view mounted');
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getCards(function () {
      _this.loading = false;
    });
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getCardTypes();
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getMarkets();
  }
});

/***/ }),

/***/ "BWa3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bhlb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BlEr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[(_vm.showAddCardToSequenceModal)?_c('AddCardToSequenceModal'):_vm._e(),_vm._v(" "),(_vm.showAddMediaToCardModal)?_c('AddMediaToCardModal'):_vm._e(),_vm._v(" "),(_vm.showAddSequenceToPolicyModal)?_c('AddSequenceToPolicyModal'):_vm._e(),_vm._v(" "),(_vm.showColdDeckModal)?_c('ColdDeckResetModal'):_vm._e(),_vm._v(" "),(_vm.showCreateCardLocalRecordModal)?_c('CreateCardLocalRecordModal'):_vm._e(),_vm._v(" "),(_vm.showCopyVolumeLinksModal)?_c('CopyVolumeLinksModal'):_vm._e(),_vm._v(" "),(_vm.showCopyLocalRecordModal)?_c('CopyCardLocalRecordModal'):_vm._e(),_vm._v(" "),(_vm.showCreateCardModal)?_c('CreateCardModal'):_vm._e(),_vm._v(" "),(_vm.showCreateMarketModal)?_c('CreateMarketModal'):_vm._e(),_vm._v(" "),(_vm.showCreateMediaLibraryLocalRecordModal)?_c('CreateMediaLibraryLocalRecordModal'):_vm._e(),_vm._v(" "),(_vm.showCreateMediaLibraryModal)?_c('CreateMediaLibraryModal'):_vm._e(),_vm._v(" "),(_vm.showCreateProductGroupModal)?_c('CreateProductGroupModal'):_vm._e(),_vm._v(" "),(_vm.showCreateProductLocalRecordModal)?_c('CreateProductLocalRecordModal'):_vm._e(),_vm._v(" "),(_vm.showCreateProductGroupLocalRecordModal)?_c('CreateProductGroupLocalRecordModal'):_vm._e(),_vm._v(" "),(_vm.showCreateProductModal)?_c('CreateProductModal'):_vm._e(),_vm._v(" "),(_vm.showDeprecateMediaModal)?_c('DeprecateMediaModal'):_vm._e(),_vm._v(" "),(_vm.showDeleteRecordModal)?_c('DeleteRecordModal'):_vm._e(),_vm._v(" "),(_vm.showCardHelpModal)?_c('EditHelpModal'):_vm._e(),_vm._v(" "),(_vm.showLogoutModal)?_c('LogoutModal'):_vm._e(),_vm._v(" "),(_vm.showMediaUploadModal)?_c('MediaUploadModal'):_vm._e(),_vm._v(" "),(_vm.showUploadProductImageModal)?_c('ProductImageUploadModal'):_vm._e(),_vm._v(" "),(_vm.showCardIconModal)?_c('CardIconUploadModal'):_vm._e(),_vm._v(" "),(_vm.showDeleteProductModal)?_c('DeleteProductModal'):_vm._e(),_vm._v(" "),(_vm.showRestoreProductModal)?_c('RestoreProductModal'):_vm._e(),_vm._v(" "),(_vm.showUpdateThumbModal)?_c('UpdateThumbModal'):_vm._e(),_vm._v(" "),_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bv+7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_LibraryGrid__ = __webpack_require__("0gt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general_Spinner__ = __webpack_require__("dSGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_nav_tabs_themes_paper_css__ = __webpack_require__("CQ+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_nav_tabs_themes_paper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_nav_tabs_themes_paper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_Utils__ = __webpack_require__("8u3o");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductLibrary',
  components: {
    LibraryGrid: __WEBPACK_IMPORTED_MODULE_0__general_LibraryGrid__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_2__general_Spinner__["a" /* default */],
    VueTabs: __WEBPACK_IMPORTED_MODULE_3_vue_nav_tabs__["VueTabs"],
    VTab: __WEBPACK_IMPORTED_MODULE_3_vue_nav_tabs__["VTab"]
  },
  computed: {
    getProducts: function getProducts() {
      return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.getProducts;
    },
    getProductGroups: function getProductGroups() {
      return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.getAllProductGroups;
    },
    getMarkets: function getMarkets() {
      return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.getMarkets;
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getProducts();
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getMarkets();
  },

  methods: {
    returnToActive: function returnToActive() {
      this.tabName = 'Active Products';
    },
    toggleCreateProductModal: function toggleCreateProductModal() {
      return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('showCreateProductModal', true);
    },
    handleTabChange: function handleTabChange(tabIndex, newTab) {
      var _this = this;

      if (this.tabName === 'Deleted Products') {
        // get deleted products
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__services_Utils__["a" /* getResource */])('/v1/products/deleted').then(function (res) {
          if (res.status === 'success') {
            _this.deletedProducts = res.products;
          }
          if (res.status === 'error') return console.log(res.error);
        }).catch(function (err) {
          return console.log(err);
        });
      }
    }
  },
  data: function data() {
    return {
      tabName: '',
      deletedProducts: []
    };
  }
});

/***/ }),

/***/ "BvEj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.wrapper)},[(_vm.policiesLoaded)?_c('LibraryGrid',{attrs:{"fullWidth":"fullWidth"}},[_c('div',{staticClass:"view-explanation"},[_c('button',{staticClass:"toggle-cards button__action button__delete",on:{"click":function($event){_vm.toggleDeleted()}}},[_vm._v(_vm._s(_vm.showDeleted ? 'View Active Policies' : 'View Deleted Policies'))]),_c('h1',[_vm._v("Policies")]),_c('p',[_vm._v("Policies are a set of rule groups that initiate a  "),_c('router-link',{attrs:{"to":"/sequences"}},[_vm._v("sequence")]),_vm._v(". Each group contains a set of rules and conditions. When a user of the app fulfills all the rules of the policy, the platform will launch the designated sequence and begin delivering  "),_c('router-link',{attrs:{"to":"/cards"}},[_vm._v("action cards.")])],1)]),_vm._l((_vm.getPolicies),function(policy){return (_vm.showDeleted ? policy.deleted : !policy.deleted)?_c('section',{staticClass:"cardWrap",on:{"click":function($event){_vm.setActivePolicy(policy)}}},[_c('div',{style:(_vm.styles.cardContainer)},[_c('p',{style:(_vm.styles.cardName)},[_vm._v("Policy")]),_c('p',[_vm._v(_vm._s(policy.title))])]),_c('i',{staticClass:"glyphicon glyphicon-chevron-right",style:(_vm.styles.backIcon)})]):_vm._e()}),(!_vm.showDeleted)?_c('section',{staticClass:"cardWrap",on:{"click":_vm.createNewPolicy}},[_c('div',{style:(_vm.styles.cardContainer)},[_c('p',{style:(_vm.styles.cardName)},[_vm._v("Policy")]),_c('p',[_vm._v("Create New Policy")])]),_c('i',{staticClass:"glyphicon glyphicon-chevron-right",style:(_vm.styles.backIcon)})]):_vm._e()],2):_vm._e(),(!_vm.policiesLoaded)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C+7Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:"mediaCardBase",staticClass:"mediaCard box__shadow box__shadow--link",style:([_vm.styles.card.base(_vm.src, _vm.isActiveItem) ].concat( _vm.viewSpecificStyles)),on:{"click":function($event){!_vm.isMediaLibrary ? _vm.handleMedia() : null},"mouseover":function($event){_vm.isMediaLibrary ? _vm.showOptions() : null},"mouseout":function($event){_vm.isMediaLibrary ? _vm.hideOptions() : null}}},[_c('div',{key:"mediaCardCard",style:(_vm.cardSpecificStyles)},[_c('span',{style:(_vm.styles.contentTag(_vm.contentType || 'video'))},[_vm._v(_vm._s(_vm.contentType || 'video'))]),_c('p',[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C3oi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_js__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__package_json__ = __webpack_require__("7YgM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__package_json__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'top',
  computed: {
    version: function version() {
      return __WEBPACK_IMPORTED_MODULE_3__package_json___default.a.version;
    }
  },
  data: function data() {
    return {
      loading: false,
      ready: false,
      styles: {
        wrap: function wrap(r) {
          return {
            opacity: r ? '1' : '0',
            transition: 'opacity 1500ms ease-out'
          };
        }
      }
    };
  },

  methods: {
    getDomain: function getDomain(domain) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__services_Utils_js__["a" /* getResource */])('/v1/tenants/domain').then(function (res) {
          console.log(res);
          console.log(res);
          __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setDomain', domain);
          if (res.status === 'success') {
            __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setTenant', res.tenant);
            return resolve();
          }
          __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setTenant', false);
          return reject(res);
        }).catch(function (err) {
          console.log(err);
          __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setTenant', false);
          return reject(err);
        });
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    console.log(__WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].getters.getTenant);
    if (!__WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].getters.getTenant._id) {
      var str = window.location.host;
      var domain = str.split('.')[0];
      this.getDomain(domain).then(function () {
        console.log(__WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].getters.getTenant._id);
        window.Intercom("boot", {
          app_id: "kkkzq24u"
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
    setTimeout(function () {
      _this.ready = true;
    }, 500);

    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setUser', {});
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setCards', []);
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setCardTypes', []);
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setActiveCard', {});
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setActiveLocalRecord', {});
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setActiveLocalRecordSaved', []);
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setMedia', []);
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setActiveMedia', {});
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setAllProducts', []);
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setActiveProducts', {});
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setAllProductGroups', []);
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setAllMediaLibraries', []);
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setActiveMediaLibrary', {});
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setMediaTabs', []);
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setMediaActiveTab', {});
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setPolicies', []);
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setActivePolicy', {});
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setInteractionTypes', []);
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setSelectedSequence', {});
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setMarkets', []);
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setActiveMarket', {});
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setSequences', []);
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setActiveSequence', {});
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setSequenceCards', []);
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setProducts', []);
    __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* default */].commit('setActiveProduct', {});
  }
});

/***/ }),

/***/ "C5+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaLibraryLibrary_vue__ = __webpack_require__("Ne/p");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_649473b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MediaLibraryLibrary_vue__ = __webpack_require__("mFHL");
function injectStyle (ssrContext) {
  __webpack_require__("I/Y4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-649473b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaLibraryLibrary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_649473b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MediaLibraryLibrary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CQ+f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CTts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card__wrapper box__shadow",style:(_vm.specificStyles)},[_c('section',{staticStyle:{"width":"100%"}},[(_vm.getActiveMedia && _vm.getActiveMedia.status)?_c('div',{style:(_vm.styles.mediaContainer)},[_c('MediaCard',{attrs:{"contentType":_vm.getActiveMedia.type,"onClick":_vm.toggleAddMediaToCardModal,"title":_vm.getActiveMedia.title,"isActiveItem":true,"isActionCard":true,"src":_vm.getActiveMedia.thumbnail,"content":_vm.getActiveMedia.contentType,"cardSpecificStyles":{ width: '100%' },"viewSpecificStyles":{ width: '100%', boxShadow: 'none' },"isMediaLibrary":false}})],1):_vm._e(),((_vm.media && !_vm.media.status) || _vm.getActiveCard.mediaId && !_vm.getActiveMedia || ((_vm.getActiveCard.cardType.name === 'media' || _vm.getActiveCard.cardType.name === 'message') && !_vm.getActiveMedia))?_c('div',{staticClass:"no-media-box"},[_c('button',{staticClass:"button__action",on:{"click":_vm.toggleAddMediaToCardModal}},[_vm._v("Add Media")])]):_vm._e(),(_vm.fields.includes('icon') && !_vm.getActiveLocalRecord.cardImageUrl)?_c('div',{staticClass:"no-media-box"},[_c('button',{staticClass:"button__action",on:{"click":function($event){_vm.toggleAddIconToCardModal('cardImageUrl')}}},[_vm._v("Add Image")])]):_vm._e(),(_vm.fields.includes('icon') && _vm.getActiveLocalRecord.cardImageUrl)?_c('div',[_c('img',{staticClass:"card-icon",attrs:{"src":_vm.getActiveLocalRecord.cardImageUrl},on:{"click":function($event){_vm.toggleAddIconToCardModal('cardImageUrl')}}})]):_vm._e(),(_vm.fields.includes('title'))?_c('div',[_c('MixedContentInput',{attrs:{"template":_vm.shortId,"activeSetting":_vm.activeSetting,"isEditing":_vm.isEditing,"section":"title","content":_vm.getActiveLocalRecord.title || '(no content)',"paramOptions":_vm.params,"edit":_vm.checkEdits}})],1):_vm._e(),(_vm.fields.includes('callToAction'))?_c('div',[_c('MixedContentInput',{attrs:{"template":_vm.shortId,"isEditing":_vm.isEditing,"activeSetting":_vm.activeSetting,"section":"callToAction","content":_vm.callToAction || '(no content)',"paramOptions":_vm.params,"edit":_vm.checkEdits}})],1):_vm._e(),(_vm.fields.includes('label'))?_c('div',{staticClass:"label"},[_c('label',[_vm._v("Label")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.label),expression:"getActiveLocalRecord.label"}],attrs:{"type":"text","placeholder":"Label"},domProps:{"value":(_vm.getActiveLocalRecord.label)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord, "label", $event.target.value)}}})]):_vm._e(),(_vm.fields.includes('socialLinks'))?_c('div',{staticClass:"link-list"},[_c('label',[_vm._v("Link List")]),_vm._l((_vm.getActiveLocalRecord.socialLinks),function(link,index){return _c('div',{staticClass:"link-item"},[_c('div',{staticClass:"link-icon"},[_c('label',[_vm._v("Icon")]),(_vm.getActiveLocalRecord.socialLinks[index].icon)?_c('img',{attrs:{"src":_vm.getActiveLocalRecord.socialLinks[index].icon}}):_vm._e(),(!_vm.getActiveLocalRecord.socialLinks[index].icon)?_c('button',{staticClass:"button__action",on:{"click":function($event){_vm.toggleAddIconToCardModal(index)}}},[_vm._v("Add Icon")]):_vm._e()]),_c('div',{staticClass:"link-text"},[_c('label',[_vm._v("Text")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.socialLinks[index].text),expression:"getActiveLocalRecord.socialLinks[index].text"}],attrs:{"type":"text"},domProps:{"value":(_vm.getActiveLocalRecord.socialLinks[index].text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord.socialLinks[index], "text", $event.target.value)}}})]),_c('div',{staticClass:"link-url"},[_c('label',[_vm._v("Url")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.socialLinks[index].url),expression:"getActiveLocalRecord.socialLinks[index].url"}],attrs:{"type":"text"},domProps:{"value":(_vm.getActiveLocalRecord.socialLinks[index].url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord.socialLinks[index], "url", $event.target.value)}}})]),_c('div',{staticClass:"link-delete",on:{"click":function($event){_vm.removeLinkItem(index)}}},[_vm._v("X")])])}),(!_vm.getActiveLocalRecord.socialLinks || _vm.getActiveLocalRecord.socialLinks.length < 6)?_c('button',{staticClass:"button__action add-link",on:{"click":_vm.addSocialLink}},[_vm._v("Add Link")]):_vm._e()],2):_vm._e(),(_vm.fields.includes('buttonText'))?_c('div',{staticClass:"action-button"},[_c('div',[_c('label',[_vm._v("Action Button Text")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.actionButton[_vm.activeSetting]),expression:"getActiveLocalRecord.actionButton[activeSetting]"}],attrs:{"type":"text"},domProps:{"value":(_vm.getActiveLocalRecord.actionButton[_vm.activeSetting])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord.actionButton, _vm.activeSetting, $event.target.value)}}})]),_c('div',[_c('label',[_vm._v("Action Button URL")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.actionUrl),expression:"getActiveLocalRecord.actionUrl"}],attrs:{"type":"text"},domProps:{"value":(_vm.getActiveLocalRecord.actionUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord, "actionUrl", $event.target.value)}}})])]):_vm._e(),(_vm.fields.includes('triggerContextImage') && !_vm.getActiveLocalRecord.trigger.imageUrl)?_c('div',{staticClass:"no-media-box"},[_c('button',{staticClass:"button__action",on:{"click":function($event){_vm.toggleAddIconToCardModal('trigger')}}},[_vm._v("Add Trigger Context Image")])]):_vm._e(),(_vm.fields.includes('triggerContextImage') && _vm.getActiveLocalRecord.trigger)?_c('div',{staticClass:"trigger-context-image"},[_c('img',{staticClass:"card-icon",attrs:{"src":_vm.getActiveLocalRecord.trigger.imageUrl},on:{"click":function($event){_vm.toggleAddIconToCardModal('trigger')}}}),(!_vm.getActiveLocalRecord.trigger.contextType === 'imageonly')?_c('label',[_vm._v("Trigger Context Url")]):_vm._e(),(!_vm.getActiveLocalRecord.trigger.contextType === 'imageonly')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.trigger.url),expression:"getActiveLocalRecord.trigger.url"}],attrs:{"type":"text"},domProps:{"value":(_vm.getActiveLocalRecord.trigger.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord.trigger, "url", $event.target.value)}}}):_vm._e()]):_vm._e()]),_c('div',{staticClass:"label"},[_c('label',[_vm._v("Background URL")]),_c('MixedContentInput',{attrs:{"template":_vm.shortId,"isEditing":_vm.isEditing,"activeSetting":_vm.activeSetting,"section":"backgroundUrl","content":_vm.getActiveLocalRecord.backgroundUrl || '(no content)',"paramOptions":_vm.params,"edit":_vm.checkEdits}})],1),(_vm.fields.includes('help'))?_c('footer',{staticStyle:{"align-self":"flex-end","width":"100%"}},[_c('div',{staticClass:"togglePopupButton",style:(_vm.styles.cardFooter),on:{"click":_vm.toggleFooterPopup}},[_c('a',{staticClass:"footer__link",attrs:{"href":_vm.helpUrl,"target":"_blank"},on:{"click":_vm.showHelpModal}},[_vm._v(_vm._s(_vm.getActiveLocalRecord.help && _vm.getActiveLocalRecord.help.text ? _vm.getActiveLocalRecord.help.text : '(no content)'))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CU9l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("RsN3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d3fb2258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("luDF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d3fb2258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D8EQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RuleGroup_vue__ = __webpack_require__("Ae+d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_689c03a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_RuleGroup_vue__ = __webpack_require__("3brE");
function injectStyle (ssrContext) {
  __webpack_require__("oLqE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-689c03a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RuleGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_689c03a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_RuleGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DKJX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DW0e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Da9Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Pencil_vue__ = __webpack_require__("F4kw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b4ada0ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Pencil_vue__ = __webpack_require__("eG35");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Pencil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b4ada0ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Pencil_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Drut":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeprecateMedia_vue__ = __webpack_require__("oxTG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9306da46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DeprecateMedia_vue__ = __webpack_require__("QIUK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeprecateMedia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9306da46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DeprecateMedia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dv9g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__ = __webpack_require__("27h4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a61bd2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__ = __webpack_require__("LcfB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a61bd2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EFJe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_filesize_vue__ = __webpack_require__("wqq6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e455c196_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_filesize_vue__ = __webpack_require__("QbYu");
function injectStyle (ssrContext) {
  __webpack_require__("nBIt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_filesize_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e455c196_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_filesize_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ELdm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v(" Copy content from another market")]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Copy Content from...")]),_c('multiselect',{attrs:{"options":_vm.getAvailableMarkets,"searchable":false,"selectLabel":'',"allow-empty":false,"deselectLabel":'',"multiple":false},model:{value:(_vm.copiedLocale),callback:function ($$v) {_vm.copiedLocale=$$v},expression:"copiedLocale"}})],1),_c('button',{staticClass:"button__submit",on:{"click":_vm.submit}},[_vm._v("Copy and replace volume links")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ENQm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rule__container"},[_c('div',{staticClass:"rule__control-group rule__control-group--select"},[_c('label',{staticClass:"label__rule"},[_vm._v("Type")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeType),expression:"activeType"}],staticClass:"form__select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.activeType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setActiveType]}},_vm._l((_vm.getInteractionTypes()),function(type,index){return _c('option',{key:((type.label) + "-" + index),domProps:{"value":type}},[_vm._v(_vm._s(type.label))])}))]),(_vm.activeType.props && _vm.activeType.props.length)?_c('div',{staticClass:"rule__control-group rule__control-group--select"},[_c('label',{staticClass:"label__rule"},[_vm._v("Property")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeProperty),expression:"activeProperty"}],staticClass:"form__select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.activeProperty=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setActiveProperty]}},_vm._l((_vm.activeType.props),function(prop,index){return _c('option',{key:((prop.key) + "-" + index),domProps:{"value":prop}},[_vm._v(_vm._s(prop.key))])}))]):_vm._e(),(_vm.activeProperty && _vm.activeProperty.operators && _vm.activeProperty.operators.length)?_c('div',{staticClass:"rule__control-group rule__control-group--select"},[_c('label',{staticClass:"label__rule"},[_vm._v("Operator")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeOperator),expression:"activeOperator"}],staticClass:"form__select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.activeOperator=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setActiveOperator]}},_vm._l((_vm.activeProperty.operators),function(operator,index){return _c('option',{key:(operator + "-" + index),domProps:{"value":operator}},[_vm._v(_vm._s(operator))])}))]):_vm._e(),(_vm.activeProperty && _vm.activeProperty.comparands && _vm.activeProperty.comparands.length)?_c('div',{staticClass:"rule__control-group rule__control-group--select"},[_c('label',{staticClass:"label__rule"},[_vm._v("Comparand")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeComparand),expression:"activeComparand"}],staticClass:"form__select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.activeComparand=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setActiveComparand]}},_vm._l((_vm.activeProperty.comparands),function(comparand,index){return _c('option',{key:(comparand + "-" + index),domProps:{"value":comparand}},[_vm._v(_vm._s(comparand))])}))]):_vm._e(),(_vm.activeProperty && !_vm.activeProperty.comparands.length)?_c('div',{staticClass:"rule__control-group"},[_c('label',{staticClass:"label__rule"},[_vm._v("Comparand")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeComparand),expression:"activeComparand"}],staticClass:"input__text",attrs:{"id":"comparandInput","type":"text"},domProps:{"value":(_vm.activeComparand)},on:{"change":_vm.setActiveComparand,"input":function($event){if($event.target.composing){ return; }_vm.activeComparand=$event.target.value}}})]):_vm._e(),_c('span',{on:{"click":_vm.removeRule}},[_c('CloseIcon',{staticClass:"remove__icon"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EOVc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUJE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClassName,attrs:{"hidden":_vm.state.hidden}},[_c('div',{class:_vm.className,style:({ 'width': _vm.percentWidth + '%' }),attrs:{"aria-valuemax":"100","aria-valuemin":"0","aria-valuenow":_vm.percentWidth,"role":"progressbar"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F4kw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PencilIcon",
  props: {
    title: {
      type: String,
      default: "Pencil icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "FOrB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateMediaLibrary_vue__ = __webpack_require__("fMvi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2f23970_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateMediaLibrary_vue__ = __webpack_require__("ceid");
function injectStyle (ssrContext) {
  __webpack_require__("xSQf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a2f23970"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateMediaLibrary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2f23970_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateMediaLibrary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FaWy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropZone",staticClass:"fine-uploader-dropzone-container"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FgtX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GME8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MaybeDropzoneContent_vue__ = __webpack_require__("h1k8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1e13be6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_MaybeDropzoneContent_vue__ = __webpack_require__("ZOaG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MaybeDropzoneContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1e13be6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_MaybeDropzoneContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gr9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.wrapper(_vm.getCards))},[_c('nav',{staticClass:"nav"},[_c('div'),_vm._v(" "),_c('div',[_c('button',{staticClass:"button__action",on:{"click":_vm.toggleNewCardModal}},[_vm._v("Create New Action Card")])])]),_vm._v(" "),(_vm.checkCardsLoaded && _vm.getCards)?_c('LibraryGrid',[_c('div',{staticClass:"view-explanation"},[_c('button',{staticClass:"toggle-cards button__action button__delete",on:{"click":function($event){_vm.toggleDeleted()}}},[_vm._v(_vm._s(_vm.showDeleted ? 'View Active Cards' : 'View Deleted Cards'))]),_vm._v(" "),_c('h1',[_vm._v("Action Cards")]),_vm._v(" "),_c('p',[_vm._v("Action cards are issued to app users, alone or within a\n        "),_c('router-link',{attrs:{"to":"/sequences"}},[_vm._v("sequence")]),_vm._v(", when certain conditions are met. Depending on the type of action card, these cards can deliver next steps, follow ups, general advice, and training media.\n      ")],1)]),_vm._v(" "),_vm._l((_vm.getCards),function(card,index){return (_vm.showDeleted ? card.deleted : !card.deleted)?_c('router-link',{key:index,staticClass:"card-wrap",attrs:{"to":'/cards/'+card._id}},[_c('LibraryActionCard',{attrs:{"slug":card.legacyName ? card.legacyName : '',"cardTitle":card.displayName === 'Training Media' ? (card.mediaId ? card.mediaId.title : '') : card.displayName,"media":card.mediaId ? card.mediaId : null,"title":card.title ? card.title.intial : null,"callToAction":card.callToAction ? card.callToAction.intial : ''}})],1):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H+iw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rule_vue__ = __webpack_require__("tZIx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d24331ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Rule_vue__ = __webpack_require__("ENQm");
function injectStyle (ssrContext) {
  __webpack_require__("PnVb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d24331ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Rule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H9sC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-container",style:(_vm.styles.container)},[_c('div',{attrs:{"id":("input__" + _vm.section)}},[(!_vm.content && !_vm.paramOptions)?_c('div',{staticClass:"empty-state"},[_vm._v("(no content)")]):_vm._e(),_vm._v(" "),_c('textarea',{ref:"textarea",class:_vm.isEmpty ? 'empty-state' : '',attrs:{"type":"text"},on:{"keyup":_vm.onInputChange,"blur":_vm.onInputBlur,"focus":_vm.onInputFocus,"click":_vm.onInputChange}},[_vm._v(_vm._s(_vm.content))]),_vm._v(" "),(_vm.showParamMenu)?_c('div',{staticClass:"menu__param-options",style:(_vm.styles.paramMenuStyles(this.paramCoords))},[_c('ul',_vm._l((_vm.filteredParamOptions()),function(option){return _c('li',{on:{"click":function () { return _vm.onParamClick(option); }}},[_vm._v("\n          "+_vm._s(option)+"\n        ")])}))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I/Y4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I2oz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: ''
    },
    uploader: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      _unmounted: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this._unmounted = true;
  },


  methods: {
    _onFilesSelected: function _onFilesSelected(e) {
      this.uploader.methods.addFiles(e.target);
    }
  }
});

/***/ }),

/***/ "IGsQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateCardLocalRecord_vue__ = __webpack_require__("f5s3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b4a89b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateCardLocalRecord_vue__ = __webpack_require__("Zbtr");
function injectStyle (ssrContext) {
  __webpack_require__("ZEDR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b4a89b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateCardLocalRecord_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b4a89b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateCardLocalRecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "INAC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ITDl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v("Are you sure you would like to delete this?")]),_c('div',{staticClass:"button-container"},[_c('button',{staticClass:"button__action",on:{"click":_vm.deleteRecord}},[_vm._v("Yes")]),_c('button',{staticClass:"button__action button__delete",on:{"click":_vm.closeModal}},[_vm._v("Cancel")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IfCs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general_PolicyForm__ = __webpack_require__("Togc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__general_Spinner__ = __webpack_require__("dSGv");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'policyTemplate',
  components: {
    policyForm: __WEBPACK_IMPORTED_MODULE_2__general_PolicyForm__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_7__general_Spinner__["a" /* default */]
  },
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  computed: {
    getInteractionTypes: function getInteractionTypes() {
      if (!__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getInteractionTypes.length) {
        console.log('running service');
        __WEBPACK_IMPORTED_MODULE_4__services_Services__["a" /* default */].getInteractionTypes();
      }
      return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getInteractionTypes;
    },
    getActivePolicy: function getActivePolicy() {
      return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getActivePolicy;
    },
    getSequences: function getSequences() {
      return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getSequences;
    }
  },
  methods: {
    returnToPolicies: function returnToPolicies() {
      this.$router.push('/policies');
    },
    deletePolicy: function deletePolicy() {
      var _this = this;

      if (this.getActivePolicy.deleted) {
        var update = {
          deleted: false,
          _id: this.$route.params.shortId
        };

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_Utils__["c" /* postResource */])('/v1/policies/delete', false, update).then(function (res) {
          _this.getActivePolicy.deleted = false;
          _this.showSuccessMsg({
            message: _this.getActivePolicy.title + ' Policy has been restored!'
          });
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('showDeleteRecordModal', true);
      }
    },
    getPolicy: function getPolicy() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_Utils__["a" /* getResource */])('/v1/policies/single', 'id=' + this.$route.params.shortId).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
          var policy, i, _loop, ii;

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  policy = res.policy;

                  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setSelectedSequence', policy.sequence);

                  if (policy.rules && !_this2.policyLoaded) {
                    if (policy.rules && policy.rules.length) {
                      for (i in policy.rules) {

                        if (policy.rules[i].groupRules && policy.rules[i].groupRules.length) {
                          _loop = function _loop(ii) {
                            var group = policy.rules[i].groupRules[ii];
                            if (group.interactionType) {
                              group.interactionType = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getInteractionTypes.find(function (t) {
                                return t._id === group.interactionType;
                              });
                              group.property = group.interactionType.props.find(function (p) {
                                return p._id === group.property;
                              });
                              var endFirst = i == policy.rules[i].groupRules.length - 1;
                              var endLast = ii == policy.rules[i].groupRules.length - 1;
                              console.log(endFirst, endLast);
                              if (endFirst && endLast) {
                                console.log('setting policy!');
                                //   store.commit('setActivePolicy', policy);
                                console.log(policy.rules[0].groupRules[0].property);
                              }
                            }
                            // console.log('setting policy!');
                            // store.commit('setActivePolicy', policy);
                            //   console.log(policy.rules[0][0].property);
                          };

                          for (ii in policy.rules[i].groupRules) {
                            _loop(ii);
                          }
                        }
                      }
                    }

                    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setActivePolicy', policy);
                    _this2.policyLoaded = true;
                  }

                case 3:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        return console.log(error);
      });
    }
  },
  data: function data() {
    return {
      oldN: {},
      newN: {},
      policyLoaded: false,
      styles: {
        container: {
          padding: '2rem',
          width: '100%'
        },
        pageHeader: {
          display: 'flex',
          padding: '0 1rem',
          width: '100%',
          position: 'relative'
        },
        pageHead: {
          fontSize: '1.5em',
          maxWidth: '600px',
          margin: '20px auto',
          fontWeight: '700',
          color: '#aaa'
        }
      }
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_4__services_Services__["a" /* default */].setInteractionTypes(this.getPolicy);
  }
});

/***/ }),

/***/ "J8d8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.container)},[_c('button',{staticClass:"button__action",on:{"click":_vm.returnToPolicies}},[_c('i',{staticClass:"glyphicon glyphicon-chevron-left icon"}),_vm._v(" Back to Policies")]),_c('div',{style:(_vm.styles.pageHeader)},[_c('h1',{style:(_vm.styles.pageHead)},[_vm._v("Create a New Policy")])]),_c('policyForm')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JA9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","fill":"#000000","viewBox":"0 0 24 24","width":"24"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JAUS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__johmun_vue_tags_input__ = __webpack_require__("vdhV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__johmun_vue_tags_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__johmun_vue_tags_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductGroupEditor',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a,
    VueTagsInput: __WEBPACK_IMPORTED_MODULE_6__johmun_vue_tags_input___default.a
  },
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data: function data() {
    return {
      tag: '',
      tags: [],
      postalValidation: [{
        classes: 'min-length',
        rule: function rule(tag) {
          return tag.text.length < 5;
        }
      }, {
        classes: 'only-numbers',
        rule: '^[0-9]*$'
      }]
    };
  },

  computed: {
    getActiveProductGroup: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveProductGroup;
      },
      set: function set(productGroup) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveProductGroup', productGroup);
      }
    },
    getActiveLocale: function getActiveLocale() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveLocale;
    },

    getActiveLocalRecord: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveLocalRecord;
      },
      set: function set(record) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocalRecord', record);
      }
    },
    getAllProductGroups: function getAllProductGroups() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAllProductGroups;
    },
    getMarkets: function getMarkets() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets;
    },

    getSortedAvailableLocales: {
      get: function get() {
        if (this.getActiveProductGroup && this.getActiveProductGroup.localRecords) {
          var locales = [];

          this.getActiveProductGroup.localRecords.forEach(function (locale) {
            locales.push(locale.locale);
          });

          return locales.sort(function (a, b) {
            return a.name - b.name;
          }).reverse();
        }
      },
      set: function set(newLocales) {
        var activeProductGroup = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getActiveProductGroup);
        activeProductGroup.markets = newLocales;
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveProductGroup', activeProductGroup);
        if (activeProductGroup.localRecords && newLocales.length > activeProductGroup.localRecords.length) {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('showCreateProductGroupLocalRecordModal', true);
        }
      }
    },
    getMarketsByLocale: function getMarketsByLocale() {
      if (this.getMarkets) {
        var marketsByLocale = [];

        this.getMarkets.forEach(function (market) {

          marketsByLocale.push(market.locale);
        });

        return marketsByLocale;
      }
    }
  },
  methods: {
    initializeProductGroup: function initializeProductGroup(edited) {
      var _this = this;

      var product = this.getActiveProductGroup;

      if (!product._id) {
        this.showErrorMsg({ message: 'No matching product found' });
        this.$router.push('/products/');
      }

      // initialize default locale when we have the product record, but don't reset the active locale if we're already editing
      if (!edited) {
        if (product.fallbackLocale) {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocale', product.fallbackLocale);
        } else if (product.localRecords) {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocale', product.localRecords[0].locale);
        }
      }

      var activeContent = product.localRecords && product.localRecords.length === 1 ? product.localRecords[0].content : product.localRecords.filter(function (record) {
        return record.locale === _this.getActiveLocale;
      })[0].content || {};

      if (activeContent) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocalRecord', activeContent);
        this.tags = activeContent.postalCodes;
      } else {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocalRecord', {});
      }
    },
    changeLocale: function changeLocale(locale) {
      console.log(locale);
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocale', locale);
      this.initializeProductGroup(true);
    },
    toggleAddLocale: function toggleAddLocale() {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('showCreateProductGroupLocalRecordModal', true);
    },
    save: function save() {
      var _this2 = this;

      var update = this.getActiveProductGroup;
      var contentUpdate = this.getActiveLocalRecord;
      update.content = contentUpdate;

      var postalCodes = [];

      if (this.tags && this.tags.length) {
        for (var i = 0; i < this.tags.length; i++) {
          var tag = this.tags[i];
          if (tag.tiClasses.indexOf('ti-invalid') === -1) {
            postalCodes.push(tag.text);
          }
        }
      }

      update.content.postalCodes = postalCodes;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_Utils__["c" /* postResource */])('/v1/productgroups/update', 'id=' + this.getActiveProductGroup._id + '&locale=' + encodeURIComponent(this.getActiveLocale), update).then(function (res) {
        console.log(res);
        // return  Services.setActiveProduct(productId, this.initializeProduct(true));
        __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].getProductGroups();
      }).then(function () {
        _this2.showSuccessMsg({
          message: _this2.getActiveLocale + ' product group saved!'
        });
      }).catch(function (error) {
        _this2.showSuccessMsg({
          message: _this2.getActiveLocale + ' product group saved!'
        });
      });
    }
  },
  mounted: function mounted() {
    var productGroupId = this.$route.params.productGroupId;

    if (!productGroupId) {
      this.showErrorMsg({ message: 'No matching product group found' });
      this.$router.push('/product-groups/');
    }

    __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].setActiveProductGroup(productGroupId, this.initializeProductGroup);
    if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets.length) {
      __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].getMarkets();
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].clearActiveProductGroup();
    __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].clearActiveRecords();
  }
});

/***/ }),

/***/ "JBFH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'onboardTeam',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "JFG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LibraryActionCard_vue__ = __webpack_require__("S+gV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc87d45_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_LibraryActionCard_vue__ = __webpack_require__("2ZuK");
function injectStyle (ssrContext) {
  __webpack_require__("5Toc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bc87d45"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LibraryActionCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc87d45_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_LibraryActionCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JNez":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_LibraryGrid__ = __webpack_require__("0gt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MarketLibrary',
  components: {
    LibraryGrid: __WEBPACK_IMPORTED_MODULE_0__general_LibraryGrid__["a" /* default */]
  },
  computed: {
    // getProductGroups() {
    //   return store.getters.getAllProductGroups;
    // },
    getMarkets: function getMarkets() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getMarkets;
    }
  },
  data: function data() {
    return {
      getFlagUrl: __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getFlagUrl
    };
  },
  mounted: function mounted() {
    // Services.getProductGroups();
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getMarkets();
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].setActiveMarket(null);
  },

  methods: {
    toggleCreateMarketModal: function toggleCreateMarketModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('showCreateMarketModal', true);
    }
  }
});

/***/ }),

/***/ "JbFR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon content-save-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M15,9H5V5H15M12,19C10.34,19 9,17.66 9,16C9,14.34 10.34,13 12,13C13.66,13 15,14.34 15,16C15,17.66 13.66,19 12,19M17,3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V7L17,3Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JgKm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jnnu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v("Upload New Image")]),_c('div',{staticClass:"fuck"},[(_vm.newImage)?_c('img',{attrs:{"src":_vm.newImage}}):_vm._e()]),(!_vm.image)?_c('div',{staticClass:"no-image"},[_c('form',{ref:"form"},[_c('input',{attrs:{"name":"imageContainer","type":"file","accept":"image/*"},on:{"change":_vm.onFileChange}})])]):_c('div',{staticClass:"image__editor"},[_c('div',{staticClass:"image__container"},[_c('img',{attrs:{"src":_vm.image}})]),_c('div',{staticClass:"button__container"},[_c('button',{staticClass:"button__submit",on:{"click":_vm.uploadImage}},[_vm._v("Upload")]),_c('button',{staticClass:"button__action",on:{"click":_vm.removeImage}},[_vm._v("Change Image")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K33D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionCard_vue__ = __webpack_require__("r31D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c15c94a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ActionCard_vue__ = __webpack_require__("CTts");
function injectStyle (ssrContext) {
  __webpack_require__("vkBM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c15c94a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c15c94a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ActionCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KLkz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"container"},[_c('h4',[_vm._v("Are you sure you want to logout?")]),_vm._v(" "),_c('div',{staticClass:"container__buttons"},[_c('button',{staticClass:"button__logout",on:{"click":_vm.logout}},[_vm._v("Logout")]),_vm._v(" "),_c('button',{staticClass:"button__cancel",on:{"click":_vm.cancel}},[_vm._v("Cancel")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KXx3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KeLa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PolicyTemplate_vue__ = __webpack_require__("IfCs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17838ab6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PolicyTemplate_vue__ = __webpack_require__("afd0");
function injectStyle (ssrContext) {
  __webpack_require__("qEdA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17838ab6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PolicyTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17838ab6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PolicyTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LIX2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.base(_vm.showModal))},[_c('div',{on:{"click":_vm.closeModal}},[_c('CloseIcon',{style:(_vm.styles.closeIcon)})],1),_c('div',{style:(_vm.styles.modal)},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LNRi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LPxX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Services__ = __webpack_require__("bdTy");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mediaRow',
  props: {
    onClick: Function,
    isActionCard: Boolean,
    isTop: Boolean,
    media: Object,
    viewSpecificStyles: Object,
    cardSpecificStyles: Object,
    _id: String,
    src: String,
    isActiveItem: Boolean,
    isMediaLibrary: Boolean,
    contentType: String,
    content: String,
    refreshMedia: Function,
    title: String,
    selectedMlId: String,
    selectedPgId: String
  },
  methods: {
    handleMedia: function handleMedia() {
      console.log('clicking');
      if (this.isActionCard) {
        this.onClick(true);
      } else {
        this.onClick(this.media);
        console.log('go to media');
        this.$router.push('/media/' + __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.getActiveMedia._id);
      }
    },
    showOptions: function showOptions() {
      this.visibleOptions = true;
    },
    hideOptions: function hideOptions() {
      this.visibleOptions = false;
    },
    showSuccess: function showSuccess() {
      var _this = this;

      // give cards a little time to move
      setTimeout(function () {
        _this.showSuccessMsg({ message: 'Media moved to top!' });
      }, 400);
    },
    moveToTop: function moveToTop() {
      var _this2 = this;

      // create top level position
      var update = {
        position: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.getMedia[0].position + 1
      };

      var selectedMlId = this.selectedMlId;
      var selectedPgId = this.selectedPgId;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_Utils_js__["c" /* postResource */])('/v1/media/update?mediaId=' + this.media._id, false, update, this.showSuccess()).then(function (res) {
        _this2.refreshMedia();
        return res;
      }).catch(function (err) {
        console.log(err);
        _this2.showErrorMsg({
          message: 'An error occurred. Please try again.'
        });
      });
    }
  },
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data: function data() {
    var _this3 = this;

    return {
      visibleOptions: false,
      tagColors: {
        video: {
          bg: '#09a3ed',
          text: '#fff'
        },
        image: {
          bg: 'purple',
          text: '#fff'
        },
        audio: {
          bg: 'green',
          text: '#fff'
        },
        pdf: {
          bg: 'orange',
          text: '#444'
        }
      },
      styles: {
        card: {
          base: function base(src, active) {
            return {
              background: '#fff',
              flex: '0 0 auto',
              margin: 0,
              display: 'flex',
              flexFlow: 'row nowrap',
              justifyContent: 'flex-start',
              fontWeight: '400',
              fontSize: '1em',
              width: '100%',
              textAlign: 'left',
              padding: '10px',
              borderBottom: '1px solid #eee'
            };
          }
        },
        title: {
          margin: '10px 0 0',
          fontWeight: '700',
          lineHeight: '1.25rem'
        },
        contentTag: function contentTag(type) {
          return {
            background: _this3.tagColors[type].bg || '#888',
            display: 'inline',
            color: _this3.tagColors[type].text || '#fff',
            padding: '5px',
            borderRadius: '4px',
            fontSize: '0.7em',
            fontWeight: '700',
            textTransform: 'uppercase',
            margin: '0 auto auto 0'
          };
        }
      }
    };
  }
});

/***/ }),

/***/ "LcfB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LcrT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterTeam_vue__ = __webpack_require__("bzSC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b31f256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterTeam_vue__ = __webpack_require__("7zKI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterTeam_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b31f256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterTeam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d24fdc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("BlEr");
function injectStyle (ssrContext) {
  __webpack_require__("f0CP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d24fdc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MYLI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ChevronLeftIcon",
  props: {
    title: {
      type: String,
      default: "Chevron Left icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "Mcuh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__general_Spinner__ = __webpack_require__("dSGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_nav_tabs_themes_paper_css__ = __webpack_require__("CQ+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_nav_tabs_themes_paper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_nav_tabs_themes_paper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_avatar__ = __webpack_require__("Y50r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modals_ManageRole_vue__ = __webpack_require__("kv+F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modals_ManageUser_vue__ = __webpack_require__("1LgV");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tenantSettings',
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_8_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_8_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_6_vue_avatar___default.a,
    ManageRoleModal: __WEBPACK_IMPORTED_MODULE_9__modals_ManageRole_vue__["a" /* default */],
    ManageUserModal: __WEBPACK_IMPORTED_MODULE_10__modals_ManageUser_vue__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_3__general_Spinner__["a" /* default */],
    VueTabs: __WEBPACK_IMPORTED_MODULE_4_vue_nav_tabs__["VueTabs"],
    VTab: __WEBPACK_IMPORTED_MODULE_4_vue_nav_tabs__["VTab"]
  },
  computed: {
    getTenant: function getTenant() {
      var tenant = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getTenant;
      if (!this.tenantSet && tenant._id) {
        this.tenant = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tenant);
        this.tenantSet = true;
      }
      return tenant;
    }
  },
  data: function data() {
    return {
      tenant: {
        name: '',
        domain: ''
      },
      tenantSet: false,
      tenantUsers: null,
      tenantRoles: null,
      selectedRole: null,
      selectedUser: null,
      showManageRoleModal: false,
      showManageUserModal: false
    };
  },

  methods: {
    submitBusinessProfile: function submitBusinessProfile() {
      console.log(this.tenant);
    },
    getUserName: function getUserName(name) {
      var p = name.first + ' ' + name.last;
      return p;
    },
    resetPassword: function resetPassword(user) {
      var _this = this;

      var domain = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getDomain;
      var email = user.primary_email;
      var tenantId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getTenant._id;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__services_Utils__["c" /* postResource */])('/v1/auth/reset/1', '', {
        email: email,
        domain: domain,
        tenantId: tenantId
      }).then(function (res) {
        _this.showSuccessMsg({
          message: 'Password email link sent!'
        });
      }).catch(function (err) {
        return console.log(err);
      });
    },
    isTenantAdmin: function isTenantAdmin(id) {
      var admins = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getTenant.admins;
      if (admins) return admins.includes(id);
    },
    toggleModal: function toggleModal(modal, data) {
      if (modal === 'manageRole') {
        if (data) {
          this.selectedRole = data;
        } else {
          this.selectedRole = null; // resets data on toggle close
          // create new role
        }
        this.showManageRoleModal = !this.showManageRoleModal;
      } else if (modal === 'manageUser') {
        if (data) {
          this.selectedUser = data;
        } else {
          this.selectedUser = null;
        }
        this.showManageUserModal = !this.showManageUserModal;
      } else if (modal === 'coldDeck') {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('showColdDeckModal', true);
      }
    },
    refreshRoles: function refreshRoles() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getTenantRoles().then(function (roles) {
        return _this2.tenantRoles = roles;
      }).catch(function (err) {
        return console.log(err);
      });
    },
    refreshUsers: function refreshUsers() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getTenantUsers().then(function (users) {
        return _this3.tenantUsers = users;
      }).catch(function (err) {
        return console.log(err);
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getTenantUsers().then(function (users) {
      return _this4.tenantUsers = users.sort(function (a, b) {
        return b.profile.name.first < a.profile.name.first;
      });
    }).catch(function (err) {
      return console.log(err);
    });
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getTenantRoles().then(function (roles) {
      return _this4.tenantRoles = roles;
    }).catch(function (err) {
      return console.log(err);
    });
  }
});

/***/ }),

/***/ "MfUB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__general_LibraryGrid__ = __webpack_require__("0gt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__general_Spinner__ = __webpack_require__("dSGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_notifications__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'userLibrary',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_4__general_Spinner__["a" /* default */],
    LibraryGrid: __WEBPACK_IMPORTED_MODULE_3__general_LibraryGrid__["a" /* default */]
  },
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data: function data() {
    return {
      loaded: false,
      loading: false,
      users: [],
      subscriptions: [],
      userSubscriptions: {},
      subscriptionLoadErrors: {},
      selectedSubscriptions: {},
      assigningUser: null,
      searchQuery: '',
      searchTimeout: null,
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
        pages: 0
      },
      styles: {
        wrapper: {
          display: 'flex',
          flexFlow: 'row nowrap',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          height: '100vh',
          width: '100%'
        }
      }
    };
  },

  methods: {
    loadUsers: function loadUsers() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var query, res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.prev = 1;
                query = 'page=' + _this.pagination.page + '&limit=' + _this.pagination.limit + (_this.searchQuery ? '&search=' + encodeURIComponent(_this.searchQuery) : '');
                _context.next = 5;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_Utils__["a" /* getResource */])('/v1/app-users/list', query);

              case 5:
                res = _context.sent;

                _this.users = res.users || [];
                _this.pagination = res.pagination || _this.pagination;

                // Load subscriptions for each user
                _this.users.forEach(function (user) {
                  var userId = user.personId || user.businessId;
                  if (userId && !_this.userSubscriptions[userId]) {
                    _this.loadUserSubscription(userId);
                  }
                });
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](1);

                console.error('Error loading users:', _context.t0);
                _this.showErrorMsg({ message: 'Failed to load users' });

              case 15:
                _this.loading = false;

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 11]]);
      }))();
    },
    loadSubscriptions: function loadSubscriptions() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_Utils__["a" /* getResource */])('/v1/subscriptions/list');

              case 3:
                res = _context2.sent;

                _this2.subscriptions = res.subscriptions || [];
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                console.error('Error loading subscriptions:', _context2.t0);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7]]);
      }))();
    },
    loadUserSubscription: function loadUserSubscription(userId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_Utils__["a" /* getResource */])('/v1/app-users/' + userId + '/subscription', 'env=test');

              case 3:
                res = _context3.sent;

                if (res.data && res.data.success && res.data.subscription) {
                  _this3.$set(_this3.userSubscriptions, userId, res.data.subscription);
                } else {
                  _this3.$set(_this3.userSubscriptions, userId, { name: 'None' });
                }
                _context3.next = 12;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.error('Error loading subscription for ' + userId + ':', _context3.t0);
                _this3.$set(_this3.subscriptionLoadErrors, userId, true);
                _this3.$set(_this3.userSubscriptions, userId, { name: 'Error' });

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 7]]);
      }))();
    },
    assignSubscription: function assignSubscription(user) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var userId, subscriptionId;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                userId = user.personId || user.businessId;
                subscriptionId = _this4.selectedSubscriptions[user._id];

                if (!(!userId || !subscriptionId)) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt('return');

              case 4:

                _this4.assigningUser = user._id;
                _context4.prev = 5;
                _context4.next = 8;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_Utils__["c" /* postResource */])('/v1/app-users/' + userId + '/subscription', 'env=test', { subscriptionId: subscriptionId });

              case 8:
                _this4.showSuccessMsg({ message: 'Subscription assigned to ' + user.email });

                // Reload subscription for this user
                _this4.$set(_this4.userSubscriptions, userId, null);
                _context4.next = 12;
                return _this4.loadUserSubscription(userId);

              case 12:
                _this4.$set(_this4.selectedSubscriptions, user._id, '');
                _context4.next = 19;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4['catch'](5);

                console.error('Error assigning subscription:', _context4.t0);
                _this4.showErrorMsg({ message: 'Failed to assign subscription: ' + (_context4.t0.error || 'Unknown error') });

              case 19:
                _this4.assigningUser = null;

              case 20:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[5, 15]]);
      }))();
    },
    debouncedSearch: function debouncedSearch() {
      var _this5 = this;

      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(function () {
        _this5.pagination.page = 1;
        _this5.loadUsers();
      }, 400);
    },
    changePage: function changePage(page) {
      if (page < 1 || page > this.pagination.pages) return;
      this.pagination.page = page;
      this.loadUsers();
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return '—';
      var d = new Date(dateStr);
      return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this6.loadSubscriptions(), _this6.loadUsers()]);

            case 2:
              _this6.loaded = true;

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this6);
    }))();
  }
});

/***/ }),

/***/ "MoYv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.base)},[_c('form',{style:(_vm.styles.form),on:{"submit":function($event){$event.preventDefault();return _vm.handleFormSubmit($event)}}},[_c('div',{style:(_vm.styles.formHeader)},[_c('img',{style:(_vm.styles.icon),attrs:{"src":_vm.getIcon}}),_vm._v(" "),_c('h2',{style:(_vm.styles.formHeaderTitle)},[_vm._v("Sign into"),_c('br'),_c('strong',[_vm._v(_vm._s(_vm.getTenantName))])])]),_vm._v(" "),_c('div',{style:(_vm.styles.inputContainer)},[_c('span',{style:(_vm.styles.inputContainerLabel)},[_vm._v("Email Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"emailInput",staticClass:"input__text",attrs:{"placeholder":"you@somewhere.com","type":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{style:(_vm.styles.inputContainer)},[_c('span',{style:(_vm.styles.inputContainerLabel)},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"input__text",attrs:{"placeholder":"your password","type":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"button__submit",attrs:{"type":"submit"}},[_vm._v("\n      Login →\n    ")])]),_vm._v(" "),_c('p',[_c('router-link',{staticClass:"password-link",attrs:{"to":"reset"}},[_vm._v("Forgot Password?")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MxbS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_loader_lib_template_compiler_index_id_data_v_455e460e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_play_icon_vue__ = __webpack_require__("ffEG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__vue_loader_lib_template_compiler_index_id_data_v_455e460e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_play_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N3Ep":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ContentSaveIcon",
  props: {
    title: {
      type: String,
      default: "Content Save icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "NCkF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ImageFilterNoneIcon",
  props: {
    title: {
      type: String,
      default: "Image Filter None icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "ND0a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.onlyRenderIfDeletable || _vm.state.deletable)?_c('button',{staticClass:"vue-fine-uploader-delete-button",attrs:{"type":"button","aria-label":"delete","disabled":!_vm.state.deletable || _vm.state.deleting},on:{"click":_vm._onClick}},[_vm._t("default",[_vm._v("Delete")])],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_material_design_icons_styles_css__ = __webpack_require__("siN1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_material_design_icons_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_material_design_icons_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast_dist_css_iziToast_min_css__ = __webpack_require__("20Zl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast_dist_css_iziToast_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_izitoast_dist_css_iziToast_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_fineuploader_gallery_gallery_css__ = __webpack_require__("DKJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_fineuploader_gallery_gallery_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_fineuploader_gallery_gallery_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_izitoast__ = __webpack_require__("YxSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_js__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuex_router_sync__);





// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// See https://matteogabriele.gitbooks.io/vue-analytics/







// Vue use
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]);

function toast(_ref) {
  var title = _ref.title,
      message = _ref.message,
      type = _ref.type,
      timeout = _ref.timeout,
      cb = _ref.cb,
      icon = _ref.icon;

  if (type === __WEBPACK_IMPORTED_MODULE_5_vue_notifications___default.a.types.warn) type = 'warning';
  return __WEBPACK_IMPORTED_MODULE_8_izitoast___default.a[type]({ title: title, message: message, timeout: timeout, icon: 'toast-icons', iconText: icon, progressBar: false, position: 'topRight' });
}

var options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuelidate___default.a);

__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_notifications___default.a, options);

var unsync = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_10__store_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */]);

// Vue config
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].config.devtools = true;

// Init App
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */]({
  'el': '#app',
  router: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_10__store_js__["a" /* default */],
  'template': '<App/>',
  'components': { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ "NQth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: Number,
      required: true
    },
    uploader: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      state: {
        filename: this.uploader.methods.getName(this.id)
      }
    };
  },
  created: function created() {
    this._interceptSetName();
  },


  methods: {
    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.filename !== this.state.filename;
    },
    _interceptSetName: function _interceptSetName() {
      var _this = this;

      var oldSetName = this.uploader.methods.setName;

      this.uploader.methods.setName = function (id, newName) {
        oldSetName.call(_this.uploader.methods, id, newName);

        if (id === _this.id) {
          _this.$set(_this.state, 'filename', newName);
        }
      };
    }
  }
});

/***/ }),

/***/ "NddR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ne/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_LibraryGrid__ = __webpack_require__("0gt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MediaLibraryLibrary',
  components: {
    LibraryGrid: __WEBPACK_IMPORTED_MODULE_0__general_LibraryGrid__["a" /* default */]
  },
  computed: {
    getMediaLibraries: function getMediaLibraries() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getAllMediaLibraries;
    },
    getMarkets: function getMarkets() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getMarkets;
    }
  },
  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveLocale', null);
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getMediaLibraries();
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getMarkets();
  },

  methods: {
    toggleCreateMediaLibraryModal: function toggleCreateMediaLibraryModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('showCreateMediaLibraryModal', true);
    }
  }
});

/***/ }),

/***/ "Nsld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_LibraryGrid__ = __webpack_require__("0gt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general_Spinner__ = __webpack_require__("dSGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("olkN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'policyLibrary',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__general_Spinner__["a" /* default */],
    LibraryGrid: __WEBPACK_IMPORTED_MODULE_0__general_LibraryGrid__["a" /* default */]
  },
  computed: {
    getPolicies: function getPolicies() {
      return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getPolicies;
    }
  },
  methods: {
    toggleDeleted: function toggleDeleted() {
      this.showDeleted = !this.showDeleted;
    },
    togglePoliciesLoaded: function togglePoliciesLoaded() {
      this.policiesLoaded = true;
    },
    setActivePolicy: function setActivePolicy(policy) {
      // Services.setActivePolicy(policy);
      this.$router.push('/policies/' + policy._id);
    },
    createNewPolicy: function createNewPolicy() {
      this.$router.push('/policies/create');
    }
  },
  data: function data() {
    return {
      showDeleted: false,
      policiesLoaded: false,
      blankPolicy: {
        title: '',
        rules: [],
        sequence: null
      },
      styles: {
        wrapper: {
          display: 'flex',
          flexFlow: 'row nowrap',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          height: '100vh',
          // boxSizing: 'border-box',
          // padding: '0 1rem',
          width: '100%'
        },
        cardContainer: {
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        cardPreview: {
          background: 'teal',
          position: 'relative',
          padding: '20'
        },
        cardName: {
          color: '#aaa',
          fontSize: '0.9em',
          marginBottom: '0'
        },
        cardMetadataSection: {
          display: 'flex',
          flexFlow: 'column nowrap',
          padding: '40',
          width: '100%'
        },
        backIcon: {
          margin: 'auto 5px auto auto',
          color: '#aaa'
        }
      }
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getPolicies(this.togglePoliciesLoaded);
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].setActivePolicy(this.blankPolicy);
  }
});

/***/ }),

/***/ "NvbM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_waiting_placeholder_vue__ = __webpack_require__("6XKK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c0369ff0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_waiting_placeholder_vue__ = __webpack_require__("62Jf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_waiting_placeholder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c0369ff0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_waiting_placeholder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O/aY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_History_vue__ = __webpack_require__("2VKE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0d676745_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_History_vue__ = __webpack_require__("0W5C");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_History_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0d676745_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_History_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OLIX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div'),_c('div',{staticClass:"form"},[(!_vm.selectedUser)?_c('h2',[_vm._v("Create a New User")]):_vm._e(),(_vm.selectedUser)?_c('h2',[_vm._v("Manage User")]):_vm._e(),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Email Address")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.primary_email),expression:"primary_email"}],attrs:{"type":"email"},domProps:{"value":(_vm.primary_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.primary_email=$event.target.value}}}),(_vm.errors.primary_email)?_c('p',{staticClass:"validation__error"},[_vm._v("Please enter a valid email address.")]):_vm._e()]),_c('div',{staticClass:"form__control-group form__control-group--half"},[_c('label',[_vm._v("First Name")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.name.first),expression:"profile.name.first"}],attrs:{"type":"text"},domProps:{"value":(_vm.profile.name.first)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile.name, "first", $event.target.value)}}}),(_vm.errors.profile.name.first)?_c('p',{staticClass:"validation__error"},[_vm._v("Please enter a first name.")]):_vm._e()]),_c('div',{staticClass:"form__control-group form__control-group--half"},[_c('label',[_vm._v("Last Name")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.name.last),expression:"profile.name.last"}],attrs:{"type":"text"},domProps:{"value":(_vm.profile.name.last)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile.name, "last", $event.target.value)}}}),(_vm.errors.profile.name.first)?_c('p',{staticClass:"validation__error"},[_vm._v("Please enter a first name.")]):_vm._e()]),_c('div',{staticClass:"form__control-group form__control-group--half"},[_c('label',[_vm._v("Role")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.role),expression:"role"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.role=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.roles),function(role){return _c('option',{domProps:{"value":role._id}},[_vm._v(_vm._s(role.title))])}))]),_c('div',{staticClass:"form__control-group form__control-group--half"},[_c('label',[_vm._v("Status")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.statuses),function(status,index){return _c('option',{domProps:{"value":status}},[_vm._v(_vm._s(status))])}))]),_c('div',{staticClass:"form__control-group"},[(!_vm.selectedUser)?_c('button',{staticClass:"button__submit",on:{"click":_vm.submit}},[_vm._v("Create User")]):_vm._e(),(_vm.selectedUser)?_c('button',{staticClass:"button__submit",on:{"click":_vm.submit}},[_vm._v("Save")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OpqZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateMediaLibraryLocalRecord',
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
    },
    data: function data() {
        return {
            newLocale: ''
        };
    },

    computed: {
        getActiveMediaLibrary: function getActiveMediaLibrary() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveMediaLibrary;
        },
        getAvailableMarkets: function getAvailableMarkets() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets;
        }
    },
    notifications: {
        showSuccessMsg: {
            type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.success,
            title: '',
            icon: '✅'
        },
        showErrorMsg: {
            type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.error,
            title: '',
            icon: '❗️'
        }
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].getMarkets();
    },

    methods: {
        submit: function submit() {
            var _this = this;

            var newRecord = {
                recordId: this.getActiveMediaLibrary._id,
                recordType: 'MediaLibrary',
                locale: this.newLocale
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_Utils_js__["c" /* postResource */])('/v1/medialibraries/addLocalRecord', false, newRecord).then(function (res) {
                console.log('success!', res);
                _this.showSuccessMsg({ message: 'New ' + _this.newLocale + ' record added to ' + _this.getActiveMediaLibrary.title + '!' });
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('hideModals', true);
                __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].setActiveMediaLibrary(_this.getActiveMediaLibrary._id, _this.$router.push('/media-libraries/' + _this.getActiveMediaLibrary._id));
                return res;
            }).catch(function (error) {
                var message = 'An error occurred. Please try again.';
                if (error.error) {
                    message = error.error;
                }
                _this.showErrorMsg({
                    message: message
                });
            });
        }
    }
});

/***/ }),

/***/ "P9Ox":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PRWs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductGroupEditor_vue__ = __webpack_require__("JAUS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dfffcfd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ProductGroupEditor_vue__ = __webpack_require__("0ByY");
function injectStyle (ssrContext) {
  __webpack_require__("DW0e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dfffcfd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductGroupEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dfffcfd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ProductGroupEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PnVb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PrcN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QINQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_loader_lib_template_compiler_index_id_data_v_5a9f59aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_upload_success_icon_vue__ = __webpack_require__("JA9R");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__vue_loader_lib_template_compiler_index_id_data_v_5a9f59aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_upload_success_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QIUK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('h1',[_vm._v("Deprecate Media")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QbYu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!(_vm.state.size == null || _vm.state.size < 0))?_c('span',{staticClass:"vue-fine-uploader-filesize"},[_c('span',{staticClass:"vue-fine-uploader-filesize-value"},[_vm._v(_vm._s(_vm.formatted.size)+"\n         ")]),_c('span',{staticClass:"vue-fine-uploader-filesize-separator"}),_c('span',{staticClass:"vue-fine-uploader-filesize-unit"},[_vm._v(_vm._s(_vm.formatted.units))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QlgD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QnPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.wrap(_vm.ready))},[_c('nav',{key:_vm.getRouteName,staticClass:"sidebar-nav",style:(_vm.styles.nav),attrs:{"aria-label":"Navigation"}},[_c('div',{style:(_vm.styles.headerIcons)},[_c('img',{style:(_vm.styles.logo),attrs:{"src":_vm.getIcon}}),_vm._v(" "),(_vm.ready)?_c('Avatar',{style:(_vm.styles.headerAvatar),attrs:{"username":_vm.getUserName,"color":"#ccc","backgroundColor":"#2b4663","size":40}}):_vm._e()],1),_vm._v(" "),_c('div',{style:(_vm.styles.navItemContainer)},[_vm._l((_vm.links),function(link){return _c('router-link',{key:link.name,staticClass:"navigationLink",class:{'active-link': _vm.navIsActive(link.path)},style:(_vm.styles.navItem),attrs:{"exact":"","to":link.path}},[_c('span',{class:link.icon}),_vm._v(" "),_c('span',{style:(_vm.styles.navTitle)},[_vm._v(_vm._s(link.title))])])}),_vm._v(" "),_c('div',{staticClass:"settingsLink"},[_c('p',{staticClass:"navigationLink",on:{"click":_vm.goToSettings}},[_c('span',{staticClass:"glyphicon glyphicon-cog"}),_vm._v(" \n          Settings\n        ")]),_vm._v(" "),_c('p',{staticClass:"navigationLink",on:{"click":_vm.toggleLogoutModal}},[_c('span',{staticClass:"glyphicon glyphicon-log-out"}),_vm._v(" \n          Logout\n        ")]),_vm._v(" "),_c('span',{style:(_vm.styles.version)},[_vm._v("v"+_vm._s(_vm.version))])])],2)]),_vm._v(" "),_c('div',{style:(_vm.styles.contentWrapper(_vm.getRouteName === 'media', !!!_vm.getActiveMedia, false)),attrs:{"id":"scrollWrapper"}},[(!_vm.loading)?_c('router-view'):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QsxE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v("Are you sure you want to un-delete and restore this product?")]),_c('div',{staticClass:"button-wrapper"},[_c('button',{staticClass:"button button__submit",on:{"click":function($event){_vm.remove()}}},[_vm._v("Yes")]),_c('button',{staticClass:"button",on:{"click":function($event){_vm.cancel()}}},[_vm._v("Cancel")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RBIG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('h2',[_vm._v("Edit Action Card Media")]),_vm._v(" "),(_vm.getMedia && _vm.getMedia.length)?_c('div',{staticClass:"grid"},_vm._l((_vm.getMedia),function(media,index){return _c('div',{key:("media.title-" + index),attrs:{"title":((media.title) + " - " + (media.fileName))}},[_c('img',{attrs:{"src":media.thumbnail,"alt":media.title},on:{"click":function($event){_vm.newselectActiveMedia(media)}}}),_vm._v(" "),_c('h5',[_vm._v(_vm._s(media.title)+" "+_vm._s(media.mmId ? (" - mmId " + (media.mmId)) : ''))])])})):_vm._e(),_vm._v(" "),(!_vm.getMedia.length)?_c('div',{staticClass:"no-media"},[_c('h3',[_vm._v("No Media found for this market.")]),_vm._v(" "),_c('router-link',{staticClass:"button__action",attrs:{"to":"/media"}},[_vm._v("Manage Media")])],1):_vm._e(),_vm._v(" "),(_vm.getMedia.length >= 20)?_c('button',{staticClass:"button__action",on:{"click":_vm.loadMoreMedia}},[_vm._v("Load More")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RDpX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tenant-settings-wrapper"}},[_c('h1',{staticClass:"settings-title"},[_vm._v("\n    "+_vm._s(_vm.getTenant.name)+"\n  ")]),_vm._v(" "),(_vm.tenant)?_c('vue-tabs',{attrs:{"activeTextColor":"#09a3ed"}},[_c('v-tab',{attrs:{"title":"My Business"}},[_c('div',{staticClass:"inner-tab"},[(_vm.tenant)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitBusinessProfile($event)}}},[_c('div',[_c('h4',[_vm._v("\n              Business Name\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              The name of your business or company.\n            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tenant.name),expression:"tenant.name"}],attrs:{"type":"text"},domProps:{"value":(_vm.tenant.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tenant, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("\n              Business Domain\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              The host domain associated with your business. This value cannot be edited.\n            ")]),_vm._v(" "),_c('input',{staticClass:"disabled",attrs:{"disabled":"","type":"text"},domProps:{"value":_vm.tenant.domain}})]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("\n              Business Logo\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              The logo of your business or company.\n            ")]),_vm._v(" "),_c('button',{staticClass:"button__action"},[_vm._v("Choose New Image")]),_vm._v(" "),_c('img',{staticClass:"tenantLogo",attrs:{"src":_vm.getTenant.icon}})]),_vm._v(" "),_c('button',{staticClass:"button__submit",attrs:{"type":"submit"}},[_vm._v("Save Changes")])]):_vm._e()])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Users"}},[_c('div',{staticClass:"inner-tab"},[_c('button',{staticClass:"button__action",attrs:{"id":"cold-deck-button"},on:{"click":function($event){_vm.toggleModal('coldDeck')}}},[_vm._v("Reset App User Deck")]),_vm._v(" "),_c('button',{staticClass:"button__action",attrs:{"id":"new-user-button"},on:{"click":function($event){_vm.toggleModal('manageUser')}}},[_vm._v("+ New Admin User")]),_vm._v(" "),_c('h2',[_vm._v("\n          All Users\n        ")]),_vm._v(" "),(_vm.tenantUsers)?_c('ul',{staticClass:"user-list"},_vm._l((_vm.tenantUsers),function(user,index){return _c('li',{staticClass:"user-item"},[_c('Avatar',{style:({ flex: '0 0 auto', borderRadius: '10px', marginRight: '30px' }),attrs:{"username":_vm.getUserName(user.profile.name),"color":"#ccc","backgroundColor":"#2b4663","size":40}}),_vm._v(" "),_c('h4',[_vm._v("\n              "+_vm._s(user.profile.name.first)+" "+_vm._s(user.profile.name.last)+"\n            ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(user.primary_email))]),_vm._v(" "),(user.role)?_c('span',{staticClass:"user-role-tag"},[_vm._v("\n              "+_vm._s(user.role.title)+"\n            ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"button__action manage-user",on:{"click":function($event){_vm.resetPassword(user)}}},[_vm._v("Reset Password")]),_vm._v(" "),_c('button',{staticClass:"button__action manage-user",on:{"click":function($event){_vm.toggleModal('manageUser', user)}}},[_vm._v("Manage User")])],1)})):_vm._e()])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Roles"}},[_c('div',{staticClass:"inner-tab"},[_c('button',{staticClass:"button__action",attrs:{"id":"new-user-button"},on:{"click":function($event){_vm.toggleModal('manageRole')}}},[_vm._v("+ New Role")]),_vm._v(" "),_c('h2',[_vm._v("\n          All Roles\n        ")]),_vm._v(" "),(_vm.tenantRoles)?_c('ul',{staticClass:"user-list"},_vm._l((_vm.tenantRoles),function(role,index){return _c('li',{staticClass:"user-item"},[_c('h4',[_vm._v("\n              "+_vm._s(role.title)+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"button__action manage-user",on:{"click":function($event){_vm.toggleModal('manageRole', role)}}},[_vm._v("\n              Manage Role\n            ")])])})):_vm._e()])])],1):_vm._e(),_vm._v(" "),(_vm.showManageRoleModal)?_c('ManageRoleModal',{attrs:{"selectedRole":_vm.selectedRole,"refreshRoles":_vm.refreshRoles,"close":_vm.toggleModal}}):_vm._e(),_vm._v(" "),(_vm.showManageUserModal)?_c('ManageUserModal',{attrs:{"selectedUser":_vm.selectedUser,"refreshUsers":_vm.refreshUsers,"roles":_vm.tenantRoles,"close":_vm.toggleModal}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RGi4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RQ7e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RVph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddSequenceToPolicy_vue__ = __webpack_require__("yauI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cde9e30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddSequenceToPolicy_vue__ = __webpack_require__("1alf");
function injectStyle (ssrContext) {
  __webpack_require__("rdWY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cde9e30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddSequenceToPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cde9e30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddSequenceToPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RqMe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MediaLibraryEditor',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
  },
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    getActiveMediaLibrary: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveMediaLibrary;
      },
      set: function set(mediaLibrary) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveMediaLibrary', mediaLibrary);
      }
    },
    getActiveLocale: function getActiveLocale() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveLocale;
    },

    getActiveLocalRecord: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveLocalRecord;
      },
      set: function set(record) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocalRecord', record);
      }
    },
    getMarkets: function getMarkets() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets;
    },

    getSortedAvailableLocales: {
      get: function get() {
        if (this.getActiveMediaLibrary && this.getActiveMediaLibrary.localRecords) {
          var locales = [];

          this.getActiveMediaLibrary.localRecords.forEach(function (locale) {
            locales.push(locale.locale);
          });

          return locales.sort(function (a, b) {
            return a.name - b.name;
          }).reverse();
        }
      },
      set: function set(newLocales) {
        var activeMediaLibrary = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getActiveMediaLibrary);
        activeMediaLibrary.markets = newLocales;
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveMediaLibrary', activeMediaLibrary);
        if (activeMediaLibrary.localRecords && newLocales.length > activeMediaLibrary.localRecords.length) {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('showCreateMediaLibraryLocalRecordModal', true);
        }
      }
    },
    getMarketsByLocale: function getMarketsByLocale() {
      if (this.getMarkets) {
        var marketsByLocale = [];

        this.getMarkets.forEach(function (market) {
          marketsByLocale.push(market.locale);
        });

        return marketsByLocale;
      }
    }
  },
  methods: {
    initializeMediaLibrary: function initializeMediaLibrary(edited) {
      var mediaLibrary = this.getActiveMediaLibrary;

      if (!mediaLibrary._id) {
        this.showErrorMsg({ message: 'No matching media library found' });
        this.$router.push('/media-libraries/');
      }

      this.setActiveLocalContent();
    },
    setActiveLocalRecord: function setActiveLocalRecord(locale) {
      if (!locale) {
        var defaultLocale = this.getActiveMediaLibrary.localRecords ? this.getActiveMediaLibrary.localRecords[0].locale : '';
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocale', defaultLocale);
      } else {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocale', locale);
      }

      //   this.setActiveLocalContent();
    },
    setActiveLocalContent: function setActiveLocalContent() {
      var _this = this;

      if (this.getActiveMediaLibrary.localRecords && this.getActiveMediaLibrary.localRecords.length && this.getActiveLocale) {
        var activeContent = this.getActiveMediaLibrary.localRecords.filter(function (record) {
          return record.locale === _this.getActiveLocale;
        })[0].content || {};
        if (!activeContent.title) {
          activeContent.title = '';
        }
        return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocalRecord', activeContent);
      } else if (this.getActiveMediaLibrary.localRecords && this.getActiveMediaLibrary.localRecords.length) {
        var _activeContent = this.getActiveMediaLibrary.localRecords[0].content;
        return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocalRecord', _activeContent);
      } else {
        this.getActiveLocalRecord = {
          title: ''
        };
      }
    },
    changeLocale: function changeLocale(locale) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocale', locale);
      this.setActiveLocalContent();
      this.initializeMediaLibrary(true);
    },
    toggleAddLocale: function toggleAddLocale() {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('showCreateMediaLibraryLocalRecordModal', true);
    },
    save: function save() {
      var _this2 = this;

      var update = this.getActiveMediaLibrary;
      var contentUpdate = this.getActiveLocalRecord;
      update.content = contentUpdate;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_Utils__["c" /* postResource */])('/v1/medialibraries/update', 'id=' + this.getActiveMediaLibrary._id + '&locale=' + encodeURIComponent(this.getActiveLocale), update).then(function (res) {
        _this2.showSuccessMsg({
          message: _this2.getActiveLocale + ' media library saved!'
        });
      }).catch(function (error) {
        _this2.showSuccessMsg({
          message: _this2.getActiveLocale + ' media library saved!'
        });
      });
    }
  },
  mounted: function mounted() {
    var mediaLibraryId = this.$route.params.mediaLibraryId;

    if (!mediaLibraryId) {
      this.showErrorMsg({ message: 'No matching media library found' });
      this.$router.push('/media-libraries/');
    }

    __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].setActiveMediaLibrary(mediaLibraryId, this.initializeMediaLibrary(false));

    // this.setActiveLocalRecord();
    if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets.length) {
      __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].getMarkets();
    }
  },
  updated: function updated() {
    if (!this.getActiveLocale) {
      this.setActiveLocalRecord();
      this.setActiveLocalContent();
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocale', null);
    __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].clearActiveProduct();
    __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].clearActiveRecords();
  }
});

/***/ }),

/***/ "RsN3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cancel_button__ = __webpack_require__("SpcU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__delete_button__ = __webpack_require__("mMeq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dropzone__ = __webpack_require__("UNH8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__file_input__ = __webpack_require__("pfih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filename__ = __webpack_require__("gv+3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filesize__ = __webpack_require__("EFJe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__retry_button__ = __webpack_require__("Ulzb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pause_resume_button__ = __webpack_require__("5D2W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__progress_bar__ = __webpack_require__("n50U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__status__ = __webpack_require__("aE7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__thumbnail__ = __webpack_require__("y1gN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pause_icon__ = __webpack_require__("idea");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__play_icon__ = __webpack_require__("MxbS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__upload_icon__ = __webpack_require__("BAag");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__upload_failed_icon__ = __webpack_require__("q8NN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__upload_success_icon__ = __webpack_require__("QINQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__x_icon__ = __webpack_require__("wWn5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__MaybeDropzone__ = __webpack_require__("+WJj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__FileInputComponent__ = __webpack_require__("lCJy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__gallery_css__ = __webpack_require__("DKJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__gallery_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__gallery_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//























var isFileGone = function isFileGone(statusToCheck, statusEnum) {
  return [statusEnum.CANCELED, statusEnum.DELETED].indexOf(statusToCheck) >= 0;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CancelButton: __WEBPACK_IMPORTED_MODULE_0__cancel_button__["a" /* default */],
    DeleteButton: __WEBPACK_IMPORTED_MODULE_1__delete_button__["a" /* default */],
    Dropzone: __WEBPACK_IMPORTED_MODULE_2__dropzone__["a" /* default */],
    FileInput: __WEBPACK_IMPORTED_MODULE_3__file_input__["a" /* default */],
    Filename: __WEBPACK_IMPORTED_MODULE_4__filename__["a" /* default */],
    Filesize: __WEBPACK_IMPORTED_MODULE_5__filesize__["a" /* default */],
    RetryButton: __WEBPACK_IMPORTED_MODULE_6__retry_button__["a" /* default */],
    PauseResumeButton: __WEBPACK_IMPORTED_MODULE_7__pause_resume_button__["a" /* default */],
    ProgressBar: __WEBPACK_IMPORTED_MODULE_8__progress_bar__["a" /* default */],
    Status: __WEBPACK_IMPORTED_MODULE_9__status__["a" /* default */],
    Thumbnail: __WEBPACK_IMPORTED_MODULE_10__thumbnail__["a" /* default */],
    PauseIcon: __WEBPACK_IMPORTED_MODULE_11__pause_icon__["a" /* default */],
    PlayIcon: __WEBPACK_IMPORTED_MODULE_12__play_icon__["a" /* default */],
    UploadIcon: __WEBPACK_IMPORTED_MODULE_13__upload_icon__["a" /* default */],
    UploadFailedIcon: __WEBPACK_IMPORTED_MODULE_14__upload_failed_icon__["a" /* default */],
    UploadSuccessIcon: __WEBPACK_IMPORTED_MODULE_15__upload_success_icon__["a" /* default */],
    XIcon: __WEBPACK_IMPORTED_MODULE_16__x_icon__["a" /* default */],
    MaybeDropzone: __WEBPACK_IMPORTED_MODULE_17__MaybeDropzone__["a" /* default */],
    FileInputComponent: __WEBPACK_IMPORTED_MODULE_18__FileInputComponent__["a" /* default */]
  },
  props: {
    // TODO: Change all the jsx types to another format
    uploader: {
      type: Object,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    fileInputMultiple: {
      default: true
    },
    dropzoneDisabled: {
      default: false
    },
    dropzoneDropActiveClassName: {
      default: 'vue-fine-uploader-gallery-dropzone-active'
    },
    dropzoneMultiple: {
      default: true
    },
    thumbnailMaxSize: {
      default: 130
    }
  },
  mounted: function mounted() {
    this.uploader.on('statusChange', this._onStatusChange);
  },
  destroyed: function destroyed() {
    this.uploader.off('statusChange', this._onStatusChange);
  },
  data: function data() {
    return {
      state: {
        visibleFiles: []
      }
    };
  },

  computed: {
    chunkingEnabled: function chunkingEnabled() {
      return this.uploader.options.chunking && this.uploader.options.chunking.enabled;
    },
    deleteEnabled: function deleteEnabled() {
      return this.uploader.options.deleteFile && this.uploader.options.deleteFile.enabled;
    }
  },
  methods: {
    _onStatusChange: function _onStatusChange(id, oldStatus, status) {
      var statusEnum = this.uploader.qq.status;
      var visibleFiles = this.state.visibleFiles;

      if (status === statusEnum.SUBMITTED) {
        visibleFiles.push({ id: id });
        this.state.visibleFiles = visibleFiles;
      } else if (isFileGone(status, statusEnum)) {
        this._removeVisibleFile(id);
      } else if (status === statusEnum.UPLOAD_SUCCESSFUL || status === statusEnum.UPLOAD_FAILED) {
        if (status === statusEnum.UPLOAD_SUCCESSFUL) {
          var visibleFileIndex = this._findFileIndex(id);
          if (visibleFileIndex < 0) {
            visibleFiles.push({ id: id, fromServer: true });
          }
        }
        this._updateVisibleFileStatus(id, status);
      }
    },
    _removeVisibleFile: function _removeVisibleFile(id) {
      var visibleFileIndex = this._findFileIndex(id);

      if (visibleFileIndex >= 0) {
        var visibleFiles = this.state.visibleFiles;

        visibleFiles.splice(visibleFileIndex, 1);
        this.state.visibleFiles = visibleFiles;
      }
    },
    _updateVisibleFileStatus: function _updateVisibleFileStatus(id, status) {
      this.state.visibleFiles.some(function (file) {
        if (file.id === id) {
          file.status = status;
          // TODO: Trigger an update. Currently, complete isn't showing unless another action occurs. If the code below is enabled, there is a bug where it does not delete properly
          // Vue Code
          // this.state.visibleFiles = { ...this.state.visibleFiles };
          // React Code
          // this.setState({ visibleFiles: this.state.visibleFiles })
          return true;
        }
      });
    },
    _findFileIndex: function _findFileIndex(id) {
      var visibleFileIndex = -1;

      this.state.visibleFiles.some(function (file, index) {
        if (file.id === id) {
          visibleFileIndex = index;
          return true;
        }
      });

      return visibleFileIndex;
    }
  }
});

/***/ }),

/***/ "RtVH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v(" Add a New Localized Content Record to Product Group")]),_c('div',{staticClass:"form__control-group rule__control-group--select"},[_c('label',[_vm._v("Select New Locale")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newLocale),expression:"newLocale"}],staticClass:"form__select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.newLocale=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.getAvailableMarkets),function(market){return _c('option',[_vm._v(_vm._s(market.locale))])}))]),_c('button',{staticClass:"button__submit",on:{"click":_vm.submit}},[_vm._v("Add Locale Record To Product")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S+gV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MediaCard__ = __webpack_require__("lVNX");
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LibraryActionCard',
  components: {
    MediaCard: __WEBPACK_IMPORTED_MODULE_0__MediaCard__["a" /* default */]
  },
  props: {
    slug: String,
    cardTitle: String,
    media: Object,
    title: String,
    callToAction: String
  }
});

/***/ }),

/***/ "S7Ij":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S9FO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S9iv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('nav',{staticClass:"nav"},[_c('div'),_c('div',[_c('button',{staticClass:"button__action",attrs:{"to":"/products/create"},on:{"click":_vm.toggleCreateProductModal}},[_vm._v("Create New Product")])])]),_c('LibraryGrid',[_c('div',{staticClass:"view-explanation"},[_c('h1',[_vm._v("Products")])]),_c('vue-tabs',{attrs:{"active-text-color":"#09a3ed"},on:{"tab-change":_vm.handleTabChange},model:{value:(_vm.tabName),callback:function ($$v) {_vm.tabName=$$v},expression:"tabName"}},[_c('v-tab',{attrs:{"title":"Active Products"}},[_c('LibraryGrid',{attrs:{"baseStyle":{backgroundColor: '#FFF', minHeight: 'inherit'}}},[(!_vm.getProducts.length)?_c('button',{staticClass:"box",attrs:{"to":"/products/create"},on:{"click":_vm.toggleCreateProductModal}},[_vm._v("Create a New Product")]):_vm._e(),_vm._l((_vm.getProducts),function(product){return (_vm.getProducts.length)?_c('router-link',{key:("" + (product._id)),staticClass:"product__link",attrs:{"to":("/products/" + (product._id))}},[_c('div',{staticClass:"product box"},[_c('div',{staticClass:"image__container"},[(product.defaultImage)?_c('img',{attrs:{"src":product.defaultImage}}):_vm._e(),(!product.defaultImage)?_c('img',{attrs:{"src":"/static/images/product-placeholder.png"}}):_vm._e()]),_c('h3',[_vm._v(_vm._s(product.name))])])]):_vm._e()})],2)],1),_c('v-tab',{attrs:{"title":"Deleted Products"}},[_c('LibraryGrid',{attrs:{"baseStyle":{backgroundColor: '#FFF', minHeight: 'inherit'}}},[(!_vm.deletedProducts.length)?_c('div',{staticClass:"no-deleted-products"},[_c('div',[_c('h3',[_vm._v("No deleted products found.")]),_c('button',{staticClass:"box",attrs:{"to":"/products/create"},on:{"click":_vm.returnToActive}},[_vm._v("View Active Products")])])]):_vm._e(),_vm._l((_vm.deletedProducts),function(product){return (_vm.deletedProducts.length)?_c('router-link',{key:("" + (product._id)),staticClass:"product__link",attrs:{"to":("/products/" + (product._id))}},[_c('div',{staticClass:"product box"},[_c('div',{staticClass:"image__container"},[(product.defaultImage)?_c('img',{attrs:{"src":product.defaultImage}}):_vm._e(),(!product.defaultImage)?_c('img',{attrs:{"src":"/static/images/product-placeholder.png"}}):_vm._e()]),_c('h3',[_vm._v(_vm._s(product.name))])])]):_vm._e()})],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SeoI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submitForm($event)}}},[_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Title")]),_c('div',{staticClass:"container__input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"input__text",attrs:{"type":"text"},domProps:{"value":(_vm.title)},on:{"change":_vm.updatePolicyTitle,"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_c('p',{staticClass:"validation__error",style:(_vm.styles.validation(_vm.showTitleValidation))},[_vm._v("Please enter a title")])])]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Rules")]),_c('p',[_vm._v("Create one or more groups of interaction rules to trigger the sequence")]),_vm._l((_vm.getActiveRules()),function(rule,index){return _c('div',{key:("rule-" + index)},[(index > 0 && _vm.getActiveRules().length > 1)?_c('p',{staticClass:"text__or"},[_vm._v("or")]):_vm._e(),_c('RuleGroup',{attrs:{"groupIndex":index}})],1)}),_c('button',{staticClass:"button__action",attrs:{"type":"button"},on:{"click":_vm.addNewRuleGroup}},[_c('i',{staticClass:"glyphicon glyphicon-plus icon"}),_vm._v("Add Rule Group")]),_c('p',{staticClass:"validation__error",style:(_vm.styles.validation(_vm.showRuleValidation && !_vm.getActiveRules()))},[_vm._v("Please create at least one rule group")])],2),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Sequence")]),_c('div',{staticClass:"container__input"},[(_vm.getSelectedSequence)?_c('section',{staticClass:"cardWrap cardWrap",style:(_vm.styles.cardWrap),on:{"click":_vm.toggleAddSequenceModal}},[_c('div',{style:(_vm.styles.cardContainer)},[_c('p',[_vm._v(_vm._s(_vm.getSelectedSequence.name))])])]):_vm._e(),(!_vm.getSelectedSequence)?_c('button',{staticClass:"button__action",attrs:{"type":"button"},on:{"click":_vm.toggleAddSequenceModal}},[_c('i',{staticClass:"glyphicon glyphicon-plus icon"}),_vm._v("Add Sequence")]):_vm._e(),(_vm.getSelectedSequence)?_c('button',{staticClass:"button__action",attrs:{"type":"button"},on:{"click":_vm.toggleAddSequenceModal}},[_c('i',{staticClass:"glyphicon glyphicon-edit icon"}),_vm._v("Change Sequence")]):_vm._e(),_c('p',{staticClass:"validation__error",style:(_vm.styles.validation(_vm.showSequenceValidation))},[_vm._v("Please select a sequence")])])]),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__control-group"},[_c('button',{staticClass:"button__submit",attrs:{"type":"submit"}},[_vm._v("Save")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SpcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_cancel_button_vue__ = __webpack_require__("1Et1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_61baedfb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_cancel_button_vue__ = __webpack_require__("r1t+");
function injectStyle (ssrContext) {
  __webpack_require__("PrcN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_cancel_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_61baedfb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_cancel_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Swet":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","fill":"#000000","viewBox":"0 0 24 24","width":"24"}},[_c('path',{attrs:{"d":"M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TTau":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tais":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PlusCircleIcon",
  props: {
    title: {
      type: String,
      default: "Plus Circle icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "TcCV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaTemplate_vue__ = __webpack_require__("X+Mz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55774d2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaTemplate_vue__ = __webpack_require__("gkF0");
function injectStyle (ssrContext) {
  __webpack_require__("Bhlb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55774d2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55774d2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tk4x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Togc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PolicyForm_vue__ = __webpack_require__("eua4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4641efa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PolicyForm_vue__ = __webpack_require__("SeoI");
function injectStyle (ssrContext) {
  __webpack_require__("mV7m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f4641efa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PolicyForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4641efa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PolicyForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tz+P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: Number,
      required: true
    },
    onlyRenderIfRetryable: {
      type: Boolean,
      default: true
    },
    uploader: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      state: {
        retryable: false
      },
      _unmounted: false
    };
  },
  mounted: function mounted() {
    this.uploader.on('complete', this._onComplete);
    this.uploader.on('statusChange', this._onStatusChange);
  },
  beforeDestroy: function beforeDestroy() {
    this._unmounted = true;
    this._unregisterEventHandlers();
  },


  methods: {
    _onComplete: function _onComplete(id, name, response) {
      if (id === this.id && !this._unmounted) {
        var retryForbidden = this.isRetryForbidden(response, this.uploader);

        if (!response.success && !retryForbidden && !this.state.retryable) {
          this.$set(this.state, 'retryable', true);
        } else if (response.success && this.state.retryable) {
          this.$set(this.state, 'retryable', false);
        } else if (retryForbidden && this.state.retryable) {
          this.$set(this.state, 'retryable', false);
          this._unregisterEventHandlers();
        }
      }
    },
    _onStatusChange: function _onStatusChange(id, oldStatus, newStatus) {
      if (id === this.id && !this._unmounted && newStatus === 'retrying upload') {
        this.$set(this.state, 'retryable', false);
      }
    },
    _onClick: function _onClick() {
      if (this.state.retryable) {
        this.uploader.methods.retry(this.id);
      }
    },
    _unregisterEventHandlers: function _unregisterEventHandlers() {
      this.uploader.off('complete', this._onComplete);
      this.uploader.off('statusChange', this._onStatusChange);
    },
    isRetryForbidden: function isRetryForbidden(response, uploader) {
      var preventRetryResponseProperty = uploader.options.retry && uploader.options.retry.preventRetryResponseProperty || 'preventRetry';

      return !!response[preventRetryResponseProperty];
    }
  }
});

/***/ }),

/***/ "UMqW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nav_tabs_themes_paper_css__ = __webpack_require__("CQ+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nav_tabs_themes_paper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_nav_tabs_themes_paper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fine_uploader_wrappers_s3__ = __webpack_require__("Zvkh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fine_uploader_wrappers_s3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_fine_uploader_wrappers_s3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__general_LibraryGrid__ = __webpack_require__("0gt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__general_MediaCard__ = __webpack_require__("lVNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__general_MediaRow__ = __webpack_require__("vQRO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__general_Spinner__ = __webpack_require__("dSGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mediaLibrary',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_9__general_Spinner__["a" /* default */],
    LibraryGrid: __WEBPACK_IMPORTED_MODULE_5__general_LibraryGrid__["a" /* default */],
    MediaCard: __WEBPACK_IMPORTED_MODULE_6__general_MediaCard__["a" /* default */],
    VueTabs: __WEBPACK_IMPORTED_MODULE_2_vue_nav_tabs__["VueTabs"],
    VTab: __WEBPACK_IMPORTED_MODULE_2_vue_nav_tabs__["VTab"],
    MediaRow: __WEBPACK_IMPORTED_MODULE_7__general_MediaRow__["a" /* default */]
  },
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_11_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_11_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  computed: {
    // Artifact of original client side filtering search
    filteredItems: {
      get: function get() {
        var arr = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getMedia;
        return arr;
      },
      set: function set(items) {
        __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('setMedia', items);
      }
    },
    isSelectedItem: function isSelectedItem(item) {
      var arr = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getSelectedMedia;
      if (arr.includes(item)) return true;
      return false;
    },
    mediaLoaded: function mediaLoaded() {
      return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.checkMediaLoaded;
    },
    marketsLoaded: function marketsLoaded() {
      return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.checkMarketsLoaded;
    },
    markets: function markets() {
      return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getMarkets;
    },
    mediaLibraries: function mediaLibraries() {
      return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getAllMediaLibraries;
    },
    productGroups: function productGroups() {
      return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getAllProductGroups;
    },
    getActiveMarket: function getActiveMarket() {
      return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getActiveMarket;
    },
    getMediaTabs: function getMediaTabs() {
      return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getMediaTabs;
    },
    getActiveMediaTab: function getActiveMediaTab() {
      return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getActiveMediaTab;
    }
  },
  methods: {
    updatePosition: function updatePosition(event) {
      var _this = this;

      var mediaId = this.filteredItems[event.newIndex]._id;

      var update = {};

      if (this.selectedPgId) {
        update.tabId = this.selectedPgId;
      } else {
        update.tabId = this.selectedMlId;
      }

      update.pos = event.newIndex;

      // new index logic
      var position = 0;
      if (event.newIndex === 0) {
        // new first item
        var topIndex = this.filteredItems[1].positions[update.tabId];
        position = topIndex + 1000;
      } else if (event.newIndex === this.filteredItems.length - 1) {
        // new last item
        var bottomIndex = this.filteredItems[this.filteredItems.length - 2].positions[update.tabId];
        position = bottomIndex - 1;
      } else {
        // item in between
        var aboveIndex = event.newIndex - 1;
        var belowIndex = event.newIndex + 1;
        var abovePosition = this.filteredItems[aboveIndex].positions[update.tabId];
        var belowPosition = this.filteredItems[belowIndex].positions[update.tabId];
        position = Math.floor(Math.random() * belowPosition) + abovePosition;
        position = Math.floor(Math.random() * (abovePosition - belowPosition + 1)) + belowPosition;
      }

      update.pos = position;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_Utils__["c" /* postResource */])('/v1/media/updatePosition', 'mediaId=' + mediaId, update).then(function (res) {
        _this.showSuccessMsg({
          message: 'New media order saved!'
        });
      }).catch(function (error) {
        _this.showErrorMsg({
          message: 'An error occurred. Please try again.'
        });
      });
    },
    changeMarket: function changeMarket() {
      var marketId = this.$refs.marketDropdown.value;
      var markets = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getMarkets;
      var market = markets.filter(function (m) {
        return m._id === marketId;
      })[0];
      __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('setActiveMarket', market);
      this.refreshMedia();
    },
    onScroll: function onScroll() {
      var el = document.getElementById('scrollWrapper');
      if (el.scrollTop + el.clientHeight >= document.getElementById('mediaLibraryContainer').clientHeight) {
        this.loadMoreMedia();
      }
    },
    handleTabChange: function handleTabChange(index) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('setMediaLoadedStatus', false);
      var tabs = this.getMediaTabs;
      var activeTab = tabs[index];
      var market = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getActiveMarket;
      __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('setActiveMediaTab', activeTab ? activeTab : null);

      if (activeTab) {
        if (activeTab._id === 'featured') {
          this.selectedMlId = 'featured';
          this.selectedPgId = null;
          this.last = null;
          this.moreMedia = null;
          return __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getMediaByMarket(market._id, 'featured', false, false, false, function (res) {
            _this2.moreMedia = res.more;
          });
        } else if (activeTab.type === 'mediaLibrary') {
          this.selectedMlId = activeTab._id;
          this.selectedPgId = null;
          this.last = null;
          this.moreMedia = null;
          return __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getMediaByMarket(market._id, activeTab._id, false, false, false, function (res) {
            _this2.moreMedia = res.more;
          });
        } else if (activeTab.type === 'productGroup') {
          this.selectedPgId = activeTab._id;
          this.selectedMlId = null;
          this.last = null;
          this.moreMedia = null;
          return __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getMediaByMarket(market._id, false, activeTab._id, false, false, function (res) {
            _this2.moreMedia = res.more;
          });
        }
      } else if (!activeTab && index === tabs.length) {
        this.selectedPgId = null;
        this.selectedMlId = 'none';
        this.last = null;
        this.moreMedia = null;
        return __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getMediaByMarket(market._id, 'none', false, false, false, function (res) {
          _this2.moreMedia = res.more;
        });
      }
    },
    handleLibraryChange: function handleLibraryChange(id) {
      var _this3 = this;

      var mlId = id;
      var market = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getActiveMarket;
      if (mlId === 'all') {
        this.selectedMlId = null;
        this.last = null;
        this.moreMedia = null;
        __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getMediaByMarket(market._id, false, this.selectedPgId, false, false, function (res) {
          _this3.moreMedia = res.more;
        });
      } else if (mlId === 'none') {
        this.selectedMlId = 'none';
        this.last = null;
        this.moreMedia = null;
        __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getMediaByMarket(market._id, 'none', this.selectedPgId, false, false, function (res) {
          _this3.moreMedia = res.more;
        });
      } else {
        this.selectedMlId = mlId;
        this.last = null;
        this.moreMedia = null;
        __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getMediaByMarket(market._id, mlId, this.selectedPgId, false, false, function (res) {
          _this3.moreMedia = res.more;
        });
      }
    },
    handleGroupChange: function handleGroupChange(e) {
      var _this4 = this;

      var pgId = e.target.value;
      var market = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getActiveMarket;
      if (pgId === 'all') {
        this.selectedPgId = null;
        this.last = null;
        this.moreMedia = null;
        __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getMediaByMarket(market._id, this.selectedMlId, false, false, false, function (res) {
          _this4.moreMedia = res.more;
        });
      } else {
        this.selectedPgId = pgId;
        this.last = null;
        this.moreMedia = null;
        __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getMediaByMarket(market._id, this.selectedMlId, pgId, false, false, function (res) {
          _this4.moreMedia = res.more;
        });
      }
    },
    loadMoreMedia: function loadMoreMedia() {
      var _this5 = this;

      if (this.moreMedia) {
        var media = this.filteredItems;
        var count = 0;
        if (this.selectedMlId) {
          count = media[media.length - 1].positions[this.selectedMlId] - 1;
        } else {
          count = media[media.length - 1].positions[this.selectedPgId] - 1;
        }
        this.last = count;
        __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getMediaByMarket(__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getActiveMarket._id, this.selectedMlId, this.selectedPgId, count, this.moreMedia, function (res) {
          _this5.moreMedia = res.more;
        });
      }
    },
    navigateToMediaSearch: function navigateToMediaSearch() {
      this.$router.push('search/media');
    },
    refreshMedia: function refreshMedia() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('setMediaLoadedStatus', false);
      this.last = null;
      this.moreMedia = null;
      __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getMediaByMarket(__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getActiveMarket._id, this.selectedMlId, this.selectedPgId, false, false, function (res) {
        _this6.moreMedia = res.more;
      });
    },
    toggleUploadMediaModal: function toggleUploadMediaModal(bool) {
      __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('showMediaUploadModal', bool);
    }
  },
  data: function data() {
    return {
      query: '',
      selectActiveMedia: __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].selectActiveMedia,
      toggleUploadMedia: __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].toggleUploadMedia,
      getFlagUrl: __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getFlagUrl,
      selectedMlId: 'featured',
      selectedPgId: null,
      last: null,
      moreMedia: true,
      canDelete: true,
      unsavedEdits: {
        description: false,
        title: false,
        productGroups: false,
        generalUses: false
      },
      styles: {
        wrapper: function wrapper(loaded) {
          return {
            display: 'flex',
            flexFlow: 'row nowrap',
            justifyContent: loaded ? 'flex-start' : 'center',
            alignItems: loaded ? 'flex-start' : 'center',
            height: '100vh',
            background: '#f5f5f5'
          };
        },
        libraryWrapper: {
          background: '#f5f5f5',
          paddingBottom: '20px'
        },
        nav: {
          position: 'fixed',
          top: '0',
          left: '200px',
          right: '0',
          background: 'rgba(255,255,255,0.9)',
          borderBottom: '1px solid #eee',
          boxShadow: '0 0 20px 5px rgba(0,0,0,0.1)',
          height: '60px',
          zIndex: '99',
          padding: '10px',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        marketSelect: {
          width: '250px',
          fontSize: '1em',
          fontWeight: 700,
          // padding: '10px',
          height: '40px',
          boxSizing: 'border-box',
          margin: 'auto auto auto 0'
        },
        navInputWrapper: {
          flex: '0 0 auto',
          width: 'auto',
          padding: '8px',
          margin: 'auto 0 auto auto',
          background: '#fff',
          border: '1px solid #ddd',
          borderRadius: '4px',
          overflow: 'hidden',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        navInput: {
          flex: '1',
          padding: '0',
          margin: 'auto 0',
          borderRadius: '0',
          border: '0',
          background: '#fff'
        },
        navInputIcon: {
          margin: 'auto 10px auto 3px',
          color: '#09a3ed',
          fontSize: '1em',
          position: 'relative',
          top: '-1px'
        },
        toggleUploadModalButton: {
          background: '#fff',
          border: '1px solid #09a3ed',
          fontSize: '0.9em',
          color: '#09a3ed',
          borderRadius: '5px',
          padding: '8px 12px',
          margin: 'auto 0 auto 10px',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          cursor: 'pointer'
        },
        uploadIcon: {
          position: 'relative',
          top: '-2px',
          fontSize: '1em'
        },
        refreshMediaButton: {
          border: '0',
          background: '#fff',
          color: '#09a3ed',
          margin: 'auto 10px',
          cursor: 'pointer'
        },
        noMedia: {
          margin: '100px auto auto',
          display: 'block',
          textAlign: 'center'
        },
        loadMoreButton: {
          padding: '10px 20px',
          background: 'transparent',
          color: '#09a3ed',
          display: 'block',
          margin: '20px auto',
          border: '1px solid #09a3ed',
          borderRadius: '100px',
          cursor: 'pointer'
        }
      }
    };
  },
  mounted: function mounted() {
    var _this7 = this;

    __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].clearActiveMedia();
    __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getMediaTabs();
    var market = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getActiveMarket;
    if (market && market._id) {
      __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getMediaByMarket(market._id, this.selectedMlId, false, false, false, function (res) {
        _this7.moreMedia = res.more;
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getMarkets(function (markets) {
        __WEBPACK_IMPORTED_MODULE_8__services_Services__["a" /* default */].getMediaByMarket(markets[0]._id, _this7.selectedMlId, false, false, false, function (res) {
          _this7.moreMedia = res.more;
        });
      });
    }
    var el = document.getElementById('scrollWrapper');
    el.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy: function beforeDestroy() {
    var el = document.getElementById('scrollWrapper');
    el.removeEventListener('scroll', this.onScroll);
  }
});

/***/ }),

/***/ "UNH8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_dropzone_vue__ = __webpack_require__("YgLn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_23099bce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_dropzone_vue__ = __webpack_require__("FaWy");
function injectStyle (ssrContext) {
  __webpack_require__("bsKQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_dropzone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_23099bce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_dropzone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UZbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    /**
     * API getters
     */
    getApi: function getApi(store) {
        var loc = window.location.host;
        var hn = loc.split('.')[0];
        if (hn === 'localhost:8080') return 'http://localhost:3030';
        var testStr = hn.split('-');
        if (testStr[0] && testStr[1] && testStr[1] === 'test') return 'https://admin-test-api.gegservices.io';
        if (hn !== 'admin-dev' && hn !== 'admin-test') return 'https://admin-api.gegservices.io';
        var url = 'https://' + hn + '-api.gegservices.io';
        return store.mainApi || url;
        // return 'http://localhost:3031';
    },
    getToken: function getToken(store) {
        return store.token;
    },


    /**
    * Routes
    */
    getRoute: function getRoute(store) {
        return store.route;
    },


    /**
    * Authentication
    */
    isAuthenticated: function isAuthenticated(store) {
        return !!store.token;
    },
    authStatus: function authStatus(store) {
        return store.status;
    },
    getDomain: function getDomain(store) {
        return store.domain;
    },
    getTenant: function getTenant(store) {
        return store.tenant;
    },
    getUser: function getUser(store) {
        return store.user;
    },

    /**
    * Charts
    */
    getCharts: function getCharts(store) {
        return store.charts;
    },


    /**
    * Media
    */
    getMedia: function getMedia(store) {
        return store.media;
    },
    checkMediaLoaded: function checkMediaLoaded(store) {
        return store.mediaLoaded;
    },
    getActiveMedia: function getActiveMedia(store) {
        return store.activeMedia;
    },
    getSelectedMedia: function getSelectedMedia(store) {
        return store.selectedMedia;
    },
    getAllMediaLibraries: function getAllMediaLibraries(store) {
        return store.allMediaLibraries;
    },
    getActiveMediaLibrary: function getActiveMediaLibrary(store) {
        return store.activeMediaLibrary;
    },
    getMediaTabs: function getMediaTabs(store) {
        return store.mediaTabs;
    },
    getActiveMediaTab: function getActiveMediaTab(store) {
        return store.activeMediaTab;
    },


    /**
    * Modals
    */
    getShowAddCardToSequenceModal: function getShowAddCardToSequenceModal(store) {
        return store.showAddCardToSequenceModal;
    },
    getShowAddMediaToCardModal: function getShowAddMediaToCardModal(store) {
        return store.showAddMediaToCardModal;
    },
    getShowAddSequenceToPolicyModal: function getShowAddSequenceToPolicyModal(store) {
        return store.showAddSequenceToPolicyModal;
    },
    getShowUploadMediaModal: function getShowUploadMediaModal(store) {
        return store.showUploadMediaModal;
    },
    getShowUpdateThumbModal: function getShowUpdateThumbModal(store) {
        return store.showUpdateThumbModal;
    },
    getShowDeprecateMediaModal: function getShowDeprecateMediaModal(store) {
        return store.showDeprecateMediaModal;
    },
    getShowColdDeckModal: function getShowColdDeckModal(store) {
        return store.showColdDeckModal;
    },
    getShowLogoutModal: function getShowLogoutModal(store) {
        return store.showLogoutModal;
    },
    getShowCardHelpModal: function getShowCardHelpModal(store) {
        return store.showCardHelpModal;
    },
    getShowCreateCardModal: function getShowCreateCardModal(store) {
        return store.showCreateCardModal;
    },
    getShowCreateLocalRecord: function getShowCreateLocalRecord(store) {
        return store.showCreateLocalRecordModal;
    },
    getShowCreateMediaLibrary: function getShowCreateMediaLibrary(store) {
        return store.showCreateMediaLibraryModal;
    },
    getShowCreateMediaLibraryLocalRecord: function getShowCreateMediaLibraryLocalRecord(store) {
        return store.showCreateMediaLibraryLocalRecordModal;
    },
    getShowCreateProductLocalRecord: function getShowCreateProductLocalRecord(store) {
        return store.showCreateProductLocalRecordModal;
    },
    getShowCreateProductGroupLocalRecord: function getShowCreateProductGroupLocalRecord(store) {
        return store.showCreateProductGroupLocalRecordModal;
    },
    getShowCreateMarket: function getShowCreateMarket(store) {
        return store.showCreateMarketModal;
    },
    getShowCreateProduct: function getShowCreateProduct(store) {
        return store.showCreateProductModal;
    },
    getShowCreateProductGroup: function getShowCreateProductGroup(store) {
        return store.showCreateProductGroupModal;
    },
    getShowDeleteRecord: function getShowDeleteRecord(store) {
        return store.showDeleteRecordModal;
    },
    getShowUploadProductImage: function getShowUploadProductImage(store) {
        return store.showUploadProductImageModal;
    },
    getShowCardIcon: function getShowCardIcon(store) {
        return store.showCardIconModal;
    },
    getShowCopyVolumeLinks: function getShowCopyVolumeLinks(store) {
        return store.showCopyVolumeLinksModal;
    },
    getShowCopyLocalRecord: function getShowCopyLocalRecord(store) {
        return store.showCopyLocalRecordModal;
    },
    getShowDeleteProductModal: function getShowDeleteProductModal(store) {
        return store.showDeleteProductModal;
    },
    getShowRestoreProductModal: function getShowRestoreProductModal(store) {
        return store.showRestoreProductModal;
    },


    /**
    * Products
    */

    getProducts: function getProducts(store) {
        return store.products;
    },
    getActiveProduct: function getActiveProduct(store) {
        return store.activeProduct;
    },
    getActiveProductGroup: function getActiveProductGroup(store) {
        return store.activeProductGroup;
    },
    getAllProductGroups: function getAllProductGroups(store) {
        return store.allProductGroups;
    },
    getIsEditingPrimaryImage: function getIsEditingPrimaryImage(store) {
        return store.isEditingPrimaryImage;
    },


    /**
    * Markets
    */
    getMarkets: function getMarkets(store) {
        return store.markets;
    },
    getActiveMarket: function getActiveMarket(store) {
        return store.activeMarket;
    },
    checkMarketsLoaded: function checkMarketsLoaded(store) {
        return store.marketsLoaded;
    },


    /**
    * Cards
    */
    getCards: function getCards(store) {
        return store.cards;
    },
    getActiveCard: function getActiveCard(store) {
        return store.activeCard;
    },
    checkCardsReady: function checkCardsReady(store) {
        return store.cardsLoaded;
    },
    getCardTypes: function getCardTypes(store) {
        return store.cardTypes;
    },
    getActiveLocale: function getActiveLocale(store) {
        return store.activeLocale;
    },
    getActiveLocalRecord: function getActiveLocalRecord(store) {
        return store.activeLocalRecord;
    },
    getActiveLocalRecordSaved: function getActiveLocalRecordSaved(store) {
        return store.activeLocalRecordSaved;
    },
    getCardIconContext: function getCardIconContext(store) {
        return store.cardIconContext;
    },


    /**
    * Policies
    */

    getPolicies: function getPolicies(store) {
        return store.policies;
    },
    getActivePolicyOption: function getActivePolicyOption(store) {
        return store.activePolicyOption;
    },
    getActivePolicy: function getActivePolicy(store) {
        return store.activePolicy;
    },
    getSelectedSequence: function getSelectedSequence(store) {
        return store.selectedSequence;
    },
    getInteractionTypes: function getInteractionTypes(store) {
        return store.interactionTypes;
    },


    /**
    * Sequences
    */
    getSequences: function getSequences(store) {
        return store.sequences;
    },
    getActiveSequence: function getActiveSequence(store) {
        return store.activeSequence;
    },
    getSequenceCards: function getSequenceCards(store) {
        return store.sequenceCards;
    },
    getOriginalSequenceCards: function getOriginalSequenceCards(store) {
        return store.originalSequenceCards;
    },
    getSequenceStatus: function getSequenceStatus(store) {
        return store.unsavedSequence;
    },


    /**
     * Error messaging
     */
    getErrors: function getErrors(store) {
        return store.errors;
    }
});

/***/ }),

/***/ "Ulzb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_retry_button_vue__ = __webpack_require__("Tz+P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_31e76ce3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_retry_button_vue__ = __webpack_require__("x3qJ");
function injectStyle (ssrContext) {
  __webpack_require__("P9Ox")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_retry_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_31e76ce3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_retry_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V/KL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardUser_vue__ = __webpack_require__("lPia");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e2c9481_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardUser_vue__ = __webpack_require__("5aEr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e2c9481_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "VBxv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VWrl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ImageArea_vue__ = __webpack_require__("WHJf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_89924450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ImageArea_vue__ = __webpack_require__("7US3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ImageArea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_89924450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ImageArea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VxPh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaLibrary_vue__ = __webpack_require__("UMqW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab34f14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaLibrary_vue__ = __webpack_require__("/NP2");
function injectStyle (ssrContext) {
  __webpack_require__("yUAE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ab34f14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaLibrary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab34f14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaLibrary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W/Lp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","fill":"#000000","viewBox":"0 0 24 24","width":"24"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W25j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_notifications__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductImageUpload',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__general_Modal__["a" /* default */]
  },
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  computed: {
    getActiveProduct: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getActiveProduct;
      },
      set: function set(product) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setActiveProduct', product);
      }
    }
  },
  data: function data() {
    return {
      image: '',
      imageFile: '',
      newImage: ''
    };
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setIsPrimaryImage', false);
  },

  methods: {
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;
      this.imageFile = files[0];

      this.createImage(files[0]);
    },
    createImage: function createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = function (e) {
        vm.image = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    base64MimeType: function base64MimeType(encoded) {
      var result = null;

      if (typeof encoded !== 'string') {
        return result;
      }

      var mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

      if (mime && mime.length) {
        result = mime[1];
      }

      return result;
    },
    uploadImage: function uploadImage() {
      var _this = this;

      var imageData = {};
      imageData.image = this.image;
      var imageJSON = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(imageData);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_Utils__["b" /* postImage */])('/v1/products/images/add', 'productId=' + this.getActiveProduct._id, this.image).then(function (res) {
        // get image url back
        _this.showSuccessMsg({
          message: 'New image uploaded successfully. Be sure to save your changes!'
        });
        var activeLocalRecord = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getActiveLocalRecord);
        if (!activeLocalRecord.images) {
          activeLocalRecord.images = [];
        }

        if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getIsEditingPrimaryImage) {
          activeLocalRecord.images.unshift(res.imageUrl);
        } else {
          activeLocalRecord.images.push(res.imageUrl);
        }

        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setActiveLocalRecord', activeLocalRecord);
        return res;
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('hideModals', true);
      }).catch(function (error) {
        var message = 'An error occurred. Please try again.';
        if (typeof error.error === 'string' || error.error instanceof String) {
          message = error.error;
        } else if (error.message) {
          message = error.message;
        }
        return _this.showErrorMsg({
          message: message
        });
      });
    },
    removeImage: function removeImage(e) {
      this.image = '';
    }
  }
});

/***/ }),

/***/ "WHJf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ImageAreaIcon",
  props: {
    title: {
      type: String,
      default: "Image Area icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "WKPr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WVmP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WtOz":
/***/ (function(module, exports) {

module.exports = [{"name":"Afghanistan","alpha2":"AF","alpha3":"AFG"},{"name":"Åland Islands","alpha2":"AX","alpha3":"ALA"},{"name":"Albania","alpha2":"AL","alpha3":"ALB"},{"name":"Algeria","alpha2":"DZ","alpha3":"DZA"},{"name":"American Samoa","alpha2":"AS","alpha3":"ASM"},{"name":"Andorra","alpha2":"AD","alpha3":"AND"},{"name":"Angola","alpha2":"AO","alpha3":"AGO"},{"name":"Anguilla","alpha2":"AI","alpha3":"AIA"},{"name":"Antarctica","alpha2":"AQ","alpha3":"ATA"},{"name":"Antigua and Barbuda","alpha2":"AG","alpha3":"ATG"},{"name":"Argentina","alpha2":"AR","alpha3":"ARG"},{"name":"Armenia","alpha2":"AM","alpha3":"ARM"},{"name":"Aruba","alpha2":"AW","alpha3":"ABW"},{"name":"Australia","alpha2":"AU","alpha3":"AUS"},{"name":"Austria","alpha2":"AT","alpha3":"AUT"},{"name":"Azerbaijan","alpha2":"AZ","alpha3":"AZE"},{"name":"Bahamas","alpha2":"BS","alpha3":"BHS"},{"name":"Bahrain","alpha2":"BH","alpha3":"BHR"},{"name":"Bangladesh","alpha2":"BD","alpha3":"BGD"},{"name":"Barbados","alpha2":"BB","alpha3":"BRB"},{"name":"Belarus","alpha2":"BY","alpha3":"BLR"},{"name":"Belgium","alpha2":"BE","alpha3":"BEL"},{"name":"Belize","alpha2":"BZ","alpha3":"BLZ"},{"name":"Benin","alpha2":"BJ","alpha3":"BEN"},{"name":"Bermuda","alpha2":"BM","alpha3":"BMU"},{"name":"Bhutan","alpha2":"BT","alpha3":"BTN"},{"name":"Bolivia (Plurinational State of)","alpha2":"BO","alpha3":"BOL"},{"name":"Bonaire, Sint Eustatius and Saba","alpha2":"BQ","alpha3":"BES"},{"name":"Bosnia and Herzegovina","alpha2":"BA","alpha3":"BIH"},{"name":"Botswana","alpha2":"BW","alpha3":"BWA"},{"name":"Bouvet Island","alpha2":"BV","alpha3":"BVT"},{"name":"Brazil","alpha2":"BR","alpha3":"BRA"},{"name":"British Indian Ocean Territory","alpha2":"IO","alpha3":"IOT"},{"name":"Brunei Darussalam","alpha2":"BN","alpha3":"BRN"},{"name":"Bulgaria","alpha2":"BG","alpha3":"BGR"},{"name":"Burkina Faso","alpha2":"BF","alpha3":"BFA"},{"name":"Burundi","alpha2":"BI","alpha3":"BDI"},{"name":"Cabo Verde","alpha2":"CV","alpha3":"CPV"},{"name":"Cambodia","alpha2":"KH","alpha3":"KHM"},{"name":"Cameroon","alpha2":"CM","alpha3":"CMR"},{"name":"Canada","alpha2":"CA","alpha3":"CAN"},{"name":"Cayman Islands","alpha2":"KY","alpha3":"CYM"},{"name":"Central African Republic","alpha2":"CF","alpha3":"CAF"},{"name":"Chad","alpha2":"TD","alpha3":"TCD"},{"name":"Chile","alpha2":"CL","alpha3":"CHL"},{"name":"China","alpha2":"CN","alpha3":"CHN"},{"name":"Christmas Island","alpha2":"CX","alpha3":"CXR"},{"name":"Cocos (Keeling) Islands","alpha2":"CC","alpha3":"CCK"},{"name":"Colombia","alpha2":"CO","alpha3":"COL"},{"name":"Comoros","alpha2":"KM","alpha3":"COM"},{"name":"Congo","alpha2":"CG","alpha3":"COG"},{"name":"Congo, Democratic Republic of the","alpha2":"CD","alpha3":"COD"},{"name":"Cook Islands","alpha2":"CK","alpha3":"COK"},{"name":"Costa Rica","alpha2":"CR","alpha3":"CRI"},{"name":"Côte d'Ivoire","alpha2":"CI","alpha3":"CIV"},{"name":"Croatia","alpha2":"HR","alpha3":"HRV"},{"name":"Cuba","alpha2":"CU","alpha3":"CUB"},{"name":"Curaçao","alpha2":"CW","alpha3":"CUW"},{"name":"Cyprus","alpha2":"CY","alpha3":"CYP"},{"name":"Czechia","alpha2":"CZ","alpha3":"CZE"},{"name":"Denmark","alpha2":"DK","alpha3":"DNK"},{"name":"Djibouti","alpha2":"DJ","alpha3":"DJI"},{"name":"Dominica","alpha2":"DM","alpha3":"DMA"},{"name":"Dominican Republic","alpha2":"DO","alpha3":"DOM"},{"name":"Ecuador","alpha2":"EC","alpha3":"ECU"},{"name":"Egypt","alpha2":"EG","alpha3":"EGY"},{"name":"El Salvador","alpha2":"SV","alpha3":"SLV"},{"name":"Equatorial Guinea","alpha2":"GQ","alpha3":"GNQ"},{"name":"Eritrea","alpha2":"ER","alpha3":"ERI"},{"name":"Estonia","alpha2":"EE","alpha3":"EST"},{"name":"Eswatini","alpha2":"SZ","alpha3":"SWZ"},{"name":"Ethiopia","alpha2":"ET","alpha3":"ETH"},{"name":"Falkland Islands (Malvinas)","alpha2":"FK","alpha3":"FLK"},{"name":"Faroe Islands","alpha2":"FO","alpha3":"FRO"},{"name":"Fiji","alpha2":"FJ","alpha3":"FJI"},{"name":"Finland","alpha2":"FI","alpha3":"FIN"},{"name":"France","alpha2":"FR","alpha3":"FRA"},{"name":"French Guiana","alpha2":"GF","alpha3":"GUF"},{"name":"French Polynesia","alpha2":"PF","alpha3":"PYF"},{"name":"French Southern Territories","alpha2":"TF","alpha3":"ATF"},{"name":"Gabon","alpha2":"GA","alpha3":"GAB"},{"name":"Gambia","alpha2":"GM","alpha3":"GMB"},{"name":"Georgia","alpha2":"GE","alpha3":"GEO"},{"name":"Germany","alpha2":"DE","alpha3":"DEU"},{"name":"Ghana","alpha2":"GH","alpha3":"GHA"},{"name":"Gibraltar","alpha2":"GI","alpha3":"GIB"},{"name":"Greece","alpha2":"GR","alpha3":"GRC"},{"name":"Greenland","alpha2":"GL","alpha3":"GRL"},{"name":"Grenada","alpha2":"GD","alpha3":"GRD"},{"name":"Guadeloupe","alpha2":"GP","alpha3":"GLP"},{"name":"Guam","alpha2":"GU","alpha3":"GUM"},{"name":"Guatemala","alpha2":"GT","alpha3":"GTM"},{"name":"Guernsey","alpha2":"GG","alpha3":"GGY"},{"name":"Guinea","alpha2":"GN","alpha3":"GIN"},{"name":"Guinea-Bissau","alpha2":"GW","alpha3":"GNB"},{"name":"Guyana","alpha2":"GY","alpha3":"GUY"},{"name":"Haiti","alpha2":"HT","alpha3":"HTI"},{"name":"Heard Island and McDonald Islands","alpha2":"HM","alpha3":"HMD"},{"name":"Holy See","alpha2":"VA","alpha3":"VAT"},{"name":"Honduras","alpha2":"HN","alpha3":"HND"},{"name":"Hong Kong","alpha2":"HK","alpha3":"HKG"},{"name":"Hungary","alpha2":"HU","alpha3":"HUN"},{"name":"Iceland","alpha2":"IS","alpha3":"ISL"},{"name":"India","alpha2":"IN","alpha3":"IND"},{"name":"Indonesia","alpha2":"ID","alpha3":"IDN"},{"name":"Iran (Islamic Republic of)","alpha2":"IR","alpha3":"IRN"},{"name":"Iraq","alpha2":"IQ","alpha3":"IRQ"},{"name":"Ireland","alpha2":"IE","alpha3":"IRL"},{"name":"Isle of Man","alpha2":"IM","alpha3":"IMN"},{"name":"Israel","alpha2":"IL","alpha3":"ISR"},{"name":"Italy","alpha2":"IT","alpha3":"ITA"},{"name":"Jamaica","alpha2":"JM","alpha3":"JAM"},{"name":"Japan","alpha2":"JP","alpha3":"JPN"},{"name":"Jersey","alpha2":"JE","alpha3":"JEY"},{"name":"Jordan","alpha2":"JO","alpha3":"JOR"},{"name":"Kazakhstan","alpha2":"KZ","alpha3":"KAZ"},{"name":"Kenya","alpha2":"KE","alpha3":"KEN"},{"name":"Kiribati","alpha2":"KI","alpha3":"KIR"},{"name":"Korea (Democratic People's Republic of)","alpha2":"KP","alpha3":"PRK"},{"name":"Korea, Republic of","alpha2":"KR","alpha3":"KOR"},{"name":"Kuwait","alpha2":"KW","alpha3":"KWT"},{"name":"Kyrgyzstan","alpha2":"KG","alpha3":"KGZ"},{"name":"Lao People's Democratic Republic","alpha2":"LA","alpha3":"LAO"},{"name":"Latvia","alpha2":"LV","alpha3":"LVA"},{"name":"Lebanon","alpha2":"LB","alpha3":"LBN"},{"name":"Lesotho","alpha2":"LS","alpha3":"LSO"},{"name":"Liberia","alpha2":"LR","alpha3":"LBR"},{"name":"Libya","alpha2":"LY","alpha3":"LBY"},{"name":"Liechtenstein","alpha2":"LI","alpha3":"LIE"},{"name":"Lithuania","alpha2":"LT","alpha3":"LTU"},{"name":"Luxembourg","alpha2":"LU","alpha3":"LUX"},{"name":"Macao","alpha2":"MO","alpha3":"MAC"},{"name":"Madagascar","alpha2":"MG","alpha3":"MDG"},{"name":"Malawi","alpha2":"MW","alpha3":"MWI"},{"name":"Malaysia","alpha2":"MY","alpha3":"MYS"},{"name":"Maldives","alpha2":"MV","alpha3":"MDV"},{"name":"Mali","alpha2":"ML","alpha3":"MLI"},{"name":"Malta","alpha2":"MT","alpha3":"MLT"},{"name":"Marshall Islands","alpha2":"MH","alpha3":"MHL"},{"name":"Martinique","alpha2":"MQ","alpha3":"MTQ"},{"name":"Mauritania","alpha2":"MR","alpha3":"MRT"},{"name":"Mauritius","alpha2":"MU","alpha3":"MUS"},{"name":"Mayotte","alpha2":"YT","alpha3":"MYT"},{"name":"Mexico","alpha2":"MX","alpha3":"MEX"},{"name":"Micronesia (Federated States of)","alpha2":"FM","alpha3":"FSM"},{"name":"Moldova, Republic of","alpha2":"MD","alpha3":"MDA"},{"name":"Monaco","alpha2":"MC","alpha3":"MCO"},{"name":"Mongolia","alpha2":"MN","alpha3":"MNG"},{"name":"Montenegro","alpha2":"ME","alpha3":"MNE"},{"name":"Montserrat","alpha2":"MS","alpha3":"MSR"},{"name":"Morocco","alpha2":"MA","alpha3":"MAR"},{"name":"Mozambique","alpha2":"MZ","alpha3":"MOZ"},{"name":"Myanmar","alpha2":"MM","alpha3":"MMR"},{"name":"Namibia","alpha2":"NA","alpha3":"NAM"},{"name":"Nauru","alpha2":"NR","alpha3":"NRU"},{"name":"Nepal","alpha2":"NP","alpha3":"NPL"},{"name":"Netherlands","alpha2":"NL","alpha3":"NLD"},{"name":"New Caledonia","alpha2":"NC","alpha3":"NCL"},{"name":"New Zealand","alpha2":"NZ","alpha3":"NZL"},{"name":"Nicaragua","alpha2":"NI","alpha3":"NIC"},{"name":"Niger","alpha2":"NE","alpha3":"NER"},{"name":"Nigeria","alpha2":"NG","alpha3":"NGA"},{"name":"Niue","alpha2":"NU","alpha3":"NIU"},{"name":"Norfolk Island","alpha2":"NF","alpha3":"NFK"},{"name":"North Macedonia","alpha2":"MK","alpha3":"MKD"},{"name":"Northern Mariana Islands","alpha2":"MP","alpha3":"MNP"},{"name":"Norway","alpha2":"NO","alpha3":"NOR"},{"name":"Oman","alpha2":"OM","alpha3":"OMN"},{"name":"Pakistan","alpha2":"PK","alpha3":"PAK"},{"name":"Palau","alpha2":"PW","alpha3":"PLW"},{"name":"Palestine, State of","alpha2":"PS","alpha3":"PSE"},{"name":"Panama","alpha2":"PA","alpha3":"PAN"},{"name":"Papua New Guinea","alpha2":"PG","alpha3":"PNG"},{"name":"Paraguay","alpha2":"PY","alpha3":"PRY"},{"name":"Peru","alpha2":"PE","alpha3":"PER"},{"name":"Philippines","alpha2":"PH","alpha3":"PHL"},{"name":"Pitcairn","alpha2":"PN","alpha3":"PCN"},{"name":"Poland","alpha2":"PL","alpha3":"POL"},{"name":"Portugal","alpha2":"PT","alpha3":"PRT"},{"name":"Puerto Rico","alpha2":"PR","alpha3":"PRI"},{"name":"Qatar","alpha2":"QA","alpha3":"QAT"},{"name":"Réunion","alpha2":"RE","alpha3":"REU"},{"name":"Romania","alpha2":"RO","alpha3":"ROU"},{"name":"Russian Federation","alpha2":"RU","alpha3":"RUS"},{"name":"Rwanda","alpha2":"RW","alpha3":"RWA"},{"name":"Saint Barthélemy","alpha2":"BL","alpha3":"BLM"},{"name":"Saint Helena, Ascension and Tristan da Cunha","alpha2":"SH","alpha3":"SHN"},{"name":"Saint Kitts and Nevis","alpha2":"KN","alpha3":"KNA"},{"name":"Saint Lucia","alpha2":"LC","alpha3":"LCA"},{"name":"Saint Martin (French part)","alpha2":"MF","alpha3":"MAF"},{"name":"Saint Pierre and Miquelon","alpha2":"PM","alpha3":"SPM"},{"name":"Saint Vincent and the Grenadines","alpha2":"VC","alpha3":"VCT"},{"name":"Samoa","alpha2":"WS","alpha3":"WSM"},{"name":"San Marino","alpha2":"SM","alpha3":"SMR"},{"name":"Sao Tome and Principe","alpha2":"ST","alpha3":"STP"},{"name":"Saudi Arabia","alpha2":"SA","alpha3":"SAU"},{"name":"Senegal","alpha2":"SN","alpha3":"SEN"},{"name":"Serbia","alpha2":"RS","alpha3":"SRB"},{"name":"Seychelles","alpha2":"SC","alpha3":"SYC"},{"name":"Sierra Leone","alpha2":"SL","alpha3":"SLE"},{"name":"Singapore","alpha2":"SG","alpha3":"SGP"},{"name":"Sint Maarten (Dutch part)","alpha2":"SX","alpha3":"SXM"},{"name":"Slovakia","alpha2":"SK","alpha3":"SVK"},{"name":"Slovenia","alpha2":"SI","alpha3":"SVN"},{"name":"Solomon Islands","alpha2":"SB","alpha3":"SLB"},{"name":"Somalia","alpha2":"SO","alpha3":"SOM"},{"name":"South Africa","alpha2":"ZA","alpha3":"ZAF"},{"name":"South Georgia and the South Sandwich Islands","alpha2":"GS","alpha3":"SGS"},{"name":"South Sudan","alpha2":"SS","alpha3":"SSD"},{"name":"Spain","alpha2":"ES","alpha3":"ESP"},{"name":"Sri Lanka","alpha2":"LK","alpha3":"LKA"},{"name":"Sudan","alpha2":"SD","alpha3":"SDN"},{"name":"Suriname","alpha2":"SR","alpha3":"SUR"},{"name":"Svalbard and Jan Mayen","alpha2":"SJ","alpha3":"SJM"},{"name":"Sweden","alpha2":"SE","alpha3":"SWE"},{"name":"Switzerland","alpha2":"CH","alpha3":"CHE"},{"name":"Syrian Arab Republic","alpha2":"SY","alpha3":"SYR"},{"name":"Taiwan, Province of China","alpha2":"TW","alpha3":"TWN"},{"name":"Tajikistan","alpha2":"TJ","alpha3":"TJK"},{"name":"Tanzania, United Republic of","alpha2":"TZ","alpha3":"TZA"},{"name":"Thailand","alpha2":"TH","alpha3":"THA"},{"name":"Timor-Leste","alpha2":"TL","alpha3":"TLS"},{"name":"Togo","alpha2":"TG","alpha3":"TGO"},{"name":"Tokelau","alpha2":"TK","alpha3":"TKL"},{"name":"Tonga","alpha2":"TO","alpha3":"TON"},{"name":"Trinidad and Tobago","alpha2":"TT","alpha3":"TTO"},{"name":"Tunisia","alpha2":"TN","alpha3":"TUN"},{"name":"Turkey","alpha2":"TR","alpha3":"TUR"},{"name":"Turkmenistan","alpha2":"TM","alpha3":"TKM"},{"name":"Turks and Caicos Islands","alpha2":"TC","alpha3":"TCA"},{"name":"Tuvalu","alpha2":"TV","alpha3":"TUV"},{"name":"Uganda","alpha2":"UG","alpha3":"UGA"},{"name":"Ukraine","alpha2":"UA","alpha3":"UKR"},{"name":"United Arab Emirates","alpha2":"AE","alpha3":"ARE"},{"name":"United Kingdom of Great Britain and Northern Ireland","alpha2":"GB","alpha3":"GBR"},{"name":"United States of America","alpha2":"US","alpha3":"USA"},{"name":"United States Minor Outlying Islands","alpha2":"UM","alpha3":"UMI"},{"name":"Uruguay","alpha2":"UY","alpha3":"URY"},{"name":"Uzbekistan","alpha2":"UZ","alpha3":"UZB"},{"name":"Vanuatu","alpha2":"VU","alpha3":"VUT"},{"name":"Venezuela (Bolivarian Republic of)","alpha2":"VE","alpha3":"VEN"},{"name":"Viet Nam","alpha2":"VN","alpha3":"VNM"},{"name":"Virgin Islands (British)","alpha2":"VG","alpha3":"VGB"},{"name":"Virgin Islands (U.S.)","alpha2":"VI","alpha3":"VIR"},{"name":"Wallis and Futuna","alpha2":"WF","alpha3":"WLF"},{"name":"Western Sahara","alpha2":"EH","alpha3":"ESH"},{"name":"Yemen","alpha2":"YE","alpha3":"YEM"},{"name":"Zambia","alpha2":"ZM","alpha3":"ZMB"},{"name":"Zimbabwe","alpha2":"ZW","alpha3":"ZWE"}]

/***/ }),

/***/ "X+Mz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_design_icons_ChevronLeft__ = __webpack_require__("wkzG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_design_icons_ContentSave__ = __webpack_require__("9FoL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_Delete__ = __webpack_require__("02d3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_ImageArea__ = __webpack_require__("VWrl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material_design_icons_ImageFilterNone__ = __webpack_require__("xqtn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__general_Spinner__ = __webpack_require__("dSGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_Utils_js__ = __webpack_require__("8u3o");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mediaTemplate',
  components: {
    DeleteIcon: __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_Delete__["a" /* default */],
    ChevronLeftIcon: __WEBPACK_IMPORTED_MODULE_4_vue_material_design_icons_ChevronLeft__["a" /* default */],
    ContentSaveIcon: __WEBPACK_IMPORTED_MODULE_5_vue_material_design_icons_ContentSave__["a" /* default */],
    ImageFilterNoneIcon: __WEBPACK_IMPORTED_MODULE_8_vue_material_design_icons_ImageFilterNone__["a" /* default */],
    ImageAreaIcon: __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_ImageArea__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_10__general_Spinner__["a" /* default */]
  },
  computed: {
    getMedia: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters.getActiveMedia;
      },
      set: function set(activeMedia) {
        __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].commit('setActiveMedia', activeMedia);
      }
    },
    getMediaThumbnail: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters.getActiveMedia.thumbnail;
      },
      set: function set() {
        this.showSuccessMsg({
          message: 'Thumbnail successfully updated.'
        });
      }
    },
    getAllProductGroups: function getAllProductGroups() {
      return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters.getAllProductGroups;
    },
    getAllMediaLibraries: function getAllMediaLibraries() {
      return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters.getAllMediaLibraries;
    },
    listOtherMarkets: function listOtherMarkets() {
      var markets = __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters.getMarkets;
      var media = __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters.getActiveMedia;
      console.log(media.markets);
      var other = markets.filter(function (m) {
        return !media.markets.map(function (ma) {
          return ma._id;
        }).includes(m._id);
      });
      return other;
    }
  },
  data: function data() {
    var _styles, _ref2;

    return _ref2 = {
      toggleUpdateThumbModal: __WEBPACK_IMPORTED_MODULE_9__services_Services__["a" /* default */].toggleUpdateThumbModal,
      getFlagUrl: __WEBPACK_IMPORTED_MODULE_9__services_Services__["a" /* default */].getFlagUrl,
      canDelete: true,
      metadata: {},
      title: '',
      descriptionSaved: '',
      description: '',
      keywords: '',
      keywordsSaved: '',
      featured: false,
      featuredSaved: false,
      mediaLoaded: true,
      mediaLoading: false,
      productGroupsSaved: [],
      productGroups: [],
      mediaLibrariesSaved: [],
      mediaLibraries: []
    }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref2, 'mediaLoaded', true), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref2, 'showAddMarket', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref2, 'unsavedEdits', {
      description: false,
      title: false,
      productGroups: false,
      generalUses: false
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref2, 'saveText', 'Save Changes'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref2, 'styles', (_styles = {
      base: function base(active) {
        return {
          opacity: active ? 1 : 0,
          pointerEvents: active ? 'auto' : 'none',
          flex: '0 0 auto',
          width: 'calc(100vw - 200px)',
          minHeight: '100vh',
          background: '#eee',
          display: 'flex',
          flexFlow: 'column nowrap',
          overflowY: 'auto',
          overflowX: 'hidden',
          padding: '70px 10px 10px'
        };
      },
      nav: {
        position: 'fixed',
        top: '0',
        left: '200px',
        right: '0',
        background: 'rgba(255,255,255,0.9)',
        borderBottom: '1px solid #eee',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        boxShadow: '0 0 20px 5px rgba(0,0,0,0.1)',
        height: '60px',
        zIndex: '99',
        padding: '10px',
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        overflowX: 'auto',
        overflowY: 'hidden'
      },
      loaderBackground: {
        position: 'absolute',
        top: '0',
        left: '0',
        bottom: '0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        right: '0',
        background: 'rgba(255,255,255,0.75)'
      },
      mediaSidebar: {
        overflowY: 'visible',
        flex: '0 0 auto'
      },
      navButton: {
        background: '#fff',
        border: '1px solid #09a3ed',
        fontSize: '0.9em',
        color: '#09a3ed',
        borderRadius: '5px',
        padding: '8px 12px',
        margin: 'auto 0 auto 10px',
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        cursor: 'pointer'
      },
      altNavButton: {
        background: '#fff',
        border: '1px solid #aaa',
        fontSize: '0.9em',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        color: '#aaa',
        borderRadius: '5px',
        padding: '8px 12px',
        margin: 'auto 10px auto 0',
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        cursor: 'pointer'
      },
      mediaContainer: {
        display: 'flex',
        flexFlow: 'row nowrap',
        width: '100%',
        flex: '1'
      },
      mediaThumbnailContainer: {
        flex: '1',
        padding: '0 10px 0 0'
      },
      mediaThumbnail: {
        flex: '0 0 auto',
        maxWidth: '100%',
        margin: '10px 5px 0 0'
      },
      marketRef: {
        padding: '10px',
        borderRadius: '5px',
        margin: '5px auto',
        boxShadow: '0 1px 4px 1px rgba(0,0,0,0.1)',
        background: '#fff',
        fontWeight: 400,
        fontSize: '0.9em',
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
      },
      marketSelector: {
        padding: '10px',
        width: '100%',
        display: 'block',
        margin: '10px auto auto'
      },
      metadataContainer: {
        flex: '2',
        padding: '0'
      },
      marketsContainer: {
        flex: '1',
        padding: '0 0 0 10px'
      },
      metadataSection: {
        display: 'flex',
        flexFlow: 'column nowrap',
        padding: '15px',
        margin: '0 0 5px',
        borderBottom: '1px solid #eee',
        background: '#fff'
      },
      metedataTitle: {
        fontSize: '0.78em',
        margin: '0 0 5px',
        fontWeight: '700',
        textTransform: 'uppercase',
        color: '#aaa'
      },
      idWrapper: {
        background: '#fff',
        padding: '10px',
        display: 'flex',
        margin: '0 0 5px'
      },
      mediaId: {
        flex: '1',
        fontFamily: 'monospace',
        fontSize: '1em',
        fontWeight: '700',
        color: '#555',
        margin: 'auto auto auto 10px'
      },
      createdStamp: {
        flex: '1',
        fontSize: '0.8em',
        fontWeight: '700',
        color: '#555',
        margin: 'auto auto auto 10px'
      },
      flagStyles: {
        maxHeight: '24px',
        margin: 'auto 10px auto 0'
      },
      metadataInput: {
        border: '1px solid #aaa',
        padding: '10px',
        margin: '0',
        borderRadius: '5px',
        fontSize: '1.1em'
        // ':focus': {
        //   background: '#f5f5f5',
        //   padding: 10
        // }
      },
      clearButton: {
        background: '#ccc',
        color: '#888',
        margin: '10px auto 10px 0',
        padding: '10px',
        fontSize: '0.9em'
      },
      addInput: {
        borderRight: '0',
        borderLeft: '0',
        borderTop: '0',
        borderBottom: '1px solid #ddd',
        outline: 'none',
        padding: '5px'
      },
      actionIcon: {
        fontSize: '1.1em'
      },
      addMarketButton: {
        fontSize: '0.9em',
        color: '#888',
        borderRadius: '100px',
        padding: '5px 15px',
        margin: '10px auto',
        display: 'block',
        cursor: 'pointer',
        border: '1px solid #aaa',
        textAlign: 'center'
      },
      removeMarket: {
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        fontSize: '1em',
        color: '#aaa',
        zIndex: 99999,
        cursor: 'pointer'
      },
      separator: {
        margin: '20px 0',
        borderTop: '1px solid #ccc'
      },
      deleteButton: function deleteButton(canDelete) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({
          cursor: canDelete ? 'pointer' : 'no-drop',
          border: '1px solid #eb4d4b',
          background: '#fff',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          opacity: canDelete ? '1' : '0.3',
          pointerEvents: canDelete ? 'auto' : 'none',
          fontSize: '0.9em',
          color: '#eb4d4b',
          borderRadius: '5px',
          padding: '8px 9px',
          margin: 'auto 0 auto 10px',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        }, 'cursor', 'pointer');
      },
      deleteMediaType: {
        textTransform: 'capitalize'
      }
    }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_styles, 'separator', {
      flex: 1
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_styles, 'p', {
      lineHeight: '1.5px',
      color: '#444',
      margin: '8px 0 0',
      fontSize: '14px',
      fontWeight: '400',
      textTransform: 'capitalize'
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_styles, 'infoTitle', {
      margin: '0px',
      textTransform: 'uppercase',
      color: '#888',
      fontSize: '0.8em',
      fontWeight: '700'
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_styles, 'urlInformation', {
      margin: '0',
      textTransform: 'uppercase',
      color: '#888',
      padding: '10px 0 5px',
      fontSize: '0.8em',
      fontWeight: '700'
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_styles, 'urlInput', {
      width: '100%',
      padding: '10px',
      borderRadius: '5px',
      border: '1px solid #ddd',
      color: '#09a3ed',
      fontSize: '0.9em',
      marginBottom: '10px'
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_styles, 'previewThumbWrap', {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'flex-start'
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_styles, 'backIcon', {
      fontSize: '1.2em'
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_styles, 'checkBoxGroup', {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap'
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_styles, 'checkBoxes', {
      fontWeight: 'normal',
      marginRight: '15px',
      minWidth: '95px'
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_styles, 'checkBox', {
      marginRight: '5px'
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_styles, 'topBar', {
      boxSizng: 'border-box',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '10px',
      width: '100%'
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_styles, 'editsWrapper', function editsWrapper(display) {
      return {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'no-wrap',
        opacity: display ? '1' : '0',
        transition: 'all 0.2s',
        transform: display ? 'translateY(0)' : 'translateY(20px)',
        width: '100%'
      };
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_styles, 'saveButton', function saveButton(display) {
      return {
        background: '#09a3ed',
        color: '#fff',
        borderRadius: '100px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        width: '160px',
        flex: '0 0 auto',
        fontSize: '0.9em',
        opacity: display ? '1' : '0',
        padding: '9px 12px',
        margin: 'auto 0 auto 10px',
        pointerEvents: display ? 'inherit' : 'none',
        transform: display ? 'translateY(0)' : 'translateY(20px)',
        transition: 'all 0.2s',
        border: '0',
        ':hover': {
          opacity: '0.9'
        }
      };
    }), _styles)), _ref2;
  },

  methods: {
    setActiveMedia: function setActiveMedia(media) {
      __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].commit('setActiveMedia', media);
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format('M/D/YY hh:mma') + (' (' + __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).fromNow() + ')');
    },
    promptDelete: function promptDelete(mediaId) {
      var shouldDelete = confirm('Are you sure you want to permanently delete Media ' + mediaId + '?');
      if (shouldDelete) return this.deleteMedia(mediaId);
    },
    deleteMedia: function deleteMedia(mediaId) {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__services_Utils_js__["c" /* postResource */])('/v1/media/delete?mediaId=' + mediaId).then(function (res) {
        _this.showSuccessMsg({
          message: 'Media successfully deleted.'
        });
        _this.$router.push('/media');
      }).catch(function (err) {
        _this.showErrorMsg({
          message: 'An error occurred. Please try again.'
        });
        console.log(err);
      });
    },
    setMediaProps: function setMediaProps(media) {
      // set saved values to component
      console.log('setting our props', media);
      this.title = media.title;
      this.titleSaved = media.title;
      this.description = media.description;
      this.descriptionSaved = media.description;
      this.productGroups = media.productGroups;
      this.productGroupsSaved = media.productGroups;
      this.mediaLibraries = media.mediaLibraries;
      this.mediaLibrariesSaved = media.mediaLibraries;
      this.keywords = media.keywords;
      this.keywordsSaved = media.keywords;
      this.featured = media.featured;
      this.featuredSaved = media.featured;
    },
    toggleShowAddMarket: function toggleShowAddMarket() {
      var b = this.showAddMarket;
      this.showAddMarket = !b;
    },
    goBack: function goBack() {
      this.$router.push('/media');
    },
    editsExist: function editsExist() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.unsavedEdits).some(function (k) {
        return _this2.unsavedEdits[k];
      });
    },
    removeMediaFromMarket: function removeMediaFromMarket(marketId, mediaId) {
      var _this3 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__services_Utils_js__["c" /* postResource */])('/v1/markets/media/remove', 'marketId=' + marketId + '&mediaId=' + mediaId).then(function (res) {
        if (res.status === 'success') {
          _this3.showSuccessMsg({
            message: 'Successfully removed media from market.'
          });
          __WEBPACK_IMPORTED_MODULE_9__services_Services__["a" /* default */].getMedia(_this3.$route.params.mediaId, function (media) {
            _this3.setMediaProps(_this3.getMedia);
          });
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    addMediaToMarket: function addMediaToMarket() {
      var _this4 = this;

      var mediaId = __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters.getActiveMedia._id;
      console.log(mediaId);
      var marketId = this.$refs.selectedMarket.value;
      console.log(marketId);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__services_Utils_js__["c" /* postResource */])('/v1/markets/media/add', 'marketId=' + marketId + '&mediaId=' + mediaId).then(function (res) {
        if (res.status === 'success') {
          _this4.showSuccessMsg({
            message: 'Successfully added media to market.'
          });
          __WEBPACK_IMPORTED_MODULE_9__services_Services__["a" /* default */].getMedia(_this4.$route.params.mediaId, function (media) {
            _this4.setMediaProps(_this4.getMedia);
          });
        }
      }).catch(function (err) {
        console.log(err);
        _this4.showErrorMsg({
          message: 'An error occurred. Please try again.'
        });
      });
    },
    updateLibraries: function updateLibraries() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var checkboxes = document.getElementsByName('media_library_associations');
        var checkboxesChecked = [];
        // loop over them all
        for (var i = 0; i < checkboxes.length; i++) {
          // And stick the checked ones onto an array...
          if (checkboxes[i].checked) {
            var checkedGroup = _this5.getAllMediaLibraries.find(function (group) {
              return group.id == checkboxes[i].value;
            });
            checkboxesChecked.push(checkedGroup);
          }
        }

        _this5.mediaLibraries = checkboxesChecked;

        // check if we have added or removed anything
        var newGroups = checkboxesChecked.filter(function (o) {
          return !_this5.mediaLibrariesSaved.find(function (o2) {
            return o.id === o2.id;
          });
        });
        var removedGroups = _this5.mediaLibrariesSaved.filter(function (o) {
          return !checkboxesChecked.find(function (o2) {
            return o.id === o2.id;
          });
        });

        if (newGroups.length > 0 || removedGroups.length > 0) {
          var unsavedEdits = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this5.unsavedEdits);
          unsavedEdits.mediaLibraries = true;

          _this5.unsavedEdits = unsavedEdits;
        } else {
          var _unsavedEdits = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this5.unsavedEdits);
          _unsavedEdits.mediaLibraries = false;

          _this5.unsavedEdits = _unsavedEdits;
        }
        resolve('updated');
      });
    },
    checkBoxes: function checkBoxes(section) {
      var _this6 = this;

      console.log('comparing libraries');
      var sectionSaved = section + 'Saved';
      var equalSections = this[sectionSaved].every(function (e) {
        return _this6[section].includes(e);
      }) && this[section].every(function (e) {
        return _this6[sectionSaved].includes(e);
      });

      console.log('equal libraries', equalSections);

      var unsavedEdits = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.unsavedEdits);

      if (!equalSections) {
        unsavedEdits[section] = true;
      } else {
        unsavedEdits[section] = false;
      }

      this.unsavedEdits = unsavedEdits;
    },
    checkGroups: function checkGroups(id) {
      if (this.productGroups.length) {
        return this.productGroups.find(function (group) {
          return group === id;
        });
      }
    },
    checkEdits: function checkEdits(section, string) {
      // Detect if they changed anything

      var originalSection = section + 'Saved';
      if (this[originalSection] != string) {
        console.log('editing subject');
        var unsavedEdits = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.unsavedEdits);
        unsavedEdits[section] = true;

        this.unsavedEdits = unsavedEdits;
      } else {
        var _unsavedEdits2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.unsavedEdits);
        _unsavedEdits2[section] = false;

        this.unsavedEdits = _unsavedEdits2;
      }
    },
    updateMedia: function updateMedia(media) {
      var _this7 = this;

      // insert setup here...
      var update = {
        title: this.title,
        description: this.description,
        productGroups: this.productGroups,
        mediaLibraries: this.mediaLibraries,
        keywords: this.keywords,
        featured: this.featured
      };

      // product groups we need to add the media to
      var addedProductGroups = [];

      if (this.productGroups.length && !this.productGroups.every(function (e) {
        return _this7.productGroupsSaved.includes(e);
      })) {
        console.log('we have new product groups');
        // for each product group we added that is not in productsGroupSaved, push to addedProductGroups
        for (var i in this.productGroups) {
          var productGroup = this.productGroups[i];
          if (!this.productGroupsSaved.includes(productGroup)) {
            console.log('added product group', productGroup);
            addedProductGroups.push(productGroup);
          }
        }
      }

      if (addedProductGroups.length) {
        update.addedProductGroups = addedProductGroups;
      }

      var addedMediaLibraries = [];
      // media libraries we need to add the media to
      if (this.mediaLibraries.length && !this.mediaLibraries.every(function (e) {
        return _this7.mediaLibrariesSaved.includes(e);
      })) {
        console.log('we have new media libraries');
        for (var _i in this.mediaLibraries) {
          var mediaLibrary = this.mediaLibraries[_i];
          if (!this.mediaLibrariesSaved.includes(mediaLibrary)) {
            console.log('added media library', mediaLibrary);
            addedMediaLibraries.push(mediaLibrary);
          }
        }
      }

      if (addedMediaLibraries.length) {
        update.addedMediaLibraries = addedMediaLibraries;
      }

      var removedProductGroups = [];
      // product groups we need to remove the media from
      if (this.productGroupsSaved.length && !this.productGroupsSaved.every(function (e) {
        return _this7.productGroups.includes(e);
      })) {
        for (var _i2 in this.productGroupsSaved) {
          var _productGroup = this.productGroupsSaved[_i2];
          if (!this.productGroups.includes(_productGroup)) {
            console.log('removed product group', _productGroup);
            removedProductGroups.push(_productGroup);
          }
        }
      }

      if (removedProductGroups.length) {
        update.removedProductGroups = removedProductGroups;
      }

      var removedMediaLibraries = [];
      // media libraries we need to remove the media from
      if (this.mediaLibrariesSaved.length && !this.mediaLibrariesSaved.every(function (e) {
        return _this7.mediaLibraries.includes(e);
      })) {
        console.log('we have media libraries to remove');
        for (var _i3 in this.mediaLibrariesSaved) {
          var _mediaLibrary = this.mediaLibrariesSaved[_i3];
          if (!this.mediaLibraries.includes(_mediaLibrary)) {
            console.log('removed media library', _mediaLibrary);
            removedMediaLibraries.push(_mediaLibrary);
          }
        }
      }

      if (removedMediaLibraries.length) {
        update.removedMediaLibraries = removedMediaLibraries;
      }

      console.log('our media update', update);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__services_Utils_js__["c" /* postResource */])('/v1/media/update?mediaId=' + this.getMedia._id, false, update).then(function (res) {
        _this7.saveText = 'Saved!';
        _this7.showSuccessMsg({
          message: 'Media successfully saved!'
        });
        return res;
      }).then(function (res) {
        console.log('success', res);
        if (res.media) {
          _this7.setMediaProps(res.media);
        }
      }).then(function () {
        setTimeout(function () {
          _this7.unsavedEdits = {
            description: false,
            title: false,
            productGroups: false,
            generalUses: false
          };

          setTimeout(function () {
            _this7.saveText = 'Save';
          }, 500);
        }, 2250);
      }).catch(function (err) {
        console.log(err);
        _this7.showErrorMsg({
          message: 'An error occurred. Please try again.'
        });
      });
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    __WEBPACK_IMPORTED_MODULE_9__services_Services__["a" /* default */].getMedia(this.$route.params.mediaId, function (media) {
      if (!_this8.getMedia._id) {
        _this8.$router.push('/media');
      }
      _this8.setMediaProps(_this8.getMedia);
    });

    __WEBPACK_IMPORTED_MODULE_9__services_Services__["a" /* default */].getMarkets();
  },
  beforeDestroy: function beforeDestroy() {
    this.description = '';
    this.title = '';

    __WEBPACK_IMPORTED_MODULE_9__services_Services__["a" /* default */].clearActiveMedia();
  },

  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_13_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_13_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  }
});

/***/ }),

/***/ "X7oY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XCse":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoggedOut_vue__ = __webpack_require__("C3oi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ac4618f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoggedOut_vue__ = __webpack_require__("/CA7");
function injectStyle (ssrContext) {
  __webpack_require__("WKPr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ac4618f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoggedOut_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ac4618f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoggedOut_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XDUX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dropzoneDisabled)?_c('div',{staticClass:"vue-fine-uploader-gallery-nodrop-container"},[(_vm.hasVisibleFiles)?_c('span'):_vm._t("content",[_c('MaybeDropzoneContent',{attrs:{"content":_vm.content,"disabled":_vm.dropzoneDisabled}})]),_vm._v(" "),_vm._t("default")],2):_c('Dropzone',{staticClass:"vue-fine-uploader-gallery-dropzone",attrs:{"uploader":_vm.uploader,"disabled":_vm.disabled,"dropActiveClassName":_vm.dropActiveClassName,"multiple":_vm.multiple}},[(_vm.hasVisibleFiles)?_c('span'):_vm._t("content",[_c('MaybeDropzoneContent',{attrs:{"content":_vm.content,"disabled":_vm.dropzoneDisabled}})]),_vm._v(" "),_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XQ53":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XU5O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XrmM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MixedContentInput_vue__ = __webpack_require__("u5Rx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb004712_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MixedContentInput_vue__ = __webpack_require__("H9sC");
function injectStyle (ssrContext) {
  __webpack_require__("oHJn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bb004712"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MixedContentInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb004712_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MixedContentInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y8nc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_placeholder_vue__ = __webpack_require__("9TV7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b4bc9e2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeholder_vue__ = __webpack_require__("BWa3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_placeholder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b4bc9e2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeholder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YAPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("sEs6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9544f38a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("nnlE");
function injectStyle (ssrContext) {
  __webpack_require__("XQ53")
  __webpack_require__("nUYM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9544f38a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9544f38a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YR+v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.rootClass},[_c('canvas',{ref:"canvas",class:_vm.canvasClass,attrs:{"hidden":_vm.isHidden}}),_vm._v(" "),(_vm._failure)?_c('Placeholder',{class:_vm.placeholderClass,attrs:{"size":_vm.maxSize,"status":_vm.notAvailableStatus}},[_vm._t("notAvailablePlaceholder",[_c('NotAvailablePlaceholder',{attrs:{"maxSize":_vm.maxSize}})])],2):(!_vm.drawComplete)?_c('Placeholder',{class:_vm.placeholderClass,attrs:{"size":_vm.maxSize,"status":_vm.waitingStatus}},[_vm._t("waitingPlaceholder",[_c('WaitingPlaceholder',{attrs:{"maxSize":_vm.maxSize}})])],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_CardLibrary__ = __webpack_require__("6I4N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_CardTemplate__ = __webpack_require__("B6Tu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_Dashboard__ = __webpack_require__("YAPR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Error__ = __webpack_require__("Dv9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layouts_LoggedIn__ = __webpack_require__("pDhz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layouts_LoggedOut__ = __webpack_require__("XCse");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Login__ = __webpack_require__("kvsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_MediaLibrary__ = __webpack_require__("VxPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_MediaTemplate__ = __webpack_require__("TcCV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_MediaLibraryLibrary__ = __webpack_require__("C5+w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_MediaLibraryEditor__ = __webpack_require__("hCFp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_NotFound__ = __webpack_require__("rzym");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_OnboardTeam__ = __webpack_require__("2mEl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_OnboardUser__ = __webpack_require__("V/KL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_MarketLibrary__ = __webpack_require__("pacP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_MarketEditor__ = __webpack_require__("oa5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_ProductLibrary__ = __webpack_require__("mgHm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_ProductEditor__ = __webpack_require__("zEvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_ProductGroupLibrary__ = __webpack_require__("olTT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_ProductGroupEditor__ = __webpack_require__("PRWs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_PolicyLibrary__ = __webpack_require__("wtDP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_UserLibrary__ = __webpack_require__("0XmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_InteractionTypes__ = __webpack_require__("7/ZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_PolicyNew__ = __webpack_require__("g/M8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_PolicyTemplate__ = __webpack_require__("KeLa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_views_RegisterTeam__ = __webpack_require__("LcrT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_views_RegisterUser__ = __webpack_require__("qHIf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_views_ResetPassword__ = __webpack_require__("ZDis");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_views_SearchMediaLibrary__ = __webpack_require__("0PtA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_views_SequenceLibrary__ = __webpack_require__("+c4t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_views_SequenceTemplate__ = __webpack_require__("kWqs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_views_TenantSettings__ = __webpack_require__("x3eB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__store__ = __webpack_require__("olkN");




































__WEBPACK_IMPORTED_MODULE_33_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_28_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_28_vue_router__["a" /* default */]({
    'mode': 'history',
    'base': __dirname,
    'linkActiveClass': 'active',
    'routes': [
    /**
     * Core routes
     */
    {
        'path': '/',
        'component': __WEBPACK_IMPORTED_MODULE_5__components_layouts_LoggedOut__["a" /* default */],
        // Change redirect to checking for token beforeEnter
        'redirect': '/login',
        'children': [{
            'path': '/login',
            'component': __WEBPACK_IMPORTED_MODULE_6__components_views_Login__["a" /* default */],
            'name': 'login'
        }, {
            'path': '/register/team',
            'component': __WEBPACK_IMPORTED_MODULE_25__components_views_RegisterTeam__["a" /* default */],
            'name': 'registerTeam'
        }, {
            'path': '/register/user',
            'component': __WEBPACK_IMPORTED_MODULE_26__components_views_RegisterUser__["a" /* default */],
            'name': 'registerUser'
        }, {
            'path': '/reset/:tokenId?',
            'component': __WEBPACK_IMPORTED_MODULE_27__components_views_ResetPassword__["a" /* default */],
            'name': 'resetPassword'
        }]
    },
    // Authenticated routes
    {
        'path': '/',
        'component': __WEBPACK_IMPORTED_MODULE_4__components_layouts_LoggedIn__["a" /* default */],
        'redirect': '/',
        'children': [{
            'path': '/dashboard',
            'component': __WEBPACK_IMPORTED_MODULE_2__components_views_Dashboard__["a" /* default */],
            'name': 'dashboard'
        }, {
            'path': '/media',
            'component': __WEBPACK_IMPORTED_MODULE_7__components_views_MediaLibrary__["a" /* default */],
            'name': 'mediaLibrary'
        }, {
            'path': '/media/:mediaId',
            'component': __WEBPACK_IMPORTED_MODULE_8__components_views_MediaTemplate__["a" /* default */],
            'name': 'mediaTemplate'
        }, {
            'path': '/search/media',
            'component': __WEBPACK_IMPORTED_MODULE_29__components_views_SearchMediaLibrary__["a" /* default */],
            'name': 'mediaSearch'
        }, {
            'path': '/media-libraries',
            'component': __WEBPACK_IMPORTED_MODULE_9__components_views_MediaLibraryLibrary__["a" /* default */],
            'name': 'mediaLibraryLibrary'
        }, {
            'path': '/media-libraries/:mediaLibraryId',
            'component': __WEBPACK_IMPORTED_MODULE_10__components_views_MediaLibraryEditor__["a" /* default */],
            'name': 'mediaLibraryEditor'
        }, {
            'path': '/cards',
            'component': __WEBPACK_IMPORTED_MODULE_0__components_views_CardLibrary__["a" /* default */],
            'name': 'cardLibrary'
        }, {
            'path': '/cards/:shortId',
            'component': __WEBPACK_IMPORTED_MODULE_1__components_views_CardTemplate__["a" /* default */],
            'name': 'cardTemplate'
        }, {
            'path': '/policies',
            'component': __WEBPACK_IMPORTED_MODULE_20__components_views_PolicyLibrary__["a" /* default */],
            'name': 'policyLibrary'
        }, {
            'path': '/interaction-types',
            'component': __WEBPACK_IMPORTED_MODULE_22__components_views_InteractionTypes__["a" /* default */],
            'name': 'interactionTypes'
        }, {
            'path': '/policies/create',
            'component': __WEBPACK_IMPORTED_MODULE_23__components_views_PolicyNew__["a" /* default */],
            'name': 'policyNew'
        }, {
            'path': '/policies/:shortId',
            'component': __WEBPACK_IMPORTED_MODULE_24__components_views_PolicyTemplate__["a" /* default */],
            'name': 'policyTemplate'
        }, {
            'path': '/sequences',
            'component': __WEBPACK_IMPORTED_MODULE_30__components_views_SequenceLibrary__["a" /* default */],
            'name': 'sequenceLibrary'
        }, {
            'path': '/sequences/create',
            'component': __WEBPACK_IMPORTED_MODULE_31__components_views_SequenceTemplate__["a" /* default */],
            'name': 'sequenceTemplate',
            'props': {
                'newSequence': true
            }
        }, {
            'path': '/sequences/:shortId',
            'component': __WEBPACK_IMPORTED_MODULE_31__components_views_SequenceTemplate__["a" /* default */],
            'name': 'sequenceTemplate',
            'props': {
                'newSequence': false
            }
        }, {
            'path': '/products',
            'component': __WEBPACK_IMPORTED_MODULE_16__components_views_ProductLibrary__["a" /* default */],
            'name': 'productLibrary'
        }, {
            'path': '/products/:productId',
            'component': __WEBPACK_IMPORTED_MODULE_17__components_views_ProductEditor__["a" /* default */],
            'name': 'productEditor'
        }, {
            'path': '/product-groups',
            'component': __WEBPACK_IMPORTED_MODULE_18__components_views_ProductGroupLibrary__["a" /* default */],
            'name': 'productLibrary'
        }, {
            'path': '/product-groups/:productGroupId',
            'component': __WEBPACK_IMPORTED_MODULE_19__components_views_ProductGroupEditor__["a" /* default */],
            'name': 'productGroupEditor'
        }, {
            'path': '/settings',
            'component': __WEBPACK_IMPORTED_MODULE_32__components_views_TenantSettings__["a" /* default */],
            'name': 'settings',
            'props': {}
        }, {
            'path': '/markets',
            'component': __WEBPACK_IMPORTED_MODULE_14__components_views_MarketLibrary__["a" /* default */],
            'name': 'marketLibrary'
        }, {
            path: '/markets/:marketId',
            component: __WEBPACK_IMPORTED_MODULE_15__components_views_MarketEditor__["a" /* default */],
            name: 'marketEditor'
        }, {
            path: '/users',
            component: __WEBPACK_IMPORTED_MODULE_21__components_views_UserLibrary__["a" /* default */],
            name: 'userLibrary'
        }]
    }, {
        'path': '/error',
        'component': __WEBPACK_IMPORTED_MODULE_3__components_views_Error__["a" /* default */],
        'name': 'error',
        'meta': {}
    }, {
        'path': '*',
        'redirect': '/login'
    }]
});

router.afterEach(function (to, from) {
    window.Intercom("update");
});

/* harmony default export */ __webpack_exports__["a"] = (router);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ "YgLn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fine_uploader_lib_dnd__ = __webpack_require__("wKfx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fine_uploader_lib_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fine_uploader_lib_dnd__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dropActiveClassName: {
      type: String,
      default: 'vue-fine-uploader-dropzone-active'
    },
    multiple: {
      type: Boolean
    },
    onDropError: {
      type: Function
    },
    onProcessingDroppedFiles: {
      type: Function
    },
    onProcessingDroppedFilesComplete: {
      type: Function
    },
    uploader: {
      type: Object, required: true
    }
  },

  mounted: function mounted() {
    this._registerDropzone();
  },
  updated: function updated() {
    this._registerDropzone();
  },
  beforeDestroy: function beforeDestroy() {
    this._qqDropzone && this._qqDropzone.dispose();
  },


  methods: {
    _onDropError: function _onDropError(errorCode, errorData) {
      console.error(errorCode, errorData);

      this.onDropError && this.onDropError(errorCode, errorData);
    },
    _onProcessingDroppedFilesComplete: function _onProcessingDroppedFilesComplete(files) {
      this.uploader.methods.addFiles(files);

      this.onProcessingDroppedFilesComplete && this.onProcessingDroppedFilesComplete(files);
    },
    _registerDropzone: function _registerDropzone() {
      this._qqDropzone && this._qqDropzone.dispose();

      var dropzoneEl = this.$refs.element || this.$refs.dropZone;

      this._qqDropzone = new __WEBPACK_IMPORTED_MODULE_0_fine_uploader_lib_dnd___default.a.DragAndDrop({
        allowMultipleItems: !!this.multiple,
        callbacks: {
          dropError: this._onDropError.bind(this),
          processingDroppedFiles: this.onProcessingDroppedFiles || function () {},
          processingDroppedFilesComplete: this._onProcessingDroppedFilesComplete.bind(this)
        },
        classes: {
          dropActive: this.dropActiveClassName || ''
        },
        dropZoneElements: [dropzoneEl]
      });
    }
  }
});

/***/ }),

/***/ "Yzb8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:"mediaCardBase",staticClass:"media-row",style:([_vm.styles.card.base(_vm.src, _vm.isActiveItem) ].concat( _vm.viewSpecificStyles)),on:{"click":function($event){!_vm.isMediaLibrary ? _vm.handleMedia() : null},"mouseover":function($event){_vm.isMediaLibrary ? _vm.showOptions() : null},"mouseout":function($event){_vm.isMediaLibrary ? _vm.hideOptions() : null}}},[_c('div',{staticClass:"media-row-thumbnail"},[_c('img',{attrs:{"src":_vm.src}})]),_c('div',{staticClass:"media-row-metadata"},[_c('p',[_vm._v(_vm._s(_vm.title))]),_c('div',[_c('span',{style:(_vm.styles.contentTag(_vm.contentType || 'video'))},[_vm._v(_vm._s(_vm.contentType || 'video'))]),_c('span',{staticClass:"mm-id-tag"},[_vm._v("#"+_vm._s(_vm.media.mmId))])])]),_c('button',{staticClass:"button__action",on:{"click":_vm.handleMedia}},[_vm._v("Edit")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZDis":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__("fpno");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a7df4d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__("B7da");
function injectStyle (ssrContext) {
  __webpack_require__("S7Ij")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a7df4d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a7df4d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZEDR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZEKS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZNO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProductGroup_vue__ = __webpack_require__("BDc+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8d4ef20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProductGroup_vue__ = __webpack_require__("gaLc");
function injectStyle (ssrContext) {
  __webpack_require__("5Do9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c8d4ef20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProductGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8d4ef20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProductGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZOaG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.disabled && !_vm.content)?_c('span',{class:_vm.className},[_vm._v("\n  Upload files\n")]):(_vm.content)?_c('span',{class:_vm.className},[_vm._v("\n  "+_vm._s(_vm.content)+"\n")]):(!_vm.disabled)?_c('span',{class:_vm.className},[_c('UploadIcon',{staticClass:"vue-fine-uploader-gallery-dropzone-upload-icon"}),_vm._v("\n  Drop files here\n")],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZPAl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Services_js__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general_LibraryGrid_vue__ = __webpack_require__("0gt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__general_MediaCard_vue__ = __webpack_require__("lVNX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mediaSearch',
  components: {
    LibraryGrid: __WEBPACK_IMPORTED_MODULE_2__general_LibraryGrid_vue__["a" /* default */],
    MediaCard: __WEBPACK_IMPORTED_MODULE_3__general_MediaCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      searchQuery: '',
      selectActiveMedia: __WEBPACK_IMPORTED_MODULE_1__services_Services_js__["a" /* default */].selectActiveMedia,
      mediaItems: [],
      styles: {
        libraryWrapper: {
          background: '#f5f5f5',
          paddingBottom: '20px'
        },
        nav: {
          position: 'fixed',
          top: '0',
          left: '200px',
          right: '0',
          background: 'rgba(255,255,255,0.9)',
          borderBottom: '1px solid #eee',
          boxShadow: '0 0 20px 5px rgba(0,0,0,0.1)',
          height: '60px',
          zIndex: '99',
          padding: '10px',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        navInputWrapper: {
          flex: '0 0 auto',
          width: '100%',
          padding: '10px',
          margin: 'auto 0 auto auto',
          background: '#fff',
          overflow: 'hidden',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        navInput: {
          flex: '1',
          padding: '0',
          margin: 'auto 0',
          borderRadius: '0',
          border: '0',
          background: '#fff'
        },
        navInputIcon: {
          margin: 'auto 20px auto 15px',
          color: '#09a3ed',
          fontSize: '1em',
          position: 'relative',
          top: '-1px'
        }
      }
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    searchMedia: function searchMedia() {
      var _this = this;

      var query = this.searchQuery;
      if (this.searchQuery === '') {
        this.mediaItems = [];
        return false;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__services_Utils_js__["a" /* getResource */])('/v1/media/search', 'term=' + encodeURIComponent(query)).then(function (res) {
        _this.mediaItems = res.media;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  },
  mounted: function mounted() {
    this.$refs.searchInput.focus();
  }
});

/***/ }),

/***/ "Zbtr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v(" Add a New Localized Content Record to Card")]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Assign a new market and local record to this action card")]),_c('multiselect',{staticClass:"locale-picker",attrs:{"options":_vm.getMarketsByLocale,"searchable":"false","selectLabel":'',"searchable":false,"allow-empty":false,"deselectLabel":'',"multiple":false},model:{value:(_vm.newLocale),callback:function ($$v) {_vm.newLocale=$$v},expression:"newLocale"}})],1),_c('div',{staticClass:"form__control-group copy-content"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isCopying),expression:"isCopying"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isCopying)?_vm._i(_vm.isCopying,null)>-1:(_vm.isCopying)},on:{"change":function($event){var $$a=_vm.isCopying,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isCopying=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isCopying=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isCopying=$$c}}}}),_vm._v("  Check here to copy content from another market")]),(_vm.isCopying)?_c('div',[_c('label',[_vm._v("Copy Content from...")]),_c('multiselect',{attrs:{"options":_vm.getSortedAvailableLocales,"searchable":false,"selectLabel":'',"allow-empty":false,"deselectLabel":'',"multiple":false},model:{value:(_vm.copiedLocale),callback:function ($$v) {_vm.copiedLocale=$$v},expression:"copiedLocale"}})],1):_vm._e()]),_c('button',{staticClass:"button__submit",on:{"click":_vm.submit}},[_vm._v("Add Locale Record To Card")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zkeb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__general_Spinner__ = __webpack_require__("dSGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__general_ActionCard__ = __webpack_require__("K33D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__general_MixedContentInput__ = __webpack_require__("XrmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__general_MediaCard__ = __webpack_require__("lVNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_material_design_icons_ChevronLeft__ = __webpack_require__("wkzG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_material_design_icons_Plus__ = __webpack_require__("mdEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cardTemplate',
  components: {
    ActionCard: __WEBPACK_IMPORTED_MODULE_6__general_ActionCard__["a" /* default */],
    ChevronLeftIcon: __WEBPACK_IMPORTED_MODULE_12_vue_material_design_icons_ChevronLeft__["a" /* default */],
    MediaCard: __WEBPACK_IMPORTED_MODULE_11__general_MediaCard__["a" /* default */],
    MixedContentInput: __WEBPACK_IMPORTED_MODULE_8__general_MixedContentInput__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_14_vue_multiselect___default.a,
    PlusIcon: __WEBPACK_IMPORTED_MODULE_13_vue_material_design_icons_Plus__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_5__general_Spinner__["a" /* default */]
  },
  computed: {
    getActiveMedia: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getActiveMedia;
      },
      set: function set(newMedia) {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setActiveMedia', newMedia);
        if (this.getActiveLocale === this.getActiveCard.fallbackLocale) {
          // edit on the card level as well
          var activeCard = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.getActiveCard);
          activeCard.mediaID = newMedia;
          __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setActiveCard', activeCard);
        }
        var activeRecord = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.getActiveLocalRecord);
        activeRecord.mediaId = newMedia;
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setActiveLocalRecord', activeRecord);
      }
    },
    getActiveCard: function getActiveCard() {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getActiveCard;
    },
    getAvailableFields: function getAvailableFields() {
      if (this.getActiveCard) {
        return this.getActiveCard.cardType.fields;
      }
    },
    getEnglishRecords: function getEnglishRecords() {
      if (this.getActiveCard) {
        if (this.getActiveCard.localRecords.length > 1) {
          var filteredRecords = this.getActiveCard.localRecords.filter(function (record) {
            return record.locale === 'EN-US';
          });
          if (filteredRecords && filteredRecords.length) {
            return filteredRecords[0].content;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },

    getSortedAvailableLocales: {
      get: function get() {
        if (this.getActiveCard && this.getActiveCard.localRecords) {
          var locales = [];

          this.getActiveCard.localRecords.forEach(function (locale) {
            // lol?
            locales.push(locale.locale);
          });

          return locales.sort(function (a, b) {
            return a.name - b.name;
          }).reverse();
        }
      },
      set: function set(newLocales) {
        var activeCard = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.getActiveCard);
        activeCard.markets = newLocales;
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setActiveCard', activeCard);
        if (newLocales.length > this.getActiveCard.localRecords.length) {
          __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('showCreateLocalRecordModal', true);
        }
      }
    },
    getMarketsByLocale: function getMarketsByLocale() {
      if (this.markets) {
        var marketsByLocale = [];

        this.markets.forEach(function (market) {
          marketsByLocale.push(market.locale);
        });

        return marketsByLocale;
      }
    },

    getActiveLocale: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getActiveLocale;
      },
      set: function set(locale) {
        this.changeLocale(locale);
      }
    },
    getActiveLocalRecord: function getActiveLocalRecord() {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getActiveLocalRecord;
    },
    getActiveLocalRecordSaved: function getActiveLocalRecordSaved() {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getActiveLocalRecordSaved;
    }
  },
  watch: {
    getActiveLocalRecord: function getActiveLocalRecord(data, old) {
      console.log(data);
      this.checkUnsavedChanges(data);
    }
  },
  data: function data() {
    return {
      activeSetting: 'initial',
      defaultLocale: null,
      settings: ['initial', 'intermediate', 'done', 'completed'],
      ready: false,
      showFooterPopup: false,
      helpText: null,
      helpTextSaved: null,
      helpUrl: null,
      helpUrlSaved: null,
      displayName: null,
      title: null,
      titleSaved: null,
      callToAction: null,
      callToActionSaved: null,
      subject: null,
      subjectSaved: null,
      body: null,
      bodySaved: null,
      label: null,
      labelSaved: null,
      socialLinks: null,
      socialLinksSaved: null,
      icon: null,
      iconSaved: null,
      reason: null,
      buttonText: null,
      buttonTextSaved: null,
      actionUrl: null,
      actionUrlSaved: null,
      triggerContextImage: null,
      triggerContextImageSaved: null,
      shortId: this.$route.params.shortId,
      params: [],
      fields: [],
      unsavedChanges: false,
      isDraft: false,
      unsavedEdits: {
        callToAction: false,
        helpText: false,
        helpUrl: false,
        title: false,
        subject: false,
        body: false
      },
      market: null,
      markets: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getMarkets,
      editHint: true,
      saveText: 'Save',
      toggleAddMediaToCardModal: __WEBPACK_IMPORTED_MODULE_7__services_Services__["a" /* default */].toggleAddMediaToCard,
      styles: {
        backButton: {
          display: 'flex',
          height: '30px',
          justifyContent: 'center',
          alignItems: 'center'
        },
        backArrow: {
          margin: 'auto 5px auto 0'
        },
        pageHeader: {
          display: 'flex',
          padding: '0 2rem',
          width: '100%'
        },
        pageHead: {
          fontSize: '1.5em',
          maxWidth: 600,
          margin: '20px auto 40px',
          fontWeight: 700,
          color: '#aaa'
        },
        messageWrapper: {
          padding: '20px'
        },
        messageContentWrapper: {
          background: '#f5f5f5',
          borderRadius: '10px',
          fontSize: '1.1em',
          padding: '20px'
        },
        mediaButtonContainer: {
          position: 'absolute',
          right: '2rem'
        },
        mediaButtons: {
          background: '#09a3ed',
          fontSize: '0.9em',
          color: '#fff',
          borderRadius: '5px',
          lineHeight: '1.2rem',
          padding: '5px 10px 5px 5px',
          margin: 'auto 0 auto 10px',
          border: '0',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          ':hover': {
            cursor: 'pointer',
            opacity: '0.9'
          }
        },
        titleInputStyle: {
          padding: '10px',
          margin: '0 auto 10px'
        },
        descriptionInputStyle: {
          padding: '10px',
          fontWeight: '400',
          fontSize: '1.5em',
          margin: '0 auto',
          textAlign: 'center'
        },
        subjectInputStyle: {
          padding: '10px',
          fontSize: '1em',
          margin: '0 auto 10px'
        },
        bodyInputStyle: {
          padding: '10px',
          fontSize: '1.25em',
          margin: '0 auto'
        },
        mediaContainer: {
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          height: '100%',
          padding: '1rem 2rem',
          width: '100%'
        },
        cardWrap: {
          display: 'flex',
          flexFlow: 'column nowrap',
          alignItems: 'center'
        },
        card: function card(media) {
          return {
            maxWidth: '500px',
            width: '100%',
            padding: '2rem 1rem',
            minHeight: media ? 'auto' : '600px',
            display: 'flex',
            margin: '0 auto 40px',
            flexFlow: 'column nowrap',
            borderRadius: '3px',
            border: '1px solid #eee'
          };
        },
        cardHead: {
          fontWeight: '700',
          display: 'flex',
          flexFlow: 'column nowrap',
          alignItems: 'center',
          justifyContent: 'center'
        },
        cardTitle: {
          fontSize: '1.2em',
          color: '#888',
          textAlign: 'center',
          border: '0',
          fontWeight: '400',
          outline: 'none',
          width: '100%',
          margin: 'auto auto 5px'
        },
        cardDescription: {
          fontSize: '1.35em',
          color: '#111',
          textAlign: 'center',
          border: '0',
          fontWeight: '400',
          outline: 'none',
          width: '90%',
          lineHeight: '2px',
          margin: '5px auto auto'
        },
        cardFooter: {
          display: 'flex',
          margin: 'auto 0 0',
          padding: '20px 10px 40px',
          fontSize: '1.1em',
          flexFlow: 'column nowrap',
          alignItems: 'center'
        },
        topBar: {
          boxShadow: '0 0 8px 0 rgba(0,0,0,.1)',
          position: 'relative',
          zIndex: '99',
          boxSizng: 'border-box',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '10px',
          width: '100%'
        },
        editsWrapper: function editsWrapper(display) {
          return {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'no-wrap',
            opacity: display ? '1' : '0',
            transition: 'all 0.2s',
            transform: display ? 'translateY(0)' : 'translateY(20px)'
          };
        },
        editsHint: function editsHint(display) {
          return {
            color: '#AAA',
            fontSize: '1rem',
            position: 'relative',
            opacity: display ? '1' : '0',
            transition: 'all 0.2s'
            // top: '5px'
          };
        },
        saveButton: {
          background: '#6ab04c',
          fontSize: '1rem',
          color: '#fff',
          borderRadius: '5px',
          padding: '5px 15px',
          margin: 'auto 23px',
          border: '0',
          ':hover': {
            opacity: '0.9'
          }
        },
        footerPopupWrapper: {
          position: 'fixed',
          top: '0',
          zIndex: '999',
          bottom: '0',
          right: '0',
          left: '0',
          background: 'rgba(0,0,0,0.25)',
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        footerPopupModal: {
          width: '400px',
          background: '#fff',
          padding: '10px',
          margin: 'auto',
          display: 'flex',
          flexFlow: 'column nowrap'
        }
      }
    };
  },

  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_10_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_10_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  methods: {
    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(date).fromNow();
    },
    deleteCard: function deleteCard() {
      var _this = this;

      if (this.getActiveCard.deleted) {
        var update = {
          deleted: false,
          _id: this.$route.params.shortId
        };

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__services_Utils__["c" /* postResource */])('/v1/actioncards/delete', false, update).then(function (res) {
          _this.getActiveCard.deleted = false;
          _this.showSuccessMsg({
            message: _this.getActiveLocale + ' Action card has been restored!'
          });
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('showDeleteRecordModal', true);
      }
    },
    checkUnsavedChanges: function checkUnsavedChanges(data) {
      var unsavedChanges = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getActiveLocalRecord) !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getActiveLocalRecordSaved);
      this.unsavedChanges = unsavedChanges;
      console.log(unsavedChanges);
      return unsavedChanges;
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    publishChanges: function publishChanges() {
      var _this2 = this;

      var locale = this.getActiveLocale;
      var cardId = this.getActiveCard._id;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__services_Utils__["c" /* postResource */])('/v1/actioncards/publish', 'locale=' + locale + '&cardId=' + cardId).then(function (res) {
        if (res.status === 'success') {
          _this2.isDraft = false;
          _this2.showSuccessMsg({
            message: _this2.getActiveLocale + ' Action card has been published!'
          });
        } else {
          console.log(res);
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    setActiveSetting: function setActiveSetting(setting) {
      console.log('clicking');
      this.activeSetting = setting;
      // const localContent = this.getActiveCard.localRecords.filter(record => {return record.locale === this.getActiveLocale})[0].content || {};

      // this.title = localContent.title[setting] || '';
      // this.callToAction = localContent.callToAction[setting] || '';
      // // this.market = this.getActiveCard.market;
    },
    toggleFooterPopup: function toggleFooterPopup() {
      this.showFooterPopup = !this.showFooterPopup;
    },
    toggleAddLocale: function toggleAddLocale() {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('showCreateLocalRecordModal', true);
    },
    toggleCopyContent: function toggleCopyContent() {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('showCopyLocalRecordModal', true);
    },
    setActiveMedia: function setActiveMedia(media) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setActiveMedia', media);
    },
    changeLocale: function changeLocale(locale) {
      //   check for changes
      var unsavedChanges = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getActiveLocalRecord) !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getActiveLocalRecordSaved);

      var answer = true;

      if (unsavedChanges) {
        answer = window.confirm('You have unsaved changes. Do you want to change locales without saving?');
      }

      if (!unsavedChanges || answer) {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setActiveLocale', locale);
        this.initializeCard(true);
        this.updateSavedRecord();
      }
    },
    updateSavedRecord: function updateSavedRecord() {
      var _this3 = this;

      var card = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getActiveCard;

      var activeContent = card.localRecords.filter(function (record) {
        return record.locale === _this3.getActiveLocale;
      })[0].content || {};

      var clonedContent = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(activeContent));

      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setActiveLocalRecordSaved', clonedContent);
    },
    initializeCard: function initializeCard(edited) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var card, activeContentObj, activeContent, clonedContent;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                card = _this4.getActiveCard;


                console.log('intializing card', card);
                if (!edited) {
                  // initialize default locale once we have the card record, but don't reset default locale if we're already editing
                  if (_this4.getActiveCard.defaultLocale) {
                    _this4.defaultLocale = _this4.getActiveCard.defaultLocale;
                  } else if (_this4.getActiveCard.fallbackLocale && _this4.getSortedAvailableLocales && _this4.getSortedAvailableLocales.indexOf(_this4.getActiveCard.fallbackLocale) > -1) {
                    _this4.defaultLocale = _this4.getActiveCard.fallbackLocale;
                  } else if (_this4.getActiveCard.localRecords) {
                    _this4.defaultLocale = _this4.getActiveCard.localRecords[0].locale;
                  }
                  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setActiveLocale', _this4.defaultLocale);
                }

                // activeContent could be pulled from a single local Record on mount, or from the locale they just switched to, or be blank if it's a brand new record

                activeContentObj = card.localRecords.length === 1 ? card.localRecords[0].draftContent ? { content: card.localRecords[0].draftContent, draft: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(card.localRecords[0].draftContent) !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(card.localRecords[0].content) } : { content: card.localRecords[0].content } : function () {
                  var record = card.localRecords.filter(function (record) {
                    return record.locale === _this4.getActiveLocale;
                  })[0];
                  return record.draftContent ? { content: record.draftContent, draft: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(record.draftContent) !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(record.content) } : { content: record.content };
                }();


                if (card.cardType.name === 'opportunity' && (!activeContentObj.content || !activeContentObj.content.actionButton)) {
                  if (!activeContentObj.content) {
                    activeContentObj.content = {};
                  }
                  activeContentObj.content.actionButton = {};
                }

                if (card.cardType.name === 'opportunity' && (!activeContentObj.content || !activeContentObj.content.trigger)) {
                  console.log('no trigger');
                  if (!activeContentObj.content) {
                    activeContentObj.content = {};
                  }

                  activeContentObj.content.trigger = {
                    contextType: '',
                    imageUrl: ''
                  };
                }

                if (activeContentObj.draft) _this4.isDraft = true;
                activeContent = activeContentObj.content;


                if (activeContent) {
                  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setActiveLocalRecord', activeContent);
                  clonedContent = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(activeContent));

                  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setActiveLocalRecordSaved', clonedContent);
                } else {
                  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setActiveLocalRecord', {});
                  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setActiveLocalRecordSaved', {});
                }

                if (card.cardType) {
                  _this4.params = card.cardType.parameters;
                  _this4.fields = card.cardType.fields;
                }

                _this4.displayName = card.displayName;

                //   console.log('activeContent', activeContent);

                // initialize media
                if (activeContent && activeContent.mediaId || card.mediaId || card.cardType.name === 'media') {
                  console.log('we have media');

                  // prefer the localized record's media
                  if (activeContent && activeContent.mediaId) {
                    console.log('media here');
                    _this4.getActiveMedia = activeContent.mediaId;
                  } else if (_this4.getActiveLocale === 'EN-US' && card.mediaId) {
                    // fallback if media wasn't migrated to a local record and still on the original action card
                    _this4.getActiveMedia = card.mediaId;
                  } else {
                    _this4.getActiveMedia = {};
                  }
                } else {
                  _this4.getActiveMedia = null;
                }
                _this4.ready = true;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    saveChanges: function saveChanges() {
      var _this5 = this;

      this.saveText = 'Saving...';
      var update = this.getActiveLocalRecord;

      if (this.getActiveMedia) {
        update.mediaId = this.getActiveMedia._id;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__services_Utils__["c" /* postResource */])('/v1/actioncards/update', 'id=' + this.getActiveCard._id + '&locale=' + encodeURIComponent(this.getActiveLocale), update).then(function (res) {
        console.log(res);
        return __WEBPACK_IMPORTED_MODULE_7__services_Services__["a" /* default */].setActiveCard(_this5.$route.params.shortId, _this5.getActiveLocale, function () {
          _this5.initializeCard(true);
        });
      }).then(function () {
        _this5.showSuccessMsg({
          message: _this5.getActiveLocale + ' Action card saved!'
        });
        var clonedContent = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this5.getActiveLocalRecord));

        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setActiveLocalRecordSaved', clonedContent);
      }).catch(function (error) {
        _this5.showErrorMsg({
          message: 'An error occurred. Please try again.'
        });
      });
    },
    checkEdits: function checkEdits() {
      console.log('empty check edits');
    }
    // see if we are even using these
    // storeNewHelpInfo() {
    //   const title = this.helpText;
    //   const url = this.helpUrl;
    //   const rowKey = 'ParameterizedHelp';

    //   console.log('submitting new help');

    //   this.checkEdits('helpText', title)
    //     .then(() => {
    //       console.log('updated title');
    //       return this.checkEdits('helpUrl', url);
    //     })
    //     .then(() => {
    //       this.helpText = title;
    //       this.helpUrl = url;
    //       this.showFooterPopup = false;
    //     })
    //     .catch(err => console.log(err));
    // },
    // cleanParams(paramStr) {
    //   const arr = paramStr.match(/{(.*?)}/g) || [];
    //   const sanitized = arr.map(param => param.substring(1, param.length - 1));
    //   return sanitized;
    // },
    // checkEdits(section, string) {
    //     let currentActiveCard = {...this.getActiveCard};
    //     if(section === 'callToAction' || 'title'){
    //       currentActiveCard[section][this.activeSetting] = string;
    //     }
    //     console.log('currentActiveCard', section)
    //     store.commit('setActiveCard', currentActiveCard);
    // }

  },
  mounted: function mounted() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_7__services_Services__["a" /* default */].setActiveCard(_this6.$route.params.shortId, _this6.getActiveLocale, _this6.initializeCard);
              __WEBPACK_IMPORTED_MODULE_7__services_Services__["a" /* default */].getMarkets();

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this6);
    }))();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getActiveLocalRecord) !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getActiveLocalRecordSaved)) {
      var answer = window.confirm('You have unsaved changes. Do you want to leave without saving?');
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_7__services_Services__["a" /* default */].clearActiveMedia();
    __WEBPACK_IMPORTED_MODULE_7__services_Services__["a" /* default */].clearActiveCard();
    __WEBPACK_IMPORTED_MODULE_7__services_Services__["a" /* default */].clearActiveRecords();
  },
  created: function created() {
    var _this7 = this;

    if (this.getActiveCard && this.getActiveCard.localRecords && this.getActiveCard.localRecords.length) {
      var activeContentObj = this.getActiveCard.localRecords.filter(function (record) {
        return record.locale === _this7.getActiveLocale;
      })[0];
      var activeContent = activeContentObj.content || {};
      if (activeContentObj.draftContent) {
        console.log('has draft content');
        activeContent = activeContentObj.draftContent;
      }
      console.log('active content', activeContent);

      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setActiveLocalRecord', activeContent);
      //   store.commit('setActiveLocalRecordSaved', activeContent);
    }
  }
});

/***/ }),

/***/ "ZtZW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notFound',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "a7Z+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aDBo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PlusIcon",
  props: {
    title: {
      type: String,
      default: "Plus icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "aE7u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_status_vue__ = __webpack_require__("agdM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2e3f49d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_status_vue__ = __webpack_require__("17F8");
function injectStyle (ssrContext) {
  __webpack_require__("vjA/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_status_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2e3f49d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_status_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aO9V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v(" Add a New Localized Content Record to Media Library")]),_c('div',{staticClass:"form__control-group rule__control-group--select"},[_c('label',[_vm._v("Select New Locale")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newLocale),expression:"newLocale"}],staticClass:"form__select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.newLocale=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.getAvailableMarkets),function(market){return _c('option',[_vm._v(_vm._s(market.locale))])}))]),_c('button',{staticClass:"button__submit",on:{"click":_vm.submit}},[_vm._v("Add Record To Media Library")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aPRR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var isUploadComplete = function isUploadComplete(status) {
  return status === 'upload failed' || status === 'upload successful' || status === 'canceled';
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: Number
    },
    hideBeforeStart: {
      type: Boolean,
      default: true
    },
    hideOnComplete: {
      type: Boolean,
      default: true
    },
    uploader: {
      type: Object,
      rquired: true
    }
  },

  data: function data() {
    return {
      state: {
        bytesUploaded: null,
        hidden: this.hideBeforeStart,
        totalSize: null
      },
      _unmounted: false
    };
  },
  created: function created() {
    this._createEventHandlers();
  },
  mounted: function mounted() {
    if (this._isTotalProgress) {
      this.uploader.on('totalProgress', this._trackProgressEventHandler);
    } else {
      this.uploader.on('progress', this._trackProgressEventHandler);
    }

    this.uploader.on('statusChange', this._trackStatusEventHandler);
  },
  beforeDestroy: function beforeDestroy() {
    this._unmounted = true;
    this._unregisterEventHandlers();
  },


  methods: {
    _createEventHandlers: function _createEventHandlers() {
      var _this = this;

      if (this._isTotalProgress) {
        this._trackProgressEventHandler = function (bytesUploaded, totalSize) {
          _this.$set(_this.state, 'bytesUploaded', bytesUploaded);
          _this.$set(_this.state, 'totalSize', totalSize);
        };
      } else {
        this._trackProgressEventHandler = function (id, name, bytesUploaded, totalSize) {
          if (id === _this.id) {
            _this.$set(_this.state, 'bytesUploaded', bytesUploaded);
            _this.$set(_this.state, 'totalSize', totalSize);
          }
        };
      }

      this._trackStatusEventHandler = function (id, oldStatus, newStatus) {
        if (!_this._unmounted) {
          if (_this._isTotalProgress) {
            if (!_this.state.hidden && _this.hideOnComplete && isUploadComplete(newStatus) && !_this.uploader.methods.getInProgress()) {
              _this.$set(_this.state, 'hidden', true);
            } else if (_this.state.hidden && _this.uploader.methods.getInProgress()) {
              _this.$set(_this.state, 'hidden', false);
            }
          } else if (id === _this.id) {
            if (_this.state.hidden && newStatus === 'uploading') {
              _this.$set(_this.state, 'hidden', false);
            } else if (!_this.state.hidden && _this.hideOnComplete && isUploadComplete(newStatus)) {
              _this.$set(_this.state, 'hidden', true);
            }
          }
        }
      };
    },
    _unregisterEventHandlers: function _unregisterEventHandlers() {
      if (this._isTotalProgress) {
        this.uploader.off('totalProgress', this._trackProgressEventHandler);
      } else {
        this.uploader.off('progress', this._trackProgressEventHandler);
      }

      this.uploader.off('statusChange', this._trackStatusEventHandler);
    }
  },

  computed: {
    _isTotalProgress: function _isTotalProgress() {
      return typeof this.id !== 'number';
    },
    className: function className() {
      return this._isTotalProgress ? 'vue-fine-uploader-total-progress-bar' : 'vue-fine-uploader-file-progress-bar';
    },
    containerClassName: function containerClassName() {
      return this.className + '-container';
    },
    percentWidth: function percentWidth() {
      return this.state.bytesUploaded / this.state.totalSize * 100 || 0;
    }
  }
});

/***/ }),

/***/ "afd0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.container)},[_c('div',{staticClass:"policy-container"},[_c('button',{staticClass:"button__action",on:{"click":_vm.returnToPolicies}},[_c('i',{staticClass:"glyphicon glyphicon-chevron-left icon"}),_vm._v(" Back to Policies")]),_c('div',{staticClass:"delete"},[_c('button',{staticClass:"button__action button__delete",on:{"click":_vm.deletePolicy}},[_vm._v(_vm._s(_vm.getActivePolicy.deleted ? 'Restore Policy' : 'Delete Policy'))])])]),_c('div',{style:(_vm.styles.pageHeader)},[_c('h1',{style:(_vm.styles.pageHead)},[_vm._v("Edit Policy")])]),(_vm.policyLoaded)?_c('policyForm'):_vm._e(),(!_vm.policyLoaded)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "agdM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isplainobject__ = __webpack_require__("hvKM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isplainobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isplainobject__);



//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: Number,
      required: true
    },
    text: {
      type: Object,
      validator: function validator(value) {
        var obj = {
          deleting: 'string',
          paused: 'string',
          queued: 'string',
          retrying_upload: 'string',
          submitted: 'string',
          submitting: 'string',
          uploading: 'string',
          upload_failed: 'string',
          upload_successful: 'string'
        };

        if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isplainobject___default()(value)) {
          return false;
        }

        var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj);
        var valueKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(value);

        return valueKeys.every(function (key) {
          if (keys.indexOf(key) === -1) {
            return false;
          }

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value[key]) === obj[key];
        });
      },
      default: function _default() {
        return Object({
          deleting: 'Deleting...',
          paused: 'Paused',
          queued: 'Queued',
          retrying_upload: 'Retrying...',
          submitted: 'Submitted',
          submitting: 'Submitting...',
          uploading: 'Uploading...',
          upload_failed: 'Failed',
          upload_successful: 'Completed'
        });
      }
    },
    uploader: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    var defaultText = {
      deleting: 'Deleting...',
      paused: 'Paused',
      queued: 'Queued',
      retrying_upload: 'Retrying...',
      submitted: 'Submitted',
      submitting: 'Submitting...',
      uploading: 'Uploading...',
      upload_failed: 'Failed',
      upload_successful: 'Completed'
    };

    return {
      state: {
        status: '',
        text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultText, this.text || {})
      },
      _unmounted: false
    };
  },
  mounted: function mounted() {
    this.uploader.on('statusChange', this._onStatusChange);

    // Read the status of the file when we start up
    // in case it was already submitted, and there won't be a
    // status change event to react to.
    var uploads = this.uploader.methods.getUploads();
    var fileStatus = null;

    uploads.forEach(function (upload) {
      if (upload.id === this.id) {
        fileStatus = upload.status;
      }
    }, this);

    if (fileStatus !== null) {
      this._onStatusChange(this.id, null, fileStatus);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this._unmounted = true;
    this._unregisterStatusChangeHandler();
  },


  watch: {
    text: function text(newValue, oldValue) {
      this.$set(this.state, 'text', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.state.text, newValue));
    }
  },

  methods: {
    _onStatusChange: function _onStatusChange(id, oldStatus, newStatus) {
      if (id === this.id && !this._unmounted) {
        var newStatusToDisplay = this.getStatusToDisplay({
          displayMap: this.state.text,
          status: newStatus
        });

        newStatusToDisplay && this.$set(this.state, 'status', newStatusToDisplay);
      }
    },
    _unregisterStatusChangeHandler: function _unregisterStatusChangeHandler() {
      this.uploader.off('statusChange', this._onStatusChange);
    },
    getStatusToDisplay: function getStatusToDisplay(_ref) {
      var displayMap = _ref.displayMap,
          status = _ref.status;

      var key = void 0;

      if (status.indexOf(' ') > 0) {
        var statusParts = status.split(' ');

        key = statusParts[0] + '_' + statusParts[1];
      } else {
        key = status;
      }

      return displayMap[key];
    }
  }
});

/***/ }),

/***/ "aoQK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateProductLocalRecord',
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
    },
    data: function data() {
        return {
            newLocale: ''
        };
    },

    computed: {
        getActiveProduct: function getActiveProduct() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveProduct;
        },
        getAvailableMarkets: function getAvailableMarkets() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets;
        }
    },
    notifications: {
        showSuccessMsg: {
            type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.success,
            title: '',
            icon: '✅'
        },
        showErrorMsg: {
            type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.error,
            title: '',
            icon: '❗️'
        }
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].getMarkets();
    },

    methods: {
        submit: function submit() {
            var _this = this;

            var newRecord = {
                recordId: this.getActiveProduct._id,
                recordType: 'Product',
                locale: this.newLocale
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_Utils_js__["c" /* postResource */])('/v1/products/addLocalRecord', false, newRecord).then(function (res) {
                console.log('success!', res);
                _this.showSuccessMsg({ message: 'New ' + _this.newLocale + ' record added to ' + _this.getActiveProduct.title + '!' });
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('hideModals', true);
                __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].setActiveProduct(_this.getActiveProduct._id, _this.$router.push('/products/' + _this.getActiveProduct._id));
                return res;
            }).catch(function (error) {
                var message = 'An error occurred. Please try again.';
                if (error.error) {
                    message = error.error;
                }
                _this.showErrorMsg({
                    message: message
                });
            });
        }
    }
});

/***/ }),

/***/ "aole":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aytQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon image-filter-none-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b18h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductImageUpload_vue__ = __webpack_require__("W25j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ba6bf66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ProductImageUpload_vue__ = __webpack_require__("i2+6");
function injectStyle (ssrContext) {
  __webpack_require__("JgKm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ba6bf66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductImageUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ba6bf66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ProductImageUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bNK2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_local_storage__ = __webpack_require__("+Y1O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils_js__ = __webpack_require__("8u3o");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ColdDeckResetModal',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
  },
  computed: {
    getTenant: function getTenant() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getTenant;
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      console.log('form submitted');
      var stage = this.stage;
      var userId = this.userId;
      var tenant = this.getTenant;
      var tenantId = tenant.platform_id;
      console.log(tenantId);
      if (!userId || !userId.length) return alert('Please enter a valid User ID and try again.');
      var bool = confirm('Do you want to proceed with resetting User ' + userId + ' deck?');
      if (bool) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_Utils_js__["c" /* postResource */])('/v1/tenants/coldStart?userId=' + userId + '&env=' + stage).then(function (res) {
          return res.json();
        }).then(function (res) {
          if (res.status === 'success') {
            alert('Deck successfully reset for User ' + userId);
          } else {
            alert('Reset failed. Please check console logs for more details.');
            console.log(res);
          }
        });
      }
    },
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('hideModals', true);
      __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.set('GEG__KEY', '');
      this.$router.push('/');
    }
  },
  data: function data() {
    return {
      userId: null,
      stage: null,
      styles: {
        toggleColdDeckIcon: {
          position: 'fixed',
          top: '10px',
          right: '10px',
          fontSize: '2em',
          color: '#ddd',
          cursor: 'pointer'
        },
        modalForm: {
          padding: '20px',
          width: '100%',
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        userInputContainer: {
          padding: '10px 0',
          width: '100%',
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        userInput: {
          padding: '10px',
          width: '100%'
        },
        inputSelect: {
          padding: '10px',
          fontSize: '1em'
        },
        submitButtonContainer: {
          padding: '10px 0'
        },
        inputLabel: {
          fontSize: '0.9em',
          fontWeight: '700',
          margin: '10px 0 5px'
        }
      }
    };
  }
});

/***/ }),

/***/ "bdTy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast__ = __webpack_require__("YxSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_izitoast__);



// import allSequences from './allSequences.js';



/* harmony default export */ __webpack_exports__["a"] = ({
    /**
     * Cards
     */

    getCards: function getCards(callback) {
        console.log('retrieving cards');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/actioncards/list?locale=' + encodeURIComponent('EN-US')).then(function (res) {
            if (res.status === 'success') {
                // commit cards to store
                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setCards', res.actionCards);
                if (callback) return callback();
            }
            if (res.status === 'error') console.log(res.error);
        }).catch(function (err) {
            return console.log(err);
        });
    },
    getCardTypes: function getCardTypes() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/actioncardtypes/list').then(function (res) {
            if (res.status === 'success') {
                // commit cards to store
                console.log(res);
                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setCardTypes', res.actionCardTypes);
            }
            if (res.status === 'error') console.log(res.error);
        }).catch(function (err) {
            return console.log(err);
        });
    },
    setActiveCard: function setActiveCard(id, locale, callback) {
        console.log('get active card');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/actioncards/single?id=' + id + '&locale=' + locale).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveCard', res.card);
            if (callback) return callback();
        }).catch(function (err) {
            console.log(err);
        });
    },
    clearActiveRecords: function clearActiveRecords() {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveLocalRecord', {});
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveLocalRecordSaved', {});
    },


    /**
     * Media
     */
    getMedia: function getMedia(id, callback) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/media/single?id=' + id).then(function (res) {
            console.log(res);
            var media = res.media;
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveMedia', media);
            if (res.status === 'error') console.log('error retrieving media', res.error);
            return res.media;
        }).then(function (media) {
            if (callback) return callback(media);
        }).catch(function (err) {
            return console.log(err);
        });

        // store.commit('setMedia', allMedia);
    },
    getMediaByMarket: function getMediaByMarket(marketId, mlId, pgId, last, cont, callback) {
        var reqUrl = 'marketId=' + marketId;
        if (last) reqUrl += '&last=' + last;
        if (mlId) reqUrl += '&mlId=' + mlId;
        if (pgId) reqUrl += '&pgId=' + pgId;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/markets/media', reqUrl).then(function (res) {
            if (res.status === 'error') console.log('error retrieving media', res.error);
            if (!cont) {
                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setMedia', res.media);
                return res;
            } else {
                var prevMedia = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getMedia;
                var media = prevMedia.concat(res.media);
                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setMedia', media);
                return res;
            }
        }).then(function (res) {
            if (callback) return callback(res);
        }).catch(function (err) {
            console.log('getMediaByMarket failed', err);
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setMediaLoadedStatus', true);
            __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.error({
                title: 'Media library',
                message: 'Failed to load media. Please try reloading the page.',
                position: 'topRight',
                progressBar: false
            });
            if (callback) callback({ status: 'error', error: err });
        });

        // store.commit('setMedia', allMedia);
    },
    getMediaByMarketForAC: function getMediaByMarketForAC(marketId) {
        var reqUrl = 'marketId=' + marketId;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/media/list', reqUrl).then(function (res) {
            if (res.status === 'error') {
                console.log('error retrieving media', res.error);
            }
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setMedia', res.media);
            return res;
        }).catch(function (err) {
            return console.log(err);
        });
    },
    getMediaAssociations: function getMediaAssociations() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/media/associations').then(function (res) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setAllProductGroups', res.productGroups);
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setAllMediaLibraries', res.libraries);
        }).catch(function (err) {
            return console.log(err);
        });
    },
    toggleUploadMedia: function toggleUploadMedia(status) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('showMediaUploadModal', status);
    },
    toggleUpdateThumbModal: function toggleUpdateThumbModal(status) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('showUpdateThumbModal', status);
    },
    toggleAddMediaToCard: function toggleAddMediaToCard(status) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('showAddMediaToCardModal', status);
    },
    toggleAddIconToCard: function toggleAddIconToCard(status) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('showCardIconModal', status);
    },
    toggleAddSequenceToPolicy: function toggleAddSequenceToPolicy(status) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('showAddSequenceToPolicyModal', status);
    },
    selectActiveMedia: function selectActiveMedia(media) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveMedia', media);
    },
    clearActiveMedia: function clearActiveMedia() {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveMedia', null);
    },
    getMediaTabs: function getMediaTabs() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/medialibraries/tabs').then(function (res) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setMediaTabs', res.tabs);
        }).catch(function (err) {
            return console.log(err);
        });
    },


    /**
    * Media Libraries
    */

    setActiveMediaLibrary: function setActiveMediaLibrary(id, callback) {
        console.log('get active media library');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/medialibraries/single?id=' + id).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveMediaLibrary', res.mediaLibrary);
            if (callback) return callback();
        }).catch(function (err) {
            console.log(err);
        });
    },


    /**
     * Action Cards
     */
    findMedia: function findMedia(card) {
        var cardType = '';

        if (card.TrainingMedia) {
            cardType = 'TrainingMedia';
        } else if (card.ActionCardMediaDto) {
            cardType = 'ActionCardMediaDto';
        }

        var media = {};

        if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getMedia.length) {
            console.log('we already have media', __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getMedia);
            console.log(cardType);
            media = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getMedia.find(function (obj) {
                return obj.id == card[cardType].MmId._;
            });
        } else {
            this.getMedia(function () {
                media = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getMedia.find(function (obj) {
                    return obj.id == card[cardType].MmId._;
                });
            });
        }

        this.selectActiveMedia(media);
        return media;
    },
    clearActiveCard: function clearActiveCard() {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveCard', null);
    },


    /**
     * Policies
     */

    getPolicies: function getPolicies(callback) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/policies/list').then(function (res) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setPolicies', res.policies);
            if (callback) return callback();
        }).catch(function (err) {
            return console.log(err);
        });
    },
    setActivePolicy: function setActivePolicy(policy) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActivePolicy', policy);
    },
    clearSelectedSequence: function clearSelectedSequence() {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setSelectedSequence', null);
    },
    clearActivePolicy: function clearActivePolicy(policy) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActivePolicy', {});
    },
    getInteractionTypes: function getInteractionTypes() {
        return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getInteractionTypes;
    },
    setInteractionTypes: function setInteractionTypes(callback) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/interactionTypes/list').then(function (res) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setInteractionTypes', res.interactionTypes);
            console.log('our interaction types', res.interactionTypes);
            return res;
        }).then(function () {
            if (callback) {
                console.log('callback');
                callback();
            }
            return;
        }).catch(function (err) {
            return console.log(err);
        });
    },
    getTenantUsers: function getTenantUsers() {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/tenants/users').then(function (res) {
                return resolve(res.users);
            }).catch(function (err) {
                return reject(err);
            });
        });
    },
    getTenantRoles: function getTenantRoles() {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/tenants/roles').then(function (res) {
                resolve(res.roles);
            }).catch(function (err) {
                return reject(err);
            });
        });
    },


    /**
     * Markets
     */
    getMarkets: function getMarkets(callback) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/markets/list').then(function (res) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setMarkets', res.markets);
            if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getActiveMarket._id) {
                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveMarket', res.markets[0]);
            }
            if (res.status === 'error') console.log('error retrieving markets', res.error);
            return res.markets;
        }).then(function (markets) {
            if (callback) return callback(markets);
        }).catch(function (err) {
            return console.log(err);
        });
    },
    setActiveMarket: function setActiveMarket(marketId, callback) {
        console.log('set active market');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/markets/single?id=' + marketId).then(function (res) {
            if (res.status === 'success') {
                var market = res.market;
                if (res.cards) {
                    market.cards = res.cards;
                }
                if (res.activityPhrases) {
                    market.activityPhrases = res.activityPhrases.content;
                    market.hasPhrases = true;
                } else {
                    market.hasPhrases = false;
                    market.activityPhrases = {};
                }
                if (res.cards) {
                    market.mediaRecords = res.mediaRecords;
                }
                if (res.cards) {
                    market.products = res.products;
                }

                if (res.volumeLinks) {
                    market.volumeLinks = res.volumeLinks;
                }

                if (res.productGroups) {
                    market.productGroups = res.productGroups;
                }
                return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveMarket', market);
            }
        }).then(function () {
            if (callback) return callback();
        }).catch(function (err) {
            return console.log(err);
        });
    },
    clearActiveMarket: function clearActiveMarket() {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveMarket', {});
    },


    /**
     * Sequences
     */

    getSequences: function getSequences() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/sequences/list').then(function (res) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setSequences', res.sequences);
        }).catch(function (err) {
            return console.log(err);
        });
        // store.commit('setSequences', allSequences);
    },
    setActiveSequence: function setActiveSequence(sequenceId, callback) {
        console.log('setting a new sequence', sequenceId);

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/sequences/single?sequenceId=' + sequenceId).then(function (res) {
            console.log('found sequence', res.sequence);
            if (res.sequence.actionCards) {
                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setSequenceCards', res.sequence.actionCards);
            }
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveSequence', res.sequence);
        }).then(function () {
            if (callback) return callback();
        }).catch(function (err) {
            console.log(err);
        });
    },
    clearActiveSequence: function clearActiveSequence() {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveSequence', {});
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setSequenceCards', []);
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setOriginalSequenceCards', []);
    },
    updateNewSequence: function updateNewSequence(sequence, cards) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveSequence', sequence);
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setOriginalSequenceCards', cards);
    },
    checkSequenceChanges: function checkSequenceChanges(name) {
        console.log('checking changes');

        if (name && name != __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getActiveSequence.name) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setSequenceStatus', true);
            return;
        }
        if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getSequenceCards.length !== __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getOriginalSequenceCards.length) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setSequenceStatus', true);
            // return false;
            return;
        }

        for (var i = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getSequenceCards.length; i--;) {
            console.log(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getSequenceCards[i]);
            if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getSequenceCards[i] !== __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getOriginalSequenceCards[i]) {
                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setSequenceStatus', true);
                // return false;
                return;
            }
        }

        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setSequenceStatus', false);
        return true;
    },


    /**
    * Products
    */

    getProducts: function getProducts() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/products/list').then(function (res) {
            if (res.status === 'success') {
                return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setProducts', res.products);
            }
            if (res.status === 'error') return console.log(res.error);
        }).catch(function (err) {
            return console.log(err);
        });
    },
    getProductGroups: function getProductGroups() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/productgroups/list').then(function (res) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setAllProductGroups', res.groups);
            if (res.status === 'error') return console.log(res.error);
        }).catch(function (err) {
            return console.log(err);
        });
    },
    setActiveProduct: function setActiveProduct(productId, callback) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/products/single?id=' + productId).then(function (res) {
            if (res.status === 'success') {
                console.log('active product', res.product);
                return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveProduct', res.product);
            }
            if (res.status === 'error') return console.log(res.error);
        }).then(function () {
            if (callback) return callback();
        }).catch(function (err) {
            return console.log(err);
        });
    },
    setActiveProductGroup: function setActiveProductGroup(productGroupId, callback) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/productgroups/single?id=' + productGroupId).then(function (res) {
            if (res.status === 'success') {
                console.log('active product group', res.productGroup);
                return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveProductGroup', res.productGroup);
            }
            if (res.status === 'error') return console.log(res.error);
        }).then(function () {
            if (callback) return callback();
        }).catch(function (err) {
            return console.log(err);
        });
    },
    clearActiveProduct: function clearActiveProduct() {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveProduct', {});
    },
    clearActiveProductGroup: function clearActiveProductGroup() {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveProductGroup', {});
    },


    /**
    * Media Libraries
    */
    getMediaLibraries: function getMediaLibraries() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getResource */])('/v1/medialibraries/list').then(function (res) {
            if (res.status === 'success') {
                return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setAllMediaLibraries', res.libraries);
            }
            if (res.status === 'error') return res.error;
        }).catch(function (err) {
            return console.log(err);
        });
    },


    /**
    * Misc
    */

    getFlagUrl: function getFlagUrl(market) {
        if (market && market.region) {

            // check for countries who have mismatching first two characters of 2- and 3-letter country codes
            var mismatchCountries = [{
                code: 'ALA',
                flag: 'AX'
            }, {
                code: 'AND',
                flag: 'AD'
            }, {
                code: 'AGO',
                flag: 'AO'
            }, {
                code: 'ATA',
                flag: 'AQ'
            }, {
                code: 'ATG',
                flag: 'AG'
            }, {
                code: 'ARM',
                flag: 'AM'
            }, {
                code: 'ABW',
                flag: 'AW'
            }, {
                code: 'AUT',
                flag: 'AT'
            }, {
                code: 'BHS',
                flag: 'BS'
            }, {
                code: 'BGD',
                flag: 'BD'
            }, {
                code: 'BRB',
                flag: 'BB'
            }, {
                code: 'BLR',
                flag: 'BY'
            }, {
                code: 'BLZ',
                flag: 'BZ'
            }, {
                code: 'BEN',
                flag: 'BJ'
            }, {
                code: 'BES',
                flag: 'BQ'
            }, {
                code: 'BIH',
                flag: 'BA'
            }, {
                code: 'BRN',
                flag: 'BN'
            }, {
                code: 'BDI',
                flag: 'BI'
            }, {
                code: 'CPV',
                flag: 'CV'
            }, {
                code: 'CYM',
                flag: 'KY'
            }, {
                code: 'CAF',
                flag: 'CF'
            }, {
                code: 'CHL',
                flag: 'CL'
            }, {
                code: 'CHN',
                flag: 'CN'
            }, {
                code: 'COM',
                flag: 'KM'
            }, {
                code: 'COG',
                flag: 'CG'
            }, {
                code: 'COK',
                flag: 'CK'
            }, {
                code: 'CUW',
                flag: 'CW'
            }, {
                code: 'DNK',
                flag: 'DK'
            }, {
                code: 'SLV',
                flag: 'SV'
            }, {
                code: 'GNQ',
                flag: 'GQ'
            }, {
                code: 'EST',
                flag: 'EE'
            }, {
                code: 'SWZ',
                flag: 'SZ'
            }, {
                code: 'FLK',
                flag: 'FK'
            }, {
                code: 'FRO',
                flag: 'FO'
            }, {
                code: 'GUF',
                flag: 'GF'
            }, {
                code: 'PYF',
                flag: 'PF'
            }, {
                code: 'GRL',
                flag: 'GL'
            }, {
                code: 'GRD',
                flag: 'GD'
            }, {
                code: 'GLP',
                flag: 'GP'
            }, {
                code: 'GIN',
                flag: 'GN'
            }, {
                code: 'GNB',
                flag: 'GW'
            }, {
                code: 'GUY',
                flag: 'GY'
            }, {
                code: 'IRQ',
                flag: 'IQ'
            }, {
                code: 'IRL',
                flag: 'IE'
            }, {
                code: 'ISR',
                flag: 'IL'
            }, {
                code: 'JAM',
                flag: 'JM'
            }, {
                code: 'KAZ',
                flag: 'KZ'
            }, {
                code: 'PRK',
                flag: 'KP'
            }, {
                code: 'KOR',
                flag: 'KR'
            }, {
                code: 'LBR',
                flag: 'LR'
            }, {
                code: 'LBY',
                flag: 'LY'
            }, {
                code: 'MAC',
                flag: 'MO'
            }, {
                code: 'MDG',
                flag: 'MG'
            }, {
                code: 'MDV',
                flag: 'MV'
            }, {
                code: 'MLT',
                flag: 'MT'
            }, {
                code: 'MTQ',
                flag: 'MQ'
            }, {
                code: 'MYT',
                flag: 'YT'
            }, {
                code: 'MEX',
                flag: 'MX'
            }, {
                code: 'FSM',
                flag: 'FM'
            }, {
                code: 'MNE',
                flag: 'ME'
            }, {
                code: 'MOZ',
                flag: 'MZ'
            }, {
                code: 'NIU',
                flag: 'NU'
            }, {
                code: 'MNP',
                flag: 'MP'
            }, {
                code: 'PAK',
                flag: 'PK'
            }, {
                code: 'PLW',
                flag: 'PW'
            }, {
                code: 'PNG',
                flag: 'PG'
            }, {
                code: 'PRY',
                flag: 'PY'
            }, {
                code: 'PCN',
                flag: 'PN'
            }, {
                code: 'POL',
                flag: 'PL'
            }, {
                code: 'PRT',
                flag: 'PT'
            }, {
                code: 'MAF',
                flag: 'MF'
            }, {
                code: 'SPM',
                flag: 'PM'
            }, {
                code: 'SEN',
                flag: 'SN'
            }, {
                code: 'SRB',
                flag: 'RS'
            }, {
                code: 'SYC',
                flag: 'SC'
            }, {
                code: 'SVK',
                flag: 'SK'
            }, {
                code: 'SVN',
                flag: 'SI'
            }, {
                code: 'SLB',
                flag: 'SB'
            }, {
                code: 'SGS',
                flag: 'GS'
            }, {
                code: 'SUR',
                flag: 'SR'
            }, {
                code: 'SWE',
                flag: 'SE'
            }, {
                code: 'TUN',
                flag: 'TN'
            }, {
                code: 'TUR',
                flag: 'TR'
            }, {
                code: 'TKM',
                flag: 'TM'
            }, {
                code: 'TUV',
                flag: 'TV'
            }, {
                code: 'UKR',
                flag: 'UA'
            }, {
                code: 'ARE',
                flag: 'AE'
            }, {
                code: 'URY',
                flag: 'UY'
            }, {
                code: 'WLF',
                flag: 'WF'
            }, {
                code: 'ESH',
                flag: 'EH'
            }];

            if (mismatchCountries.some(function (country) {
                return country.code === market.country;
            })) {
                var _flag = mismatchCountries.find(function (country) {
                    return country.code === market.country;
                }).flag;
                return 'https://www.countryflags.io/' + _flag + '/flat/48.png';
            }

            var flag = market.region.substring(0, market.region.length - 1);
            return 'https://www.countryflags.io/' + flag + '/flat/48.png';
        }

        // no market sent
        return '';
    }
});

/***/ }),

/***/ "bsKQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bzSC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'registerTeam',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "cXFH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('form',{style:(_vm.styles.modalForm),on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{style:(_vm.styles.userInputContainer)},[_c('span',{style:(_vm.styles.inputLabel)},[_vm._v("USER ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userId),expression:"userId"}],style:(_vm.styles.userInput),attrs:{"type":"text","placeholder":"Enter a valid User ID"},domProps:{"value":(_vm.userId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userId=$event.target.value}}})]),_vm._v(" "),_c('div',{style:(_vm.styles.userInputContainer)},[_c('span',{style:(_vm.styles.inputLabel)},[_vm._v("ENVIRONMENT")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.stage),expression:"stage"}],style:(_vm.styles.inputSelect),on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.stage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("Choose an environment...")]),_vm._v(" "),_c('option',{attrs:{"value":"test","default":""}},[_vm._v("Test")]),_vm._v(" "),_c('option',{attrs:{"value":"prod"}},[_vm._v("Production")])])]),_vm._v(" "),_c('div',{style:(_vm.styles.submitButtonContainer)},[_c('button',{attrs:{"type":"submit"}},[_vm._v("Reset Deck")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ceid":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v("Create a New Media Library")]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Title")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],attrs:{"type":"text","placeholder":"Name"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}})]),_c('div',{staticClass:"form__control-group rule__control-group--select"},[_c('label',[_vm._v("Default Market")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.market),expression:"market"}],staticClass:"form__select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.market=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"disabled","selected":"selected"}},[_vm._v("Select Market")]),_vm._l((_vm.getMarkets),function(market,index){return _c('option',{key:market.name,domProps:{"value":market}},[_vm._v(_vm._s(market.title)+" - "+_vm._s(market.primaryLanguage))])})],2)]),_c('button',{staticClass:"button__submit",on:{"click":_vm.submit}},[_vm._v("Create")]),(_vm.showError)?_c('p',{staticClass:"validation__error"},[_vm._v("Please enter a Title and Default Market.")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cnpZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProduct_vue__ = __webpack_require__("gXoZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084ddaf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProduct_vue__ = __webpack_require__("ydoa");
function injectStyle (ssrContext) {
  __webpack_require__("7PuQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-084ddaf8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084ddaf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dJYX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[(!_vm.selectedRole)?_c('h2',[_vm._v("Create a New Role")]):_vm._e(),(_vm.selectedRole)?_c('h2',[_vm._v("Manage Role")]):_vm._e(),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Title")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],attrs:{"type":"text","placeholder":"Title"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Privileges")]),_vm._l((Object.keys(_vm.privileges)),function(p){return _c('div',[_c('span',{staticClass:"role-label"},[_c('i',{class:("glyphicon glyphicon-" + (_vm.roles[p].icon))}),_c('span',[_vm._v(_vm._s(_vm.roles[p].label))])]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.privileges[p]),expression:"privileges[p]"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.privileges, p, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"read"}},[_vm._v("read")]),_c('option',{attrs:{"value":"write"}},[_vm._v("write")]),_c('option',{attrs:{"value":"admin"}},[_vm._v("admin")])])])})],2),(!_vm.selectedRole)?_c('button',{staticClass:"button__submit",on:{"click":_vm.submit}},[_vm._v("Create Role")]):_vm._e(),(_vm.selectedRole)?_c('button',{staticClass:"button__submit",on:{"click":_vm.submit}},[_vm._v("Update Role")]):_vm._e(),(_vm.showError)?_c('p',{staticClass:"validation__error"},[_vm._v("Please enter a Title")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dSGv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__ = __webpack_require__("A5tq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31ec5f1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__ = __webpack_require__("sxfZ");
function injectStyle (ssrContext) {
  __webpack_require__("vDyk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31ec5f1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dlb7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
* original author Phil Teare
* using wikipedia data
*/

/* harmony default export */ __webpack_exports__["a"] = ({
    "ab": {
        "code": "AB",
        "name": "Abkhaz",
        "nativeName": "аҧсуа"
    },
    "aa": {
        "code": "AA",
        "name": "Afar",
        "nativeName": "Afaraf"
    },
    "af": {
        "code": "AF",
        "name": "Afrikaans",
        "nativeName": "Afrikaans"
    },
    "ak": {
        "code": "AK",
        "name": "Akan",
        "nativeName": "Akan"
    },
    "sq": {
        "code": "SQ",
        "name": "Albanian",
        "nativeName": "Shqip"
    },
    "am": {
        "code": "AM",
        "name": "Amharic",
        "nativeName": "አማርኛ"
    },
    "ar": {
        "code": "AR",
        "name": "Arabic",
        "nativeName": "العربية"
    },
    "an": {
        "code": "AN",
        "name": "Aragonese",
        "nativeName": "Aragonés"
    },
    "hy": {
        "code": "HY",
        "name": "Armenian",
        "nativeName": "Հայերեն"
    },
    "as": {
        "code": "AS",
        "name": "Assamese",
        "nativeName": "অসমীয়া"
    },
    "av": {
        "code": "AV",
        "name": "Avaric",
        "nativeName": "авар мацӀ, магӀарул мацӀ"
    },
    "ae": {
        "code": "AE",
        "name": "Avestan",
        "nativeName": "avesta"
    },
    "ay": {
        "code": "AY",
        "name": "Aymara",
        "nativeName": "aymar aru"
    },
    "az": {
        "code": "AZ",
        "name": "Azerbaijani",
        "nativeName": "azərbaycan dili"
    },
    "bm": {
        "code": "BM",
        "name": "Bambara",
        "nativeName": "bamanankan"
    },
    "ba": {
        "code": "BA",
        "name": "Bashkir",
        "nativeName": "башҡорт теле"
    },
    "eu": {
        "code": "EU",
        "name": "Basque",
        "nativeName": "euskara, euskera"
    },
    "be": {
        "code": "BE",
        "name": "Belarusian",
        "nativeName": "Беларуская"
    },
    "bn": {
        "code": "BN",
        "name": "Bengali",
        "nativeName": "বাংলা"
    },
    "bh": {
        "code": "BH",
        "name": "Bihari",
        "nativeName": "भोजपुरी"
    },
    "bi": {
        "code": "BI",
        "name": "Bislama",
        "nativeName": "Bislama"
    },
    "bs": {
        "code": "BS",
        "name": "Bosnian",
        "nativeName": "bosanski jezik"
    },
    "br": {
        "code": "BR",
        "name": "Breton",
        "nativeName": "brezhoneg"
    },
    "bg": {
        "code": "BG",
        "name": "Bulgarian",
        "nativeName": "български език"
    },
    "my": {
        "code": "MY",
        "name": "Burmese",
        "nativeName": "ဗမာစာ"
    },
    "ca": {
        "code": "CA",
        "name": "Catalan; Valencian",
        "nativeName": "Català"
    },
    "ch": {
        "code": "CH",
        "name": "Chamorro",
        "nativeName": "Chamoru"
    },
    "ce": {
        "code": "CE",
        "name": "Chechen",
        "nativeName": "нохчийн мотт"
    },
    "ny": {
        "code": "NY",
        "name": "Chichewa; Chewa; Nyanja",
        "nativeName": "chiCheŵa, chinyanja"
    },
    "zh": {
        "code": "ZH",
        "name": "Chinese",
        "nativeName": "中文 (Zhōngwén), 汉语, 漢語"
    },
    "cv": {
        "code": "CV",
        "name": "Chuvash",
        "nativeName": "чӑваш чӗлхи"
    },
    "kw": {
        "code": "KW",
        "name": "Cornish",
        "nativeName": "Kernewek"
    },
    "co": {
        "code": "CO",
        "name": "Corsican",
        "nativeName": "corsu, lingua corsa"
    },
    "cr": {
        "code": "CR",
        "name": "Cree",
        "nativeName": "ᓀᐦᐃᔭᐍᐏᐣ"
    },
    "hr": {
        "code": "HR",
        "name": "Croatian",
        "nativeName": "hrvatski"
    },
    "cs": {
        "code": "CS",
        "name": "Czech",
        "nativeName": "česky, čeština"
    },
    "da": {
        "code": "DA",
        "name": "Danish",
        "nativeName": "dansk"
    },
    "dv": {
        "code": "DV",
        "name": "Divehi; Dhivehi; Maldivian;",
        "nativeName": "ދިވެހި"
    },
    "nl": {
        "code": "NL",
        "name": "Dutch",
        "nativeName": "Nederlands, Vlaams"
    },
    "en": {
        "code": "EN",
        "name": "English",
        "nativeName": "English"
    },
    "eo": {
        "code": "EO",
        "name": "Esperanto",
        "nativeName": "Esperanto"
    },
    "et": {
        "code": "ET",
        "name": "Estonian",
        "nativeName": "eesti, eesti keel"
    },
    "ee": {
        "code": "EE",
        "name": "Ewe",
        "nativeName": "Eʋegbe"
    },
    "fo": {
        "code": "FO",
        "name": "Faroese",
        "nativeName": "føroyskt"
    },
    "fj": {
        "code": "FJ",
        "name": "Fijian",
        "nativeName": "vosa Vakaviti"
    },
    "fi": {
        "code": "FI",
        "name": "Finnish",
        "nativeName": "suomi, suomen kieli"
    },
    "fr": {
        "code": "FR",
        "name": "French",
        "nativeName": "français, langue française"
    },
    "ff": {
        "code": "FF",
        "name": "Fula; Fulah; Pulaar; Pular",
        "nativeName": "Fulfulde, Pulaar, Pular"
    },
    "gl": {
        "code": "GL",
        "name": "Galician",
        "nativeName": "Galego"
    },
    "ka": {
        "code": "KA",
        "name": "Georgian",
        "nativeName": "ქართული"
    },
    "de": {
        "code": "DE",
        "name": "German",
        "nativeName": "Deutsch"
    },
    "el": {
        "code": "EL",
        "name": "Greek, Modern",
        "nativeName": "Ελληνικά"
    },
    "gn": {
        "code": "GN",
        "name": "Guaraní",
        "nativeName": "Avañeẽ"
    },
    "gu": {
        "code": "GU",
        "name": "Gujarati",
        "nativeName": "ગુજરાતી"
    },
    "ht": {
        "code": "HT",
        "name": "Haitian; Haitian Creole",
        "nativeName": "Kreyòl ayisyen"
    },
    "ha": {
        "code": "HA",
        "name": "Hausa",
        "nativeName": "Hausa, هَوُسَ"
    },
    "he": {
        "code": "HE",
        "name": "Hebrew (modern)",
        "nativeName": "עברית"
    },
    "hz": {
        "code": "HZ",
        "name": "Herero",
        "nativeName": "Otjiherero"
    },
    "hi": {
        "code": "HI",
        "name": "Hindi",
        "nativeName": "हिन्दी, हिंदी"
    },
    "ho": {
        "code": "HO",
        "name": "Hiri Motu",
        "nativeName": "Hiri Motu"
    },
    "hu": {
        "code": "HU",
        "name": "Hungarian",
        "nativeName": "Magyar"
    },
    "ia": {
        "code": "IA",
        "name": "Interlingua",
        "nativeName": "Interlingua"
    },
    "id": {
        "code": "ID",
        "name": "Indonesian",
        "nativeName": "Bahasa Indonesia"
    },
    "ie": {
        "code": "IE",
        "name": "Interlingue",
        "nativeName": "Originally called Occidental; then Interlingue after WWII"
    },
    "ga": {
        "code": "GA",
        "name": "Irish",
        "nativeName": "Gaeilge"
    },
    "ig": {
        "code": "IG",
        "name": "Igbo",
        "nativeName": "Asụsụ Igbo"
    },
    "ik": {
        "code": "IK",
        "name": "Inupiaq",
        "nativeName": "Iñupiaq, Iñupiatun"
    },
    "io": {
        "code": "IO",
        "name": "Ido",
        "nativeName": "Ido"
    },
    "is": {
        "code": "IS",
        "name": "Icelandic",
        "nativeName": "Íslenska"
    },
    "it": {
        "code": "IT",
        "name": "Italian",
        "nativeName": "Italiano"
    },
    "iu": {
        "code": "IU",
        "name": "Inuktitut",
        "nativeName": "ᐃᓄᒃᑎᑐᑦ"
    },
    "ja": {
        "code": "JA",
        "name": "Japanese",
        "nativeName": "日本語 (にほんご／にっぽんご)"
    },
    "jv": {
        "code": "JV",
        "name": "Javanese",
        "nativeName": "basa Jawa"
    },
    "kl": {
        "code": "KL",
        "name": "Kalaallisut, Greenlandic",
        "nativeName": "kalaallisut, kalaallit oqaasii"
    },
    "kn": {
        "code": "KN",
        "name": "Kannada",
        "nativeName": "ಕನ್ನಡ"
    },
    "kr": {
        "code": "KR",
        "name": "Kanuri",
        "nativeName": "Kanuri"
    },
    "ks": {
        "code": "KS",
        "name": "Kashmiri",
        "nativeName": "कश्मीरी, كشميري‎"
    },
    "kk": {
        "code": "KK",
        "name": "Kazakh",
        "nativeName": "Қазақ тілі"
    },
    "km": {
        "code": "KM",
        "name": "Khmer",
        "nativeName": "ភាសាខ្មែរ"
    },
    "ki": {
        "code": "KI",
        "name": "Kikuyu, Gikuyu",
        "nativeName": "Gĩkũyũ"
    },
    "rw": {
        "code": "RW",
        "name": "Kinyarwanda",
        "nativeName": "Ikinyarwanda"
    },
    "ky": {
        "code": "KY",
        "name": "Kirghiz, Kyrgyz",
        "nativeName": "кыргыз тили"
    },
    "kv": {
        "code": "KV",
        "name": "Komi",
        "nativeName": "коми кыв"
    },
    "kg": {
        "code": "KG",
        "name": "Kongo",
        "nativeName": "KiKongo"
    },
    "ko": {
        "code": "KO",
        "name": "Korean",
        "nativeName": "한국어 (韓國語), 조선말 (朝鮮語)"
    },
    "ku": {
        "code": "KU",
        "name": "Kurdish",
        "nativeName": "Kurdî, كوردی‎"
    },
    "kj": {
        "code": "KJ",
        "name": "Kwanyama, Kuanyama",
        "nativeName": "Kuanyama"
    },
    "la": {
        "code": "LA",
        "name": "Latin",
        "nativeName": "latine, lingua latina"
    },
    "lb": {
        "code": "LB",
        "name": "Luxembourgish, Letzeburgesch",
        "nativeName": "Lëtzebuergesch"
    },
    "lg": {
        "code": "LG",
        "name": "Luganda",
        "nativeName": "Luganda"
    },
    "li": {
        "code": "LI",
        "name": "Limburgish, Limburgan, Limburger",
        "nativeName": "Limburgs"
    },
    "ln": {
        "code": "LN",
        "name": "Lingala",
        "nativeName": "Lingála"
    },
    "lo": {
        "code": "LO",
        "name": "Lao",
        "nativeName": "ພາສາລາວ"
    },
    "lt": {
        "code": "LT",
        "name": "Lithuanian",
        "nativeName": "lietuvių kalba"
    },
    "lu": {
        "code": "LU",
        "name": "Luba-Katanga",
        "nativeName": ""
    },
    "lv": {
        "code": "LV",
        "name": "Latvian",
        "nativeName": "latviešu valoda"
    },
    "gv": {
        "code": "GV",
        "name": "Manx",
        "nativeName": "Gaelg, Gailck"
    },
    "mk": {
        "code": "MK",
        "name": "Macedonian",
        "nativeName": "македонски јазик"
    },
    "mg": {
        "code": "MG",
        "name": "Malagasy",
        "nativeName": "Malagasy fiteny"
    },
    "ms": {
        "code": "MS",
        "name": "Malay",
        "nativeName": "bahasa Melayu, بهاس ملايو‎"
    },
    "ml": {
        "code": "ML",
        "name": "Malayalam",
        "nativeName": "മലയാളം"
    },
    "mt": {
        "code": "MT",
        "name": "Maltese",
        "nativeName": "Malti"
    },
    "mi": {
        "code": "MI",
        "name": "Māori",
        "nativeName": "te reo Māori"
    },
    "mr": {
        "code": "MR",
        "name": "Marathi (Marāṭhī)",
        "nativeName": "मराठी"
    },
    "mh": {
        "code": "MH",
        "name": "Marshallese",
        "nativeName": "Kajin M̧ajeļ"
    },
    "mn": {
        "code": "MN",
        "name": "Mongolian",
        "nativeName": "монгол"
    },
    "na": {
        "code": "NA",
        "name": "Nauru",
        "nativeName": "Ekakairũ Naoero"
    },
    "nv": {
        "code": "NV",
        "name": "Navajo, Navaho",
        "nativeName": "Diné bizaad, Dinékʼehǰí"
    },
    "nb": {
        "code": "NB",
        "name": "Norwegian Bokmål",
        "nativeName": "Norsk bokmål"
    },
    "nd": {
        "code": "ND",
        "name": "North Ndebele",
        "nativeName": "isiNdebele"
    },
    "ne": {
        "code": "NE",
        "name": "Nepali",
        "nativeName": "नेपाली"
    },
    "ng": {
        "code": "NG",
        "name": "Ndonga",
        "nativeName": "Owambo"
    },
    "nn": {
        "code": "NN",
        "name": "Norwegian Nynorsk",
        "nativeName": "Norsk nynorsk"
    },
    "no": {
        "code": "NO",
        "name": "Norwegian",
        "nativeName": "Norsk"
    },
    "ii": {
        "code": "II",
        "name": "Nuosu",
        "nativeName": "ꆈꌠ꒿ Nuosuhxop"
    },
    "nr": {
        "code": "NR",
        "name": "South Ndebele",
        "nativeName": "isiNdebele"
    },
    "oc": {
        "code": "OC",
        "name": "Occitan",
        "nativeName": "Occitan"
    },
    "oj": {
        "code": "OJ",
        "name": "Ojibwe, Ojibwa",
        "nativeName": "ᐊᓂᔑᓈᐯᒧᐎᓐ"
    },
    "cu": {
        "code": "CU",
        "name": "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
        "nativeName": "ѩзыкъ словѣньскъ"
    },
    "om": {
        "code": "OM",
        "name": "Oromo",
        "nativeName": "Afaan Oromoo"
    },
    "or": {
        "code": "OR",
        "name": "Oriya",
        "nativeName": "ଓଡ଼ିଆ"
    },
    "os": {
        "code": "OS",
        "name": "Ossetian, Ossetic",
        "nativeName": "ирон æвзаг"
    },
    "pa": {
        "code": "PA",
        "name": "Panjabi, Punjabi",
        "nativeName": "ਪੰਜਾਬੀ, پنجابی‎"
    },
    "pi": {
        "code": "PI",
        "name": "Pāli",
        "nativeName": "पाऴि"
    },
    "fa": {
        "code": "FA",
        "name": "Persian",
        "nativeName": "فارسی"
    },
    "pl": {
        "code": "PL",
        "name": "Polish",
        "nativeName": "polski"
    },
    "ps": {
        "code": "PS",
        "name": "Pashto, Pushto",
        "nativeName": "پښتو"
    },
    "pt": {
        "code": "PT",
        "name": "Portuguese",
        "nativeName": "Português"
    },
    "qu": {
        "code": "QU",
        "name": "Quechua",
        "nativeName": "Runa Simi, Kichwa"
    },
    "rm": {
        "code": "RM",
        "name": "Romansh",
        "nativeName": "rumantsch grischun"
    },
    "rn": {
        "code": "RN",
        "name": "Kirundi",
        "nativeName": "kiRundi"
    },
    "ro": {
        "code": "RO",
        "name": "Romanian, Moldavian, Moldovan",
        "nativeName": "română"
    },
    "ru": {
        "code": "RU",
        "name": "Russian",
        "nativeName": "русский язык"
    },
    "sa": {
        "code": "SA",
        "name": "Sanskrit (Saṁskṛta)",
        "nativeName": "संस्कृतम्"
    },
    "sc": {
        "code": "SC",
        "name": "Sardinian",
        "nativeName": "sardu"
    },
    "sd": {
        "code": "SD",
        "name": "Sindhi",
        "nativeName": "सिन्धी, سنڌي، سندھی‎"
    },
    "se": {
        "code": "SE",
        "name": "Northern Sami",
        "nativeName": "Davvisámegiella"
    },
    "sm": {
        "code": "SM",
        "name": "Samoan",
        "nativeName": "gagana faa Samoa"
    },
    "sg": {
        "code": "SG",
        "name": "Sango",
        "nativeName": "yângâ tî sängö"
    },
    "sr": {
        "code": "SR",
        "name": "Serbian",
        "nativeName": "српски језик"
    },
    "gd": {
        "code": "GD",
        "name": "Scottish Gaelic; Gaelic",
        "nativeName": "Gàidhlig"
    },
    "sn": {
        "code": "SN",
        "name": "Shona",
        "nativeName": "chiShona"
    },
    "si": {
        "code": "SI",
        "name": "Sinhala, Sinhalese",
        "nativeName": "සිංහල"
    },
    "sk": {
        "code": "SK",
        "name": "Slovak",
        "nativeName": "slovenčina"
    },
    "sl": {
        "code": "SL",
        "name": "Slovene",
        "nativeName": "slovenščina"
    },
    "so": {
        "code": "SO",
        "name": "Somali",
        "nativeName": "Soomaaliga, af Soomaali"
    },
    "st": {
        "code": "ST",
        "name": "Southern Sotho",
        "nativeName": "Sesotho"
    },
    "es": {
        "code": "ES",
        "name": "Spanish; Castilian",
        "nativeName": "español, castellano"
    },
    "su": {
        "code": "SU",
        "name": "Sundanese",
        "nativeName": "Basa Sunda"
    },
    "sw": {
        "code": "SW",
        "name": "Swahili",
        "nativeName": "Kiswahili"
    },
    "ss": {
        "code": "SS",
        "name": "Swati",
        "nativeName": "SiSwati"
    },
    "sv": {
        "code": "SV",
        "name": "Swedish",
        "nativeName": "svenska"
    },
    "ta": {
        "code": "TA",
        "name": "Tamil",
        "nativeName": "தமிழ்"
    },
    "te": {
        "code": "TE",
        "name": "Telugu",
        "nativeName": "తెలుగు"
    },
    "tg": {
        "code": "TG",
        "name": "Tajik",
        "nativeName": "тоҷикӣ, toğikī, تاجیکی‎"
    },
    "th": {
        "code": "TH",
        "name": "Thai",
        "nativeName": "ไทย"
    },
    "ti": {
        "code": "TI",
        "name": "Tigrinya",
        "nativeName": "ትግርኛ"
    },
    "bo": {
        "code": "BO",
        "name": "Tibetan Standard, Tibetan, Central",
        "nativeName": "བོད་ཡིག"
    },
    "tk": {
        "code": "TK",
        "name": "Turkmen",
        "nativeName": "Türkmen, Түркмен"
    },
    "tl": {
        "code": "TL",
        "name": "Tagalog",
        "nativeName": "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔"
    },
    "tn": {
        "code": "TN",
        "name": "Tswana",
        "nativeName": "Setswana"
    },
    "to": {
        "code": "TO",
        "name": "Tonga (Tonga Islands)",
        "nativeName": "faka Tonga"
    },
    "tr": {
        "code": "TR",
        "name": "Turkish",
        "nativeName": "Türkçe"
    },
    "ts": {
        "code": "TS",
        "name": "Tsonga",
        "nativeName": "Xitsonga"
    },
    "tt": {
        "code": "TT",
        "name": "Tatar",
        "nativeName": "татарча, tatarça, تاتارچا‎"
    },
    "tw": {
        "code": "TW",
        "name": "Twi",
        "nativeName": "Twi"
    },
    "ty": {
        "code": "TY",
        "name": "Tahitian",
        "nativeName": "Reo Tahiti"
    },
    "ug": {
        "code": "UG",
        "name": "Uighur, Uyghur",
        "nativeName": "Uyƣurqə, ئۇيغۇرچە‎"
    },
    "uk": {
        "code": "UK",
        "name": "Ukrainian",
        "nativeName": "українська"
    },
    "ur": {
        "code": "UR",
        "name": "Urdu",
        "nativeName": "اردو"
    },
    "uz": {
        "code": "UZ",
        "name": "Uzbek",
        "nativeName": "zbek, Ўзбек, أۇزبېك‎"
    },
    "ve": {
        "code": "VE",
        "name": "Venda",
        "nativeName": "Tshivenḓa"
    },
    "vi": {
        "code": "VI",
        "name": "Vietnamese",
        "nativeName": "Tiếng Việt"
    },
    "vo": {
        "code": "VO",
        "name": "Volapük",
        "nativeName": "Volapük"
    },
    "wa": {
        "code": "WA",
        "name": "Walloon",
        "nativeName": "Walon"
    },
    "cy": {
        "code": "CY",
        "name": "Welsh",
        "nativeName": "Cymraeg"
    },
    "wo": {
        "code": "WO",
        "name": "Wolof",
        "nativeName": "Wollof"
    },
    "fy": {
        "code": "FY",
        "name": "Western Frisian",
        "nativeName": "Frysk"
    },
    "xh": {
        "code": "XH",
        "name": "Xhosa",
        "nativeName": "isiXhosa"
    },
    "yi": {
        "code": "YI",
        "name": "Yiddish",
        "nativeName": "ייִדיש"
    },
    "yo": {
        "code": "YO",
        "name": "Yoruba",
        "nativeName": "Yorùbá"
    },
    "za": {
        "code": "ZA",
        "name": "Zhuang, Chuang",
        "nativeName": "Saɯ cueŋƅ, Saw cuengh"
    }
});

/***/ }),

/***/ "eG35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon pencil-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "edcc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon plus-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "efj3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DeleteIcon",
  props: {
    title: {
      type: String,
      default: "Delete icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "el3G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ercg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LibraryGrid',
  props: {
    baseStyle: Object
  },
  data: function data() {
    return {
      styles: {
        base: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          display: 'flex',
          flexFlow: 'column nowrap',
          width: '100%',
          background: '#f5f5f5',
          minHeight: '100vh',
          padding: '0',
          position: 'relative',
          paddingTop: '60px'
        }, this.baseStyle),
        navList: {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          display: 'flex',
          flexFlow: 'row nowrap',
          listStyle: 'none',
          padding: '0 0 5px 0',
          margin: 0,
          borderBottom: '1px solid #ddd'
        },
        content: {
          display: 'flex',
          flexFlow: 'row wrap',
          width: '100%',
          padding: '10px'
        },
        navListItem: {
          margin: '5'
        }
      }
    };
  }
});

/***/ }),

/***/ "eua4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RuleGroup__ = __webpack_require__("D8EQ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'policyForm',
  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_2_vue_select___default.a,
    RuleGroup: __WEBPACK_IMPORTED_MODULE_6__RuleGroup__["a" /* default */]
  },
  computed: {
    getSelectedSequence: function getSelectedSequence() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getSelectedSequence;
    },
    getActiveTitle: function getActiveTitle() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActivePolicy.title;
    }
  },
  methods: {
    getActiveRules: function getActiveRules() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActivePolicy.rules;
    },
    getActivePolicy: function getActivePolicy() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActivePolicy;
    },
    parsePolicy: function parsePolicy() {
      var policy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActivePolicy);
      // need to clean...
      var cleanedRules = policy.rules.map(function (r) {
        // r[n].interactionType
        var rule = {};
        rule.groupRules = r.groupRules.map(function (n) {
          // n.interationType
          var id = n.interactionType._id;
          var update = n;
          update.interactionType = id;
          update.operator = n.operator || '';
          update.property = n.property ? n.property._id : '';
          update.comparand = n.comparand || '';
          return update;
        });

        return rule;
      });

      policy.rules = cleanedRules;

      if (policy.sequence._id) {
        policy.sequence = policy.sequence._id;
      }

      return policy;
    },
    toggleTitleValidation: function toggleTitleValidation() {
      if (this.showTitleValidation) {
        this.showTitleValidation = false;
      }
    },
    validateForm: function validateForm() {
      if (!this.getActivePolicy() || !this.getActivePolicy().title.length || this.getActivePolicy().rules.length || !this.getActivePolicy().sequence.length) {
        if (!this.getActivePolicy().title.length) {
          this.showTitleValidation = true;
        }
        if (!this.getActivePolicy().rules.length) {
          this.showRuleValidation = true;
        }

        if (!this.getActivePolicy().sequence) {
          this.showSequenceValidation = true;
        }

        return false;
      } else {
        this.showTitleValidation = false;
        this.showRuleValidation = false;
        this.showSequenceValidation = false;
        return true;
      }
    },
    submitForm: function submitForm() {
      var _this = this;

      var validForm = this.validateForm();

      if (!this.showTitleValidation && !this.showRuleValidation && !this.showSequenceValidation) {
        var policy = this.parsePolicy();
        if (!this.id) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_Utils_js__["c" /* postResource */])('/v1/policies/create', false, policy).then(function (res) {
            _this.showSuccessMsg({ message: 'Policy created!' });
            return res;
          }).then(function (res) {
            setTimeout(function () {
              _this.$router.push('/policies/');
            }, 600);
          }).catch(function (error) {
            _this.showErrorMsg({
              message: 'An error occurred. Please try again.'
            });
          });
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_Utils_js__["c" /* postResource */])('/v1/policies/update', false, policy).then(function (res) {
            _this.showSuccessMsg({ message: 'Policy updated!' });
          }).catch(function (error) {
            _this.showErrorMsg({
              message: 'An error occurred. Please try again.'
            });
          });
        }
      }
    },
    updatePolicyTitle: function updatePolicyTitle() {
      var activePolicy = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActivePolicy;
      activePolicy.title = this.title;
      if (this.title.length) {
        this.showTitleValidation = false;
      }
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActivePolicy', activePolicy);
    },
    setActiveOption: function setActiveOption(val) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActivePolicyOption', val);
    },
    addNewRuleGroup: function addNewRuleGroup() {
      var activePolicy = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActivePolicy;
      if (!activePolicy.rules) {
        activePolicy.rules = [];
      }
      activePolicy.rules.push({
        ruleGroupId: '',
        groupRules: []
      });
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActivePolicy', activePolicy);
    },
    removeRuleGroup: function removeRuleGroup(index) {
      var activePolicy = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActivePolicy;
      activePolicy.rules.splice(index, 1);
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActivePolicy', activePolicy);
    },
    toggleAddSequenceModal: function toggleAddSequenceModal() {
      console.log('adding sequence to policy');
      this.showSequenceValidation = false;
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('showAddSequenceToPolicyModal', true);
    }
  },
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data: function data() {
    return {
      id: this.$route.params.shortId,
      title: '',
      saveText: 'Save',
      showTitleValidation: false,
      showSequenceValidation: false,
      showRuleValidation: false,
      styles: {
        cardWrap: {
          background: '#fff',
          display: 'flex',
          padding: '10px',
          flexFlow: 'row nowrap',
          justifyContent: 'space-between',
          width: 'calc(33.33% - 20px)',
          // margin: '10px',
          ':hover': {
            border: '1px solid #888',
            cursor: 'pointer'
          }
        },
        cardContainer: {
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        validation: function validation(show) {
          return {
            transition: 'all 0.2s',
            opacity: show ? '1' : '0'
          };
        },
        cardPreview: {
          background: 'teal',
          position: 'relative',
          padding: '20px'
        },
        cardName: {
          color: '#aaa',
          fontSize: '0.9em',
          marginBottom: '0'
        }
      }
    };
  },
  created: function created() {
    if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getSequences.length) {
      __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].getSequences();
    }
    if (this.id) {
      this.title = this.getActiveTitle;
    }
  }
});

/***/ }),

/***/ "f0CP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f5s3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateLocalRecord',
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */],
        Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
    },
    data: function data() {
        return {
            newLocale: '',
            isCopying: false,
            copiedLocale: ''
        };
    },

    computed: {
        getActiveCard: function getActiveCard() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveCard;
        },
        getSortedAvailableLocales: function getSortedAvailableLocales() {
            if (this.getActiveCard && this.getActiveCard.localRecords) {
                var locales = [];

                this.getActiveCard.localRecords.forEach(function (locale) {
                    // lol?
                    locales.push(locale.locale);
                });

                return locales.sort(function (a, b) {
                    return a.name - b.name;
                }).reverse();
            }
        },
        getAvailableMarkets: function getAvailableMarkets() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets;
        },
        getMarketsByLocale: function getMarketsByLocale() {
            if (this.getAvailableMarkets) {
                var marketsByLocale = [];

                this.getAvailableMarkets.forEach(function (market) {
                    marketsByLocale.push(market.locale);
                });

                return marketsByLocale;
            }
        }
    },
    notifications: {
        showSuccessMsg: {
            type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.success,
            title: '',
            icon: '✅'
        },
        showErrorMsg: {
            type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.error,
            title: '',
            icon: '❗️'
        }
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].getMarkets();
    },

    methods: {
        submit: function submit() {
            var _this = this;

            var newRecord = {
                recordId: this.getActiveCard._id,
                recordType: 'ActionCard',
                locale: this.newLocale
            };

            if (this.isCopying) {
                newRecord.copiedLocale = this.copiedLocale;
            }

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_Utils_js__["c" /* postResource */])('/v1/actioncards/addLocalRecord', false, newRecord).then(function (res) {
                console.log('success!', res);
                _this.showSuccessMsg({ message: 'New ' + _this.newLocale + ' record added to ' + _this.getActiveCard.displayName + '!' });
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('hideModals', true);
                __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].setActiveCard(_this.getActiveCard._id, _this.locale, _this.$router.push('/cards/' + _this.getActiveCard._id));
                return res;
            }).catch(function (error) {
                var message = 'An error occurred. Please try again.';
                if (error.error) {
                    message = error.error;
                }
                _this.showErrorMsg({
                    message: message
                });
            });
        }
    }
});

/***/ }),

/***/ "fI8+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('nav',{staticClass:"nav"},[_c('div'),_c('div'),_c('button',{staticClass:"button__action",attrs:{"to":"/products/create"},on:{"click":_vm.toggleCreateMarketModal}},[_vm._v("Create New Market")])]),_c('LibraryGrid',[_c('div',{staticClass:"view-explanation"},[_c('h1',[_vm._v("Markets")]),_c('p',[_vm._v("Markets are comprised of two parts: a country and a language. Creating new markets will allow you to create new local records for Action Cards, Media, Products, and Product Groups.")])]),(!_vm.getMarkets.length)?_c('button',{staticClass:"box",on:{"click":_vm.toggleCreateMarketModal}},[_vm._v("Create a New Market")]):_vm._e(),_c('div',{staticClass:"market-list"},_vm._l((_vm.getMarkets),function(market){return (_vm.getMarkets.length)?_c('div',{key:("" + (market._id)),staticClass:"market",attrs:{"to":("/markets/" + (market._id))}},[_c('div',{staticClass:"market-information"},[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":_vm.getFlagUrl(market)}})]),_c('div',{staticClass:"market-details"},[_c('h3',[_vm._v(_vm._s(market.title))]),_c('div',{staticClass:"market-minor"},[_c('p',[_c('strong',[_vm._v("Locale")]),_vm._v(_vm._s(market.locale))]),_c('p',[_c('strong',[_vm._v("Country:")]),_vm._v(_vm._s(market.country))]),_c('p',[_c('strong',[_vm._v("Language:")]),_vm._v(_vm._s(market.primaryLanguage))])])])]),_c('div',{staticClass:"buttons"},[_c('router-link',{staticClass:"button__action",attrs:{"to":("/markets/" + (market._id))}},[_vm._v("Edit")])],1)]):_vm._e()}))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fMvi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CreateMediaLibrary',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
  },
  computed: {
    getMarkets: function getMarkets() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets;
    }
  },
  data: function data() {
    return {
      title: '',
      market: '',
      showError: false
    };
  },

  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      if (!this.title || !this.market) {
        this.showError = true;
        return false;
      }
      var newMediaLibrary = {};

      newMediaLibrary.title = this.title;
      newMediaLibrary.markets = this.market._id;

      newMediaLibrary.fallbackLocale = this.market.locale;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__services_Utils__["c" /* postResource */])('/v1/medialibraries/create', false, newMediaLibrary).then(function (res) {
        console.log('success!', res);
        _this.showSuccessMsg({
          message: _this.title + ' media library created!'
        });
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('hideModals', true);
        _this.$router.push('/media-libraries/' + res.mediaLibrary._id);
        return res;
      }).catch(function (error) {
        var message = 'An error occurred. Please try again.';
        if (error.message) {
          message = error.message;
        }
        _this.showErrorMsg({
          message: message
        });
      });
    }
  }
});

/***/ }),

/***/ "fToH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ffEG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","fill":"#000000","viewBox":"0 0 24 24","width":"24"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fpno":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_local_storage__ = __webpack_require__("+Y1O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__general_Spinner__ = __webpack_require__("dSGv");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'resetPassword',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_4__general_Spinner__["a" /* default */]
  },
  data: function data() {
    var _input;

    return {
      emailSent: false,
      formSubmitted: false,
      validToken: false,
      email: '',
      pswd1: '',
      pswd2: '',
      token: this.$route.params.tokenId,
      styles: {
        container: {
          display: 'flex',
          flexDirection: 'column',
          background: '#f5f5f5',
          height: '100vh',
          boxShadow: '0 0 40px 10px rgba(0,0,0,0.2)',
          width: '60vw',
          flexWrap: 'nowrap',
          alignItems: 'center',
          justifyContent: 'center'
        },
        spinner: {
          position: 'relative',
          marginTop: '40px'
        },
        form: {
          padding: '1rem'
        },
        inputWrap: {
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        inputLabel: {
          color: '#888',
          fontSize: '0.8em',
          fontWeight: 700,
          textTransform: 'uppercase',
          margin: '10px 0 10px'
        },
        input: (_input = {
          margin: 'auto',
          padding: '15px'
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_input, 'margin', '0 0 10px'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_input, 'outline', 'none'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_input, 'boxShadow', 'none'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_input, 'borderRadius', '4px'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_input, 'border', '1px solid #aaa'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_input, 'width', '400px'), _input),
        button: {
          marginTop: '10px'
        },
        submitMessage: {
          maxWidth: '600px',
          textAlign: 'center',
          lineHeight: '1.5',
          color: '#555'
        }
      }
    };
  },

  methods: {
    submitNewPassword: function submitNewPassword() {
      var _this = this;

      if (this.pswd1 !== this.pswd2) {
        return alert('Passwords do not match. Please try again');
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_Utils__["c" /* postResource */])('/v1/auth/reset/2', '', {
        tokenId: this.token,
        value: this.pswd1
      }).then(function (res) {
        if (res.status === 'success') {
          __WEBPACK_IMPORTED_MODULE_3_local_storage___default.a.set('GEG__KEY', res.token);
          _this.$router.push({ name: 'dashboard' });
        }
      }).catch(function (err) {
        console.log(err);
        _this.$router.push({ name: 'resetPassword' });
      });
    },
    submitReset: function submitReset() {
      var _this2 = this;

      if (!this.email || !this.email.length) return alert('Please enter a valid email and try again.');

      this.formSubmitted = true;

      var domain = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getDomain;
      var tenantId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getTenant._id;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_Utils__["c" /* postResource */])('/v1/auth/reset/1', '', {
        email: this.email,
        domain: domain,
        tenantId: tenantId
      }).then(function (res) {
        console.log(res);
        _this2.emailSent = true;
      }).catch(function (err) {
        return console.log(err);
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "g/M8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PolicyNew_vue__ = __webpack_require__("ip05");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d37e0eec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PolicyNew_vue__ = __webpack_require__("J8d8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PolicyNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d37e0eec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PolicyNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g4q4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CopyVolumeLinks',
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */],
        Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
    },
    data: function data() {
        return {
            isCopying: false,
            copiedLocale: ''
        };
    },

    computed: {
        getActiveCard: function getActiveCard() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveCard;
        },
        getActiveMarket: function getActiveMarket() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveMarket;
        },
        getActiveLocale: function getActiveLocale() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveMarket.locale;
        },
        getAvailableMarkets: function getAvailableMarkets() {
            var markets = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets;

            var availableMarkets = [];

            for (var i in markets) {
                var locale = markets[i].locale;
                if (locale !== this.getActiveLocale) {
                    availableMarkets.push(locale);
                }
            }

            return availableMarkets;
        },
        getMarketsByLocale: function getMarketsByLocale() {
            if (this.getAvailableMarkets) {
                var marketsByLocale = [];

                this.getAvailableMarkets.forEach(function (market) {
                    marketsByLocale.push(market.locale);
                });

                return marketsByLocale;
            }
        }
    },
    notifications: {
        showSuccessMsg: {
            type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.success,
            title: '',
            icon: '✅'
        },
        showErrorMsg: {
            type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.error,
            title: '',
            icon: '❗️'
        }
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].getMarkets();
    },

    methods: {
        submit: function submit() {
            var _this = this;

            var update = {
                recordId: this.getActiveMarket._id,
                targetLocale: this.getActiveLocale,
                sourceLocale: this.copiedLocale
            };

            console.log(update);

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_Utils_js__["c" /* postResource */])('/v1/markets/copyVolumeLinks', 'id=' + this.getActiveMarket._id, update).then(function (res) {
                console.log('success!', res);
                _this.showSuccessMsg({ message: 'Content copied from ' + _this.copiedLocale + '!' });
                var marketId = _this.$route.params.marketId;
                __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].setActiveMarket(marketId);
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('hideModals', true);
                return res;
            }).catch(function (error) {
                var message = 'An error occurred. Please try again.';
                if (error.error) {
                    message = error.error;
                }
                _this.showErrorMsg({
                    message: message
                });
            });
        }
    }
});

/***/ }),

/***/ "g9zK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FileInput',{staticClass:"vue-fine-uploader-gallery-file-input-container",attrs:{"uploader":_vm.uploader,"multiple":_vm.multiple}},[_c('span',{staticClass:"vue-fine-uploader-gallery-file-input-content"},[_vm._t("default",[_c('UploadIcon',{staticClass:"vue-fine-uploader-gallery-file-input-upload-icon"}),_vm._v("\n      Select Files\n    ")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gS9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCardHelp_vue__ = __webpack_require__("5n36");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82a5c586_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_EditCardHelp_vue__ = __webpack_require__("isUr");
function injectStyle (ssrContext) {
  __webpack_require__("NddR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-82a5c586"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCardHelp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82a5c586_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_EditCardHelp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gXoZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CreateProduct',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
  },
  computed: {
    getCardTypes: function getCardTypes() {
      if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getCardTypes.length) {
        return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getCardTypes;
      } else {
        __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].getCardTypes();
        return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getCardTypes;
      }
    },
    getMarkets: function getMarkets() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets;
    }
  },
  data: function data() {
    return {
      name: '',
      market: '',
      showError: false
    };
  },

  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      if (!this.name || !this.market) {
        this.showError = true;
        return false;
      }
      var newProduct = {};

      newProduct.name = this.name;
      newProduct.markets = this.market._id;

      newProduct.fallbackLocale = this.market.locale;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__services_Utils__["c" /* postResource */])('/v1/products/create', false, newProduct).then(function (res) {
        console.log('success!', res);
        _this.showSuccessMsg({ message: _this.name + ' product created!' });
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('hideModals', true);
        _this.$router.push('/products/' + res.product._id);
        return res;
      }).catch(function (error) {
        var message = 'An error occurred. Please try again.';
        if (error.message) {
          message = error.message;
        }
        _this.showErrorMsg({
          message: message
        });
      });
    }
  }
});

/***/ }),

/***/ "gZzY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_design_icons_Delete__ = __webpack_require__("02d3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__johmun_vue_tags_input__ = __webpack_require__("vdhV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__johmun_vue_tags_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__johmun_vue_tags_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductEditor',
  components: {
    DeleteIcon: __WEBPACK_IMPORTED_MODULE_4_vue_material_design_icons_Delete__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a,
    VueTagsInput: __WEBPACK_IMPORTED_MODULE_7__johmun_vue_tags_input___default.a
  },
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data: function data() {
    return {
      tag: '',
      tags: [],
      postalValidation: [{
        classes: 'min-length',
        rule: function rule(tag) {
          return tag.text.length < 5;
        }
      }, {
        classes: 'only-numbers',
        rule: '^[0-9]*$'
      }]
    };
  },

  computed: {
    getActiveProduct: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveProduct;
      },
      set: function set(product) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveProduct', product);
      }
    },
    getActiveLocale: function getActiveLocale() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveLocale;
    },

    getActiveLocalRecord: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveLocalRecord;
      },
      set: function set(record) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocalRecord', record);
      }
    },
    getAllProductGroups: function getAllProductGroups() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAllProductGroups;
    },
    getProductGroups: function getProductGroups() {
      if (this.getAllProductGroups) {
        var groups = [];

        this.getAllProductGroups.forEach(function (group) {
          var groupText = group.title;

          groups.push(groupText);
        });

        return groups;
      }
    },
    getMarkets: function getMarkets() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets;
    },

    getSortedAvailableLocales: {
      get: function get() {
        if (this.getActiveProduct && this.getActiveProduct.localRecords) {
          var locales = [];

          this.getActiveProduct.localRecords.forEach(function (locale) {
            locales.push(locale.locale);
          });

          return locales.sort(function (a, b) {
            return a.name - b.name;
          }).reverse();
        }
      },
      set: function set(newLocales) {
        var activeProduct = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getActiveProduct);
        activeProduct.markets = newLocales;
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveProduct', activeProduct);
        if (activeProduct.localRecords && newLocales.length > activeProduct.localRecords.length) {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('showCreateProductLocalRecordModal', true);
        }
      }
    },
    getMarketsByLocale: function getMarketsByLocale() {
      if (this.getMarkets) {
        var marketsByLocale = [];

        this.getMarkets.forEach(function (market) {
          marketsByLocale.push(market.locale);
        });

        return marketsByLocale;
      }
    }
  },
  methods: {
    initializeProduct: function initializeProduct(edited) {
      var _this = this;

      var product = this.getActiveProduct;

      if (!product._id) {
        this.showErrorMsg({ message: 'No matching product found' });
        this.$router.push('/products/');
      }

      // initialize default locale when we have the product record, but don't reset the active locale if we're already editing
      if (!edited) {
        if (product.fallbackLocale) {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocale', product.fallbackLocale);
        } else if (product.localRecords) {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocale', product.localRecords[0].locale);
        }
      }

      var activeContent = product.localRecords && product.localRecords.length === 1 ? product.localRecords[0].content : product.localRecords.filter(function (record) {
        return record.locale === _this.getActiveLocale;
      })[0].content || {};

      if (product.productGroups && !edited) {
        var groups = [];

        product.productGroups.forEach(function (group) {
          var groupName = _this.getAllProductGroups.find(function (product) {
            return product._id === group;
          }).title;

          groups.push(groupName);
        });

        this.getActiveProduct.productGroups = groups;
      }

      if (activeContent) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocalRecord', activeContent);
        this.tags = activeContent.postalCodes;
      } else {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocalRecord', {});
      }
    },
    isNumber: function isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    addImage: function addImage(isPrimary) {
      if (isPrimary) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setIsPrimaryImage', true);
      } else {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setIsPrimaryImage', false);
      }
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('showUploadProductImageModal', true);
    },
    removeImage: function removeImage(index) {
      console.log('remove slice', index);
      var activeContent = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getActiveLocalRecord);
      var currentImages = activeContent.images;

      currentImages.splice(index, 1);
    },
    changeLocale: function changeLocale(locale) {
      console.log(locale);
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocale', locale);
      this.initializeProduct(true);
    },
    toggleAddLocale: function toggleAddLocale() {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('showCreateProductLocalRecordModal', true);
    },
    save: function save() {
      var _this2 = this;

      var update = this.getActiveProduct;
      var contentUpdate = this.getActiveLocalRecord;
      update.content = contentUpdate;

      var productGroupIds = [];
      update.productGroups.forEach(function (group) {
        var groupId = _this2.getAllProductGroups.find(function (product) {
          return product.name === group.name;
        })._id;
        productGroupIds.push(groupId);
      });

      update.productGroups = productGroupIds;

      var postalCodes = [];

      for (var i = 0; i < this.tags.length; i++) {
        var tag = this.tags[i];
        if (tag.tiClasses.indexOf('ti-invalid') === -1) {
          postalCodes.push(tag.text);
        }
      }

      update.content.postalCodes = postalCodes;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__services_Utils__["c" /* postResource */])('/v1/products/update', 'id=' + this.getActiveProduct._id + '&locale=' + encodeURIComponent(this.getActiveLocale), update).then(function (res) {
        console.log(res);
        // return  Services.setActiveProduct(productId, this.initializeProduct(true));
      }).then(function () {
        _this2.showSuccessMsg({
          message: _this2.getActiveLocale + ' product saved!'
        });
      }).catch(function (error) {
        _this2.showSuccessMsg({
          message: _this2.getActiveLocale + ' product saved!'
        });
      });
    },
    promptDelete: function promptDelete() {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('showDeleteProductModal', true);
    },
    restore: function restore() {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('showRestoreProductModal', true);
    }
  },
  mounted: function mounted() {
    var productId = this.$route.params.productId;

    if (!productId) {
      this.showErrorMsg({ message: 'No matching product found' });
      this.$router.push('/products/');
    }

    __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].setActiveProduct(productId, this.initializeProduct);
    if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets.length) {
      __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].getMarkets();
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setIsPrimaryImage', false);
    __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].clearActiveProduct();
    __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].clearActiveRecords();
  }
});

/***/ }),

/***/ "gaLc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v("Create a New Product Group")]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Name")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],attrs:{"type":"text","placeholder":"Name"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),(_vm.getMarkets.length > 1)?_c('div',{staticClass:"form__control-group rule__control-group--select"},[_c('label',[_vm._v("Default Market")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.market),expression:"market"}],staticClass:"form__select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.market=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"disabled","selected":"selected"}},[_vm._v("Select Market")]),_vm._l((_vm.getMarkets),function(market,index){return _c('option',{key:market.name,domProps:{"value":market}},[_vm._v(_vm._s(market.title)+" - "+_vm._s(market.primaryLanguage))])})],2)]):_vm._e(),_c('button',{staticClass:"button__submit",on:{"click":_vm.submit}},[_vm._v("Create")]),(_vm.showError)?_c('p',{staticClass:"validation__error"},[_vm._v("Please enter a Name and Default Market.")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gkF0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.base((!!_vm.getMedia) || (!_vm.getMedia && _vm.mediaLoaded)))},[(!_vm.mediaLoaded)?_c('div',{style:(_vm.styles.loaderBackground)},[_c('Spinner')],1):_vm._e(),_vm._v(" "),_c('div',{style:(_vm.styles.mediaSidebar)},[_c('div',{style:(_vm.styles.nav)},[_c('button',{staticClass:"button",style:(_vm.styles.altNavButton),on:{"click":_vm.goBack}},[_c('ChevronLeftIcon'),_vm._v("  Back to All Media\n      ")],1),_vm._v(" "),_c('span',{style:(_vm.styles.separator)}),_vm._v(" "),_c('button',{key:"saveButton",staticClass:"button",style:(_vm.styles.saveButton(_vm.editsExist())),on:{"click":function($event){_vm.updateMedia(_vm.metadata)}}},[_c('ContentSaveIcon'),_vm._v("\n          \n        "+_vm._s(_vm.saveText)+"\n      ")],1),_vm._v(" "),_c('button',{staticClass:"button",style:(_vm.styles.navButton),on:{"click":function($event){_vm.toggleUpdateThumbModal(true)}}},[_c('ImageAreaIcon'),_vm._v("  \n        Change Thumbnail\n      ")],1),_vm._v(" "),_c('button',{staticClass:"button",style:(_vm.styles.deleteButton(_vm.canDelete)),attrs:{"disabled":!_vm.canDelete},on:{"click":function () { return _vm.canDelete ? _vm.promptDelete(_vm.getMedia._id) : false; }}},[_c('DeleteIcon')],1)]),_vm._v(" "),(_vm.getMedia)?_c('div',{style:(_vm.styles.mediaContainer)},[_c('div',{style:(_vm.styles.mediaThumbnailContainer)},[(_vm.getMedia.createdAt)?_c('div',{style:(_vm.styles.idWrapper)},[_c('p',{style:(_vm.styles.infoTitle)},[_vm._v("Uploaded:")]),_vm._v(" "),_c('span',{style:(_vm.styles.createdStamp)},[_vm._v(_vm._s(_vm.formatDate(_vm.getMedia.createdAt)))])]):_vm._e(),_vm._v(" "),(_vm.getMedia.guid)?_c('div',{style:(_vm.styles.idWrapper)},[_c('p',{style:(_vm.styles.infoTitle)},[_vm._v("ID:")]),_vm._v(" "),_c('span',{style:(_vm.styles.mediaId)},[_vm._v(_vm._s(_vm.getMedia.guid))])]):_vm._e(),_vm._v(" "),(_vm.getMedia.mmId)?_c('div',{style:(_vm.styles.idWrapper)},[_c('p',{style:(_vm.styles.infoTitle)},[_vm._v("MediaMobz ID:")]),_vm._v(" "),_c('span',{style:(_vm.styles.mediaId)},[_vm._v(_vm._s(_vm.getMedia.mmId))])]):_vm._e(),_vm._v(" "),(_vm.getMedia.contentType)?_c('div',{style:(_vm.styles.idWrapper)},[_c('p',{style:(_vm.styles.infoTitle)},[_vm._v("Content Type:")]),_vm._v(" "),_c('span',{style:(_vm.styles.p)},[_vm._v(_vm._s(_vm.getMedia.contentType))])]):_vm._e(),_vm._v(" "),(_vm.getMedia.source)?_c('div',[_c('p',{style:(_vm.styles.urlInformation)},[_vm._v("Original URL:")]),_vm._v(" "),_c('input',{style:(_vm.styles.urlInput),domProps:{"value":_vm.getMedia.source}})]):_vm._e(),_vm._v(" "),(_vm.getMedia.thumbnail)?_c('div',[_c('p',{style:(_vm.styles.urlInformation)},[_vm._v("Thumbnail URL:")]),_vm._v(" "),_c('input',{style:(_vm.styles.urlInput),domProps:{"value":_vm.getMedia.thumbnail}})]):_vm._e()]),_vm._v(" "),_c('div',{style:(_vm.styles.metadataContainer)},[_c('section',{style:(_vm.styles.metadataSection)},[_c('h4',{style:(_vm.styles.metedataTitle)},[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],key:"title-input-1",ref:"title",style:(_vm.styles.metadataInput),domProps:{"value":(_vm.title)},on:{"keyup":function (e) { return _vm.checkEdits('title', e.target.value); },"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}})]),_vm._v(" "),_c('section',{style:(_vm.styles.metadataSection)},[_c('h4',{style:(_vm.styles.metedataTitle)},[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],key:"description-input-1",ref:"description",style:(_vm.styles.metadataInput),attrs:{"placeholder":(!_vm.metadata.description) ? '(no description)' : false,"resize":"auto","minHeight":"200"},domProps:{"value":(_vm.description)},on:{"keyup":function (e) { return _vm.checkEdits('description', e.target.value); },"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})]),_vm._v(" "),_c('section',{style:(_vm.styles.metadataSection)},[_c('h4',{style:(_vm.styles.metedataTitle)},[_vm._v("Keywords")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.keywords),expression:"keywords"}],key:"keywords-input-1",ref:"keywords",style:(_vm.styles.metadataInput),attrs:{"placeholder":(!_vm.keywords) ? '(no keywords)' : false,"resize":"auto","minHeight":"200"},domProps:{"value":(_vm.keywords)},on:{"keyup":function (e) { return _vm.checkEdits('keywords', e.target.value); },"input":function($event){if($event.target.composing){ return; }_vm.keywords=$event.target.value}}})]),_vm._v(" "),_c('section',{style:(_vm.styles.metadataSection)},[_c('h4',{style:(_vm.styles.metedataTitle)},[_vm._v("Product Groups")]),_vm._v(" "),_c('div',{style:(_vm.styles.checkBoxGroup)},_vm._l((_vm.getAllProductGroups),function(group,index){return (_vm.getAllProductGroups.length)?_c('label',{key:group.name,style:(_vm.styles.checkBoxes)},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.productGroups),expression:"productGroups"}],style:(_vm.styles.checkBox),attrs:{"type":"checkbox"},domProps:{"value":group._id,"checked":Array.isArray(_vm.productGroups)?_vm._i(_vm.productGroups,group._id)>-1:(_vm.productGroups)},on:{"change":[function($event){var $$a=_vm.productGroups,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=group._id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.productGroups=$$a.concat([$$v]))}else{$$i>-1&&(_vm.productGroups=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.productGroups=$$c}},function($event){_vm.checkBoxes('productGroups')}]}}),_vm._v("\n              "+_vm._s(group.title)+"\n            ")]):_vm._e()}))]),_vm._v(" "),_c('section',{style:(_vm.styles.metadataSection)},[_c('h4',{style:(_vm.styles.metedataTitle)},[_vm._v("Media Libraries")]),_vm._v(" "),_c('div',{style:(_vm.styles.checkBoxGroup)},_vm._l((_vm.getAllMediaLibraries),function(library,index){return (_vm.getAllMediaLibraries.length)?_c('label',{key:library.name,style:(_vm.styles.checkBoxes)},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mediaLibraries),expression:"mediaLibraries"}],style:(_vm.styles.checkBox),attrs:{"type":"checkbox"},domProps:{"value":library._id,"checked":Array.isArray(_vm.mediaLibraries)?_vm._i(_vm.mediaLibraries,library._id)>-1:(_vm.mediaLibraries)},on:{"change":[function($event){var $$a=_vm.mediaLibraries,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=library._id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.mediaLibraries=$$a.concat([$$v]))}else{$$i>-1&&(_vm.mediaLibraries=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.mediaLibraries=$$c}},function($event){_vm.checkBoxes('mediaLibraries')}]}}),_vm._v("\n              "+_vm._s(library.title)+"\n            ")]):_vm._e()}))])]),_vm._v(" "),(_vm.getMedia.markets && _vm.getMedia.markets.length)?_c('div',{style:(_vm.styles.marketsContainer)},[_c('section',{style:(_vm.styles.metadataSection)},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.featured),expression:"featured"}],style:(_vm.styles.checkBox),attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.featured)?_vm._i(_vm.featured,null)>-1:(_vm.featured)},on:{"change":[function($event){var $$a=_vm.featured,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.featured=$$a.concat([$$v]))}else{$$i>-1&&(_vm.featured=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.featured=$$c}},function (e) { return _vm.checkEdits('featured', e.target.value); }]}}),_vm._v(" Featured\n          ")])]),_vm._v(" "),_c('p',{style:(_vm.styles.urlInformation)},[_vm._v("Available In:")]),_vm._v(" "),_vm._l((_vm.getMedia.markets),function(market){return _c('p',{style:(_vm.styles.marketRef)},[_c('img',{style:(_vm.styles.flagStyles),attrs:{"src":_vm.getFlagUrl(market)}}),_vm._v("\n          "+_vm._s(market.title)+"\n          "),_c('i',{staticClass:"glyphicon glyphicon-remove",style:(_vm.styles.removeMarket),on:{"click":function($event){_vm.removeMediaFromMarket(market._id, _vm.getMedia._id)}}})])}),_vm._v(" "),(!_vm.showAddMarket && _vm.listOtherMarkets.length)?_c('button',{style:(_vm.styles.addMarketButton),on:{"click":_vm.toggleShowAddMarket}},[_vm._v("Add To Market")]):_vm._e(),_vm._v(" "),(_vm.showAddMarket && _vm.listOtherMarkets.length)?_c('select',{ref:"selectedMarket",style:(_vm.styles.marketSelector),on:{"change":_vm.addMediaToMarket}},[_c('option',{attrs:{"disabled":"","selected":""}},[_vm._v("Select market to add...")]),_vm._v(" "),_vm._l((_vm.listOtherMarkets),function(market){return _c('option',{domProps:{"value":market._id}},[_vm._v(_vm._s(market.title))])})],2):_vm._e(),_vm._v(" "),(_vm.showAddMarket)?_c('button',{style:(_vm.styles.addMarketButton),on:{"click":_vm.toggleShowAddMarket}},[_vm._v("Done")]):_vm._e()],2):_vm._e()]):_vm._e(),_vm._v(" "),_c('img',{style:(_vm.styles.mediaThumbnail),attrs:{"src":_vm.getMediaThumbnail}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "goc0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProductLocalRecord_vue__ = __webpack_require__("aoQK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1017184_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProductLocalRecord_vue__ = __webpack_require__("RtVH");
function injectStyle (ssrContext) {
  __webpack_require__("EOVc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c1017184"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProductLocalRecord_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1017184_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProductLocalRecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gv+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_filename_vue__ = __webpack_require__("NQth");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0b482b62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_filename_vue__ = __webpack_require__("lwlE");
function injectStyle (ssrContext) {
  __webpack_require__("/t0J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_filename_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0b482b62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_filename_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h1k8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__upload_icon__ = __webpack_require__("BAag");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    UploadIcon: __WEBPACK_IMPORTED_MODULE_0__upload_icon__["a" /* default */]
  },
  props: {
    content: {
      type: String
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    className: function className() {
      return this.disabled ? 'vue-fine-uploader-gallery-nodrop-content' : 'vue-fine-uploader-gallery-dropzone-content';
    }
  }
});

/***/ }),

/***/ "hCFp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaLibraryEditor_vue__ = __webpack_require__("RqMe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d725a4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MediaLibraryEditor_vue__ = __webpack_require__("lXxD");
function injectStyle (ssrContext) {
  __webpack_require__("INAC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8d725a4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaLibraryEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d725a4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MediaLibraryEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hQ+V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general_LibraryGrid__ = __webpack_require__("0gt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_design_icons_Close__ = __webpack_require__("wbZU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("olkN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddCardToSequenceModal',
  components: {
    LibraryGrid: __WEBPACK_IMPORTED_MODULE_1__general_LibraryGrid__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
  },
  computed: {
    checkCardsLoaded: function checkCardsLoaded() {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.checkCardsReady;
    },
    getCards: function getCards() {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getCards;
    }
  },
  methods: {
    addCardToCurrentSequence: function addCardToCurrentSequence(card) {
      var sequenceCards = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getSequenceCards;
      sequenceCards.push(card);
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setSequenceCards', sequenceCards);
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setSequenceStatus', true);
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('hideModals', true);
    },
    openNewCardModal: function openNewCardModal() {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('showCreateCardModal', true);
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].getCards();
  },
  data: function data() {
    return {
      hideModal: __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].hideModals,
      cardsLoaded: false,
      styles: {
        mediaGrid: function mediaGrid(confirmationScreen) {
          return {
            display: confirmationScreen ? 'none' : 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap'
          };
        },
        modal: {
          background: '#fff',
          width: '90vw',
          height: '90vh',
          maxHeight: '90vh',
          margin: '0 auto',
          padding: '2rem',
          overflowY: 'scroll',
          overflowX: 'hidden',
          position: 'relative'
        },
        mediaContainer: {
          margin: 'auto',
          width: '100%',
          maxWidth: '500px'
        },
        confirmationBase: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center'
        },
        buttonContainer: {
          display: 'flex',
          margin: 'auto',
          flexDirection: 'row',
          flexWrap: 'no-wrap',
          width: '235px'
        },
        confirmationButtons: {
          display: 'block',
          width: '49%'
        },
        modalHeader: {
          boxSizing: 'border-box',
          marginBottom: '1.5rem',
          paddingBottom: '0.5rem',
          borderBottom: '1px solid #444',
          display: 'flex',
          justifyContent: 'space-between',
          marginLeft: '10px',
          marginRight: '30px'
        },
        removeButton: {
          background: '#eb4d4b',
          fontSize: '0.9em',
          color: '#fff',
          borderRadius: '5px',
          padding: '5px',
          margin: 'auto 0 auto 10px',
          border: '0',
          ':hover': {
            opacity: '0.9'
          }
        },
        cancelButton: {
          background: '#888'
        },
        modalTitle: {
          color: '#444',
          fontSize: '1.5rem'
        },
        modalGridContainer: {
          overflow: 'scroll'
        },
        closeIcon: {
          position: 'fixed',
          top: '10px',
          right: '10px',
          fontSize: '2em',
          color: '#ddd',
          cursor: 'pointer'
        },
        yesButton: {
          background: '#6ab04c'
        },
        goBackLink: {
          color: 'rgb(9, 163, 237)',
          cursor: 'pointer',
          marginTop: '2rem',
          ':hover': {
            opacity: '0.9'
          }
        },
        backIcon: {
          position: 'relative',
          top: '7px'
        },
        cardWrap: {
          background: '#fff',
          display: 'flex',
          border: '1px solid #eee',
          padding: '10px',
          flexFlow: 'row nowrap',
          width: 'calc(33.33% - 20px)',
          margin: '10px',
          ':hover': {
            border: '1px solid #888',
            cursor: 'pointer'
          }
        },
        cardContainer: {
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        cardPreview: {
          background: 'teal',
          position: 'relative',
          padding: '20px'
        },
        cardName: {
          color: '#aaa',
          fontSize: '0.9em',
          marginBottom: '0'
        },
        cardMetadataSection: {
          display: 'flex',
          flexFlow: 'column nowrap',
          padding: '40px',
          width: '100%'
        },
        cardType: {
          margin: '20px auto 10px 20px',
          color: '#888'
        }
      }
    };
  }
});

/***/ }),

/***/ "hZML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Utils__ = __webpack_require__("8u3o");
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'DeleteRecordModal',
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
    },
    computed: {
        recordPath: function recordPath() {
            if (this.$route.name === 'policyTemplate') {
                return 'policies';
            }

            if (this.$route.name === 'sequenceTemplate') {
                return 'sequences';
            }

            if (this.$route.name === 'cardTemplate') {
                return 'actioncards';
            }
        },
        redirectTo: function redirectTo() {
            if (this.$route.name === 'policyTemplate') {
                return '/policies';
            }

            if (this.$route.name === 'sequenceTemplate') {
                return '/sequences';
            }

            if (this.$route.name === 'cardTemplate') {
                return '/cards';
            }
        }
    },
    methods: {
        deleteRecord: function deleteRecord() {
            var _this = this;

            // determine record type
            var update = {
                deleted: true,
                _id: this.$route.params.shortId
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__services_Utils__["c" /* postResource */])('/v1/' + this.recordPath + '/delete', false, update).then(function (res) {
                console.log(res);
                _this.$router.push(_this.redirectTo);
            }).catch(function (err) {
                console.log(err);
            });

            // send delete to delete endpoint with record Id and record type

            // close modal and redirect
        },
        closeModal: function closeModal() {
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('hideModals', true);
        }
    }
});

/***/ }),

/***/ "hgBb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.uploader)?_c('Modal',[_c('Gallery',{attrs:{"uploader":_vm.uploader}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ho1B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hrEl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_material_design_icons_Close__ = __webpack_require__("wbZU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general_LibraryGrid__ = __webpack_require__("0gt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general_MediaCard__ = __webpack_require__("lVNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("olkN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal',
  components: {
    CloseIcon: __WEBPACK_IMPORTED_MODULE_0_vue_material_design_icons_Close__["a" /* default */],
    MediaCard: __WEBPACK_IMPORTED_MODULE_2__general_MediaCard__["a" /* default */],
    LibraryGrid: __WEBPACK_IMPORTED_MODULE_1__general_LibraryGrid__["a" /* default */]
  },
  methods: {
    closeModal: function closeModal() {
      console.log('close this modal');
      this.showModal = false;
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('hideModals', true);
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.showModal = true;
    }, 300);
  },
  data: function data() {
    return {
      showModal: false,
      styles: {
        base: function base(showModal) {
          return {
            position: 'fixed',
            zIndex: '99999',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            background: 'rgba(0,0,0,0.75)',
            width: '100vw',
            height: '100vh',
            display: 'flex',
            flexFlow: 'column nowrap',
            justifyContent: 'center',
            transition: 'all 0.2s',
            opacity: showModal ? '1' : '0',
            pointerEvents: showModal ? 'auto' : 'none'
          };
        },
        modal: {
          background: '#fff',
          width: '50vw',
          height: 'auto',
          margin: '0 auto',
          borderRadius: '2px',
          overflowY: 'scroll',
          minHeight: '20vh',
          position: 'relative'
        },
        closeIcon: {
          position: 'fixed',
          top: '20px',
          right: '20px',
          fontSize: '2em',
          color: '#eee',
          cursor: 'pointer'
        }
      }
    };
  }
});

/***/ }),

/***/ "i2+6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v("Upload New Product Image")]),_c('div',{staticClass:"fuck"},[(_vm.newImage)?_c('img',{attrs:{"src":_vm.newImage}}):_vm._e()]),(!_vm.image)?_c('div',{staticClass:"no-image"},[_c('form',{ref:"form"},[_c('input',{attrs:{"name":"imageContainer","type":"file","accept":"image/*"},on:{"change":_vm.onFileChange}})])]):_c('div',{staticClass:"image__editor"},[_c('div',{staticClass:"image__container"},[_c('img',{attrs:{"src":_vm.image}})]),_c('div',{staticClass:"button__container"},[_c('button',{staticClass:"button__submit",on:{"click":_vm.uploadImage}},[_vm._v("Upload")]),_c('button',{staticClass:"button__action",on:{"click":_vm.removeImage}},[_vm._v("Change Image")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ibfx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "idea":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_loader_lib_template_compiler_index_id_data_v_5072f612_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_pause_icon_vue__ = __webpack_require__("wGu6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__vue_loader_lib_template_compiler_index_id_data_v_5072f612_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_pause_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ip05":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_PolicyForm__ = __webpack_require__("Togc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Services__ = __webpack_require__("bdTy");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'policyNew',
  components: {
    policyForm: __WEBPACK_IMPORTED_MODULE_0__general_PolicyForm__["a" /* default */]
  },
  methods: {
    returnToPolicies: function returnToPolicies() {
      this.$router.push('/policies');
    }
  },
  data: function data() {
    return {
      blankPolicy: {
        title: '',
        rules: [],
        sequence: {}
      },
      styles: {
        container: {
          padding: '2rem'
        },
        pageHeader: {
          display: 'flex',
          padding: '0 1rem',
          width: '100%',
          position: 'relative'
        },
        pageHead: {
          fontSize: '1.5em',
          maxWidth: '600px',
          margin: '20px auto',
          fontWeight: '700',
          color: '#aaa'
        }
      }
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].setInteractionTypes();
    __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].setActivePolicy(this.blankPolicy);
    __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].clearSelectedSequence();
  }
});

/***/ }),

/***/ "isUr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v("Edit Action Card's Help Text")]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Help Text")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.helpText),expression:"helpText"}],attrs:{"placeholder":"Help Text","type":"text"},domProps:{"value":(_vm.helpText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.helpText=$event.target.value}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Help URL")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.helpUrl),expression:"helpUrl"}],attrs:{"placeholder":"https://","type":"text"},domProps:{"value":(_vm.helpUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.helpUrl=$event.target.value}}})]),_c('div',{staticClass:"form__control-group"},[_c('button',{staticClass:"button__submit",on:{"click":_vm.storeHelp}},[_vm._v("Submit")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jDUJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__general_Spinner__ = __webpack_require__("dSGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_fineuploader_gallery__ = __webpack_require__("CU9l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fine_uploader_wrappers_s3__ = __webpack_require__("Zvkh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fine_uploader_wrappers_s3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_fine_uploader_wrappers_s3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_Services_js__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__("olkN");




var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










function refreshActiveMediaList() {
  var market = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getActiveMarket;
  var tab = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getActiveMediaTab;
  if (!market || !market._id) return;
  if (tab && tab._id === 'featured') {
    __WEBPACK_IMPORTED_MODULE_9__services_Services_js__["a" /* default */].getMediaByMarket(market._id, 'featured', false, false, false);
  } else if (tab && tab.type === 'mediaLibrary') {
    __WEBPACK_IMPORTED_MODULE_9__services_Services_js__["a" /* default */].getMediaByMarket(market._id, tab._id, false, false, false);
  } else if (tab && tab.type === 'productGroup') {
    __WEBPACK_IMPORTED_MODULE_9__services_Services_js__["a" /* default */].getMediaByMarket(market._id, false, tab._id, false, false);
  } else if (tab && tab._id === 'none') {
    __WEBPACK_IMPORTED_MODULE_9__services_Services_js__["a" /* default */].getMediaByMarket(market._id, 'none', false, false, false);
  } else {
    __WEBPACK_IMPORTED_MODULE_9__services_Services_js__["a" /* default */].getMediaByMarket(market._id);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MediaUploadModal',
  components: {
    Gallery: __WEBPACK_IMPORTED_MODULE_6_vue_fineuploader_gallery__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_3__general_Modal__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_4__general_Spinner__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      loadedUploader: false,
      uploader: null
    };
  },

  methods: {
    setupUploader: function setupUploader() {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
          var res, fineUploader;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__services_Utils_js__["c" /* postResource */])('/v1/media/sign');

                case 3:
                  res = _context.sent;
                  fineUploader = new __WEBPACK_IMPORTED_MODULE_7_fine_uploader_wrappers_s3___default.a({
                    options: {
                      request: {
                        endpoint: 'https://uploads-mediamobz-com.s3.amazonaws.com',
                        accessKey: 'AKIAICDZPSI6TDKJZCWA',
                        version: 4
                      },
                      signature: {
                        endpoint: 'https://glxstudio.com/api/pub/upload?expire=' + res.stamp + '&sig=' + encodeURIComponent(res.sig) + '&id=' + encodeURIComponent(res.id)
                      },
                      callbacks: {
                        onComplete: function onComplete(id, name, response, xhr) {
                          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__services_Utils_js__["c" /* postResource */])('/v1/media/upload?expire=' + res.stamp + '&sig=' + encodeURIComponent(res.sig) + '&id=' + encodeURIComponent(res.id), false, {
                            'media-key': fineUploader.methods.getKey(id),
                            name: name,
                            market: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getActiveMarket._id,
                            tab: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getActiveMediaTab
                          }).then(function (res2) {
                            if (res2.status === 'success') {
                              __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('setMediaLoadedStatus', false);
                              refreshActiveMediaList();
                              return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('showMediaUploadModal', false);
                            } else {
                              return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('showMediaUploadModal', false);
                            }
                          }).catch(function (err) {
                            return console.log(err);
                          });
                        }
                      }
                    }
                  });
                  return _context.abrupt('return', resolve(fineUploader));

                case 8:
                  _context.prev = 8;
                  _context.t0 = _context['catch'](0);
                  return _context.abrupt('return', reject(_context.t0));

                case 11:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this, [[0, 8]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.setupUploader().then(function (uploader) {
      _this2.uploader = uploader;
    }).catch(function (error) {
      return console.log(error);
    });
  }
});

/***/ }),

/***/ "jXvP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_design_icons_Pencil__ = __webpack_require__("Da9Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_Delete__ = __webpack_require__("02d3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_History__ = __webpack_require__("O/aY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material_design_icons_PlusCircle__ = __webpack_require__("5sGG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_Close__ = __webpack_require__("wbZU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__general_Spinner__ = __webpack_require__("dSGv");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sequenceTemplate',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a,
    PencilIcon: __WEBPACK_IMPORTED_MODULE_5_vue_material_design_icons_Pencil__["a" /* default */],
    DeleteIcon: __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_Delete__["a" /* default */],
    HistoryIcon: __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_History__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_13__general_Spinner__["a" /* default */],
    CloseIcon: __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_Close__["a" /* default */],
    PlusCircleIcon: __WEBPACK_IMPORTED_MODULE_8_vue_material_design_icons_PlusCircle__["a" /* default */]
  },
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  props: {
    newSequence: Boolean
  },
  computed: {
    getActiveSequence: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveSequence;
      },
      set: function set(sequence) {
        __WEBPACK_IMPORTED_MODULE_10__services_Services__["a" /* default */].setActiveSequence(sequence);
      }
    },
    getSequenceStatus: function getSequenceStatus() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getSequenceStatus;
    },

    getCards: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getSequenceCards;
      },
      set: function set(value) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setSequenceCards', value);
      }
    }
  },
  methods: {
    goBack: function goBack() {
      __WEBPACK_IMPORTED_MODULE_10__services_Services__["a" /* default */].clearActiveSequence();
      this.$router.push('/sequences');
    },
    deleteSequence: function deleteSequence() {
      var _this = this;

      if (this.getActiveSequence.deleted) {
        var update = {
          deleted: false,
          _id: this.$route.params.shortId
        };

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_Utils_js__["c" /* postResource */])('/v1/sequences/delete', false, update).then(function (res) {
          _this.getActiveSequence.deleted = false;
          _this.showSuccessMsg({
            message: _this.getActiveSequence.name + ' Sequence has been restored!'
          });
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('showDeleteRecordModal', true);
      }
    },
    toggleAddCardToSequenceModal: function toggleAddCardToSequenceModal() {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('showAddCardToSequenceModal', true);
    },
    createNewSequence: function createNewSequence() {
      var _this2 = this;

      this.$v.$touch();
      if (this.$v.$invalid || !this.getCards.length) {
        if (!this.getCards.length) {
          this.showCardValidation = true;
        }
      } else {
        var sequence = {};

        // need to add in validation
        // if(!this.title.length || !store.getters.getSequenceCards.length) {
        //   if(!this.title) {

        //   }

        //   return false;
        // }

        sequence.name = this.name;
        var newCards = this.getCards;

        var newCardArray = [];

        newCards.forEach(function (card) {
          if (card.ParameterizedTitles) {
            newCardArray.push(card.ParameterizedTitles.PartitionKey._);
          } else if (card.TrainingMedia) {
            newCardArray.push(card.TrainingMedia.PartitionKey._);
          }
        });

        sequence.templates = newCardArray;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_Utils_js__["c" /* postResource */])('/v1/sequences/create', false, sequence).then(function (res) {
          console.log('success!');
          _this2.showSuccessMsg({ message: 'Sequence created!' });
          return res;
        }).then(function (res) {
          console.log('our res', res);
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_10__services_Services__["a" /* default */].setActiveSequence(res.newSequence);
            _this2.$router.push('/sequences/' + res.newSequence._id);
          }, 600);
        }).catch(function (error) {
          _this2.showErrorMsg({
            message: 'An error occurred. Please try again.'
          });
        });
      }
    },
    goToCard: function goToCard(card) {
      var path = '';
      if (card.TrainingMedia) {
        path = card.TrainingMedia.PartitionKey._;
      } else if (card.ParameterizedTriggerScript) {
        path = card.ParameterizedTriggerScript.PartitionKey._;
      } else if (card.ParameterizedTitles) {
        path = card.ParameterizedTitles.PartitionKey._;
      }
      this.$router.push('/cards/' + card._id);
    },
    removeCardFromSequence: function removeCardFromSequence(index) {
      var sequenceCards = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.getCards));

      sequenceCards.splice(index, 1);
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setSequenceCards', sequenceCards);
      // Services.checkSequenceChanges();
    },
    saveChanges: function saveChanges() {
      var _this3 = this;

      this.name = this.getActiveSequence.name;
      this.$v.$touch();

      if (this.$v.$invalid || !this.getCards.length) {
        if (!this.getCards.length) {
          this.showCardValidation = true;
        }
      } else {
        var sequence = this.getActiveSequence || {};

        sequence.name = this.name;

        var allSequenceCards = this.getCards;

        // legacy array with partition keys to support app
        var templatesArray = [];
        var actionCardIdArray = [];

        for (var i in allSequenceCards) {
          var card = allSequenceCards[i];
          templatesArray.push(card.legacyName);
          actionCardIdArray.push(card._id);
        }

        sequence.templates = templatesArray;
        sequence.actionCards = actionCardIdArray;

        if (this.newSequence) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_Utils_js__["c" /* postResource */])('/v1/sequences/create', false, sequence).then(function (res) {
            console.log('success!');
            _this3.showSuccessMsg({ message: 'Sequence created!' });
            return res;
          }).then(function (res) {
            console.log('our res', res);
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_10__services_Services__["a" /* default */].setActiveSequence(res.newSequence);
              _this3.$router.push('/sequences/' + res.newSequence._id);
            }, 600);
          }).catch(function (error) {
            _this3.showErrorMsg({
              message: 'An error occurred. Please try again.'
            });
          });
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_Utils_js__["c" /* postResource */])('/v1/sequences/update', 'sequenceId=' + this.getActiveSequence._id, sequence).then(function (res) {
            console.log(res);
            _this3.showSuccessMsg({ message: 'Sequence saved!' });
            return res;
          }).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_10__services_Services__["a" /* default */].setActiveSequence(_this3.$route.params.shortId);
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setSequenceStatus', false);
          }).catch(function (error) {
            _this3.showErrorMsg({
              message: 'An error occurred. Please try again.'
            });
          });
        }
      }
    },
    fetchSubscriptions: function fetchSubscriptions() {
      var _this4 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_Utils_js__["a" /* getResource */])('/v1/subscriptions/list').then(function (res) {
        _this4.subscriptions = res.subscriptions;
      }).catch(function (err) {
        console.log(err);
      });
    },
    fetchHistory: function fetchHistory() {
      var _this5 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_Utils_js__["a" /* getResource */])('/v1/history/single/', 'recordType=Sequence&recordId=' + this.getActiveSequence._id).then(function (res) {
        if (res.record) {
          _this5.history = res.record.history;
          _this5.toggleHistoryPopup();
        } else {
          _this5.noHistory = true;
          _this5.toggleHistoryPopup();
        }
      }).catch(function (err) {
        return console.log('err');
      });
    },
    toggleHistoryPopup: function toggleHistoryPopup() {
      this.showHistory = !this.showHistory;
    },

    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).fromNow();
    }
  },
  mounted: function mounted() {
    this.fetchSubscriptions();
    if (!this.newSequence) {
      // set active sequence
      __WEBPACK_IMPORTED_MODULE_10__services_Services__["a" /* default */].setActiveSequence(this.$route.params.shortId);
    }

    // Services.checkSequenceChanges();
  },

  validations: {
    name: {
      required: __WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__["required"]
    }
  },
  created: function created() {
    this.$v.$reset();
  },
  data: function data() {
    return {
      subscriptions: [],
      showCardValidation: false,
      checkSequenceChanges: __WEBPACK_IMPORTED_MODULE_10__services_Services__["a" /* default */].checkSequenceChanges,
      showHistory: false,
      noHistory: false,
      history: {},
      name: '',
      saveText: 'Save',
      styles: {
        container: {
          padding: '2rem'
        },
        historyIcon: {
          display: 'flex',
          alignItems: 'center',
          margin: 'auto 10px',
          cursor: 'pointer',
          color: '#888'
        },
        topBar: {
          boxShadow: '0 0 8px 0 rgba(0,0,0,.1)',
          position: 'relative',
          zIndex: '99',
          boxSizng: 'border-box',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '10px',
          width: '100%'
        },
        showHistoryContainer: {
          position: 'fixed',
          top: '60px',
          background: '#fff',
          overflowY: 'scroll',
          left: '220px',
          height: '300px',
          width: '350px',
          padding: '0',
          boxShadow: '0 2px 4px 1px rgba(0,0,0,0.2)',
          zIndex: '9999'
        },
        closeHistory: {
          position: 'absolute',
          left: '350px',
          top: '10px',
          cursor: 'pointer'
        },
        noHistory: {
          textAlign: 'center',
          padding: '20px'
        },
        historyList: {
          padding: '0',
          margin: '0',
          listStyle: 'none'
        },
        historyListItem: {
          borderBottom: '1px solid #ddd',
          padding: '10px'
        },
        wrapper: function wrapper(loaded) {
          return {
            display: 'flex',
            flexFlow: 'row wrap',
            justifyContent: 'flex-start',
            padding: '0 10px',
            alignItems: 'flex-start',
            marginTop: '-10px',
            marginBottom: '1.5rem',
            width: '100%'
          };
        },
        pageHeader: {
          display: 'flex',
          padding: '0 10px',
          width: '100%',
          position: 'relative'
        },
        pageHead: {
          fontSize: '1.5em',
          maxWidth: '600px',
          margin: '20px auto',
          fontWeight: '700',
          color: '#aaa'
        },
        nav: {
          position: 'fixed',
          top: '0',
          left: '200px',
          right: '0',
          background: '#fff',
          boxShadow: '0 2px 5px 1px rgba(0,0,0,0.1)',
          height: '60px',
          zIndex: '99',
          padding: '10px',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        navInputWrapper: {
          flex: '0 0 auto',
          width: '250px',
          padding: '10px',
          background: '#f5f5f5',
          border: '1px solid #eee',
          borderRadius: '5px',
          overflow: 'hidden',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        navInput: {
          flex: '1',
          padding: '0',
          borderRadius: '0',
          border: '0',
          background: '#f5f5f5'
        },
        navInputIcon: {
          margin: 'auto 10px auto 0',
          color: '#888',
          fontSize: '1.25em'
        },
        toggleUploadModalButton: {
          background: '#09a3ed',
          fontSize: '0.9em',
          color: '#fff',
          borderRadius: '5px',
          padding: '5px 10px 5px 5px',
          margin: 'auto 0 auto auto',
          border: '0',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          ':hover': {
            cursor: 'pointer',
            opacity: '0.9'
          }
        },
        cardWrap: {
          background: '#fff',
          display: 'flex',
          border: '1px solid #eee',
          padding: '15px 10px 10px',
          flexFlow: 'row nowrap',
          width: 'calc(33.33% - 20px)',
          margin: '10px',
          '@media screen and (max-width: 1050px)': {
            width: '50%'
          },
          ':hover': {
            border: '1px solid #888',
            cursor: 'move'
          }
        },
        addCardWrap: {
          ':hover': {
            cursor: 'pointer'
          }
        },
        policyCardWrap: {
          ':hover': {
            border: '1px solid #eee',
            cursor: 'default'
          }
        },
        cardContainer: {
          display: 'flex',
          flexFlow: 'column nowrap'
          // cursor: 'move'
        },
        cardPreview: {
          background: 'teal',
          position: 'relative',
          padding: '20px'
        },
        cardName: {
          color: '#aaa',
          fontSize: '0.9em',
          marginBottom: '0px'
        },
        cardMetadataSection: {
          display: 'flex',
          flexFlow: 'column nowrap',
          padding: '40px',
          width: '100%'
        },
        cardType: {
          margin: '20px auto 10px 20px',
          color: '#888'
        },
        iconContainer: {
          margin: 'auto 5px auto auto',
          color: '#aaa',
          fontSize: '1.6rem',
          display: 'flex'
        },
        actionType: {
          margin: '0 auto 20px 20px',
          fontSize: '1.5em'
        },
        actionIcon: {
          cursor: 'pointer',
          fontSize: '1.6rem',
          ':hover': {
            color: '#777'
          }
        },
        tabWrap: {
          width: '100%',
          minHeight: '200px',
          margin: '0',
          display: 'flex',
          background: '#e8ffff',
          flexFlow: 'column nowrap'
        },
        tabList: {
          listStyle: 'none',
          display: 'flex',
          flexFlow: 'row nowrap',
          margin: '0',
          padding: '0'
        },
        tab: {
          flex: '1',
          padding: '10px',
          borderBottom: '5px solid #fff',
          textAlign: 'center'
        },
        indexContainer: {
          height: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '30px'
        },
        indexNumber: {
          background: '#CCC',
          color: '#777',
          borderRadius: '50%',
          padding: '0.5rem 0',
          width: '30px',
          height: '30px',
          textAlign: 'center'
        },
        editsWrapper: function editsWrapper(display) {
          return {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'no-wrap',
            position: 'absolute',
            right: '1rem',
            top: '2rem',
            transition: 'all 0.3s',
            opacity: display ? '1' : '0',
            transform: display ? 'translateY(0)' : 'translateY(20px)'
          };
        },
        editsHint: function editsHint(display) {
          return {
            color: '#AAA',
            fontSize: '1.6rem',
            position: 'relative',
            opacity: display ? '1' : '0',
            transition: 'all 0.2s',
            top: '5px'
          };
        },
        saveButton: {
          background: '#6ab04c',
          fontSize: '1.2rem',
          color: '#fff',
          borderRadius: '5px',
          padding: '5px 15px',
          margin: '-33px auto 10px',
          outline: '0',
          border: '0',
          width: '100px',
          ':hover': {
            opacity: '0.9'
          }
        },
        undoButton: {
          background: '#CCC',
          color: '#777',
          width: 'auto'
        },
        spinner: {
          bottom: 0,
          left: 0,
          margin: 'auto',
          position: 'absolute',
          right: 0,
          width: 65,
          height: 65,
          top: 0
        }
      }
    };
  }
});

/***/ }),

/***/ "jYxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardIconUpload_vue__ = __webpack_require__("kPMM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0742d0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CardIconUpload_vue__ = __webpack_require__("Jnnu");
function injectStyle (ssrContext) {
  __webpack_require__("qH1K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c0742d0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardIconUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0742d0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CardIconUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jbzV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_not_available_placeholder_vue__ = __webpack_require__("6VL3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_dfda5186_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_not_available_placeholder_vue__ = __webpack_require__("xFc/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_not_available_placeholder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_dfda5186_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_not_available_placeholder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "js80":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'DeleteProductModal',
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
    },
    notifications: {
        showSuccessMsg: {
            type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.success,
            title: '',
            icon: '✅'
        },
        showErrorMsg: {
            type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.error,
            title: '',
            icon: '❗️'
        }
    },
    methods: {
        remove: function remove() {
            var _this = this;

            var productId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveProduct._id;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_Utils_js__["c" /* postResource */])('/v1/products/delete?id=' + productId, false).then(function (res) {
                _this.showSuccessMsg({
                    message: 'Product successfully deleted.'
                });
                console.log('success!', res);
                _this.$router.push('/products/');
                return res;
            }).catch(function (error) {
                var message = 'An error occurred. Please try again.';
                if (error.error) {
                    message = error.error;
                }
                _this.showErrorMsg({
                    message: message
                });
            });
        },
        cancel: function cancel() {
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('hideModals', true);
        }
    }
});

/***/ }),

/***/ "kPMM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_notifications__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductImageUpload',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__general_Modal__["a" /* default */]
  },
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  computed: {
    getActiveCard: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getActiveCard;
      },
      set: function set(card) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setActiveCard', card);
      }
    }
  },
  data: function data() {
    return {
      image: '',
      imageFile: '',
      newImage: ''
    };
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setIsPrimaryImage', false);
  },

  methods: {
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;
      this.imageFile = files[0];

      this.createImage(files[0]);
    },
    createImage: function createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = function (e) {
        vm.image = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    base64MimeType: function base64MimeType(encoded) {
      var result = null;

      if (typeof encoded !== 'string') {
        return result;
      }

      var mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

      if (mime && mime.length) {
        result = mime[1];
      }

      return result;
    },
    uploadImage: function uploadImage() {
      var _this = this;

      var imageData = {};
      imageData.image = this.image;
      var imageJSON = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(imageData);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_Utils__["b" /* postImage */])('/v1/actioncards/images/add', 'cardId=' + this.getActiveCard._id, this.image).then(function (res) {
        // get image url back
        _this.showSuccessMsg({
          message: 'Icon uploaded successfully.'
        });
        var activeLocalRecord = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getActiveLocalRecord);
        var cardContext = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCardIconContext;

        if (!activeLocalRecord.trigger) {
          activeLocalRecord.trigger = {};
        }

        if (cardContext === 'trigger') {
          activeLocalRecord.trigger.imageUrl = res.imageUrl;
        } else if (typeof cardContext === 'string') {
          activeLocalRecord[cardContext] = res.imageUrl;
          activeLocalRecord.trigger.imageUrl = res.imageUrl;
        } else {
          activeLocalRecord.socialLinks[cardContext].icon = res.imageUrl;
        }

        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setActiveLocalRecord', activeLocalRecord);
        return res;
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setCardIconContext', null);
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('hideModals', true);
      }).catch(function (error) {
        var message = 'An error occurred. Please try again.';
        if (typeof error.error === 'string' || error.error instanceof String) {
          message = error.error;
        } else if (error.message) {
          message = error.message;
        }
        return _this.showErrorMsg({
          message: message
        });
      });
    },
    removeImage: function removeImage(e) {
      this.image = '';
    }
  }
});

/***/ }),

/***/ "kWqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SequenceTemplate_vue__ = __webpack_require__("jXvP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cdc5547_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SequenceTemplate_vue__ = __webpack_require__("svs1");
function injectStyle (ssrContext) {
  __webpack_require__("S9FO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cdc5547"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SequenceTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cdc5547_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SequenceTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kbPx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('nav',{staticClass:"nav"},[_c('router-link',{staticClass:"button__action",attrs:{"to":"/products/","active-class":"null"}},[_c('i',{staticClass:"glyphicon glyphicon-chevron-left icon"}),_vm._v("Go back")]),_c('div',{staticClass:"submit__container"},[_c('div',{staticClass:"locales"},[(_vm.getActiveProduct.localRecords.length > 1)?_c('span',[_vm._v("Switching locales will clear unsaved changes.")]):_vm._e(),_vm._l((_vm.getSortedAvailableLocales),function(localRecord){return _c('button',{staticClass:"button",attrs:{"disabled":localRecord=== _vm.getActiveLocale,"value":"localRecord"},on:{"click":function($event){_vm.changeLocale(localRecord)}}},[_vm._v(_vm._s(localRecord))])})],2),_c('button',{staticClass:"button__submit",attrs:{"type":"button"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")]),_c('button',{staticClass:"button__action",on:{"click":_vm.toggleAddLocale}},[_vm._v("Add Locale")]),(_vm.getActiveProduct.active)?_c('button',{staticClass:"button delete-icon-button",on:{"click":function($event){_vm.promptDelete()}}},[_c('DeleteIcon')],1):_vm._e(),(!_vm.getActiveProduct.active)?_c('div',[_c('button',{staticClass:"button__submit",on:{"click":function($event){_vm.restore()}}},[_vm._v("Restore product")])]):_vm._e()])],1),_c('div',{staticClass:"editing__container"},[_c('div',{staticClass:"image__container"},[_vm._m(0),_c('div',{staticClass:"primary__image"},[_c('label',[_vm._v("Primary Image")]),_c('div',{staticClass:"image__wrapper"},[(_vm.getActiveLocalRecord.images && _vm.getActiveLocalRecord.images.length)?_c('img',{staticClass:"image___primary",attrs:{"src":_vm.getActiveLocalRecord.images[0]}}):_vm._e(),(!_vm.getActiveLocalRecord.images || !_vm.getActiveLocalRecord.images.length)?_c('img',{staticClass:"image___primary",attrs:{"src":"/static/images/product-placeholder.png"},on:{"click":_vm.addImage}}):_vm._e(),(_vm.getActiveLocalRecord.images && _vm.getActiveLocalRecord.images.length)?_c('div',{staticClass:"image__editor"},[_c('button',{staticClass:"button__action",on:{"click":function($event){_vm.removeImage(0)}}},[_vm._v("Remove")])]):_vm._e()])]),_c('div',{staticClass:"image-add"},[_c('button',{staticClass:"button__action",on:{"click":function($event){_vm.addImage(true)}}},[_vm._v("Change Primary Image")])])]),_c('div',{staticClass:"content__container"},[_c('h1',[_vm._v(" ")]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Name")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.name),expression:"getActiveLocalRecord.name"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveLocalRecord.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord, "name", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Short Description")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.shortDescription),expression:"getActiveLocalRecord.shortDescription"}],staticClass:"input__text",attrs:{"type":"text","rows":"5"},domProps:{"value":(_vm.getActiveLocalRecord.shortDescription)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord, "shortDescription", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Long Description")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.longDescription),expression:"getActiveLocalRecord.longDescription"}],staticClass:"input__text",attrs:{"type":"text","rows":"7"},domProps:{"value":(_vm.getActiveLocalRecord.longDescription)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord, "longDescription", $event.target.value)}}})])]),_c('div',{staticClass:"meta__container"},[_c('h1',[_vm._v(" ")]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Price")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.price),expression:"getActiveLocalRecord.price"}],staticClass:"input__text",attrs:{"type":"number"},domProps:{"value":(_vm.getActiveLocalRecord.price)},on:{"keypress":function($event){_vm.isNumber()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord, "price", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Retail Price")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.retailPrice),expression:"getActiveLocalRecord.retailPrice"}],staticClass:"input__text",attrs:{"type":"number"},domProps:{"value":(_vm.getActiveLocalRecord.retailPrice)},on:{"keypress":function($event){_vm.isNumber()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord, "retailPrice", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("SKU")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.sku),expression:"getActiveLocalRecord.sku"}],staticClass:"input__text",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveLocalRecord.sku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord, "sku", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Quantity")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.quantity),expression:"getActiveLocalRecord.quantity"}],staticClass:"input__text",attrs:{"type":"number"},domProps:{"value":(_vm.getActiveLocalRecord.quantity)},on:{"keypress":function($event){_vm.isNumber()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord, "quantity", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Product Groups")]),_c('multiselect',{attrs:{"options":_vm.getProductGroups,"placeholder":"Add a Product Group","multiple":true},model:{value:(_vm.getActiveProduct.productGroups),callback:function ($$v) {_vm.$set(_vm.getActiveProduct, "productGroups", $$v)},expression:"getActiveProduct.productGroups"}})],1),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Markets")]),_c('multiselect',{attrs:{"options":_vm.getMarketsByLocale,"placeholder":"Add a Market","multiple":true},model:{value:(_vm.getSortedAvailableLocales),callback:function ($$v) {_vm.getSortedAvailableLocales=$$v},expression:"getSortedAvailableLocales"}})],1),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Postal Codes")]),_c('vue-tags-input',{attrs:{"tags":_vm.tags,"placeholder":"Add Postal Code","validation":_vm.postalValidation,"disableAdd":false},on:{"tags-changed":function (newTags) { return _vm.tags = newTags; }},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})],1)])]),(_vm.getActiveLocalRecord.images && _vm.getActiveLocalRecord.images.length > 0)?_c('div',{staticClass:"image__gallery"},[_c('label',[_vm._v("Additional product images")]),_c('button',{staticClass:"button__action",on:{"click":function($event){_vm.addImage(false)}}},[_vm._v("Add More Images")]),_c('div',{staticClass:"image__grid"},_vm._l((_vm.getActiveLocalRecord.images),function(image,index){return (index > 0)?_c('div',{key:("productImage-" + index),staticClass:"image__wrapper"},[_c('div',{staticClass:"image__editor"},[_c('button',{staticClass:"button__action",on:{"click":function($event){_vm.removeImage(index)}}},[_vm._v("Remove")])]),_c('img',{attrs:{"src":image}})]):_vm._e()}))]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h1',[_vm._v("Edit Product")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kv+F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageRole_vue__ = __webpack_require__("9P+G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_753216d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ManageRole_vue__ = __webpack_require__("dJYX");
function injectStyle (ssrContext) {
  __webpack_require__("sy9Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-753216d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageRole_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_753216d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ManageRole_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kvsw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("61q0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b81b55b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("MoYv");
function injectStyle (ssrContext) {
  __webpack_require__("a7Z+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b81b55b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b81b55b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lCJy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileInputComponent_vue__ = __webpack_require__("pG8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6180ebba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FileInputComponent_vue__ = __webpack_require__("g9zK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileInputComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6180ebba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FileInputComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lPia":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'onboardUser',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "lVNX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaCard_vue__ = __webpack_require__("nBR5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a47cfa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MediaCard_vue__ = __webpack_require__("C+7Q");
function injectStyle (ssrContext) {
  __webpack_require__("XU5O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18a47cfa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a47cfa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MediaCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lXxD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('nav',{staticClass:"nav"},[_c('router-link',{staticClass:"button__action",attrs:{"to":"/media-libraries/","active-class":"null"}},[_c('i',{staticClass:"glyphicon glyphicon-chevron-left icon"}),_vm._v("Go back")]),_c('div',{staticClass:"submit__container"},[_c('div',{staticClass:"locales"},[(_vm.getActiveMediaLibrary.localRecords && _vm.getActiveMediaLibrary.localRecords.length > 1)?_c('span',[_vm._v("Switching locales will clear unsaved changes.")]):_vm._e(),_vm._l((_vm.getSortedAvailableLocales),function(localRecord){return _c('button',{staticClass:"button",attrs:{"disabled":localRecord=== _vm.getActiveLocale,"value":"localRecord"},on:{"click":function($event){_vm.changeLocale(localRecord)}}},[_vm._v(_vm._s(localRecord))])})],2),_c('button',{staticClass:"button__submit",attrs:{"type":"button"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")]),_c('button',{staticClass:"button__action",on:{"click":_vm.toggleAddLocale}},[_vm._v("Add Locale")])])],1),_c('div',{staticClass:"editing__container"},[_c('div',{staticClass:"content__container"},[_c('h1',[_vm._v("Edit Media Library")]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Name")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveLocalRecord.title),expression:"getActiveLocalRecord.title"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveLocalRecord.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveLocalRecord, "title", $event.target.value)}}})])]),_c('div',{staticClass:"meta__container"},[_c('h1',[_vm._v(" ")]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Markets")]),_c('multiselect',{attrs:{"options":_vm.getMarketsByLocale,"placeholder":"Add a Market","multiple":true},model:{value:(_vm.getSortedAvailableLocales),callback:function ($$v) {_vm.getSortedAvailableLocales=$$v},expression:"getSortedAvailableLocales"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ll+q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "loD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.wrapper)},[(_vm.loaded)?_c('LibraryGrid',{attrs:{"fullWidth":"fullWidth"}},[_c('div',{staticClass:"view-explanation"},[_c('h1',[_vm._v("Users")]),_c('p',[_vm._v("Manage app user subscriptions. Search by email and assign subscriptions to users.")])]),_c('div',{staticClass:"users-toolbar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"users-search",attrs:{"type":"text","placeholder":"Search by email..."},domProps:{"value":(_vm.searchQuery)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value},_vm.debouncedSearch]}}),_c('button',{staticClass:"button__action",attrs:{"disabled":_vm.loading},on:{"click":_vm.loadUsers}},[_vm._v("Refresh")]),(_vm.pagination.total > 0)?_c('span',{staticClass:"total-count"},[_vm._v(_vm._s(_vm.pagination.total)+" total users")]):_vm._e()]),_c('div',{staticClass:"users-table-container"},[(_vm.users.length > 0)?_c('table',{staticClass:"users-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Email")]),_c('th',[_vm._v("Person ID")]),_c('th',[_vm._v("Created")]),_c('th',[_vm._v("Current Subscription")]),_c('th',[_vm._v("Assign Subscription")])])]),_c('tbody',_vm._l((_vm.users),function(user){return _c('tr',{key:user._id},[_c('td',[_vm._v(_vm._s(user.email))]),_c('td',{staticClass:"person-id"},[_vm._v(_vm._s(user.personId || user.businessId || '—'))]),_c('td',[_vm._v(_vm._s(_vm.formatDate(user.createdAt)))]),_c('td',[(_vm.userSubscriptions[user.personId || user.businessId])?_c('span',{staticClass:"subscription-badge"},[_vm._v(_vm._s(_vm.userSubscriptions[user.personId || user.businessId].name))]):(_vm.subscriptionLoadErrors[user.personId || user.businessId])?_c('span',{staticClass:"no-subscription"},[_vm._v("Error loading")]):_c('span',{staticClass:"no-subscription"},[_vm._v("Loading...")])]),_c('td',{staticClass:"assign-cell"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSubscriptions[user._id]),expression:"selectedSubscriptions[user._id]"}],staticClass:"subscription-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedSubscriptions, user._id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":"disabled"}},[_vm._v("Select...")]),_vm._l((_vm.subscriptions),function(sub){return _c('option',{key:sub._id,domProps:{"value":sub._id}},[_vm._v(_vm._s(sub.name))])})],2),_c('button',{staticClass:"button__action button__small",attrs:{"disabled":!_vm.selectedSubscriptions[user._id] || _vm.assigningUser === user._id},on:{"click":function($event){_vm.assignSubscription(user)}}},[_vm._v(_vm._s(_vm.assigningUser === user._id ? 'Assigning...' : 'Assign'))])])])}))]):(!_vm.loading)?_c('p',{staticClass:"no-results"},[_vm._v("No users found.")]):_vm._e()]),_c('div',{staticClass:"users-pagination"},[_c('button',{staticClass:"button__action button__small",attrs:{"disabled":_vm.pagination.page <= 1 || _vm.loading},on:{"click":function($event){_vm.changePage(_vm.pagination.page - 1)}}},[_vm._v("← Previous")]),_c('span',{staticClass:"page-info"},[_vm._v("Page "+_vm._s(_vm.pagination.page)+" of "+_vm._s(_vm.pagination.pages || 1))]),_c('button',{staticClass:"button__action button__small",attrs:{"disabled":_vm.pagination.page >= _vm.pagination.pages || _vm.loading},on:{"click":function($event){_vm.changePage(_vm.pagination.page + 1)}}},[_vm._v("Next →")])])]):_vm._e(),(!_vm.loaded)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lqgh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_state__ = __webpack_require__("lwq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_local_storage__ = __webpack_require__("+Y1O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_avatar__ = __webpack_require__("Y50r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__package_json__ = __webpack_require__("7YgM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_Services__ = __webpack_require__("bdTy");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'authenticatedSession',
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_5_vue_avatar___default.a
  },
  computed: {
    getIcon: function getIcon() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getTenant.icon;
    },
    getRouteName: function getRouteName() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getRoute.name;
    },
    getActiveMedia: function getActiveMedia() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getActiveMedia;
    },
    getMarkets: function getMarkets() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getMarkets;
    },
    getUser: function getUser() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getUser;
    },
    getUserName: function getUserName() {
      var user = this.getUser;
      var p = user.profile.name;
      var name = p.first + ' ' + p.last;
      return name;
    },
    version: function version() {
      return __WEBPACK_IMPORTED_MODULE_8__package_json___default.a.version;
    }
  },
  methods: {
    toggleColdDeckModal: function toggleColdDeckModal() {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('showColdDeckModal', true);
    },
    goToSettings: function goToSettings() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'settings' });
    },
    toggleLogoutModal: function toggleLogoutModal() {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('showLogoutModal', true);
    },
    navIsActive: function navIsActive(input) {
      var _this = this;

      var paths = Array.isArray(input) ? input : [input];
      if (input == this.$route.path) {
        return true;
      } else if (input !== '/media') {
        return paths.some(function (path) {
          return _this.$route.path.indexOf(path) === 0;
        });
      }
    },
    logout: function logout(message) {
      console.log('cannot log in because ', message);
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('hideModals', true);
      __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.set('GEG__KEY', '');
      this.$router.push('/');
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setUser', {});
      this.showErrorMsg({ message: message ? message : 'You\'ve been logged out.' });
    },
    validateLogin: function validateLogin() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('validating login...');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__services_Utils__["a" /* getResource */])('/v1/auth/check').then(function (res) {
          if (res.status === 'success') {
            var user = res.user;

            if (user.status !== 'active') {
              //   not an active user
              console.log('not active user');
              _this2.logout('User is inactive.');
            }

            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setUser', user);
            // update intercom settings
            window.intercomSettings = {
              app_id: "kkkzq24u",
              name: user.profile.name.first + ' ' + user.profile.name.last,
              email: user.primaryEmail,
              created_at: user.createdAt
            };
            window.Intercom("boot", {
              app_id: "kkkzq24u"
            });
            return resolve();
          }
        }).catch(function (error) {
          _this2.logout(error.error);
          return reject(error);
        });
      });
    }
  },
  data: function data() {
    return {
      loading: false,
      ready: false,
      route: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getRoute.name,
      markets: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getMarkets,
      links: {
        dashboard: {
          title: 'Dashboard',
          icon: 'glyphicon glyphicon-th-large',
          path: '/dashboard'
        },
        cards: {
          title: 'Action Cards',
          icon: 'glyphicon glyphicon-edit',
          path: '/cards',
          disabled: false
        },
        markets: {
          title: 'Markets',
          icon: 'glyphicon glyphicon-globe',
          path: '/markets'
        },
        media: {
          title: 'Media',
          icon: 'glyphicon glyphicon-film',
          path: '/media'
        },
        mediaLibraries: {
          title: 'Media Libraries',
          icon: 'glyphicon glyphicon-blackboard',
          path: '/media-libraries'
        },
        policies: {
          title: 'Policies',
          icon: 'glyphicon glyphicon-bell',
          path: '/policies'
        },
        products: {
          title: 'Products',
          icon: 'glyphicon glyphicon-tags',
          path: '/products',
          disabled: false
        },
        productGroups: {
          title: 'Product Groups',
          icon: 'glyphicon glyphicon-inbox',
          path: '/product-groups',
          disabled: false
        },
        sequences: {
          title: 'Sequences',
          icon: 'glyphicon glyphicon-tasks',
          path: '/sequences',
          disabled: false
        },
        users: {
          title: 'Users',
          icon: 'glyphicon glyphicon-user',
          path: '/users'
        }
      },
      styles: {
        wrap: function wrap(ready) {
          return {
            opacity: ready ? '1' : '0',
            transition: 'opacity 1500ms ease-out'
          };
        },
        wrapper: {
          display: 'flex',
          flexFlow: 'row nowrap'
        },
        logo: {
          width: '60px',
          background: '#fff',
          margin: '10px',
          boxSizing: 'border-box',
          padding: '10px',
          display: 'block',
          borderRadius: '10px',
          border: '1px solid #ddd',
          boxShadow: '0 5px 15px 4px rgba(0,0,0,0.1)',
          height: '60px'
        },
        headerIcons: {
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'flex-start',
          width: '100%',
          justifyContent: 'space-between',
          paddingRight: '10px'
        },
        headerAvatar: {
          marginTop: '10px',
          borderRadius: '10px'
        },
        nav: {
          background: 'linear-gradient()',
          // borderRight: '1px solid #ddd',
          boxSizing: 'border-box',
          height: '100vh',
          position: 'fixed',
          left: '0',
          top: '0',
          bottom: '0',
          padding: '0',
          display: 'flex',
          flexFlow: 'column nowrap',
          width: '200px'
        },
        navItemContainer: {
          display: 'flex',
          flexFlow: 'column nowrap',
          flex: 1
        },
        navItem: {
          display: 'block'
        },
        navTitle: {
          marginLeft: '10px'
        },
        contentWrapper: function contentWrapper(media, isActive, dash) {
          return {
            position: 'fixed',
            left: dash ? 0 : 200,
            right: 0,
            bottom: 0,
            boxShadow: '0 0 40px 10px rgba(0,0,0,0.2)',
            marginRight: 0,
            height: '100vh',
            overflowY: 'auto',
            overflowX: 'hidden',
            width: media ? 'calc(100vw - 200px)' : dash ? '100vw' : 'calc(100vw - 200px)'
          };
        },
        version: {
          fontSize: '0.8em',
          color: '#ccc',
          fontWeight: '400',
          display: 'block',
          padding: '10px 20px 0',
          textAlign: 'right'
        }
      }
    };
  },
  mounted: function mounted() {
    var _this3 = this;

    // check if user is authenticated
    this.validateLogin().then(function () {
      setTimeout(function () {
        _this3.ready = true;
        var user = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getUser;
        // check for state reset, revalidate user
        var resetState = user.prefs.resetState;
        if (resetState) {
          // re-apply state
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__services_Utils__["c" /* postResource */])('/v1/users/reset/state').then(function () {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('resetState', function () {
              // logout user
              __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.set('GEG__KEY', '');
              __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'login' });
            });
          }).catch(function (error) {
            return console.log(error);
          });
        }
        _this3.showSuccessMsg({
          message: 'Welcome back, ' + user.profile.name.first + '!'
        });
      }, 1000);
    }).catch(function (error) {
      return console.log(error);
    });
  },

  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.success,
      title: '',
      icon: '👋'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  }
});

/***/ }),

/***/ "luDF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MaybeDropzone',{attrs:{"hasVisibleFiles":this.state.visibleFiles.length > 0,"uploader":_vm.uploader,"disabled":_vm.dropzoneDisabled,"dropActiveClassName":_vm.dropzoneDropActiveClassName,"multiple":_vm.dropzoneMultiple}},[_c('FileInputComponent',{attrs:{"multiple":_vm.fileInputMultiple,"uploader":_vm.uploader}}),_vm._v(" "),_c('ProgressBar',{staticClass:"vue-fine-uploader-gallery-total-progress-bar",attrs:{"uploader":_vm.uploader}}),_vm._v(" "),_c('ul',{staticClass:"vue-fine-uploader-gallery-files"},_vm._l((_vm.state.visibleFiles),function(ref){
var id = ref.id;
var status = ref.status;
var fromServer = ref.fromServer;
return _c('li',{key:id,staticClass:"vue-fine-uploader-gallery-file"},[_c('ProgressBar',{staticClass:"vue-fine-uploader-gallery-progress-bar",attrs:{"id":id,"uploader":_vm.uploader}}),_vm._v(" "),_c('Thumbnail',{staticClass:"vue-fine-uploader-gallery-thumbnail",attrs:{"id":id,"fromServer":fromServer,"uploader":_vm.uploader,"maxSize":_vm.thumbnailMaxSize}}),_vm._v(" "),(status === 'upload successful')?_c('span',[_c('UploadSuccessIcon',{staticClass:"vue-fine-uploader-gallery-upload-success-icon"}),_vm._v(" "),_c('div',{staticClass:"vue-fine-uploader-gallery-thumbnail-icon-backdrop"})],1):_vm._e(),_vm._v(" "),(status === 'upload failed')?_c('span',[_c('UploadFailedIcon',{staticClass:"vue-fine-uploader-gallery-upload-failed-icon"}),_vm._v(" "),_c('div',{staticClass:"vue-fine-uploader-gallery-thumbnail-icon-backdrop"})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vue-fine-uploader-gallery-file-footer"},[_c('Filename',{staticClass:"vue-fine-uploader-gallery-filename",attrs:{"id":id,"uploader":_vm.uploader}}),_vm._v(" "),_c('Status',{staticClass:"vue-fine-uploader-gallery-status",attrs:{"id":id,"uploader":_vm.uploader}}),_vm._v(" "),_c('Filesize',{staticClass:"vue-fine-uploader-gallery-filesize",attrs:{"id":id,"uploader":_vm.uploader}})],1),_vm._v(" "),_c('CancelButton',{staticClass:"vue-fine-uploader-gallery-cancel-button",attrs:{"id":id,"uploader":_vm.uploader}},[_vm._t("default",[_c('XIcon')])],2),_vm._v(" "),_c('RetryButton',{staticClass:"vue-fine-uploader-gallery-retry-button",attrs:{"id":id,"uploader":_vm.uploader}},[_vm._t("default",[_c('PlayIcon')])],2),_vm._v(" "),(_vm.deleteEnabled)?_c('DeleteButton',{staticClass:"vue-fine-uploader-gallery-delete-button",attrs:{"id":id,"uploader":_vm.uploader}},[_vm._t("default",[_c('XIcon')])],2):_vm._e(),_vm._v(" "),(_vm.chunkingEnabled)?_c('PauseResumeButton',{staticClass:"vue-fine-uploader-gallery-pause-resume-button",attrs:{"id":id,"uploader":_vm.uploader}},[_vm._t("default",[_c('div',{attrs:{"slot":"resume"},slot:"resume"},[_c('PlayIcon')],1),_vm._v(" "),_c('div',{attrs:{"slot":"pause"},slot:"pause"},[_c('PauseIcon')],1)])],2):_vm._e()],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lwlE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vue-fine-uploader-filename"},[_vm._v(_vm._s(this.state.filename))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lwq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Environment settings
   */
  'env': 'dev',
  'status': '',
  'domain': '',
  'tenant': {},
  'user': {},

  /**
  * Global State
  */

  /**
  * Default empty state
  */
  'activeCard': false,
  'activeLocale': null,
  'activeLocalRecord': {},
  'activeLocalRecordSaved': {},
  'activeMarket': {},
  'activeMedia': false,
  'activeMediaLibrary': {},
  'activePolicy': {},
  'activeProduct': {},
  'activeProductGroup': {},
  'activeSequence': {},
  'allMediaLibraries': [],
  'allProductGroups': [],
  'cards': [],
  'cardsLoaded': false,
  'cardTypes': [],
  'cardIconContext': null,
  'charts': {},
  'interactionTypes': [],
  'isEditingPrimaryImage': false,
  'lastPolicyOption': {},
  'markets': [],
  'marketsLoaded': false,
  'media': [],
  'mediaDetails': null,
  'mediaGeneralUses': [],
  'mediaLoaded': false,
  'mediaTabs': [],
  'activeMediaTab': null,
  'originalSequenceCards': [],
  'policies': [],
  'productGroups': [],
  'products': [],
  'selectedCards': [],
  'selectedMedia': [],
  'selectedSequence': null,
  'sequenceCards': [],
  'sequenceLoaded': false,
  'sequences': [],
  'showAddCardToSequenceModal': false,
  'showAddMediaToCardModal': false,
  'showAddSequenceToPolicyModal': false,
  'showCardHelpModal': false,
  'showColdDeckModal': false,
  'showCreateCardModal': false,
  'showCreateLocalRecordModal': false,
  'showCreateMarketModal': false,
  'showCreateProductLocalRecordModal': false,
  'showCreateProductGroupLocalRecordModal': false,
  'showCreateMediaLibraryModal': false,
  'showCreateMediaLibraryLocalRecordModal': false,
  'showCreateProductModal': false,
  'showCreateProductGroupModal': false,
  'showDeprecateMediaModal': false,
  'showLogoutModal': false,
  'showUpdateThumbModal': false,
  'showUploadMediaModal': false,
  'showUploadProductImageModal': false,
  'showCardIconModal': false,
  'showCopyLocalRecordModal': false,
  'showCopyVolumeLinksModal': false,
  'showDeleteProductModal': false,
  'showRestoreProductModal': false,
  'showDeleteRecordModal': false,
  'unsavedSequence': false,

  /**
   * Error messages
   */
  'errors': []
});

/***/ }),

/***/ "m0Pt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m2fk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__general_Spinner__ = __webpack_require__("dSGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_fineuploader_gallery__ = __webpack_require__("CU9l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fine_uploader_wrappers_s3__ = __webpack_require__("Zvkh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fine_uploader_wrappers_s3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_fine_uploader_wrappers_s3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_Services_js__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__("olkN");




var _this = this;

//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UpdateThumbModal',
  components: {
    Gallery: __WEBPACK_IMPORTED_MODULE_6_vue_fineuploader_gallery__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_3__general_Modal__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_4__general_Spinner__["a" /* default */]
  },
  data: function data() {
    return {
      loadedUploader: false,
      uploader: null
    };
  },

  methods: {
    setupUploader: function setupUploader() {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
          var res, fineUploader;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__services_Utils_js__["c" /* postResource */])('/v1/media/sign');

                case 3:
                  res = _context.sent;
                  fineUploader = new __WEBPACK_IMPORTED_MODULE_7_fine_uploader_wrappers_s3___default.a({
                    options: {
                      request: {
                        endpoint: 'https://uploads-mediamobz-com.s3.amazonaws.com',
                        accessKey: 'AKIAICDZPSI6TDKJZCWA',
                        version: 4
                      },
                      signature: {
                        endpoint: 'https://glxstudio.com/api/pub/upload?expire=' + res.stamp + '&sig=' + encodeURIComponent(res.sig) + '&id=' + encodeURIComponent(res.id)
                      },
                      callbacks: {
                        onComplete: function onComplete(id, name, response, xhr) {
                          console.log(id);
                          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__services_Utils_js__["c" /* postResource */])('/v1/media/update?mediaId=' + __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getActiveMedia._id, false, {
                            'thumb-key': fineUploader.methods.getKey(id)
                          }).then(function (res2) {
                            if (res2.status === 'success') {
                              __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('setMediaLoadedStatus', false);
                              __WEBPACK_IMPORTED_MODULE_9__services_Services_js__["a" /* default */].getMediaByMarket(__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getActiveMarket._id);
                              __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('showUpdateThumbModal', false);
                              return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('setActiveMedia', res2.media);
                            } else {
                              console.log(res2);
                              return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('showUpdateThumbModal', false);
                            }
                          }).catch(function (err) {
                            console.log(err);
                            // this.showErrorMsg({
                            //   message: 'An error occurred. Please try again.'
                            // });
                          });
                        }
                      }
                    }
                  });
                  return _context.abrupt('return', resolve(fineUploader));

                case 8:
                  _context.prev = 8;
                  _context.t0 = _context['catch'](0);
                  return _context.abrupt('return', reject(_context.t0));

                case 11:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this, [[0, 8]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.setupUploader().then(function (uploader) {
      _this2.uploader = uploader;
    }).catch(function (error) {
      return console.log(error);
    });
  }
});

/***/ }),

/***/ "mEU1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_LibraryGrid__ = __webpack_require__("0gt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductGroupLibrary',
  components: {
    LibraryGrid: __WEBPACK_IMPORTED_MODULE_0__general_LibraryGrid__["a" /* default */]
  },
  computed: {
    getProductGroups: function getProductGroups() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getAllProductGroups;
    },
    getMarkets: function getMarkets() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getMarkets;
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getProductGroups();
    __WEBPACK_IMPORTED_MODULE_1__services_Services__["a" /* default */].getMarkets();
  },

  methods: {
    toggleCreateProductGroupModal: function toggleCreateProductGroupModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('showCreateProductGroupModal', true);
    }
  }
});

/***/ }),

/***/ "mFHL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('nav',{staticClass:"nav"},[_c('div'),_c('div'),_c('button',{staticClass:"button__action",attrs:{"to":"/products/create"},on:{"click":_vm.toggleCreateMediaLibraryModal}},[_vm._v("Create New Media Library")])]),_c('LibraryGrid',[_c('div',{staticClass:"view-explanation"},[_c('h1',[_vm._v("Media Libraries")])]),(!_vm.getMediaLibraries.length)?_c('button',{staticClass:"box",on:{"click":_vm.toggleCreateMediaLibraryModal}},[_vm._v("Create a New Media Library")]):_vm._e(),_vm._l((_vm.getMediaLibraries),function(mediaLibrary){return (_vm.getMediaLibraries.length)?_c('router-link',{key:("" + (mediaLibrary._id)),staticClass:"product-group__link",attrs:{"zx":"zx","to":("/media-libraries/" + (mediaLibrary._id))}},[_c('div',{staticClass:"product box"},[_c('h3',[_vm._v(_vm._s(mediaLibrary.title))])])]):_vm._e()})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mJol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v(" Copy content from another market")]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Copy Content from...")]),_c('multiselect',{attrs:{"options":_vm.getSortedAvailableLocales,"searchable":false,"selectLabel":'',"allow-empty":false,"deselectLabel":'',"multiple":false},model:{value:(_vm.copiedLocale),callback:function ($$v) {_vm.copiedLocale=$$v},expression:"copiedLocale"}})],1),_c('p',[_c('em',[_vm._v("Warning: this action will completely replace the current local record's published and draft content with the content from the selected market.")])]),_c('button',{staticClass:"button__submit",on:{"click":_vm.submit}},[_vm._v("Copy and replace card content")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mMeq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_delete_button_vue__ = __webpack_require__("w+Gs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_cb70dcee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_delete_button_vue__ = __webpack_require__("ND0a");
function injectStyle (ssrContext) {
  __webpack_require__("69Bm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_delete_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_cb70dcee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_delete_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "mV7m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mdEB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Plus_vue__ = __webpack_require__("aDBo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f8b3a2be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Plus_vue__ = __webpack_require__("edcc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Plus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f8b3a2be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Plus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mgHm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductLibrary_vue__ = __webpack_require__("Bv+7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1376305d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ProductLibrary_vue__ = __webpack_require__("S9iv");
function injectStyle (ssrContext) {
  __webpack_require__("w93M")
  __webpack_require__("x8Rf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1376305d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductLibrary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1376305d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ProductLibrary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n+Xd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_languages__ = __webpack_require__("dlb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_countries_json__ = __webpack_require__("WtOz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CreateMarket',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
  },
  computed: {
    getMarkets: function getMarkets() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets;
    }
  },
  data: function data() {
    return {
      title: '',
      country: '',
      language: '',
      choosePhrase: 'new',
      targetLocale: null,
      allLanguages: __WEBPACK_IMPORTED_MODULE_3__static_languages__["a" /* default */],
      allCountries: __WEBPACK_IMPORTED_MODULE_4__static_countries_json___default.a,
      showError: false
    };
  },

  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      if (!this.title || !this.country || !this.language) {
        this.showError = true;
        return false;
      }
      var newMarket = {};

      var selectedCountry = this.allCountries.filter(function (country) {
        return country.name === _this.country;
      })[0];

      newMarket.title = this.title;
      newMarket.country = selectedCountry.alpha3;
      newMarket.region = selectedCountry.alpha3;
      newMarket.locale = this.language + '-' + selectedCountry.alpha2;
      newMarket.language = this.language;
      newMarket.primaryLanguage = this.language;
      newMarket.region = selectedCountry.alpha3;
      newMarket.storeUrlPrefix = selectedCountry.alpha2;

      if (this.choosePhrase === 'new') {
        newMarket.content = 'new';
      } else {
        newMarket.content = this.targetLocale;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__services_Utils__["c" /* postResource */])('/v1/markets/create', false, newMarket).then(function (res) {
        console.log('success!', res);
        _this.showSuccessMsg({ message: _this.title + ' market created!' });
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('hideModals', true);
        __WEBPACK_IMPORTED_MODULE_5__services_Services__["a" /* default */].getMarkets();
        return res;
      }).catch(function (error) {
        var message = 'An error occurred. Please try again.';
        if (error.message) {
          message = error.message;
        }
        _this.showErrorMsg({
          message: message
        });
      });
    }
  }
});

/***/ }),

/***/ "n50U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_bar_vue__ = __webpack_require__("aPRR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6569db61_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_progress_bar_vue__ = __webpack_require__("EUJE");
function injectStyle (ssrContext) {
  __webpack_require__("KXx3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_bar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6569db61_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_progress_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nBIt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nBR5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Services__ = __webpack_require__("bdTy");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mediaCard',
  props: {
    onClick: Function,
    isActionCard: Boolean,
    isTop: Boolean,
    media: Object,
    viewSpecificStyles: Object,
    cardSpecificStyles: Object,
    _id: String,
    src: String,
    isActiveItem: Boolean,
    isMediaLibrary: Boolean,
    contentType: String,
    content: String,
    title: String
  },
  methods: {
    handleMedia: function handleMedia() {
      console.log('clicking');
      if (this.isActionCard) {
        this.onClick(true);
      } else {
        this.onClick(this.media);
        console.log('go to media');
        this.$router.push('/media/' + __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.getActiveMedia._id);
      }
    },
    showOptions: function showOptions() {
      this.visibleOptions = true;
    },
    hideOptions: function hideOptions() {
      this.visibleOptions = false;
    },
    showSuccess: function showSuccess() {
      var _this = this;

      // give cards a little time to move
      setTimeout(function () {
        _this.showSuccessMsg({ message: 'Media moved to top!' });
      }, 400);
    }
  },
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data: function data() {
    var _this2 = this;

    return {
      visibleOptions: false,
      tagColors: {
        video: {
          bg: '#09a3ed',
          text: '#fff'
        },
        image: {
          bg: 'purple',
          text: '#fff'
        },
        audio: {
          bg: 'green',
          text: '#fff'
        },
        pdf: {
          bg: 'orange',
          text: '#444'
        }
      },
      styles: {
        card: {
          base: function base(src, active) {
            return {
              backgroundImage: 'linear-gradient(to top, rgba(0,0,0,1), rgba(0,0,0,0)), url(' + _this2.src + ')',
              backgroundSize: 'cover',
              flex: '0 0 auto',
              margin: '10px',
              height: '250px',
              display: 'flex',
              flexFlow: 'column nowrap',
              justifyContent: 'flex-end',
              color: '#fff',
              fontWeight: '400',
              fontSize: '1em',
              textAlign: 'left',
              padding: '20px',
              opacity: active ? 1 : 0.8,
              border: '0',
              transition: 'all 75ms ease-out'
            };
          }
        },
        title: {
          margin: '10px 0 0',
          fontWeight: '700',
          lineHeight: '1.25rem'
        },
        contentTag: function contentTag(type) {
          return {
            background: _this2.tagColors[type].bg || '#888',
            display: 'inline',
            color: _this2.tagColors[type].text || '#fff',
            padding: '5px',
            borderRadius: '4px',
            fontSize: '0.7em',
            fontWeight: '700',
            textTransform: 'uppercase'
          };
        }
      }
    };
  }
});

/***/ }),

/***/ "nFDS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nUYM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nmuS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateMediaLibraryLocalRecord_vue__ = __webpack_require__("OpqZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54ae58f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateMediaLibraryLocalRecord_vue__ = __webpack_require__("aO9V");
function injectStyle (ssrContext) {
  __webpack_require__("Tk4x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54ae58f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateMediaLibraryLocalRecord_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54ae58f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateMediaLibraryLocalRecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nnlE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:(_vm.styles.container(_vm.chartsReady))},[_c('div',{style:(_vm.styles.dashboardContainer)},[_c('select',{ref:"rangeDropdown",style:(_vm.styles.analyticsDropdown),domProps:{"value":_vm.ranges[_vm.currentRange].key},on:{"change":_vm.changeCharts}},_vm._l((_vm.ranges),function(range,index){return _c('option',{key:range.key,domProps:{"value":range.key}},[_vm._v("\n            "+_vm._s(range.label)+"\n          ")])}))]),_vm._v(" "),_c('div',{style:(_vm.styles.dataCardSection)},[_c('div',{staticClass:"dataCardWrap",style:(_vm.styles.dataCardWrap('login'))},[_c('h5',{style:(_vm.styles.cardTitle)},[_vm._v("Logins ("+_vm._s(_vm.printTotal('logins'))+")")]),_vm._v(" "),_c('canvas',{ref:"loginChart",style:(_vm.styles.chartCanvas(_vm.chartsReady)),attrs:{"width":"auto","height":"200"}}),_vm._v(" "),(!_vm.chartsReady)?_c('Spinner'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"dataCardWrap",style:(_vm.styles.dataCardWrap('contact'))},[_c('h5',{style:(_vm.styles.cardTitle)},[_vm._v("Contacts Added ("+_vm._s(_vm.printTotal('contacts'))+")")]),_vm._v(" "),_c('canvas',{style:(_vm.styles.chartCanvas(_vm.chartsReady)),attrs:{"id":"contactChart","width":"auto","height":"200"}}),_vm._v(" "),(!_vm.chartsReady)?_c('Spinner'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"dataCardWrap",style:(_vm.styles.dataCardWrap('meeting'))},[_c('h5',{style:(_vm.styles.cardTitle)},[_vm._v("Experiences Scheduled ("+_vm._s(_vm.printTotal('meetings'))+")")]),_vm._v(" "),_c('canvas',{style:(_vm.styles.chartCanvas(_vm.chartsReady)),attrs:{"id":"meetingChart","width":"auto","height":"200"}}),_vm._v(" "),(!_vm.chartsReady)?_c('Spinner'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"dataCardWrap",style:(_vm.styles.dataCardWrap('cart'))},[_c('h5',{style:(_vm.styles.cardTitle)},[_vm._v("Shopping Carts ("+_vm._s(_vm.printTotal('share_cart'))+")")]),_vm._v(" "),_c('canvas',{style:(_vm.styles.chartCanvas(_vm.chartsReady)),attrs:{"id":"cartChart","width":"auto","height":"200"}}),_vm._v(" "),(!_vm.chartsReady)?_c('Spinner'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"dataCardWrap",style:(_vm.styles.dataCardWrap('media'))},[_c('h5',{style:(_vm.styles.cardTitle)},[_vm._v("Media Viewed ("+_vm._s(_vm.printTotal('media_started'))+" started, "+_vm._s(_vm.printTotal('media_finished'))+" finished, "+_vm._s(_vm.printTotal('media_shared'))+" shared)")]),_vm._v(" "),_c('canvas',{style:(_vm.styles.chartCanvas(_vm.chartsReady)),attrs:{"id":"mediaChart","width":"auto","height":"200"}}),_vm._v(" "),(!_vm.chartsReady)?_c('Spinner'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"dataCardWrap",style:(_vm.styles.dataCardWrap('enrollment'))},[_c('h5',{style:(_vm.styles.cardTitle)},[_vm._v("Enrollment ("+_vm._s(_vm.printTotal('share_enrollment'))+" shared, "+_vm._s(_vm.printTotal('complete_enrollment'))+" completed)")]),_vm._v(" "),_c('canvas',{style:(_vm.styles.chartCanvas(_vm.chartsReady)),attrs:{"id":"enrollmentChart","width":"auto","height":"200"}}),_vm._v(" "),(!_vm.chartsReady)?_c('Spinner'):_vm._e()],1)])]),_vm._v(" "),(!_vm.chartsReady)?_c('div',[_c('Spinner'),_vm._v(" "),_c('p',{style:(_vm.styles.loadingLabel)},[_vm._v("\n      Generating report...\n    ")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oHJn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oLqE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oa5w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketEditor_vue__ = __webpack_require__("9azx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d2f2804_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MarketEditor_vue__ = __webpack_require__("uQHr");
function injectStyle (ssrContext) {
  __webpack_require__("fToH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8d2f2804"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d2f2804_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MarketEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "odzQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v(" Add a New Localized Content Record to Product Group")]),_c('div',{staticClass:"form__control-group rule__control-group--select"},[_c('label',[_vm._v("Select New Locale")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newLocale),expression:"newLocale"}],staticClass:"form__select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.newLocale=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.getAvailableMarkets),function(market){return _c('option',[_vm._v(_vm._s(market.locale))])}))]),_c('button',{staticClass:"button__submit",on:{"click":_vm.submit}},[_vm._v("Create Local Record")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "olTT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductGroupLibrary_vue__ = __webpack_require__("mEU1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a2e6cd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ProductGroupLibrary_vue__ = __webpack_require__("/W+x");
function injectStyle (ssrContext) {
  __webpack_require__("FgtX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a2e6cd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductGroupLibrary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a2e6cd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ProductGroupLibrary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_persistedstate__ = __webpack_require__("424j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_state__ = __webpack_require__("lwq5");







/**
 * Import the individual pieces
 */


/**
 * Init Vuex
 */
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/**
 * Setup the store
 */
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  /**
   * Main state property. Can be accessed from component: this.$store.state.gameURL
   */
  state: __WEBPACK_IMPORTED_MODULE_7__store_state__["a" /* default */],

  /**
   * Computed properties for state.
   */
  getters: __WEBPACK_IMPORTED_MODULE_5__store_getters__["a" /* default */],

  /**
   * Mutations are for sync code/changes. Can be called: this.$store.commit('changeGame', param)
   */
  mutations: __WEBPACK_IMPORTED_MODULE_6__store_mutations__["a" /* default */],

  /**
   * Actions are for async code. Can be called: this.$store.dispatch('actionName', param)
   */
  actions: __WEBPACK_IMPORTED_MODULE_3__store_actions__["a" /* default */],

  /**
   * Plugins
   */
  'plugins': [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_persistedstate__["a" /* default */])({
    reducer: function reducer(state, paths) {

      var reducer = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state);
      // state which you don't want to persist.
      delete reducer.interactionGroups;
      delete reducer.selectedSequence;
      delete reducer.showAddCardToSequenceModal;
      delete reducer.showAddMediaToCardModal;
      delete reducer.showAddSequenceToPolicyModal;
      delete reducer.showCardHelpModal;
      delete reducer.showColdDeckModal;
      delete reducer.showCreateCardModal;
      delete reducer.showCreateLocalRecordModal;
      delete reducer.showCreateMarketModal;
      delete reducer.showCreateProductLocalRecordModal;
      delete reducer.showCreateMediaLibraryLocalRecordModal;
      delete reducer.showCreateProductGroupModal;
      delete reducer.showCreateMediaLibraryModal;
      delete reducer.showCreateProductModal;
      delete reducer.showDeprecateMediaModal;
      delete reducer.showLogoutModal;
      delete reducer.showUpateThumbModal;
      delete reducer.showUpdateThumbModal;
      delete reducer.showUploadMediaModal;
      delete reducer.showUploadProductImageModal;
      delete reducer.showCopyVolumeLinksModal;
      delete reducer.showCopyLocalRecordModal;
      delete reducer.showCardIconModal;
      delete reducer.showDeleteProductModal;
      delete reducer.showRestoreProductModal;
      delete reducer.showDeleteRecordModal;
      delete reducer.tenant;
      delete reducer.user;

      return reducer;
    }
  })]
}));

/***/ }),

/***/ "owT0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oxTG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'deprecateMedia',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
  }
});

/***/ }),

/***/ "p70h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon chevron-left-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pDhz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoggedIn_vue__ = __webpack_require__("lqgh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_257cc12b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoggedIn_vue__ = __webpack_require__("QnPt");
function injectStyle (ssrContext) {
  __webpack_require__("zKUB")
  __webpack_require__("/M7p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-257cc12b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoggedIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_257cc12b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoggedIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pG8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__file_input__ = __webpack_require__("pfih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__upload_icon__ = __webpack_require__("BAag");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FileInput: __WEBPACK_IMPORTED_MODULE_0__file_input__["a" /* default */],
    UploadIcon: __WEBPACK_IMPORTED_MODULE_1__upload_icon__["a" /* default */]
  },
  props: {
    uploader: {
      type: Object,
      required: true
    },
    multiple: {
      type: Boolean,
      default: true
    }
  }
});

/***/ }),

/***/ "pWUv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CopyVolumeLinks_vue__ = __webpack_require__("g4q4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ec5d374_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CopyVolumeLinks_vue__ = __webpack_require__("ELdm");
function injectStyle (ssrContext) {
  __webpack_require__("/VJE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ec5d374"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CopyVolumeLinks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ec5d374_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CopyVolumeLinks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pacP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketLibrary_vue__ = __webpack_require__("JNez");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58efdbda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MarketLibrary_vue__ = __webpack_require__("fI8+");
function injectStyle (ssrContext) {
  __webpack_require__("m0Pt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58efdbda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketLibrary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58efdbda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MarketLibrary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pfih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_file_input_vue__ = __webpack_require__("I2oz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_154244b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_file_input_vue__ = __webpack_require__("w5Lk");
function injectStyle (ssrContext) {
  __webpack_require__("ll+q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_file_input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_154244b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_file_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q25l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q8NN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_loader_lib_template_compiler_index_id_data_v_15abdb9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_upload_failed_icon_vue__ = __webpack_require__("W/Lp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__vue_loader_lib_template_compiler_index_id_data_v_15abdb9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_upload_failed_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qCZX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qEdA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qH1K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qHIf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterUser_vue__ = __webpack_require__("0Qp0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e6a62b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterUser_vue__ = __webpack_require__("vomC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e6a62b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r1t+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.onlyRenderIfCancelable || _vm.state.cancelable)?_c('button',{staticClass:"vue-fine-uploader-cancel-button",attrs:{"type":"button","aria-label":"cancel","disabled":!_vm.state.cancelable},on:{"click":_vm._onClick}},[_vm._t("default",[_vm._v("Cancel")])],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r31D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MixedContentInput__ = __webpack_require__("XrmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaCard__ = __webpack_require__("lVNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("olkN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ActionCard',
  components: {
    MediaCard: __WEBPACK_IMPORTED_MODULE_2__MediaCard__["a" /* default */],
    MixedContentInput: __WEBPACK_IMPORTED_MODULE_0__MixedContentInput__["a" /* default */]
  },
  props: {
    activeSetting: String,
    body: String,
    callToAction: String,
    checkEdits: Function,
    helpText: String,
    displayName: String,
    helpUrl: String,
    isEditing: Boolean,
    media: [Object, Boolean],
    subject: String,
    title: String,
    params: Array,
    fields: Array,
    specificStyles: Object,
    backgroundUrl: String
  },
  computed: {
    getActiveCard: function getActiveCard() {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getActiveCard;
    },
    getActiveMedia: function getActiveMedia() {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getActiveMedia;
    },
    getActiveLocalRecord: function getActiveLocalRecord() {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getActiveLocalRecord;
    }
  },
  methods: {
    cleanParams: function cleanParams(paramStr) {
      var arr = paramStr.match(/{(.*?)}/g) || [];
      var sanitized = arr.map(function (param) {
        return param.substring(1, param.length - 1);
      });
      return sanitized;
    },
    toggleFooterPopup: function toggleFooterPopup() {
      this.showFooterPopup = !this.showFooterPopup;
    },
    showHelpModal: function showHelpModal() {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('showCardHelpModal', true);
    },
    toggleAddIconToCardModal: function toggleAddIconToCardModal(context, index) {
      console.log('opening social link modal');
      if (index) {
        console.log('specific social link');
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setCardIconContext', socialLinks[index]);
      } else {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setCardIconContext', context);
      }
      __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].toggleAddIconToCard(true);
    },
    addSocialLink: function addSocialLink() {
      var emptyLink = { icon: '', text: '', url: '' };
      if (!this.getActiveLocalRecord.socialLinks) {
        this.getActiveLocalRecord.socialLinks = [emptyLink];
      } else {
        this.getActiveLocalRecord.socialLinks.push(emptyLink);
      }
    },
    removeLinkItem: function removeLinkItem(index) {
      this.getActiveLocalRecord.socialLinks.splice(index, 1);
    }
  },
  data: function data() {
    return {
      shortId: this.$route.params.shortId,
      showFooterPopup: false,
      toggleAddMediaToCardModal: __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].toggleAddMediaToCard,
      styles: {
        cardFooter: {
          display: 'flex',
          margin: 'auto 0 0',
          padding: '20px 10px 40px',
          fontSize: '1.1em',
          flexFlow: 'column nowrap',
          alignItems: 'center'
        },
        mediaContainer: {
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          position: 'relative'
        }
      }
    };
  },

  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_1_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_1_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  }
});

/***/ }),

/***/ "rMq4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteProduct_vue__ = __webpack_require__("js80");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c645d52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteProduct_vue__ = __webpack_require__("8Qc7");
function injectStyle (ssrContext) {
  __webpack_require__("UZbK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c645d52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c645d52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteProduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rdWY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rzym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__("ZtZW");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62eb5d6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("VBxv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62eb5d6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "s13m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CopyLocalRecord',
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */],
        Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
    },
    data: function data() {
        return {
            isCopying: false,
            copiedLocale: ''
        };
    },

    computed: {
        getActiveCard: function getActiveCard() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveCard;
        },
        getActiveLocale: function getActiveLocale() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveLocale;
        },
        getSortedAvailableLocales: function getSortedAvailableLocales() {
            var _this = this;

            if (this.getActiveCard && this.getActiveCard.localRecords) {
                var locales = [];

                this.getActiveCard.localRecords.forEach(function (locale) {
                    if (locale.locale !== _this.getActiveLocale) {
                        locales.push(locale.locale);
                    }
                });

                return locales.sort(function (a, b) {
                    return a.name - b.name;
                }).reverse();
            }
        },
        getAvailableMarkets: function getAvailableMarkets() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getMarkets;
        },
        getMarketsByLocale: function getMarketsByLocale() {
            if (this.getAvailableMarkets) {
                var marketsByLocale = [];

                this.getAvailableMarkets.forEach(function (market) {
                    marketsByLocale.push(market.locale);
                });

                return marketsByLocale;
            }
        }
    },
    notifications: {
        showSuccessMsg: {
            type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.success,
            title: '',
            icon: '✅'
        },
        showErrorMsg: {
            type: __WEBPACK_IMPORTED_MODULE_6_vue_notifications___default.a.types.error,
            title: '',
            icon: '❗️'
        }
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].getMarkets();
    },

    methods: {
        submit: function submit() {
            var _this2 = this;

            var update = {
                recordId: this.getActiveCard._id,
                targetLocale: this.getActiveLocale,
                sourceLocale: this.copiedLocale
            };

            console.log(update);

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_Utils_js__["c" /* postResource */])('/v1/actioncards/copy', false, update).then(function (res) {
                console.log('success!', res);
                _this2.showSuccessMsg({ message: 'Content copied from ' + _this2.copiedLocale + '!' });
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('hideModals', true);
                __WEBPACK_IMPORTED_MODULE_2__services_Services__["a" /* default */].setActiveCard(_this2.getActiveCard._id, _this2.getActiveLocale);
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocale', res.targetLocalRecord.locale);
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveLocalRecord', res.targetLocalRecord.content);
                return res;
            }).catch(function (error) {
                var message = 'An error occurred. Please try again.';
                if (error.error) {
                    message = error.error;
                }
                _this2.showErrorMsg({
                    message: message
                });
            });
        }
    }
});

/***/ }),

/***/ "sEs6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__general_Spinner__ = __webpack_require__("dSGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_chart_js__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_6__general_Spinner__["a" /* default */]
  },
  data: function data() {
    return {
      icon: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getTenant.icon,
      chartsReady: false,
      showHiddenMenu: false,
      currentRange: 'week',
      ranges: {
        day: {
          label: 'Last 24 Hours',
          key: 'day',
          start: function start() {
            return __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(-2, 'days').unix();
          },
          end: function end() {
            return __WEBPACK_IMPORTED_MODULE_4_moment___default()().unix();
          },
          unit: 1,
          labels: function labels() {
            return [__WEBPACK_IMPORTED_MODULE_4_moment___default()().add(-1, 'days').format('dddd'), 'Today'];
          }
        },
        week: {
          label: 'Last 7 Days',
          key: 'week',
          start: function start() {
            return __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(-1, 'weeks').unix();
          },
          end: function end() {
            return __WEBPACK_IMPORTED_MODULE_4_moment___default()().unix();
          },
          unit: 1,
          labels: function labels() {
            return [__WEBPACK_IMPORTED_MODULE_4_moment___default()().add(-6, 'days').format('dddd'), __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(-5, 'days').format('dddd'), __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(-4, 'days').format('dddd'), __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(-3, 'days').format('dddd'), __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(-2, 'days').format('dddd'), __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(-1, 'days').format('dddd'), 'Today'];
          }
        },
        month: {
          label: 'Last 30 Days',
          key: 'month',
          start: function start() {
            return __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(-30, 'days').unix();
          },
          end: function end() {
            return __WEBPACK_IMPORTED_MODULE_4_moment___default()().unix();
          },
          unit: 1,
          labels: function labels() {
            return new Array(30).map(function (item, i) {
              return __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(i * -1, 'days').format('M/D');
            });
          }
        },
        threeMonth: {
          label: 'Last 90 Days',
          key: 'threeMonth',
          start: function start() {
            return __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(-90, 'days').unix();
          },
          end: function end() {
            return __WEBPACK_IMPORTED_MODULE_4_moment___default()().unix();
          },
          unit: 1,
          labels: function labels() {
            return new Array(90).map(function (item, i) {
              return __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(i * -1, 'days').format('M/D');
            });
          }
        },
        year: {
          label: 'Last 365 Days',
          key: 'year',
          start: function start() {
            return __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(-365, 'days').unix();
          },
          end: function end() {
            return __WEBPACK_IMPORTED_MODULE_4_moment___default()().unix();
          },
          unit: 1,
          labels: function labels() {
            return new Array(365).map(function (i) {
              return __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(i * -1, 'days').format('M/D');
            });
          }
        }
      },
      charts: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts,
      styles: {
        container: function container(r) {
          return {
            background: '#F5F5F5',
            minHeight: '100vh',
            opacity: r ? '1' : '0'
          };
        },
        dataCardSection: {
          display: 'flex',
          flexFlow: 'row wrap',
          padding: '0 10px'
        },
        dataCardWrap: function dataCardWrap(type) {
          return {
            border: '1px solid #eee',
            background: '#fff',
            boxShadow: '0 2px 5px 1px rgba(0,0,0,0.08)',
            minHeight: '200px',
            display: 'flex',
            justifyContent: 'center',
            padding: '10px',
            flexFlow: 'column nowrap',
            position: 'relative',
            alignItems: 'center',
            margin: type === 'media' ? '10px 10px 60px' : '10px',
            borderRadius: '5px'
          };
        },
        cardTitle: {
          margin: '10px auto',
          color: '#333',
          textTransform: 'uppercase',
          display: 'flex',
          alignItems: 'center'
        },
        loadingLabel: {
          position: 'absolute',
          bottom: '40px',
          fontSize: '1.1em',
          color: '#aaa',
          fontWeight: '700',
          textAlign: 'center',
          left: '0',
          right: '0'
        },
        hiddenMenuToggle: function hiddenMenuToggle(showHiddenMenu) {
          return {
            background: 'rgba(0,0,0,0.25)',
            opacity: showHiddenMenu ? 1 : 0,
            pointerEvents: showHiddenMenu ? 'auto' : 'none',
            position: 'fixed',
            transition: '100ms ease-out',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            height: '100vh',
            width: '100vw',
            zIndex: 98
          };
        },
        rangeDropdown: function rangeDropdown(showHiddenMenu) {
          return {
            position: 'fixed',
            top: 110,
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#fff',
            boxShadow: '0 2px 5px 1px rgba(0,0,0,0.1)',
            width: 200,
            border: '1px solid #ddd',
            listStyle: 'none',
            padding: 0,
            margin: 0,
            zIndex: 99,
            opacity: showHiddenMenu ? 1 : 0,
            pointerEvents: showHiddenMenu ? 'auto' : 'none'
          };
        },
        rangeItem: {
          padding: 15,
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          borderBottom: '1px solid #ddd',
          ':hover': {
            background: '#f5f5f5',
            cursor: 'pointer'
          }
        },
        exitIcon: {
          margin: 'auto 0 auto auto',
          fontSize: '1.25em'
        },
        dashboardContainer: {
          display: 'flex',
          flexFlow: 'column nowrap',
          alignItems: 'center',
          justifyContent: 'flex-start',
          background: 'transparent',
          height: 'auto',
          padding: '20px 10px 10px 10px',
          position: 'relative'
        },
        logo: {
          height: '80px',
          width: '80px',
          margin: 'auto auto 20px'
        },
        analyticsDropdown: {
          fontSize: '1.25em',
          fontWeight: 700,
          width: '250px',
          margin: 'auto auto auto 0',
          textAlign: 'center',
          outline: '0',
          padding: '10px 20px'
        },
        loadingIconContainer: {
          width: '100%',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        chartCanvas: function chartCanvas(showChart) {
          return {
            transition: 'all 0.2s',
            opacity: showChart ? '1' : '0'
          };
        }
      }
    };
  },
  mounted: function mounted() {
    this.getChartAnalytics();
  },

  methods: {
    changeCharts: function changeCharts() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var charts;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.chartsReady = false;
                _this.currentRange = _this.$refs.rangeDropdown.value;
                _context.next = 4;
                return _this.getChartAnalytics(_this.currentRange);

              case 4:
                charts = _context.sent;

                _this.chartsReady = true;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getChartAnalytics: function getChartAnalytics() {
      var _this2 = this;

      // we would put our Utils.getResources() call here, then work with the result. for now we have some hard-coded data

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_Utils__["a" /* getResource */])('/v1/analytics/daily', 'start=' + this.ranges[this.currentRange].start() + '&end=' + this.ranges[this.currentRange].end() + '&unit=' + this.ranges[this.currentRange].unit).then(function (chartData) {
        // start preparing the data for charts
        var logins = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData.login).map(function (neg) {
          return chartData.login[neg];
        });
        var contacts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData.add_contact).map(function (neg) {
          return chartData.add_contact[neg];
        });
        var meetings = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData.add_meeting).map(function (neg) {
          return chartData.add_meeting[neg];
        });
        var sc = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData.share_cart).map(function (neg) {
          return chartData.share_cart[neg];
        });
        var ms = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData.media_started).map(function (neg) {
          return chartData.media_started[neg];
        });
        var mf = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData.media_finished).map(function (neg) {
          return chartData.media_finished[neg];
        });
        var msh = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData.media_shared).map(function (neg) {
          return chartData.media_shared[neg];
        });

        var ensh = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData.share_enrollment).map(function (neg) {
          return chartData.share_enrollment[neg];
        });
        var enc = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData.complete_enrollment).map(function (neg) {
          return chartData.complete_enrollment[neg];
        });

        //   console.log(ensh);
        //   console.log(enc);

        var uc = {
          logins: logins.reverse(),
          contacts: contacts.reverse(),
          meetings: meetings.reverse(),
          share_cart: sc.reverse(),
          media_started: ms.reverse(),
          media_finished: mf.reverse(),
          media_shared: msh.reverse(),
          share_enrollment: ensh.reverse(),
          complete_enrollment: enc.reverse()
        };

        // commit the results to store
        _this2.$store.commit('setCharts', uc);
        _this2.chartsReady = true;
        return;
      }).then(function () {
        return _this2.setupCharts();
      }).catch(function (error) {
        return console.log(error);
      });
    },
    setupCharts: function setupCharts() {
      this.setupCartChart();
      this.setupMediaChart();
      this.setupLoginChart();
      this.setupContactChart();
      this.setupMeetingChart();
      this.setupEnrollmentChart();
    },
    setupEnrollmentChart: function setupEnrollmentChart() {
      console.log('setting up enrollment chart');
      var ctx = 'enrollmentChart';
      var yMax = Math.max.apply(null, __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.share_enrollment, __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.complete_enrollment) * 2;
      var chart = new __WEBPACK_IMPORTED_MODULE_7_chart_js___default.a(ctx, {
        type: 'line',
        data: {
          labels: this.ranges[this.currentRange].labels(),
          datasets: [{
            label: 'Shared',
            data: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.share_enrollment,
            borderColor: ['#09a3ed'],
            backgroundColor: ['transparent']
          }, {
            label: 'Completed',
            data: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.complete_enrollment,
            borderColor: ['green'],
            backgroundColor: ['transparent']
          }]
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                max: yMax,
                beginAtZero: true,
                callback: function callback(value) {
                  if (value % 1 === 0) {
                    return value;
                  }
                }
              }
            }]
          }
        }
      });
    },
    setupLoginChart: function setupLoginChart() {
      var ctx = this.$refs.loginChart;
      var yMax = Math.max.apply(null, __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.logins) * 2;
      var chart = new __WEBPACK_IMPORTED_MODULE_7_chart_js___default.a(ctx, {
        type: 'line',
        data: {
          labels: this.ranges[this.currentRange].labels(),
          datasets: [{
            label: 'Logins',
            data: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.logins,
            borderColor: ['#09a3ed'],
            backgroundColor: ['transparent'],
            borderWidth: 0
          }]
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                max: yMax,
                beginAtZero: true,
                callback: function callback(value) {
                  if (value % 1 === 0) {
                    return value;
                  }
                }
              }
            }]
          }
        }
      });
    },
    setupMeetingChart: function setupMeetingChart() {
      //   console.log(this.ranges[this.currentRange].labels());
      var ctx = 'meetingChart';
      var yMax = Math.max.apply(null, __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.meetings) * 2;
      var chart = new __WEBPACK_IMPORTED_MODULE_7_chart_js___default.a(ctx, {
        type: 'line',
        data: {
          labels: this.ranges[this.currentRange].labels(),
          datasets: [{
            label: 'Experiences Scheduled',
            data: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.meetings,
            borderColor: ['purple'],
            backgroundColor: ['transparent'],
            borderWidth: 0
          }]
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                max: yMax,
                callback: function callback(value) {
                  if (value % 1 === 0) {
                    return value;
                  }
                }
              }
            }]
          }
        }
      });
    },
    setupContactChart: function setupContactChart() {
      var ctx = 'contactChart';
      var yMax = Math.max.apply(null, __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.contacts) * 1.2;
      var chart = new __WEBPACK_IMPORTED_MODULE_7_chart_js___default.a(ctx, {
        type: 'line',
        data: {
          labels: this.ranges[this.currentRange].labels(),
          datasets: [{
            label: 'Contacts Added',
            data: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.contacts,
            borderColor: ['navy'],
            backgroundColor: ['transparent'],
            borderWidth: 0
          }]
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                max: yMax,
                callback: function callback(value) {
                  if (value % 1 === 0) {
                    return value;
                  }
                }
              }
            }]
          }
        }
      });
    },
    setupCartChart: function setupCartChart() {
      var ctx = 'cartChart';
      var yMax = Math.max.apply(null, __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.share_cart) * 1.2;
      var chart = new __WEBPACK_IMPORTED_MODULE_7_chart_js___default.a(ctx, {
        type: 'line',
        data: {
          labels: this.ranges[this.currentRange].labels(),
          datasets: [{
            label: 'Shared',
            data: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.share_cart,
            borderColor: ['green'],
            backgroundColor: ['transparent'],
            borderWidth: 0
          }]
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                max: yMax,
                callback: function callback(value) {
                  if (value % 1 === 0) {
                    return value;
                  }
                }
              }
            }]
          }
        }
      });
    },
    setupMediaChart: function setupMediaChart() {
      var ctx = 'mediaChart';
      var yMax = Math.max.apply(null, __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.media_shared) * 1.2;
      var chart = new __WEBPACK_IMPORTED_MODULE_7_chart_js___default.a(ctx, {
        type: 'line',
        data: {
          labels: this.ranges[this.currentRange].labels(),
          datasets: [{
            label: 'Finished',
            data: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.media_finished,
            borderColor: ['red'],
            backgroundColor: ['transparent']
          }, {
            label: 'Started',
            data: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.media_started,
            borderColor: ['orange'],
            backgroundColor: ['transparent']
          }, {
            label: 'Shared',
            data: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts.media_shared,
            borderColor: ['green'],
            backgroundColor: ['transparent']
          }]
        },
        options: {
          legend: {
            display: true
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                stacked: true,
                max: yMax,
                callback: function callback(value) {
                  if (value % 1 === 0) {
                    return value;
                  }
                }
              }
            }],
            xAxes: [{
              ticks: {
                beginAtZero: true,
                stacked: true
              }
            }]
          }
        }
      });
    },
    printTotal: function printTotal(stat) {
      //   console.log(store.getters.getCharts);
      //   console.log(stat);
      var arr = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getCharts[stat];
      var total = 0;
      arr.forEach(function (item, i) {
        total += item;
      });
      return total;
    }
  }
});

/***/ }),

/***/ "sYv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProductGroupLocalRecord_vue__ = __webpack_require__("544f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2922d5a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProductGroupLocalRecord_vue__ = __webpack_require__("odzQ");
function injectStyle (ssrContext) {
  __webpack_require__("RGi4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2922d5a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProductGroupLocalRecord_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2922d5a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProductGroupLocalRecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sgY4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateActionCard_vue__ = __webpack_require__("2hZx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e20c4848_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateActionCard_vue__ = __webpack_require__("6FaE");
function injectStyle (ssrContext) {
  __webpack_require__("8fXO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e20c4848"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateActionCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e20c4848_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateActionCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "siN1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "svs1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{style:(_vm.styles.topBar)},[_c('button',{staticClass:"button__action",on:{"click":_vm.goBack}},[_c('i',{staticClass:"glyphicon glyphicon-chevron-left icon"}),_vm._v("\n        Back to Sequences\n        ")]),_vm._v(" "),_c('div',{staticClass:"button-container"},[_c('button',{staticClass:"button__action button__delete",on:{"click":function($event){_vm.deleteSequence()}}},[_vm._v(_vm._s(_vm.getActiveSequence.deleted ? 'Restore Sequence' : 'Delete Sequence'))]),_vm._v(" "),_c('button',{staticClass:"button__action",on:{"click":function($event){_vm.saveChanges()}}},[_vm._v("Save Changes")])])]),_vm._v(" "),_c('header',{style:(_vm.styles.pageHeader)},[(!_vm.newSequence)?_c('span',{style:(_vm.styles.historyIcon),on:{"click":_vm.fetchHistory}},[_c('HistoryIcon'),_vm._v(" \n        History\n        ")],1):_vm._e(),_vm._v(" "),(_vm.showHistory)?_c('div',{style:(_vm.styles.closeHistory),on:{"click":_vm.toggleHistoryPopup}},[_c('CloseIcon')],1):_vm._e(),_vm._v(" "),(_vm.showHistory)?_c('div',{style:(_vm.styles.showHistoryContainer)},[(_vm.noHistory)?_c('p',{style:(_vm.styles.noHistory)},[_vm._v("No history")]):_vm._e(),_vm._v(" "),(!_vm.noHistory)?_c('ul',{style:(_vm.styles.historyList)},_vm._l((_vm.history),function(item,index){return _c('li',{style:(_vm.styles.historyListItem)},[_vm._v("Sequence updated "+_vm._s(_vm.moment(item.updatedAt))+" by user.firstName")])})):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.newSequence)?_c('p',{style:(_vm.styles.pageHead)},[_vm._v("Edit Sequence")]):_vm._e(),_vm._v(" "),(_vm.newSequence)?_c('p',{style:(_vm.styles.pageHead)},[_vm._v("Create a New Sequence")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input__container",class:{ 'form-group--error': _vm.$v.name.$error }},[_c('label',{staticClass:"input__label"},[_vm._v("Name *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveSequence.name),expression:"getActiveSequence.name"}],staticClass:"input__text",class:{ 'error': _vm.$v.name.$error },attrs:{"type":"text"},domProps:{"value":(_vm.getActiveSequence.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveSequence, "name", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.name.required)?_c('div',{staticClass:"error__hint"},[_vm._v("Sequence name is required")]):_vm._e(),_vm._v(" "),_c('label',{attrs:{"for":"getActiveSequence.isActive"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveSequence.isActive),expression:"getActiveSequence.isActive"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.getActiveSequence.isActive)?_vm._i(_vm.getActiveSequence.isActive,null)>-1:(_vm.getActiveSequence.isActive)},on:{"change":function($event){var $$a=_vm.getActiveSequence.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.getActiveSequence, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.getActiveSequence, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.getActiveSequence, "isActive", $$c)}}}}),_vm._v(" Active\n      ")])]),_vm._v(" "),_c('div',{staticClass:"input__container subscription-container rule__control-group rule__control-group--select"},[_c('label',{staticClass:"input__label",attrs:{"for":""}},[_vm._v("Subscription")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveSequence.subscription),expression:"getActiveSequence.subscription"}],staticClass:"form__select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.getActiveSequence, "subscription", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.subscriptions),function(sub,index){return _c('option',{key:((sub._id) + "-" + index),domProps:{"value":sub._id}},[_vm._v(_vm._s(sub.name))])}))]),_vm._v(" "),_c('div',{staticClass:"input__container"},[_c('label',{staticClass:"input__label",attrs:{"for":"getActiveSequence.description"}},[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveSequence.description),expression:"getActiveSequence.description"}],attrs:{"id":"","cols":"30","rows":"10"},domProps:{"value":(_vm.getActiveSequence.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveSequence, "description", $event.target.value)}}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),(!_vm.newSequence && !_vm.getCards.length)?_c('Spinner'):_vm._e(),_vm._v(" "),(_vm.newSequence || (!_vm.newSequence && _vm.getCards.length))?_c('draggable',{style:(_vm.styles.wrapper(true)),attrs:{"options":{draggable:'.item'}},model:{value:(_vm.getCards),callback:function ($$v) {_vm.getCards=$$v},expression:"getCards"}},[_vm._l((_vm.getCards),function(card,index){return _c('section',{key:index,staticClass:"item cardWrap"},[_c('div',{style:(_vm.styles.indexContainer)},[_c('p',{style:(_vm.styles.indexNumber)},[_vm._v(_vm._s(index+1))])]),_vm._v(" "),_c('div',{style:(_vm.styles.cardContianer)},[_c('p',{style:(_vm.styles.cardName)},[_vm._v(_vm._s(card.legacyName))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(card.displayName))])]),_vm._v(" "),_c('div',{style:(_vm.styles.iconContainer)},[_c('div',{on:{"click":function($event){_vm.goToCard(card)}}},[_c('PencilIcon',{key:(index + "-editIcon"),staticClass:"material-icons",style:(_vm.styles.actionIcon)})],1),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.removeCardFromSequence(index)}}},[_c('DeleteIcon',{style:(_vm.styles.actionIcon)})],1)])])}),_vm._v(" "),_c('section',{key:"addnew",staticClass:"cardWrap addCardWrap",on:{"click":_vm.toggleAddCardToSequenceModal}},[_c('div',{style:(_vm.styles.cardContainer)},[(!_vm.newSequence)?_c('p',{style:(_vm.styles.cardName)},[_vm._v("Edit Sequence")]):_vm._e(),_vm._v(" "),(_vm.newSequence)?_c('p',{style:(_vm.styles.cardName)},[_vm._v("Build Sequence")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Add New Action Card")])]),_vm._v(" "),_c('div',{style:(_vm.styles.iconContainer)},[_c('PlusCircleIcon',{staticStyle:{"font-size":"1.6rem"}})],1)])],2):_vm._e(),_vm._v(" "),(_vm.showCardValidation && !_vm.getCards.length)?_c('div',{staticClass:"invalid input__container"},[_c('div',{staticClass:"error__hint error__custom"},[_vm._v("Please add at least one action card to the sequence.")])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input__container"},[_c('label',{staticClass:"input__label"},[_vm._v("Action Cards *")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sxfZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles ? _vm.styles : _vm.spinnerStyles.wrapper)},[_c('svg',{staticClass:"spinner",attrs:{"width":"65px","height":"65px","viewBox":"0 0 66 66","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"path",attrs:{"fill":"none","stroke-width":"6px","cx":"33","cy":"33","r":"30"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sy9Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t9gd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon delete-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19C6,20.1 6.9,21 8,21H16C17.1,21 18,20.1 18,19V7H6V19Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tLvy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tZIx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_design_icons_Close__ = __webpack_require__("wbZU");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CloseIcon: __WEBPACK_IMPORTED_MODULE_2_vue_material_design_icons_Close__["a" /* default */],
    vSelect: __WEBPACK_IMPORTED_MODULE_1_vue_select___default.a
  },
  props: {
    groupIndex: Number,
    ruleIndex: [Number, String]
  },
  data: function data() {
    return {
      activeType: {
        name: null,
        props: null
      },
      ruleType: null,
      activeProperty: null,
      activeOperator: null,
      activeComparand: null
    };
  },

  methods: {
    setActiveType: function setActiveType(value) {
      this.activeProperty = null;
      if (!value) {
        this.activeType = {
          name: null,
          props: [null]
        };
      }
      this.updateRule('1');
    },
    setActiveProperty: function setActiveProperty(value) {
      this.activeOperator = null;
      if (!value) {
        this.activeProperty = null;
      }
      this.updateRule('2');
    },
    setActiveOperator: function setActiveOperator(value) {
      this.activeComparand = null;

      if (!value) {
        this.activeOperator = null;
      }
      this.updateRule('3');
    },
    setActiveComparand: function setActiveComparand(value) {
      if (!value) {
        this.activeComparand = null;
      }
      this.updateRule('4');
    },
    updateRule: function updateRule(num) {
      var wholePolicy = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.getActivePolicy;
      var ruleToUpdate = wholePolicy.rules[this.groupIndex].groupRules[this.ruleIndex];
      ruleToUpdate.interactionType = this.activeType;
      ruleToUpdate.property = this.activeProperty;
      ruleToUpdate.operator = this.activeOperator;
      ruleToUpdate.comparand = this.activeComparand;

      wholePolicy.rules[this.groupIndex].groupRules[this.ruleIndex] = ruleToUpdate;

      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setActivePolicy', wholePolicy);
    },
    removeRule: function removeRule() {
      var activePolicy = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.getActivePolicy;
      activePolicy.rules[this.groupIndex].groupRules.splice(this.ruleIndex, 1);
      if (activePolicy.rules[this.groupIndex].groupRules.length == 0) {
        activePolicy.rules.splice(this.groupIndex, 1);
      }
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setActivePolicy', activePolicy);
    },
    getCurrentRule: function getCurrentRule() {
      if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.getActivePolicy.rules) {
        return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.getActivePolicy.rules[this.groupIndex].groupRules[this.ruleIndex];
      } else {
        return {};
      }
    },
    getInteractionTypes: function getInteractionTypes() {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.getInteractionTypes;
    }
  },
  created: function created() {
    if (this.getCurrentRule().interactionType) {
      this.activeType = this.getCurrentRule().interactionType;
    }
    if (this.getCurrentRule().property) {
      this.property = this.getCurrentRule.property;
      this.activeProperty = this.getCurrentRule().property;
    }
    if (this.getCurrentRule().comparand) {
      this.activeComparand = this.getCurrentRule().comparand;
    }
    if (this.getCurrentRule().operator) {
      this.activeOperator = this.getCurrentRule().operator;
    }
  }
});

/***/ }),

/***/ "u5Rx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function getOffset(el) {
  var _x = 0;
  var _y = 0;
  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    _x += el.offsetLeft - el.scrollLeft;
    _y += el.offsetTop - el.scrollTop;
    el = el.offsetParent;
  }
  return { top: _y, left: _x };
}
/**
 * returns x, y coordinates for absolute positioning of a span within a given text input
 * at a given selection point
 * @param {object} input - the input element to obtain coordinates for
 * @param {number} selectionPoint - the selection point for the input
 */
var getCursorXY = function getCursorXY(input, selectionPoint) {
  var inputX = input.offsetLeft,
      inputY = input.offsetTop;
  // create a dummy element that will be a clone of our input

  var div = document.createElement('div');
  // get the computed style of the input and clone it onto the dummy element
  var copyStyle = getComputedStyle(input);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(copyStyle), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var prop = _step.value;

      div.style[prop] = copyStyle[prop];
    }
    // we need a character that will replace whitespace when filling our dummy element if it's a single line <input/>
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var swap = '.';
  var inputValue = input.tagName === 'INPUT' ? input.value.replace(/ /g, swap) : input.value;
  // set the div content to that of the textarea up until selection
  var textContent = inputValue.substr(0, selectionPoint);
  // set the text content of the dummy element div
  div.textContent = textContent;
  if (input.tagName === 'TEXTAREA') div.style.height = 'auto';
  // if a single line input then the div needs to be single line and not break out like a text area
  if (input.tagName === 'INPUT') div.style.width = 'auto';
  // create a marker element to obtain caret position
  div.style.width = input.offsetWidth;
  div.style.height = input.offsetHeight;
  div.style.wordWrap = 'wrap';
  var span = document.createElement('span');
  // give the span the textContent of remaining content so that the recreated dummy element is as close as possible
  span.textContent = inputValue.substr(selectionPoint) || '.';
  // append the span marker to the div
  div.appendChild(span);
  // append the dummy element to the body
  document.body.appendChild(div);
  // get the marker position, this is the caret position top and left relative to the input
  var spanX = span.offsetLeft,
      spanY = span.offsetTop;
  // lastly, remove that dummy element
  // NOTE:: can comment this out for debugging purposes if you want to see where that span is rendered

  document.body.removeChild(div);
  // return an object with the x and y of the caret. account for input positioning so that you don't need to wrap the input
  return {
    x: inputX + spanX,
    y: inputY + spanY
  };
};


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MixedContentInput',
  props: {
    activeSetting: String,
    template: String,
    section: String,
    paramOptions: Array,
    inputStyle: Object,
    edit: Function,
    isEditing: Boolean
  },
  data: function data() {
    return {
      addingNewParam: false,
      newContent: null,
      showParamOptions: false,
      showAddParamButton: false,
      isEmpty: false,
      cursorPosition: null,
      selectedParam: null,
      showParamMenu: false,
      paramCoords: null,
      styles: {
        container: {
          marginBottom: '1rem',
          border: '1px solid #E2E2E2',
          background: '#FFF',
          borderRadius: '3px',
          padding: '1rem',
          width: '100%'
        },
        paramMenuStyles: function paramMenuStyles(coords) {
          return {
            background: '#fff',
            zIndex: 9999,
            position: 'absolute',
            top: coords.y ? coords.y + 30 + 'px' : false,
            left: coords.x ? coords.x - 10 + 'px' : false,
            overflowY: 'scroll',
            overflowX: 'hidden'
          };
        }
      }
    };
  },

  computed: {
    getActiveLocalRecord: function getActiveLocalRecord() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getActiveLocalRecord;
    },
    content: function content() {
      if (this.section === 'backgroundUrl') {
        return this.getActiveLocalRecord[this.section];
      }
      if (this.section === 'title' || this.section === 'callToAction') {
        if (this.getActiveLocalRecord[this.section]) {
          return this.getActiveLocalRecord[this.section][this.activeSetting] || '(no content)';
        } else {
          return '(no content)';
        }
      } else if (this.section === 'subject' || this.section === 'bodyText') {
        if (this.getActiveLocalRecord.message) {
          return this.getActiveLocalRecord.message[this.section] || '(no content)';
        } else {
          return '(no content)';
        }
      } else if (this.section === 'reason') {
        if (typeof this.getActiveLocalRecord.reason === 'string' && this.getActiveLocalRecord.reason !== '\n') {
          return this.getActiveLocalRecord.reason;
        }

        return '(no content)';
      } else {
        return this.getActiveLocalRecord.help[this.section] || '(no content)';
      }
    }
  },
  methods: {
    onEmptyContent: function onEmptyContent() {
      var ref = this.$refs.textarea;
      if (ref && ref.value) {
        return 'empty-state';
      }
      return '';
    },
    textareaResize: function textareaResize() {
      this.$refs.textarea.style.minHeight = this.$refs.textarea.scrollHeight + 'px';
    },
    spanify: function spanify(txt) {
      return txt.replace(/\b(\w+)\b/g, '<span>$1</span>');
    },
    onParamClick: function onParamClick(param) {
      var val = this.$refs.textarea.value;
      var sel = this.$refs.textarea.selectionStart;
      var word = this.getWord(val, sel);
      if (word && this.isParam(word)) {
        // existing param, no }
        var i = val.indexOf(word);
        var first = val.substr(0, i);
        var last = val.substr(i + word.length, val.length);
        var str = (first ? first : '') + ' {' + param + '} ' + (last ? last : '');
        str = str.trim().replace(/\s+/g, ' ');
        this.$refs.textarea.value = str;
      } else if (word && !this.isParam(word) && this.isUnfinishedParam(word)) {
        // new param, needs }
        var _i = val.indexOf(word);
        var _first = val.substr(0, _i);
        var _last = val.substr(_i + word.length, val.length);
        var _str = (_first ? _first : '') + ' {' + param + '} ' + (_last ? _last : '');
        _str = _str.trim().replace(/\s+/g, ' ');
        this.$refs.textarea.value = _str;
      }
    },
    onInputBlur: function onInputBlur(e) {
      var _this = this;

      if (e.target.value === '' || e.target.value === ' ') {
        e.target.value = '(no content)';
        this.isEmpty = true;
      }
      var val = this.isEmpty ? '' : e.target.value;
      setTimeout(function () {
        _this.showParamMenu = false;
        _this.paramCoords = null;
      }, 200); // allow for param click to engage

      // handle update vuex
      var activeRecord = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getActiveLocalRecord);
      if (this.section === 'title' || this.section === 'callToAction') {
        if (!activeRecord[this.section]) {
          activeRecord[this.section] = {};
        }
        activeRecord[this.section][this.activeSetting] = val;
      } else if (this.section === 'subject' || this.section === 'bodyText') {
        if (activeRecord.message) {
          activeRecord.message[this.section] = val;
        } else {
          activeRecord.message = {};
          activeRecord.message[this.section] = val;
        }
      } else {
        activeRecord[this.section] = val;
      }
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setActiveLocalRecord', activeRecord);
    },
    onInputFocus: function onInputFocus(e) {
      if (e.target.value === '(no content)') {
        e.target.value = '';
      }
    },
    onInputChange: function onInputChange(e) {
      if (e.target.value === '(no content)') {
        this.isEmpty = true;
      } else {
        this.isEmpty = false;
      }
      this.textareaResize();
      var sel = this.$refs.textarea.selectionStart;
      var word = this.getWord(e.target.value, sel);
      var isParam = this.isUnfinishedParam(word);
      var xy = getCursorXY(e.target, sel);

      // if y is close to bottom of window,
      // invert popup

      if (xy.y > window.innerHeight - 100) xy.y = xy.y - 240;

      if (isParam) {
        this.paramCoords = xy;
        this.showParamMenu = true;
      } else {
        this.showParamMenu = false;
        this.paramCoords = null;
      }
    },
    isParam: function isParam(word) {
      var first = word.indexOf('{');
      var last = word.indexOf('}');
      return first === 0 && last === word.length - 1 ? true : false;
    },
    isUnfinishedParam: function isUnfinishedParam(word) {
      var first = word.indexOf('{');
      return first === 0 ? true : false;
    },
    getWord: function getWord(val, offset) {
      var words = val.split(' ');
      var found = void 0;
      var count = 0;
      for (var i in words) {
        count += words[i].length;
        if (i !== 0) count += 1;
        if (offset === count - 1) {
          // at beginning of word
          return words[i];
        } else if (offset === count) {
          // at end of word
          var ii = parseInt(i, 10) + 1;
          return words[ii];
        } else if (count > offset) {
          return words[i];
        }
      }
    },
    filteredParamOptions: function filteredParamOptions() {
      var sel = this.$refs.textarea.selectionStart;
      var word = this.getWord(this.$refs.textarea.value, sel);
      word = word.substring(1, word.length - 1);
      var arr = this.paramOptions.filter(function (o) {
        return o.indexOf(word) !== -1;
      });
      console.log(arr);
      if (!arr.length) return this.paramOptions;
      return arr;
    }
  },
  mounted: function mounted() {
    this.$refs.textarea.style.minHeight = this.$refs.textarea.scrollHeight + 'px';
    if (this.$refs.textarea.value === '(no content)') this.isEmpty = true;
  }
});

/***/ }),

/***/ "uQHr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('nav',{staticClass:"nav"},[_c('router-link',{staticClass:"button__action",attrs:{"to":"/markets/","active-class":"null"}},[_c('i',{staticClass:"glyphicon glyphicon-chevron-left icon"}),_vm._v("Go back")]),_c('div',{staticClass:"submit__container"},[_c('button',{staticClass:"button__submit",attrs:{"type":"button"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])])],1),_c('header',[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.getActiveMarket.title))]),_c('div',[_c('img',{attrs:{"src":_vm.getFlagUrl(_vm.getActiveMarket)}})])]),_c('div',{staticClass:"editing__container"},[(_vm.getActiveMarket)?_c('vue-tabs',{attrs:{"activeTextColor":"#09a3ed"}},[_c('v-tab',{attrs:{"title":"General Settings"}},[_c('div',{staticClass:"inner-tab"},[_c('div',{staticClass:"top-details"},[_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Market")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.title),expression:"getActiveMarket.title"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket, "title", $event.target.value)}}})]),_c('div',[_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Locale")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.locale),expression:"getActiveMarket.locale"}],staticClass:"input__text title",attrs:{"disabled":"disabled","type":"text"},domProps:{"value":(_vm.getActiveMarket.locale)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket, "locale", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Country")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.country),expression:"getActiveMarket.country"}],staticClass:"input__text title",attrs:{"disabled":"disabled","type":"text"},domProps:{"value":(_vm.getActiveMarket.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket, "country", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Language")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.primaryLanguage),expression:"getActiveMarket.primaryLanguage"}],staticClass:"input__text title",attrs:{"disabled":"disabled","type":"text"},domProps:{"value":(_vm.getActiveMarket.primaryLanguage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket, "primaryLanguage", $event.target.value)}}})]),_c('p',[_vm._v("Note: Countries and languages for markets are not editable.")])])])])]),_c('v-tab',{attrs:{"title":"App Activity Phrases"}},[_c('div',{staticClass:"inner-tab"},[(!_vm.getActiveMarket.hasPhrases)?_c('div',[_c('p',[_vm._v("No activity phrases found for this market.")]),_c('div',{staticClass:"button-container"},[_c('button',{staticClass:"button__action",on:{"click":_vm.createBlankActivityPhrases}},[_vm._v("Create activity phrases from scratch")]),_c('button',{staticClass:"button__action",on:{"click":_vm.copyActivityPhrases}},[_vm._v("Copy activity phrases from an existing market")]),(_vm.showMarketChoices)?_c('div',{staticClass:"copy-phrases"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.copyFromMarket),expression:"copyFromMarket"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.copyFromMarket=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.getMarkets),function(market){return (market.locale != _vm.getActiveMarket.locale)?_c('option',{domProps:{"value":market.locale}},[_vm._v(_vm._s(market.title))]):_vm._e()})),_c('button',{staticClass:"button__action",on:{"click":_vm.createCopiedPhrases}},[_vm._v("Copy")])]):_vm._e()])]):_vm._e(),(_vm.getActiveMarket.hasPhrases)?_c('div',{staticClass:"form"},[_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Enrollment")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.enrollment),expression:"getActiveMarket.activityPhrases.enrollment"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.enrollment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "enrollment", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Completed Enrollment")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.completed_enrollment),expression:"getActiveMarket.activityPhrases.completed_enrollment"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.completed_enrollment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "completed_enrollment", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Added Contact")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.added_contact),expression:"getActiveMarket.activityPhrases.added_contact"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.added_contact)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "added_contact", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Media Followed Up")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.media_followed_up),expression:"getActiveMarket.activityPhrases.media_followed_up"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.media_followed_up)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "media_followed_up", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Low Interest Follow Up")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.low_interest_follow_up),expression:"getActiveMarket.activityPhrases.low_interest_follow_up"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.low_interest_follow_up)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "low_interest_follow_up", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Default Follow Up")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.default_follow_up),expression:"getActiveMarket.activityPhrases.default_follow_up"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.default_follow_up)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "default_follow_up", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Shared Cart")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.shared_cart),expression:"getActiveMarket.activityPhrases.shared_cart"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.shared_cart)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "shared_cart", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Purchased Cart")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.purchased_cart),expression:"getActiveMarket.activityPhrases.purchased_cart"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.purchased_cart)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "purchased_cart", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Shipped Cart")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.shipped_cart),expression:"getActiveMarket.activityPhrases.shipped_cart"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.shipped_cart)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "shipped_cart", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Scheduled Meeting With Title")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.scheduled_meeting_with_title),expression:"getActiveMarket.activityPhrases.scheduled_meeting_with_title"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.scheduled_meeting_with_title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "scheduled_meeting_with_title", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Blank Meeting")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.blank_meeting),expression:"getActiveMarket.activityPhrases.blank_meeting"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.blank_meeting)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "blank_meeting", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Future Meeting")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.future_meeting),expression:"getActiveMarket.activityPhrases.future_meeting"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.future_meeting)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "future_meeting", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Sent Message")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.sent_message),expression:"getActiveMarket.activityPhrases.sent_message"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.sent_message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "sent_message", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Sent Email")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.sent_email),expression:"getActiveMarket.activityPhrases.sent_email"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.sent_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "sent_email", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Meeting Invite")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.meeting_invite),expression:"getActiveMarket.activityPhrases.meeting_invite"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.meeting_invite)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "meeting_invite", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Shared Media")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.shared_media),expression:"getActiveMarket.activityPhrases.shared_media"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.shared_media)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "shared_media", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Shared Multiple Media")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.shared_multiple_media),expression:"getActiveMarket.activityPhrases.shared_multiple_media"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.shared_multiple_media)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "shared_multiple_media", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Received Message")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.received_message),expression:"getActiveMarket.activityPhrases.received_message"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.received_message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "received_message", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Contact Assigned")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.contact_assigned),expression:"getActiveMarket.activityPhrases.contact_assigned"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.contact_assigned)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "contact_assigned", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Contact Updated")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.contact_updated),expression:"getActiveMarket.activityPhrases.contact_updated"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.contact_updated)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "contact_updated", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Failed Subscriptions")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.failed_subscriptions),expression:"getActiveMarket.activityPhrases.failed_subscriptions"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.failed_subscriptions)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "failed_subscriptions", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Failed Subscriptions Follow Up")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.failed_subscriptions_followup),expression:"getActiveMarket.activityPhrases.failed_subscriptions_followup"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.failed_subscriptions_followup)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "failed_subscriptions_followup", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Product Upsell")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.product_upsell),expression:"getActiveMarket.activityPhrases.product_upsell"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.product_upsell)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "product_upsell", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Default")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.default),expression:"getActiveMarket.activityPhrases.default"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.default)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "default", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("GDPR Text")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.gdprtext),expression:"getActiveMarket.activityPhrases.gdprtext"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.gdprtext)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "gdprtext", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("GDPR SMS Text")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.gdprsmstext),expression:"getActiveMarket.activityPhrases.gdprsmstext"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.gdprsmstext)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "gdprsmstext", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Message Signature")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.msgsignature),expression:"getActiveMarket.activityPhrases.msgsignature"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.msgsignature)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "msgsignature", $event.target.value)}}})]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Thank you")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.activityPhrases.thankyou),expression:"getActiveMarket.activityPhrases.thankyou"}],staticClass:"input__text title",attrs:{"type":"text"},domProps:{"value":(_vm.getActiveMarket.activityPhrases.thankyou)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.activityPhrases, "thankyou", $event.target.value)}}})])]):_vm._e()])]),_c('v-tab',{attrs:{"title":"Volume Links"}},[_c('div',{staticClass:"inner-tab"},[_c('div',{staticClass:"volume-link-header"},[_c('h3',[_vm._v("Volume Links")]),_c('button',{staticClass:"button__action copy-button",on:{"click":_vm.toggleCopyVolumeLinks}},[_vm._v("Copy from Other Market")])]),(!_vm.getActiveMarket.volumeLinks)?_c('p',[_vm._v("There are no volume links associated with this market.")]):_vm._e()]),(_vm.getActiveMarket.volumeLinks)?_c('div',{staticClass:"form"},_vm._l((_vm.getActiveMarket.volumeLinks.content),function(link,name,index){return _c('div',{staticClass:"form__control-group"},[_c('h4',[_vm._v(_vm._s(_vm.getActiveMarket.volumeLinks.content[name].label))]),_c('label',[_vm._v("Title")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.volumeLinks.content[name].title),expression:"getActiveMarket.volumeLinks.content[name].title"}],staticClass:"input__text title volume-title",attrs:{"type":"text","placeholder":"Title"},domProps:{"value":(_vm.getActiveMarket.volumeLinks.content[name].title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.volumeLinks.content[name], "title", $event.target.value)}}}),_c('label',[_vm._v("URL")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getActiveMarket.volumeLinks.content[name].url),expression:"getActiveMarket.volumeLinks.content[name].url"}],staticClass:"input__text title",attrs:{"type":"text","placeholder":"URL"},domProps:{"value":(_vm.getActiveMarket.volumeLinks.content[name].url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getActiveMarket.volumeLinks.content[name], "url", $event.target.value)}}})])})):_vm._e()]),_c('v-tab',{attrs:{"title":"Action Cards"}},[_c('div',{staticClass:"inner-tab"},[_c('div',[_c('h3',[_vm._v("Action Cards")]),(!_vm.getActiveMarket.cards || !_vm.getActiveMarket.cards.length)?_c('p',[_vm._v("There are no Action Cards associated with this market.")]):_vm._e(),_c('div',{staticClass:"card-grid"},_vm._l((_vm.getActiveMarket.cards),function(card,index){return _c('router-link',{key:("card-" + index),staticClass:"card-wrap",attrs:{"to":'/cards/'+card._id}},[_c('LibraryActionCard',{attrs:{"slug":card.legacyName ? card.legacyName : '',"cardTitle":card.displayName === 'Training Media' ? (card.mediaId ? card.mediaId.title : '') : card.displayName,"media":card.mediaId ? card.mediaId : null,"title":card.title ? card.title.intial : null,"callToAction":card.callToAction ? card.callToAction.intial : ''}})],1)}))])])]),_c('v-tab',{attrs:{"title":"Media"}},[_c('div',{staticClass:"inner-tab"},[_c('h3',[_vm._v("Media")]),(!_vm.getActiveMarket.mediaRecords || !_vm.getActiveMarket.mediaRecords.length)?_c('p',[_vm._v("There are no media items associated with this market.")]):_vm._e(),_c('div',{staticClass:"media-items-list"},_vm._l((_vm.getActiveMarket.mediaRecords),function(media,index){return _c('router-link',{key:("media-" + index),attrs:{"to":("/media/" + (media._id))}},[_c('img',{attrs:{"src":media.thumbnail}})])}))])]),_c('v-tab',{attrs:{"title":"Product Groups"}},[_c('div',{staticClass:"inner-tab"},[_c('h3',[_vm._v("Product Groups")]),(!_vm.getActiveMarket.productGroups || !_vm.getActiveMarket.productGroups.length)?_c('p',[_vm._v("There are no product groups associated with this market.")]):_vm._e(),_c('div',{staticClass:"product-group-list"},_vm._l((_vm.getActiveMarket.productGroups),function(productGroup){return _c('router-link',{key:("" + (productGroup._id)),staticClass:"product-group__link",attrs:{"to":("/product-groups/" + (productGroup._id))}},[_c('div',{staticClass:"product box"},[_c('h3',[_vm._v(_vm._s(productGroup.title))])])])}))])]),_c('v-tab',{attrs:{"title":"Products"}},[_c('div',{staticClass:"inner-tab"},[_c('h3',[_vm._v("Products"),(!_vm.showProducts && _vm.getActiveMarket.products && _vm.getActiveMarket.products.length)?_c('button',{staticClass:"button__action",on:{"click":_vm.toggleProducts}},[_vm._v("Show")]):_vm._e(),(_vm.showProducts && _vm.getActiveMarket.products && _vm.getActiveMarket.products.length)?_c('button',{staticClass:"button__action",on:{"click":_vm.toggleProducts}},[_vm._v("Hide")]):_vm._e()]),(!_vm.getActiveMarket.products ||  !_vm.getActiveMarket.products.length)?_c('p',[_vm._v("There are no products associated with this market.")]):_vm._e(),(_vm.showProducts)?_c('div',{staticClass:"products"},_vm._l((_vm.getActiveMarket.products),function(product){return _c('router-link',{key:("" + (product._id)),staticClass:"product__link",attrs:{"to":("/products/" + (product._id))}},[_c('div',{staticClass:"product box"},[_c('div',{staticClass:"image__container"},[(product.defaultImage)?_c('img',{attrs:{"src":product.defaultImage}}):_vm._e(),(!product.defaultImage)?_c('img',{attrs:{"src":"/static/images/product-placeholder.png"}}):_vm._e()]),_c('h3',[_vm._v(_vm._s(product.name))])])])})):_vm._e()])])],1):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uQyi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__placeholder__ = __webpack_require__("Y8nc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__not_available_placeholder__ = __webpack_require__("jbzV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__waiting_placeholder__ = __webpack_require__("NvbM");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var defaultMaxSize = 120;
var notAvailableStatus = 'not-available';
var waitingStatus = 'waiting';

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Placeholder: __WEBPACK_IMPORTED_MODULE_0__placeholder__["a" /* default */],
    NotAvailablePlaceholder: __WEBPACK_IMPORTED_MODULE_1__not_available_placeholder__["a" /* default */],
    WaitingPlaceholder: __WEBPACK_IMPORTED_MODULE_2__waiting_placeholder__["a" /* default */]
  },
  props: {
    customResizer: {
      type: Function
    },
    fromServer: {
      type: Boolean
    },
    id: {
      type: Number,
      required: true
    },
    maxSize: {
      type: Number,
      default: defaultMaxSize
    },
    uploader: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      drawComplete: false,
      notAvailableStatus: notAvailableStatus,
      waitingStatus: waitingStatus,
      placeholderClass: 'vue-fine-uploader-thumbnail ' + (this.class || ''),
      rootClass: 'vue-fine-uploader-thumbnail-container ' + (this.class && this.class + '-container' || ''),
      canvasClass: 'vue-fine-uploader-thumbnail ' + (this.class || '')
    };
  },

  computed: {
    isHidden: function isHidden() {
      return !this.drawComplete || this._failure;
    },
    _failure: function _failure() {
      return this.drawComplete && !this.success;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.uploader.methods.drawThumbnail(this.id, this.$refs.canvas, this.maxSize, this.fromServer, this.customResizer).then(function () {
      _this.drawComplete = true;
      _this.success = true;
    }, function () {
      _this.drawComplete = true;
      _this.success = false;
    });
  }
});

/***/ }),

/***/ "uTrW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_local_storage__ = __webpack_require__("+Y1O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("olkN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LogoutModal',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
  },
  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('hideModals', true);
      __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.set('GEG__KEY', '');
      this.$router.push('/');
      this.showSuccessMsg({ message: 'You\'ve been logged out.' });
    },
    cancel: function cancel() {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('hideModals', true);
    }
  },
  data: function data() {
    return {
      userId: null,
      stage: null
    };
  },

  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success,
      title: '',
      icon: 'ℹ️'
    }
  }
});

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_state__ = __webpack_require__("lwq5");



/* harmony default export */ __webpack_exports__["a"] = ({
    resetState: function resetState(state, callback) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_2__store_state__["a" /* default */]).forEach(function (key, index) {
            state[key] = __WEBPACK_IMPORTED_MODULE_2__store_state__["a" /* default */][key];
            if (index === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_2__store_state__["a" /* default */]).length - 1) callback();
        });
    },

    /**
     * Set environment properties like API endpoints
     * @param {State} state
     * @param {string|false} env
     */
    setEnv: function setEnv(state) {
        var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "production";

        switch (env) {
            case 'development':
                state.env = 'dev';
                break;
            case 'staging':
                state.env = 'test';
                break;
            case 'production':
                state.env = 'production';
                break;
            default:
                state.env = 'dev';
        }
    },


    /**
     * Tenant mutators
     */
    setTenant: function setTenant(state, tenant) {
        state.tenant = tenant;
    },
    setDomain: function setDomain(state, domain) {
        state.domain = domain;
    },

    /**
     * User mutators
     */
    setUser: function setUser(state, user) {
        state.user = user;
    },


    /**
    * General
    */
    hideModals: function hideModals(state, status) {
        state.showAddCardToSequenceModal = false;
        state.showAddMediaToCardModal = false;
        state.showAddSequenceToPolicyModal = false;
        state.showCardHelpModal = false;
        state.showColdDeckModal = false;
        state.showCreateCardModal = false;
        state.showCreateLocalRecordModal = false;
        state.showCreateMarketModal = false;
        state.showCreateProductLocalRecordModal = false;
        state.showCreateProductGroupLocalRecordModal = false;
        state.showCreateProductModal = false;
        state.showCreateProductGroupModal = false;
        state.showCreateMediaLibraryModal = false;
        state.showCreateMediaLibraryLocalRecordModal = false;
        state.showDeprecateMediaModal = false;
        state.showLogoutModal = false;
        state.showUpateThumbModal = false;
        state.showUpdateThumbModal = false;
        state.showUploadMediaModal = false;
        state.showUploadProductImageModal = false;
        state.showCardIconModal = false;
        state.showCopyVolumeLinksModal = false;
        state.showCopyLocalRecordModal = false;
        state.showDeleteProductModal = false;
        state.showRestoreProductModal = false;
        state.showDeleteRecordModal = false;
    },


    /**
    * Charts
    */
    setCharts: function setCharts(state, charts) {
        state.charts = charts;
    },


    /**
     * Cards
    */
    setCards: function setCards(state, cards) {
        state.cards = cards;
        state.cardsLoaded = true;
    },
    setCardTypes: function setCardTypes(state, types) {
        state.cardTypes = types;
    },
    setActiveCard: function setActiveCard(state, card) {
        state.activeCard = card;
    },
    setActiveLocale: function setActiveLocale(state, locale) {
        state.activeLocale = locale;
    },
    setActiveLocalRecord: function setActiveLocalRecord(state, record) {
        state.activeLocalRecord = record;
    },


    // updateActiveCardLocalRecordSection(state, section, subsection, value){
    //     console.log(value);
    //     state.activeLocalRecord[section][subsection] = value;
    // },

    setActiveLocalRecordSaved: function setActiveLocalRecordSaved(state, record) {
        state.activeLocalRecordSaved = record;
    },
    showCardIconModal: function showCardIconModal(state, status) {
        state.showCardIconModal = status;
    },
    showCopyLocalRecordModal: function showCopyLocalRecordModal(state, status) {
        state.showCopyLocalRecordModal = status;
    },
    showCopyVolumeLinksModal: function showCopyVolumeLinksModal(state, status) {
        state.showCopyVolumeLinksModal = status;
    },
    setCardIconContext: function setCardIconContext(state, status) {
        state.cardIconContext = status;
    },


    /**
    * Media
    */
    setMedia: function setMedia(state, media) {
        state.media = media;
        state.mediaLoaded = true;
    },
    setActiveMedia: function setActiveMedia(state, media) {
        state.activeMedia = media;
    },
    setMediaLoadedStatus: function setMediaLoadedStatus(state, status) {
        state.mediaLoaded = status;
    },
    showAddCardToSequenceModal: function showAddCardToSequenceModal(state, status) {
        state.showAddCardToSequenceModal = status;
    },
    showMediaUploadModal: function showMediaUploadModal(state, status) {
        state.showUploadMediaModal = status;
    },
    showUpdateThumbModal: function showUpdateThumbModal(state, status) {
        state.showUpdateThumbModal = status;
    },
    showDeprecateMediaModal: function showDeprecateMediaModal(state, status) {
        state.showDeprecateMediaModal = status;
    },
    showColdDeckModal: function showColdDeckModal(state, status) {
        state.showColdDeckModal = status;
    },
    showLogoutModal: function showLogoutModal(state, status) {
        state.showLogoutModal = status;
    },
    showCardHelpModal: function showCardHelpModal(state, status) {
        state.showCardHelpModal = status;
    },
    setAllProducts: function setAllProducts(state, products) {
        state.products = products;
    },
    setActiveProducts: function setActiveProducts(state, product) {
        state.activeProduct = product;
    },
    setAllProductGroups: function setAllProductGroups(state, productGroups) {
        state.allProductGroups = productGroups;
    },
    setAllMediaLibraries: function setAllMediaLibraries(state, libraries) {
        state.allMediaLibraries = libraries;
    },
    setActiveMediaLibrary: function setActiveMediaLibrary(state, mediaLibrary) {
        state.activeMediaLibrary = mediaLibrary;
    },
    showAddMediaToCardModal: function showAddMediaToCardModal(state, status) {
        state.showAddMediaToCardModal = status;
    },
    showCreateCardModal: function showCreateCardModal(state, status) {
        state.showCreateCardModal = status;
    },
    showCreateLocalRecordModal: function showCreateLocalRecordModal(state, status) {
        state.showCreateLocalRecordModal = status;
    },
    showCreateMediaLibraryModal: function showCreateMediaLibraryModal(state, status) {
        state.showCreateMediaLibraryModal = status;
    },
    showCreateMediaLibraryLocalRecordModal: function showCreateMediaLibraryLocalRecordModal(state, status) {
        state.showCreateMediaLibraryLocalRecordModal = status;
    },
    showCreateProductLocalRecordModal: function showCreateProductLocalRecordModal(state, status) {
        state.showCreateProductLocalRecordModal = status;
    },
    showCreateProductGroupLocalRecordModal: function showCreateProductGroupLocalRecordModal(state, status) {
        state.showCreateProductGroupLocalRecordModal = status;
    },
    showCreateMarketModal: function showCreateMarketModal(state, status) {
        state.showCreateMarketModal = status;
    },
    showCreateProductModal: function showCreateProductModal(state, status) {
        state.showCreateProductModal = status;
    },
    showCreateProductGroupModal: function showCreateProductGroupModal(state, status) {
        state.showCreateProductGroupModal = status;
    },
    showUploadProductImageModal: function showUploadProductImageModal(state, status) {
        state.showUploadProductImageModal = status;
    },
    showDeleteProductModal: function showDeleteProductModal(state, status) {
        state.showDeleteProductModal = status;
    },
    showDeleteRecordModal: function showDeleteRecordModal(state, status) {
        state.showDeleteRecordModal = status;
    },
    showRestoreProductModal: function showRestoreProductModal(state, status) {
        state.showRestoreProductModal = status;
    },
    setMediaTabs: function setMediaTabs(state, tabs) {
        state.mediaTabs = tabs;
    },
    setActiveMediaTab: function setActiveMediaTab(state, tab) {
        state.activeMediaTab = tab;
    },


    /**
    * Policies
    */

    setPolicies: function setPolicies(state, policies) {
        state.policies = policies;
    },
    setLastPolicyOption: function setLastPolicyOption(state, lastPolicyOption) {
        state.lastPolicyOption = lastPolicyOption;
    },
    setActivePolicy: function setActivePolicy(state, policy) {
        state.activePolicy = policy;
    },
    showAddSequenceToPolicyModal: function showAddSequenceToPolicyModal(state, status) {
        state.showAddSequenceToPolicyModal = status;
    },
    setInteractionTypes: function setInteractionTypes(state, types) {
        state.interactionTypes = types;
    },
    setSelectedSequence: function setSelectedSequence(state, sequence) {
        state.selectedSequence = sequence;
    },


    /**
    * Markets
    */
    setMarkets: function setMarkets(state, markets) {
        state.markets = markets;
        state.marketsLoaded = true;
    },
    setActiveMarket: function setActiveMarket(state, market) {
        state.activeMarket = market;
    },


    /**
    * Sequences
    */

    setSequences: function setSequences(state, sequences) {
        state.sequences = sequences;
    },
    setActiveSequence: function setActiveSequence(state, sequence) {
        state.activeSequence = sequence;
    },
    setSequenceCards: function setSequenceCards(state, cards) {
        state.sequenceCards = cards;
    },
    setOriginalSequenceCards: function setOriginalSequenceCards(state, cards) {
        state.originalSequenceCards = cards;
    },
    setSequenceStatus: function setSequenceStatus(state, status) {
        state.unsavedSequence = status;
    },


    /**
    * Products
    */

    setProducts: function setProducts(state, products) {
        state.products = products;
    },
    setActiveProduct: function setActiveProduct(state, product) {
        state.activeProduct = product;
    },
    setIsPrimaryImage: function setIsPrimaryImage(state, status) {
        state.isEditingPrimaryImage = status;
    },
    setActiveProductGroup: function setActiveProductGroup(state, productGroup) {
        state.activeProductGroup = productGroup;
    },


    /**
    * Errors
    */
    pushError: function pushError(state, error) {
        if (error) {
            state.errors.push(error);
        }
    },
    clearErrors: function clearErrors(state) {
        state.errors = [];
    }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "usmd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vDyk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vQRO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaRow_vue__ = __webpack_require__("LPxX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30a6f162_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MediaRow_vue__ = __webpack_require__("Yzb8");
function injectStyle (ssrContext) {
  __webpack_require__("aole")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30a6f162"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30a6f162_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MediaRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vjA/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vkBM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vomC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w+Gs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var isDeletable = function isDeletable(status) {
  return ['delete failed', 'upload successful'].indexOf(status) >= 0;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: Number,
      required: true
    },
    onlyRenderIfDeletable: {
      type: Boolean,
      default: true
    },
    uploader: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      state: {
        deletable: false,
        deleting: false
      },
      _unmounted: false
    };
  },
  mounted: function mounted() {
    this.uploader.on('statusChange', this._onStatusChange);
  },
  beforeDestroy: function beforeDestroy() {
    this._unmounted = true;
    this._unregisterStatusChangeHandler();
  },


  methods: {
    _onStatusChange: function _onStatusChange(id, oldStatus, newStatus) {
      if (id === this.id && !this._unmounted) {
        if (!isDeletable(newStatus) && newStatus !== 'deleting' && this.state.deletable) {
          !this._unmounted && this.$set(this.state, 'deletable', false);
          !this._unmounted && this.$set(this.state, 'deleting', false);
          this._unregisterStatusChangeHandler();
        } else if (isDeletable(newStatus) && !this.state.deletable) {
          this.$set(this.state, 'deletable', true);
          this.$set(this.state, 'deleting', false);
        } else if (newStatus === 'deleting' && !this.state.deleting) {
          this.$set(this.state, 'deleting', false);
        }
      }
    },
    _onClick: function _onClick() {
      if (this.state.deletable && !this.state.deleting) {
        this.uploader.methods.deleteFile(this.id);
      }
    },
    _unregisterStatusChangeHandler: function _unregisterStatusChangeHandler() {
      this.uploader.off('statusChange', this._onStatusChange);
    }
  }
});

/***/ }),

/***/ "w5Lk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-fine-uploader-file-input"},[_c('label',[_vm._t("default",[_vm._v("Upload File")]),_vm._v(" "),_c('input',{attrs:{"type":"file","multiple":_vm.multiple,"accept":_vm.accept,"required":_vm.required},on:{"change":_vm._onFilesSelected}})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w93M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wGu6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","fill":"#000000","viewBox":"0 0 24 24","width":"24"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wOvZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateThumb_vue__ = __webpack_require__("m2fk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f04c0934_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateThumb_vue__ = __webpack_require__("hgBb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateThumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f04c0934_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateThumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wWn5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_loader_lib_template_compiler_index_id_data_v_30ae4acf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_x_icon_vue__ = __webpack_require__("Swet");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__vue_loader_lib_template_compiler_index_id_data_v_30ae4acf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_x_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wbZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Close_vue__ = __webpack_require__("1JkZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_450644b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Close_vue__ = __webpack_require__("6Jq3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Close_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_450644b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Close_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wkzG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ChevronLeft_vue__ = __webpack_require__("MYLI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4890d17e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ChevronLeft_vue__ = __webpack_require__("p70h");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ChevronLeft_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4890d17e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ChevronLeft_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wqq6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isplainobject__ = __webpack_require__("hvKM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isplainobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isplainobject__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var formatSizeAndUnits = function formatSizeAndUnits(_ref) {
  var size = _ref.size,
      units = _ref.units;

  var formattedSize = void 0;
  var formattedUnits = void 0;

  if (size < 1e+3) {
    formattedSize = size;
    formattedUnits = units.byte;
  } else if (size >= 1e+3 && size < 1e+6) {
    formattedSize = (size / 1e+3).toFixed(2);
    formattedUnits = units.kilobyte;
  } else if (size >= 1e+6 && size < 1e+9) {
    formattedSize = (size / 1e+6).toFixed(2);
    formattedUnits = units.megabyte;
  } else if (size >= 1e+9 && size < 1e+12) {
    formattedSize = (size / 1e+9).toFixed(2);
    formattedUnits = units.gigabyte;
  } else {
    formattedSize = (size / 1e+12).toFixed(2);
    formattedUnits = units.terabyte;
  }

  return { size: formattedSize, units: formattedUnits };
};

var areUnitsEqual = function areUnitsEqual(units1, units2) {
  var keys1 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(units1);

  if (keys1.length === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(units2).length) {
    return keys1.every(function (key1) {
      return units1[key1] === units2[key1];
    });
  }

  return false;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: Number,
      required: true
    },
    units: {
      type: Object,
      validator: function validator(value) {
        var obj = {
          byte: 'string',
          kilobyte: 'string',
          megabyte: 'string',
          gigabyte: 'string',
          terabyte: 'string'
        };

        if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isplainobject___default()(value)) {
          return false;
        }

        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj);
        var valueKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(value);

        return valueKeys.every(function (key) {
          if (keys.indexOf(key) === -1) {
            return false;
          }

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value[key]) === obj[key];
        });
      },
      default: function _default() {
        return Object({
          byte: 'B',
          kilobyte: 'KB',
          megabyte: 'MB',
          gigabyte: 'GB',
          terabyte: 'TB'
        });
      }
    },
    uploader: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      state: {
        size: this.uploader.methods.getSize(this.id)
      }
    };
  },


  computed: {
    formatted: function formatted() {
      return formatSizeAndUnits({ size: this.state.size, units: this.units });
    }
  },

  created: function created() {
    var _this = this;

    var scalingOption = this.uploader.options.scaling;

    if (scalingOption && scalingOption.sizes.length) {
      // If this is a scaled image, the size won't be known until upload time.
      this._onUploadHandler = function (id) {
        if (id === _this.id) {
          _this.$set(_this.state, 'size', _this.uploader.methods.getSize(id));
        }
      };
    }
  },
  mounted: function mounted() {
    this._onUploadHandler && this.uploader.on('upload', this._onUploadHandler);
  },
  beforeDestroy: function beforeDestroy() {
    this._onUploadHandler && this.uploader.off('upload', this._onUploadHandler);
  },
  beforeUpdate: function beforeUpdate(nextProps, nextState) {
    return nextState.size !== this.state.size || !areUnitsEqual(nextProps.units, this.units);
  }
});

/***/ }),

/***/ "wtDP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PolicyLibrary_vue__ = __webpack_require__("Nsld");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4876474_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PolicyLibrary_vue__ = __webpack_require__("BvEj");
function injectStyle (ssrContext) {
  __webpack_require__("q25l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4876474"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PolicyLibrary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4876474_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PolicyLibrary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x3eB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TenantSettings_vue__ = __webpack_require__("Mcuh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fac30df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TenantSettings_vue__ = __webpack_require__("RDpX");
function injectStyle (ssrContext) {
  __webpack_require__("5Uzx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TenantSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fac30df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TenantSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x3qJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.onlyRenderIfRetryable && _vm.state.retryable)?_c('button',{staticClass:"vue-fine-uploader-retry-button",attrs:{"aria-label":"retry","disabled":!_vm.state.retryable},on:{"click":_vm._onClick}},[_vm._t("default",[_vm._v("Retry")])],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x8Rf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xFc/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":_vm.maxSize,"width":_vm.maxSize,"viewBox":"0 0 252 300","version":"1.1"}},[_c('path',{attrs:{"fill":"#ffffff","d":" M 0.00 0.00 L 252.00 0.00 L 252.00 300.00 L 0.00 300.00 L 0.00 279.07 C 0.21 281.56 2.43 283.73 4.98 283.51 C 54.33 283.52 103.68 283.47 153.03 283.53 C 163.75 293.62 178.22 299.86 193.02 299.75 C 209.68 300.16 226.27 292.72 237.25 280.22 C 246.51 269.83 252.00 255.97 251.75 242.00 C 252.22 227.72 246.68 213.46 237.19 202.83 C 236.46 201.92 235.43 201.19 235.01 200.08 C 234.92 158.48 235.13 116.87 234.91 75.28 C 215.93 56.82 196.64 38.69 177.62 20.28 C 170.86 14.13 164.58 7.44 157.65 1.49 C 106.73 1.51 55.82 1.49 4.90 1.50 C 2.72 1.29 1.25 3.08 0.00 4.58 L 0.00 0.00 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#525352","d":" M 0.00 4.58 C 1.25 3.08 2.72 1.29 4.90 1.50 C 55.82 1.49 106.73 1.51 157.65 1.49 C 164.58 7.44 170.86 14.13 177.62 20.28 C 196.64 38.69 215.93 56.82 234.91 75.28 C 235.13 116.87 234.92 158.48 235.01 200.08 C 235.43 201.19 236.46 201.92 237.19 202.83 C 246.68 213.46 252.22 227.72 251.75 242.00 C 252.00 255.97 246.51 269.83 237.25 280.22 C 226.27 292.72 209.68 300.16 193.02 299.75 C 178.22 299.86 163.75 293.62 153.03 283.53 C 103.68 283.47 54.33 283.52 4.98 283.51 C 2.43 283.73 0.21 281.56 0.00 279.07 L 0.00 4.58 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 18.27 19.97 C 19.84 19.39 21.63 19.90 23.28 19.79 C 21.74 21.53 19.73 22.95 18.62 25.03 C 18.50 28.06 18.60 31.09 18.69 34.11 C 23.87 29.67 28.43 24.52 33.33 19.77 C 37.67 19.77 42.01 19.65 46.34 19.84 C 37.18 29.45 27.59 38.65 18.27 48.11 C 18.40 38.72 17.69 29.36 18.27 19.97 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 23.28 19.79 C 26.63 19.71 29.98 19.75 33.33 19.77 C 28.43 24.52 23.87 29.67 18.69 34.11 C 18.60 31.09 18.50 28.06 18.62 25.03 C 19.73 22.95 21.74 21.53 23.28 19.79 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 46.34 19.84 C 49.71 19.63 53.13 19.80 56.52 19.77 C 43.83 32.57 31.13 45.37 18.25 57.99 C 18.26 54.69 18.22 51.40 18.27 48.11 C 27.59 38.65 37.18 29.45 46.34 19.84 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 56.52 19.77 C 60.83 19.74 65.14 19.71 69.45 19.79 C 52.52 37.03 35.29 53.98 18.27 71.12 C 18.23 66.74 18.25 62.36 18.25 57.99 C 31.13 45.37 43.83 32.57 56.52 19.77 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 69.45 19.79 C 72.81 19.70 76.17 19.76 79.53 19.77 C 59.20 40.32 38.60 60.61 18.28 81.17 C 18.23 77.82 18.23 74.47 18.27 71.12 C 35.29 53.98 52.52 37.03 69.45 19.79 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 79.53 19.77 C 83.77 19.95 88.19 19.29 92.32 20.11 C 67.83 44.98 43.05 69.60 18.30 94.22 C 18.22 89.87 18.23 85.52 18.28 81.17 C 38.60 60.61 59.20 40.32 79.53 19.77 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 92.32 20.11 L 92.70 19.72 C 96.04 19.80 99.39 19.71 102.74 19.77 C 74.71 48.09 46.39 76.13 18.28 104.37 C 18.25 100.98 18.20 97.60 18.30 94.22 C 43.05 69.60 67.83 44.98 92.32 20.11 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 102.74 19.77 C 106.92 19.93 111.25 19.32 115.34 20.09 C 112.00 23.83 108.31 27.23 104.81 30.81 C 75.95 59.59 47.26 88.53 18.30 117.21 C 18.22 112.93 18.23 108.64 18.28 104.37 C 46.39 76.13 74.71 48.09 102.74 19.77 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 115.34 20.09 L 115.69 19.72 C 119.04 19.80 122.38 19.71 125.73 19.77 C 90.04 55.76 54.06 91.46 18.28 127.37 C 18.25 123.98 18.19 120.59 18.30 117.21 C 47.26 88.53 75.95 59.59 104.81 30.81 C 108.31 27.23 112.00 23.83 115.34 20.09 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 125.73 19.77 C 129.88 20.06 134.43 19.06 138.31 20.29 C 136.70 22.34 134.76 24.09 132.93 25.94 C 102.10 56.77 71.27 87.60 40.44 118.43 C 33.04 125.71 25.89 133.24 18.33 140.34 C 18.18 136.02 18.25 131.69 18.28 127.37 C 54.06 91.46 90.04 55.76 125.73 19.77 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 138.31 20.29 L 138.78 19.74 C 142.18 19.77 145.58 19.73 148.97 19.77 C 105.53 63.48 61.86 106.99 18.27 150.56 C 18.28 147.15 18.15 143.74 18.33 140.34 C 25.89 133.24 33.04 125.71 40.44 118.43 C 71.27 87.60 102.10 56.77 132.93 25.94 C 134.76 24.09 136.70 22.34 138.31 20.29 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 148.97 19.77 C 149.41 19.77 150.29 19.77 150.73 19.77 C 150.76 23.59 150.76 27.40 150.74 31.21 C 109.55 72.22 68.53 113.39 27.41 154.46 C 24.39 157.43 21.49 160.54 18.32 163.36 C 18.18 159.09 18.26 154.82 18.27 150.56 C 61.86 106.99 105.53 63.48 148.97 19.77 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 27.41 154.46 C 68.53 113.39 109.55 72.22 150.74 31.21 C 150.76 34.49 150.75 37.78 150.75 41.06 C 106.64 85.27 62.49 129.44 18.26 173.53 C 18.28 170.14 18.16 166.74 18.32 163.36 C 21.49 160.54 24.39 157.43 27.41 154.46 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 18.26 173.53 C 62.49 129.44 106.64 85.27 150.75 41.06 C 150.74 45.52 150.78 49.99 150.73 54.45 C 106.53 98.56 62.38 142.72 18.26 186.92 C 18.25 182.46 18.23 177.99 18.26 173.53 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 18.26 186.92 C 62.38 142.72 106.53 98.56 150.73 54.45 C 150.69 57.78 150.90 61.14 150.64 64.46 C 149.89 65.10 149.15 65.76 148.44 66.44 C 105.03 109.79 61.71 153.23 18.27 196.56 C 18.23 193.34 18.24 190.13 18.26 186.92 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 148.44 66.44 C 149.15 65.76 149.89 65.10 150.64 64.46 C 150.87 68.77 150.72 73.11 150.73 77.43 C 106.56 121.58 62.35 165.71 18.26 209.94 C 18.26 205.48 18.22 201.01 18.27 196.56 C 61.71 153.23 105.03 109.79 148.44 66.44 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 18.26 209.94 C 62.35 165.71 106.56 121.58 150.73 77.43 C 150.51 80.16 150.59 83.44 153.47 84.78 C 108.27 129.65 63.42 174.88 18.26 219.80 C 18.24 216.51 18.24 213.22 18.26 209.94 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 153.47 84.78 C 157.68 85.24 161.92 84.84 166.14 85.07 C 117.01 134.57 67.55 183.74 18.27 233.09 C 18.24 228.66 18.24 224.23 18.26 219.80 C 63.42 174.88 108.27 129.65 153.47 84.78 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 166.14 85.07 C 169.49 84.92 172.85 85.00 176.20 85.04 C 123.43 137.48 71.02 190.31 18.26 242.77 C 18.25 239.54 18.22 236.32 18.27 233.09 C 67.55 183.74 117.01 134.57 166.14 85.07 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 176.20 85.04 C 180.51 84.97 184.82 84.95 189.12 85.08 C 132.35 142.26 75.19 199.07 18.27 256.11 C 18.24 251.66 18.24 247.22 18.26 242.77 C 71.02 190.31 123.43 137.48 176.20 85.04 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 189.12 85.08 C 192.54 84.91 195.97 85.01 199.39 85.03 C 142.78 141.53 86.28 198.13 29.71 254.67 C 26.34 258.11 22.79 261.40 19.56 264.98 L 18.98 265.60 C 17.33 263.02 18.67 259.18 18.27 256.11 C 75.19 199.07 132.35 142.26 189.12 85.08 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 199.39 85.03 C 203.66 85.00 207.95 84.90 212.22 85.11 C 198.55 99.45 184.25 113.18 170.34 127.28 C 124.40 173.28 78.35 219.17 32.48 265.23 C 28.18 265.12 23.80 265.58 19.56 264.98 C 22.79 261.40 26.34 258.11 29.71 254.67 C 86.28 198.13 142.78 141.53 199.39 85.03 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 212.22 85.11 C 213.79 84.88 215.40 85.02 216.98 85.01 C 216.96 86.94 217.14 88.89 216.87 90.80 C 201.36 105.62 186.47 121.10 171.20 136.17 C 139.03 168.35 106.85 200.53 74.67 232.70 C 64.06 243.45 53.17 253.94 42.73 264.85 L 42.33 265.28 C 39.05 265.20 35.76 265.29 32.48 265.23 C 78.35 219.17 124.40 173.28 170.34 127.28 C 184.25 113.18 198.55 99.45 212.22 85.11 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 171.20 136.17 C 186.47 121.10 201.36 105.62 216.87 90.80 C 217.12 95.07 216.98 99.35 216.97 103.62 C 163.19 157.54 109.22 211.27 55.49 265.23 C 51.26 265.02 46.80 265.76 42.73 264.85 C 53.17 253.94 64.06 243.45 74.67 232.70 C 106.85 200.53 139.03 168.35 171.20 136.17 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 55.49 265.23 C 109.22 211.27 163.19 157.54 216.97 103.62 C 216.98 107.04 217.09 110.47 216.92 113.89 C 169.72 160.66 122.91 207.83 75.87 254.76 C 72.45 258.24 68.88 261.57 65.61 265.19 C 62.24 265.32 58.86 265.23 55.49 265.23 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 75.87 254.76 C 122.91 207.83 169.72 160.66 216.92 113.89 C 217.06 118.13 217.01 122.37 216.97 126.61 C 170.87 172.88 124.54 218.92 78.49 265.23 C 74.20 265.25 69.90 265.31 65.61 265.19 C 68.88 261.57 72.45 258.24 75.87 254.76 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 78.49 265.23 C 124.54 218.92 170.87 172.88 216.97 126.61 C 217.00 130.02 217.07 133.43 216.94 136.83 C 199.92 153.51 183.23 170.52 166.31 187.30 C 164.81 188.76 163.34 190.26 162.10 191.94 C 159.60 194.48 156.45 196.32 153.93 198.86 C 150.05 202.08 147.44 206.51 143.95 210.08 C 140.61 212.64 137.88 215.88 134.84 218.78 C 119.44 234.28 103.85 249.59 88.57 265.20 C 85.21 265.30 81.85 265.23 78.49 265.23 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 166.31 187.30 C 183.23 170.52 199.92 153.51 216.94 136.83 C 217.03 141.15 217.04 145.47 216.95 149.78 C 205.65 161.41 194.02 172.72 182.63 184.27 C 175.92 185.62 169.42 188.04 163.54 191.58 C 163.18 191.67 162.46 191.85 162.10 191.94 C 163.34 190.26 164.81 188.76 166.31 187.30 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 182.63 184.27 C 194.02 172.72 205.65 161.41 216.95 149.78 C 217.02 153.17 217.03 156.56 216.97 159.95 C 209.19 167.66 201.42 175.39 193.74 183.20 C 190.01 183.32 186.30 183.64 182.63 184.27 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 193.74 183.20 C 201.42 175.39 209.19 167.66 216.97 159.95 C 217.01 164.23 217.04 168.51 216.96 172.80 C 213.60 176.97 208.68 179.97 206.09 184.65 C 202.04 183.69 197.88 183.37 193.74 183.20 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 206.09 184.65 C 208.68 179.97 213.60 176.97 216.96 172.80 C 216.97 176.81 217.19 180.83 216.73 184.83 L 215.42 184.54 C 215.53 185.11 215.73 186.25 215.83 186.82 C 212.45 186.71 209.40 185.16 206.09 184.65 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 134.84 218.78 C 137.88 215.88 140.61 212.64 143.95 210.08 C 143.87 210.46 143.70 211.23 143.62 211.61 C 140.00 217.58 137.54 224.21 136.28 231.07 L 136.28 231.07 C 135.42 231.60 134.62 232.21 133.92 232.93 C 123.19 243.72 112.39 254.43 101.67 265.23 C 97.30 265.26 92.93 265.29 88.57 265.20 C 103.85 249.59 119.44 234.28 134.84 218.78 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 133.92 232.93 C 134.62 232.21 135.42 231.60 136.28 231.07 C 135.60 234.54 135.44 238.06 135.44 241.58 C 127.40 249.32 119.58 257.30 111.72 265.22 C 108.37 265.29 105.02 265.25 101.67 265.23 C 112.39 254.43 123.19 243.72 133.92 232.93 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 162.75 232.54 C 183.33 232.46 203.91 232.49 224.48 232.52 C 224.51 238.51 224.52 244.49 224.48 250.48 C 203.91 250.50 183.33 250.54 162.76 250.47 C 162.74 244.49 162.75 238.51 162.75 232.54 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#bababa","d":" M 111.72 265.22 C 119.58 257.30 127.40 249.32 135.44 241.58 C 135.36 245.55 135.82 249.48 136.51 253.39 C 132.54 257.31 128.60 261.27 124.66 265.23 C 120.35 265.27 116.03 265.28 111.72 265.22 Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#ffffff","d":" M 124.66 265.23 C 128.60 261.27 132.54 257.31 136.51 253.39 C 136.91 256.83 139.27 260.12 138.36 263.61 L 139.68 263.56 C 139.81 263.80 140.07 264.30 140.20 264.54 C 138.21 264.75 136.08 264.17 134.27 265.28 C 131.07 265.21 127.86 265.29 124.66 265.23 Z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Utils__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Services_js__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_local_storage__ = __webpack_require__("+Y1O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_DeprecateMedia__ = __webpack_require__("Drut");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_MediaUpload__ = __webpack_require__("/bWl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_AddMediaToCard__ = __webpack_require__("4fE7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_AddSequenceToPolicy__ = __webpack_require__("RVph");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_AddCardToSequence__ = __webpack_require__("ADqj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_UpdateThumb__ = __webpack_require__("wOvZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_DeleteRecord__ = __webpack_require__("7kDE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_EditCardHelp__ = __webpack_require__("gS9E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_CreateActionCard__ = __webpack_require__("sgY4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_modals_CreateCardLocalRecord__ = __webpack_require__("IGsQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_modals_CopyCardLocalRecord__ = __webpack_require__("7aWo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_modals_CopyVolumeLinks__ = __webpack_require__("pWUv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_modals_CreateMediaLibrary__ = __webpack_require__("FOrB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_modals_CreateMediaLibraryLocalRecord__ = __webpack_require__("nmuS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_modals_CreateProductLocalRecord__ = __webpack_require__("goc0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_modals_CreateProductGroupLocalRecord__ = __webpack_require__("sYv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_modals_ProductImageUpload__ = __webpack_require__("b18h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_modals_CardIconUpload__ = __webpack_require__("jYxr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_modals_CreateProductGroup__ = __webpack_require__("ZNO1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_modals_CreateProduct__ = __webpack_require__("cnpZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_modals_CreateMarket__ = __webpack_require__("yfN4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_modals_ColdDeckReset__ = __webpack_require__("64t4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_modals_DeleteProduct__ = __webpack_require__("rMq4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_modals_RestoreProduct__ = __webpack_require__("4D0O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_modals_Logout__ = __webpack_require__("83Hu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vue_notifications__);



var _components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
































/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  created: function created() {
    /**
     * Set the environment
     */
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setEnv');
  },

  components: (_components = {
    AddMediaToCardModal: __WEBPACK_IMPORTED_MODULE_9__components_modals_AddMediaToCard__["a" /* default */],
    AddSequenceToPolicyModal: __WEBPACK_IMPORTED_MODULE_10__components_modals_AddSequenceToPolicy__["a" /* default */],
    AddCardToSequenceModal: __WEBPACK_IMPORTED_MODULE_11__components_modals_AddCardToSequence__["a" /* default */],
    DeprecateMediaModal: __WEBPACK_IMPORTED_MODULE_7__components_modals_DeprecateMedia__["a" /* default */],
    MediaUploadModal: __WEBPACK_IMPORTED_MODULE_8__components_modals_MediaUpload__["a" /* default */],
    UpdateThumbModal: __WEBPACK_IMPORTED_MODULE_12__components_modals_UpdateThumb__["a" /* default */],
    ColdDeckResetModal: __WEBPACK_IMPORTED_MODULE_28__components_modals_ColdDeckReset__["a" /* default */],
    DeleteProductModal: __WEBPACK_IMPORTED_MODULE_29__components_modals_DeleteProduct__["a" /* default */],
    RestoreProductModal: __WEBPACK_IMPORTED_MODULE_30__components_modals_RestoreProduct__["a" /* default */],
    CreateMarketModal: __WEBPACK_IMPORTED_MODULE_27__components_modals_CreateMarket__["a" /* default */],
    CreateProductModal: __WEBPACK_IMPORTED_MODULE_26__components_modals_CreateProduct__["a" /* default */],
    DeleteRecordModal: __WEBPACK_IMPORTED_MODULE_13__components_modals_DeleteRecord__["a" /* default */],
    CreateProductGroupModal: __WEBPACK_IMPORTED_MODULE_25__components_modals_CreateProductGroup__["a" /* default */],
    LogoutModal: __WEBPACK_IMPORTED_MODULE_31__components_modals_Logout__["a" /* default */],
    EditHelpModal: __WEBPACK_IMPORTED_MODULE_14__components_modals_EditCardHelp__["a" /* default */],
    CreateCardModal: __WEBPACK_IMPORTED_MODULE_15__components_modals_CreateActionCard__["a" /* default */],
    CreateCardLocalRecordModal: __WEBPACK_IMPORTED_MODULE_16__components_modals_CreateCardLocalRecord__["a" /* default */],
    CopyVolumeLinksModal: __WEBPACK_IMPORTED_MODULE_18__components_modals_CopyVolumeLinks__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'CopyVolumeLinksModal', __WEBPACK_IMPORTED_MODULE_18__components_modals_CopyVolumeLinks__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'CopyCardLocalRecordModal', __WEBPACK_IMPORTED_MODULE_17__components_modals_CopyCardLocalRecord__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'CreateProductLocalRecordModal', __WEBPACK_IMPORTED_MODULE_21__components_modals_CreateProductLocalRecord__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'CreateProductGroupLocalRecordModal', __WEBPACK_IMPORTED_MODULE_22__components_modals_CreateProductGroupLocalRecord__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'CreateMediaLibraryModal', __WEBPACK_IMPORTED_MODULE_19__components_modals_CreateMediaLibrary__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'CreateMediaLibraryLocalRecordModal', __WEBPACK_IMPORTED_MODULE_20__components_modals_CreateMediaLibraryLocalRecord__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ProductImageUploadModal', __WEBPACK_IMPORTED_MODULE_23__components_modals_ProductImageUpload__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'CardIconUploadModal', __WEBPACK_IMPORTED_MODULE_24__components_modals_CardIconUpload__["a" /* default */]), _components),
  computed: {
    showAddCardToSequenceModal: function showAddCardToSequenceModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowAddCardToSequenceModal;
    },
    showAddSequenceToPolicyModal: function showAddSequenceToPolicyModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowAddSequenceToPolicyModal;
    },
    showAddMediaToCardModal: function showAddMediaToCardModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowAddMediaToCardModal;
    },
    showDeprecateMediaModal: function showDeprecateMediaModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowDeprecateMediaModal;
    },
    showMediaUploadModal: function showMediaUploadModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowUploadMediaModal;
    },
    showUpdateThumbModal: function showUpdateThumbModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowUpdateThumbModal;
    },
    showColdDeckModal: function showColdDeckModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowColdDeckModal;
    },
    showDeleteRecordModal: function showDeleteRecordModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowDeleteRecord;
    },
    showLogoutModal: function showLogoutModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowLogoutModal;
    },
    showDeleteProductModal: function showDeleteProductModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowDeleteProductModal;
    },
    showRestoreProductModal: function showRestoreProductModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowRestoreProductModal;
    },
    showCardHelpModal: function showCardHelpModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowCardHelpModal;
    },
    showCreateCardModal: function showCreateCardModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowCreateCardModal;
    },
    showCreateCardLocalRecordModal: function showCreateCardLocalRecordModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowCreateLocalRecord;
    },
    showCopyVolumeLinksModal: function showCopyVolumeLinksModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowCopyVolumeLinks;
    },
    showCopyLocalRecordModal: function showCopyLocalRecordModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowCopyLocalRecord;
    },
    showCreateMediaLibraryModal: function showCreateMediaLibraryModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowCreateMediaLibrary;
    },
    showCreateMediaLibraryLocalRecordModal: function showCreateMediaLibraryLocalRecordModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowCreateMediaLibraryLocalRecord;
    },
    showCreateProductLocalRecordModal: function showCreateProductLocalRecordModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowCreateProductLocalRecord;
    },
    showCreateProductGroupLocalRecordModal: function showCreateProductGroupLocalRecordModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowCreateProductGroupLocalRecord;
    },
    showCreateMarketModal: function showCreateMarketModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowCreateMarket;
    },
    showCreateProductGroupModal: function showCreateProductGroupModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowCreateProductGroup;
    },
    showCreateProductModal: function showCreateProductModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowCreateProduct;
    },
    showUploadProductImageModal: function showUploadProductImageModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowUploadProductImage;
    },
    showCardIconModal: function showCardIconModal() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getShowCardIcon;
    }
  },
  notifications: {
    showSuccessMsg: {
      type: __WEBPACK_IMPORTED_MODULE_32_vue_notifications___default.a.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: __WEBPACK_IMPORTED_MODULE_32_vue_notifications___default.a.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data: function data() {
    return {
      route: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.name,
      nonAuthRoutes: ['/', '/login', '/register', '/reset']
    };
  },

  methods: {
    getDomain: function getDomain(domain) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_Utils__["a" /* getResource */])('/v1/tenants/domain').then(function (res) {
          console.log(res);
          console.log(res);
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setDomain', domain);
          if (res.status === 'success') {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setTenant', res.tenant);
            return resolve();
          }
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setTenant', false);
          return reject(res);
        }).catch(function (err) {
          console.log(err);
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setTenant', false);
          return reject(err);
        });
      });
    },
    logout: function logout(message) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('hideModals', true);
      __WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.set('GEG__KEY', '');
      this.$router.push('/');
      this.showErrorMsg({ message: message ? message : 'You\'ve been logged out.' });
    },
    checkLogin: function checkLogin() {
      var token = __WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.get('GEG__KEY');
      var path = '/' + __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.name;

      // redirect to dashboard if logged in
      if (token && this.nonAuthRoutes.includes(path)) {
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'dashboard' });
      }
    }
  },
  mounted: function mounted() {
    console.log(__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.name);
    __WEBPACK_IMPORTED_MODULE_5__services_Services_js__["a" /* default */].getMediaAssociations();
    var str = window.location.host;
    var domain = str.split('.')[0];
    this.getDomain(domain).then(this.checkLogin).catch(function (error) {
      return console.log(error);
    });
  },

  watch: {
    $route: function $route(to, from) {
      var path = '/' + __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.name;
      console.log('path', path);

      if (!this.nonAuthRoutes.includes(path) && this.route !== 'login' && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getUser.status !== 'active') {
        //   not an active user
        console.log('not active user');
        this.logout('User is inactive.');
      }
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('hideModals', true);
    }
  }
});

/***/ }),

/***/ "xSQf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xqtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ImageFilterNone_vue__ = __webpack_require__("NCkF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6e7041e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ImageFilterNone_vue__ = __webpack_require__("aytQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ImageFilterNone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6e7041e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ImageFilterNone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y1gN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("uQyi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ce14d818_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("YR+v");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ce14d818_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yK9K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon plus-circle-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yUAE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yauI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general_LibraryGrid__ = __webpack_require__("0gt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_design_icons_Close__ = __webpack_require__("wbZU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("olkN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddSequenceToPolicyModal',
  components: {
    LibraryGrid: __WEBPACK_IMPORTED_MODULE_1__general_LibraryGrid__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
  },
  computed: {
    checkCardsLoaded: function checkCardsLoaded() {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.checkCardsReady;
    },
    getSequences: function getSequences() {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getSequences;
    }
  },
  methods: {
    setSelectedSequence: function setSelectedSequence(sequence) {
      var activePolicy = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getActivePolicy;
      activePolicy.sequence = sequence._id;
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setActivePolicy', activePolicy);
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setSelectedSequence', sequence);
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('hideModals', true);
    }
  },
  data: function data() {
    return {
      hideModal: __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].hideModals,
      cardsLoaded: false,
      styles: {
        mediaGrid: function mediaGrid(confirmationScreen) {
          return {
            display: confirmationScreen ? 'none' : 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap'
          };
        },
        modal: {
          background: '#fff',
          width: '90vw',
          height: '90vh',
          maxHeight: '90vh',
          margin: '0 auto',
          padding: '2rem 2rem 4rem',
          overflowY: 'scroll',
          overflowX: 'hidden',
          position: 'relative'
        },
        mediaContainer: {
          margin: 'auto',
          width: '100%',
          maxWidth: '500px'
        },
        confirmationBase: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center'
        },
        buttonContainer: {
          display: 'flex',
          margin: 'auto',
          flexDirection: 'row',
          flexWrap: 'no-wrap',
          width: '235px'
        },
        confirmationButtons: {
          display: 'block',
          width: '49%'
        },
        modalHeader: {
          boxSizing: 'border-box',
          paddingBottom: '0.5rem',
          borderBottom: '1px solid #444',
          display: 'flex',
          justifyContent: 'space-between',
          marginLeft: '10px',
          marginRight: '30px'
        },
        removeButton: {
          background: '#eb4d4b',
          fontSize: '0.9em',
          color: '#fff',
          borderRadius: '5px',
          padding: '5px',
          margin: 'auto 0 auto 10px',
          border: '0',
          ':hover': {
            opacity: '0.9'
          }
        },
        cancelButton: {
          background: '#888'
        },
        modalTitle: {
          color: '#444',
          fontSize: '1.5rem'
        },
        modalGridContainer: {
          overflow: 'scroll'
        },
        closeIcon: {
          position: 'fixed',
          top: '10px',
          right: '10px',
          fontSize: '2em',
          color: '#ddd',
          cursor: 'pointer'
        },
        yesButton: {
          background: '#6ab04c'
        },
        goBackLink: {
          color: 'rgb(9, 163, 237)',
          cursor: 'pointer',
          marginTop: '2rem',
          ':hover': {
            opacity: '0.9'
          }
        },
        backIcon: {
          position: 'relative',
          top: '23px'
        },
        cardWrap: {
          background: '#fff',
          display: 'flex',
          padding: '10px',
          flexFlow: 'row nowrap',
          justifyContent: 'space-between',
          width: 'calc(33.33% - 20px)',
          // margin: '10px',
          ':hover': {
            border: '1px solid #888',
            cursor: 'pointer'
          }
        },
        cardContainer: {
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        cardPreview: {
          background: 'teal',
          position: 'relative',
          padding: '20px'
        },
        cardName: {
          color: '#aaa',
          fontSize: '0.9em',
          marginBottom: '0'
        },
        cardMetadataSection: {
          display: 'flex',
          flexFlow: 'column nowrap',
          padding: '40px',
          width: '100%'
        },
        cardType: {
          margin: '20px auto 10px 20px',
          color: '#888'
        }
      }
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3__services_Services__["a" /* default */].getSequences();
  }
});

/***/ }),

/***/ "ydoa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"form"},[_c('h2',[_vm._v("Create a New Product")]),_c('div',{staticClass:"form__control-group"},[_c('label',[_vm._v("Name")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],attrs:{"type":"text","placeholder":"Name"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),(_vm.getMarkets.length > 1)?_c('div',{staticClass:"form__control-group rule__control-group--select"},[_c('label',[_vm._v("Default Market")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.market),expression:"market"}],staticClass:"form__select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.market=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"disabled","selected":"selected"}},[_vm._v("Select Market")]),_vm._l((_vm.getMarkets),function(market,index){return _c('option',{key:market.name,domProps:{"value":market}},[_vm._v(_vm._s(market.title)+" - "+_vm._s(market.primaryLanguage))])})],2)]):_vm._e(),_c('button',{staticClass:"button__submit",on:{"click":_vm.submit}},[_vm._v("Create")]),(_vm.showError)?_c('p',{staticClass:"validation__error"},[_vm._v("Please enter a Name and Default Market.")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yelj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Modal__ = __webpack_require__("+IFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Services__ = __webpack_require__("bdTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils_js__ = __webpack_require__("8u3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifications__);
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'RestoreProductModal',
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_0__general_Modal__["a" /* default */]
    },
    notifications: {
        showSuccessMsg: {
            type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.success,
            title: '',
            icon: '✅'
        },
        showErrorMsg: {
            type: __WEBPACK_IMPORTED_MODULE_4_vue_notifications___default.a.types.error,
            title: '',
            icon: '❗️'
        }
    },
    methods: {
        remove: function remove() {
            var _this = this;

            var productId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveProduct._id;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_Utils_js__["c" /* postResource */])('/v1/products/restore?id=' + productId, false).then(function (res) {
                _this.showSuccessMsg({
                    message: 'Product successfully restored.'
                });
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('hideModals', true);
                var newProduct = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getActiveProduct;
                newProduct.active = true;
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setActiveProduct', newProduct);
                return res;
            }).catch(function (error) {
                var message = 'An error occurred. Please try again.';
                if (error.error) {
                    message = error.error;
                }
                _this.showErrorMsg({
                    message: message
                });
            });
        },
        cancel: function cancel() {
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('hideModals', true);
        }
    }
});

/***/ }),

/***/ "yfN4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateMarket_vue__ = __webpack_require__("n+Xd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_275a3461_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateMarket_vue__ = __webpack_require__("2rtH");
function injectStyle (ssrContext) {
  __webpack_require__("TTau")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-275a3461"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateMarket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_275a3461_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CreateMarket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zEvH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductEditor_vue__ = __webpack_require__("gZzY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d58e282c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ProductEditor_vue__ = __webpack_require__("kbPx");
function injectStyle (ssrContext) {
  __webpack_require__("usmd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d58e282c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d58e282c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ProductEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zKUB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zRab":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zuUg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.wrapper)},[_c('LibraryGrid',{attrs:{"fullWidth":""}},[_c('div',{staticClass:"view-explanation"},[_c('button',{staticClass:"toggle-cards button__action button__delete",on:{"click":function($event){_vm.toggleDeleted()}}},[_vm._v(_vm._s(_vm.showDeleted ? 'View Active Sequences' : 'View Deleted Sequences'))]),_vm._v(" "),_c('h1',[_vm._v("Sequences")]),_vm._v(" "),_c('p',[_vm._v("Sequences are a group of\n        "),_c('router-link',{attrs:{"to":"/cards"}},[_vm._v("action cards")]),_vm._v(" set in a certain order. Sequences may be assigned to a\n        "),_c('router-link',{attrs:{"to":"/policies"}},[_vm._v("policy")]),_vm._v(", and when the rules of that policy are met by a user of the app, the designated sequence will deliver its action cards.\n      ")],1)]),_vm._v(" "),_vm._l((_vm.getSequences),function(sequence){return (_vm.showDeleted ? sequence.deleted : !sequence.deleted)?_c('section',{style:(_vm.styles.cardWrap),on:{"click":function($event){_vm.goToSequence(sequence._id)}}},[_c('div',{style:(_vm.styles.cardContainer)},[_c('p',{style:(_vm.styles.cardName)},[_vm._v("Sequence")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(sequence.name))])]),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-chevron-right",style:(_vm.styles.backIcon)})]):_vm._e()}),_vm._v(" "),(!_vm.showDeleted)?_c('section',{style:(_vm.styles.cardWrap),on:{"click":function($event){_vm.createNewSequence()}}},[_c('div',{style:(_vm.styles.cardContainer)},[_c('p',{style:(_vm.styles.cardName)},[_vm._v("Sequence")]),_vm._v(" "),_c('p',[_vm._v("Create New Sequence")])]),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-chevron-right",style:(_vm.styles.backIcon)})]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.72203960eca6f92c0748.js